import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
import {
  AggregateLienWaiverStatus,
  AgingAmountType,
  AgingDashboardSortCriteria,
  AgingIntervalType,
  AuthProviderType,
  BillingDashboardSortCriteria,
  BillingType,
  CacheType,
  CardBrand,
  CashForecastPeriodType,
  ChangeOrderRequestEventType,
  ChangeOrderRequestStatus,
  CmicAuthType,
  CmicIdpProvider,
  CollectionsEmailTemplateVariant,
  CollectionsNotificationAnchor,
  CollectionsNotificationGranularity,
  CollectionsNotificationLevel,
  CollectionsNotificationModifier,
  CollectionsNotificationType,
  CollectionsTaskStatus,
  CompanyContactDocumentLabel,
  CompanyLienWaiverTemplateSetType,
  CompanyListSortCriteria,
  CompanyMfaRequirement,
  CompanyProjectRole,
  CompanyType,
  CompanyUserRole,
  ComplianceStatus,
  ContractCategory,
  ContractCommentType,
  ContractEventType,
  ContractLienRightsStatus,
  ContractListBillingClosedOutFilter,
  ContractListContractStatusFilter,
  ContractListNextLienRightsMilestoneFilter,
  ContractListPayAppStatusFilter,
  ContractListSortCriteria,
  ContractListSubmitViaFilter,
  ContractMismatchReportOperationGroupStatus,
  ContractMismatchReportOperationStatus,
  ContractMonthlyStatusFilter,
  ContractPaymentTermsType,
  ContractSnapshotScore,
  ContractStatus,
  ContractUserRole,
  DashboardBillingStatus,
  DocumentExpirationFrequency,
  DocumentRequestStatus,
  DocumentType,
  DueToType,
  EmailType,
  FeatureFlagName,
  ForecastCurve,
  FormTemplateAnnotationImageType,
  FormTemplateAnnotationMetadataFieldType,
  FormTemplateAnnotationType,
  FormTemplateFont,
  FormTemplateOnboardingSignatureType,
  FormTemplateStatus,
  FormTemplateSuggestionsRunPhase,
  FormTemplateTag,
  FormTemplateType,
  FormTemplateVariantStatus,
  FormWorkerRole,
  GeneralContractorsSortCriteria,
  ImportIntegrationChangeOrdersMethod,
  ImportIntegrationComboJobMethod,
  ImportIntegrationProjectNameSource,
  ImportOperationStatus,
  IntegrationProjectsFilterField,
  IntegrationRequestType,
  IntegrationSyncResultCode,
  IntegrationType,
  LegalDocumentStatus,
  LienDeadlineNoticeRequirementType,
  LienMilestoneRequirementType,
  LienRightsContractEventType,
  LienRightsDeadlineAnchor,
  LienRightsDeadlineGranularity,
  LienRightsDeadlineModifier,
  LienRightsKeyDateType,
  LienRightsMilestoneType,
  LienWaiverCategory,
  LienWaiverRequestValidationStatus,
  LienWaiverType,
  LineItemType,
  MailOrderDocumentType,
  MailOrderOptionType,
  MailOrderShipmentStatus,
  MailOrderStatus,
  NotaryTag,
  NotificationType,
  OfficeTeamUpdateType,
  OutstandingPayAppsContractStatus,
  OutstandingPayAppsSortCriteria,
  PaginatedListSortOrder,
  PayAppAgingBucket,
  PayAppCollectionsNotificationStatus,
  PayAppCommentType,
  PayAppEventType,
  PayAppListSortCriteria,
  PayAppRequirementCondition,
  PayAppStatus,
  PayAppStatusFilter,
  PaymentDateEstimationType,
  Permission,
  PeyoteSqlDebuggerStatus,
  PhysicalSignatureRequired,
  PreSitelinePayAppStatus,
  ProjectOnboardingFormType,
  ProjectSnapshotDashboardSnapshotScoreFilter,
  QuickbooksOnlineSyncType,
  RateTableStatus,
  ReportDataField,
  ReportGroupByField,
  ReportRunOperationStatus,
  ReportSection,
  RequiredFieldForForms,
  RetentionTrackingLevel,
  Sage100InvoiceTaxType,
  SearchResultType,
  SignatureAnnotationType,
  SignatureFont,
  SitelineTeamMemberRole,
  SovLineItemProgressEventType,
  StoredFileType,
  StoredMaterialsCarryoverType,
  TaxCalculationType,
  TemplateListSortCriteria,
  TemplateListStatusFilter,
  TemplateVariantListSortCriteria,
  TextAlignment,
  TimeToPaymentBreakdownSortCriteria,
  TimeToPaymentViewBy,
  TransactionRelatedEntityType,
  TransactionStatus,
  TransactionType,
  Tutorial,
  UserStatus,
  VendorComplianceStatus,
  VendorContractCommitmentType,
  VendorLienWaiverReminderFrequency,
  VendorListSortCriteria,
  WriteSyncOperationGroupStatus,
  WriteSyncOperationsSortCriteria,
  WriteSyncOperationStatus,
} from 'siteline-common-all'
import {
  Boolean,
  DateTime,
  Decimal,
  EmailAddress,
  Float,
  ID,
  Int,
  JSONObject,
  LatLng,
  PhoneNumber,
  SafeInt,
  String,
  Upload,
  URL,
} from 'siteline-common-web/src/scalars.js'
export type Maybe<T> = T | null
export type InputMaybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: ID['input']; output: ID['output'] }
  String: { input: String['input']; output: String['output'] }
  Boolean: { input: Boolean['input']; output: Boolean['output'] }
  Int: { input: Int['input']; output: Int['output'] }
  Float: { input: Float['input']; output: Float['output'] }
  DateTime: { input: DateTime['input']; output: DateTime['output'] }
  Decimal: { input: Decimal['input']; output: Decimal['output'] }
  EmailAddress: { input: EmailAddress['input']; output: EmailAddress['output'] }
  JSONObject: { input: JSONObject['input']; output: JSONObject['output'] }
  LatLng: { input: LatLng['input']; output: LatLng['output'] }
  PhoneNumber: { input: PhoneNumber['input']; output: PhoneNumber['output'] }
  SafeInt: { input: SafeInt['input']; output: SafeInt['output'] }
  URL: { input: URL['input']; output: URL['output'] }
  Upload: { input: Upload['input']; output: Upload['output'] }
}

export type AbandonedPayAppsData = {
  readonly __typename: 'AbandonedPayAppsData'
  readonly abandonedPayAppsCount: Scalars['SafeInt']['output']
  readonly abandonedPayAppsIds: ReadonlyArray<Scalars['ID']['output']>
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

export type AddCompanyIntegrationInput = {
  readonly companyId: Scalars['ID']['input']
  readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
  readonly importComboJobMethod: ImportIntegrationComboJobMethod
  readonly importProjectNameSource: ImportIntegrationProjectNameSource
  readonly label?: InputMaybe<Scalars['String']['input']>
  readonly locationId?: InputMaybe<Scalars['ID']['input']>
  readonly metadata?: InputMaybe<Scalars['JSONObject']['input']>
  readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Scalars['Boolean']['input']
  readonly shouldImportNewProjectSov: Scalars['Boolean']['input']
  readonly type: IntegrationType
}

export type AddFormTemplateCommentInput = {
  readonly formTemplateId: Scalars['ID']['input']
  readonly message: Scalars['String']['input']
}

export type AgaveConnectorCompanyIntegrationStatus = {
  readonly __typename: 'AgaveConnectorCompanyIntegrationStatus'
  readonly companyIntegration: CompanyIntegration
  readonly connectorVersion: Maybe<Scalars['String']['output']>
  /** If we received an error when checking the status of the connector, it will be passed here */
  readonly errorMessage: Maybe<Scalars['String']['output']>
  readonly isConnectorOnline: Scalars['Boolean']['output']
  /** If `isConnectorOnline` is false, this will be the last time the Connector was successfullypinged */
  readonly lastPingedAt: Maybe<Scalars['DateTime']['output']>
}

export type AgaveCredentialsForDevEnvInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly userId: Scalars['String']['input']
}

export type AgaveDebuggerSessionUrlInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
}

/** Matrix of Agave endpoints × integration types, with the underlying ERP source_data.path for each cell. */
export type AgaveEndpointMatrix = {
  readonly __typename: 'AgaveEndpointMatrix'
  /** One entry per endpoint×integrationType combo that has data */
  readonly cells: ReadonlyArray<AgaveEndpointMatrixCell>
  /** All endpoint labels (rows) */
  readonly endpoints: ReadonlyArray<Scalars['String']['output']>
  /** All Agave integration types (columns) */
  readonly integrationTypes: ReadonlyArray<IntegrationType>
}

/** A single cell in the Agave endpoint matrix, representing one (endpoint, integrationType) combination. */
export type AgaveEndpointMatrixCell = {
  readonly __typename: 'AgaveEndpointMatrixCell'
  readonly endpoint: Scalars['String']['output']
  readonly integrationType: IntegrationType
  /** The MongoDB document ID of the last recorded integration request */
  readonly lastRequestId: Scalars['String']['output']
}

export type AggregateBillingForecast = {
  readonly __typename: 'AggregateBillingForecast'
  readonly forecastByMonth: ReadonlyArray<AggregateForecastMonth>
  readonly numContractsWithForecast: Scalars['SafeInt']['output']
  readonly projectedAmountThisMonth: Scalars['SafeInt']['output']
}

export type AggregateCashForecast = {
  readonly __typename: 'AggregateCashForecast'
  /** The amount that has been billed, not yet paid, and is predicted to be paid in the current period */
  readonly amountProjectedThisPeriod: Scalars['SafeInt']['output']
  readonly forecast: ReadonlyArray<CashForecastPeriod>
  /** The total amount outstanding across all periods */
  readonly totalOpenInvoiceAmount: Scalars['SafeInt']['output']
  /** Same as `totalUnknownPredictedInvoiceAmount`, but excluding pre-Siteline pay apps */
  readonly totalPayAppUnknownPredictedInvoiceAmount: Scalars['SafeInt']['output']
  /** The total amount outstanding in pay apps with an unknown predicted payment date. */
  readonly totalUnknownPredictedInvoiceAmount: Scalars['SafeInt']['output']
}

export type AggregateChangeOrderData = {
  readonly __typename: 'AggregateChangeOrderData'
  readonly totalAmountApproved: Scalars['SafeInt']['output']
  readonly totalAmountAuthorizedToProceed: Scalars['SafeInt']['output']
  readonly totalAmountProceedingWithWork: Scalars['SafeInt']['output']
  readonly totalAmountUnapproved: Scalars['SafeInt']['output']
  readonly totalOriginalContractAmount: Scalars['SafeInt']['output']
  readonly totalRevisedContractAmount: Scalars['SafeInt']['output']
}

export type AggregateChangeOrderDataByContract = {
  readonly __typename: 'AggregateChangeOrderDataByContract'
  readonly aggregateChangeOrderData: AggregateChangeOrderData
  readonly contract: Contract
}

export type AggregateForecastMonth = {
  readonly __typename: 'AggregateForecastMonth'
  readonly amountBilled: Maybe<Scalars['SafeInt']['output']>
  /** Zero-indexed month, from 0 to 11 */
  readonly month: Scalars['SafeInt']['output']
  readonly projectedAmount: Maybe<Scalars['SafeInt']['output']>
  /** Year in YYYY format */
  readonly year: Scalars['SafeInt']['output']
}

export { AggregateLienWaiverStatus }

export { AgingAmountType }

export type AgingBreakdown = {
  readonly __typename: 'AgingBreakdown'
  readonly amountAged30Days: Scalars['SafeInt']['output']
  readonly amountAged60Days: Scalars['SafeInt']['output']
  readonly amountAged90Days: Scalars['SafeInt']['output']
  readonly amountAged120Days: Scalars['SafeInt']['output']
  readonly amountAgedCurrent: Scalars['SafeInt']['output']
  readonly amountAgedTotal: Scalars['SafeInt']['output']
  /** Total amount aged, but only for pay apps which payment is overdue */
  readonly amountAgedTotalOverdueOnly: Scalars['SafeInt']['output']
  /** Rolling average number of days from pay app submission to paid, over the last 6 months */
  readonly averageDaysToPaid: Scalars['Float']['output']
  readonly hasPayAppsAgedOver90Days: Scalars['Boolean']['output']
  readonly hasPayAppsAgedOver120Days: Scalars['Boolean']['output']
  readonly numAged30Days: Scalars['SafeInt']['output']
  readonly numAged60Days: Scalars['SafeInt']['output']
  readonly numAged90Days: Scalars['SafeInt']['output']
  readonly numAged120Days: Scalars['SafeInt']['output']
  readonly numCurrent: Scalars['SafeInt']['output']
}

export type AgingDashboardSort = {
  readonly criteria: AgingDashboardSortCriteria
  readonly order?: InputMaybe<PaginatedListSortOrder>
}

export { AgingDashboardSortCriteria }

export { AgingIntervalType }

/**
 * A line item that only contains an amount.
 * Used for Quick Billing only.
 * Current billed = amount
 * Eg: "Campbell #A1245, amount $12,345"
 * Proof of material cost is stored in item attachments.
 */
export type AmountLineItem = {
  readonly __typename: 'AmountLineItem'
  /** Current amount billed for this line item */
  readonly amount: Scalars['SafeInt']['output']
  /** Amount due, post tax. This is amountDuePreTax + amountDueTaxAmount */
  readonly amountDuePostTax: Scalars['SafeInt']['output']
  /** Tax amount on the amount due. Tax rate is available on `taxGroup` */
  readonly amountDueTaxAmount: Scalars['SafeInt']['output']
  /**
   * Pay-app attachments that act as backup for this line item.
   * Typically this would be a vendor invoice.
   */
  readonly attachments: ReadonlyArray<PayAppAttachment>
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly payApp: PayApp
  /** Order in which to display the amount line items. First line item starts at 1. */
  readonly sortOrder: Scalars['SafeInt']['output']
  /** Optional tax rate to apply to the line item. It must be a tax group from the subcontractor company. */
  readonly taxGroup: Maybe<TaxGroup>
  /**
   * Pinned tax rate applied which is set to the tax group's tax percent at signing time.
   * If it is not set, we fall back to the tax group's tax percent (or 0 if it is not set).
   * Value is between 0 and 1.
   */
  readonly taxPercent: Maybe<Scalars['Float']['output']>
  readonly type: LineItemType
  readonly updatedAt: Scalars['DateTime']['output']
}

/**
 * Describes how to override the field of a template annotation.
 * This belongs to a template variant and only affects contracts that use this variant.
 */
export type AnnotationOverride = {
  readonly __typename: 'AnnotationOverride'
  readonly annotationPermanentId: Scalars['ID']['output']
  readonly copyDefaultValueFromPreviousAnnotationValue: Maybe<Scalars['Boolean']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly defaultValueKey: Maybe<Scalars['String']['output']>
  readonly doNotRetainOnReset: Maybe<Scalars['Boolean']['output']>
  readonly fieldType: Maybe<FormTemplateAnnotationMetadataFieldType>
  readonly fontColor: Maybe<Scalars['String']['output']>
  readonly fontFamily: Maybe<FormTemplateFont>
  readonly id: Scalars['ID']['output']
  readonly imageType: Maybe<FormTemplateAnnotationImageType>
  readonly isOptional: Maybe<Scalars['Boolean']['output']>
  readonly prefix: Maybe<Scalars['String']['output']>
  readonly selectedKey: Maybe<Scalars['String']['output']>
  readonly signatureType: Maybe<SignatureAnnotationType>
  readonly suffix: Maybe<Scalars['String']['output']>
  readonly syncTag: Maybe<Scalars['String']['output']>
  readonly textAlignment: Maybe<TextAlignment>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly userVisibleName: Maybe<Scalars['String']['output']>
  readonly variant: FormTemplateVariant
  readonly wrapText: Maybe<Scalars['Boolean']['output']>
}

export type ApplyAnnotationOverrideInput = {
  readonly annotationPermanentId: Scalars['ID']['input']
  readonly copyDefaultValueFromPreviousAnnotationValue?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultValueKey?: InputMaybe<Scalars['String']['input']>
  readonly doNotRetainOnReset?: InputMaybe<Scalars['Boolean']['input']>
  readonly fieldType?: InputMaybe<FormTemplateAnnotationMetadataFieldType>
  readonly fontColor?: InputMaybe<Scalars['String']['input']>
  readonly fontFamily?: InputMaybe<FormTemplateFont>
  readonly imageType?: InputMaybe<FormTemplateAnnotationImageType>
  readonly isOptional?: InputMaybe<Scalars['Boolean']['input']>
  readonly prefix?: InputMaybe<Scalars['String']['input']>
  readonly selectedKey?: InputMaybe<Scalars['String']['input']>
  readonly signatureType?: InputMaybe<SignatureAnnotationType>
  readonly suffix?: InputMaybe<Scalars['String']['input']>
  readonly syncTag?: InputMaybe<Scalars['String']['input']>
  readonly textAlignment?: InputMaybe<TextAlignment>
  /** Undefined to ignore, null to unset */
  readonly userVisibleName?: InputMaybe<Scalars['String']['input']>
  readonly variantId: Scalars['ID']['input']
  readonly wrapText?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * An auth provider is a way to authenticate a user via Firebase.
 * Currently, we only support email and SAML.
 */
export type AuthProvider = {
  readonly __typename: 'AuthProvider'
  /** Only provided for type == SAML */
  readonly samlProviderId: Maybe<Scalars['String']['output']>
  readonly type: AuthProviderType
}

export { AuthProviderType }

export type BilledPerCostCode = {
  readonly __typename: 'BilledPerCostCode'
  readonly balanceToFinish: Scalars['SafeInt']['output']
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly grossBilledThisMonth: Scalars['SafeInt']['output']
  readonly netBilledThisMonth: Scalars['SafeInt']['output']
  readonly retentionHeldAllTime: Scalars['SafeInt']['output']
  readonly retentionHeldThisMonth: Scalars['SafeInt']['output']
  readonly scheduledValue: Scalars['SafeInt']['output']
  readonly totalGrossBilled: Scalars['SafeInt']['output']
  readonly totalNetBilled: Scalars['SafeInt']['output']
}

export type BilledPerTaxGroup = {
  readonly __typename: 'BilledPerTaxGroup'
  readonly scheduledValue: Scalars['SafeInt']['output']
  readonly taxAmountThisPeriod: Scalars['SafeInt']['output']
  readonly taxGroup: TaxGroup
}

/** Billing account for a company, used for one-off payments and will eventually support carrying a balance */
export type BillingAccount = {
  readonly __typename: 'BillingAccount'
  /** Account balance in cents, will be 0 for now */
  readonly balance: Scalars['SafeInt']['output']
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly stripeCustomerId: Maybe<Scalars['String']['output']>
  readonly transactions: ReadonlyArray<BillingTransaction>
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Billing breakdown by cost code and contract */
export type BillingByCostCodeAndJob = {
  readonly __typename: 'BillingByCostCodeAndJob'
  readonly contract: Contract
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly grossBilling: Scalars['SafeInt']['output']
  readonly netBilling: Scalars['SafeInt']['output']
  readonly retentionHeld: Scalars['SafeInt']['output']
  readonly scheduledValue: Maybe<Scalars['SafeInt']['output']>
}

export type BillingDashboard = {
  readonly __typename: 'BillingDashboard'
  readonly billingSummary: BillingDashboardSummary
  readonly contracts: ReadonlyArray<BillingDashboardContract>
}

export type BillingDashboardContract = {
  readonly __typename: 'BillingDashboardContract'
  readonly billingStatus: DashboardBillingStatus
  readonly contract: Contract
  /**
   * If true, there is at least one pay app submitted between the end of the requested date range and
   * the end of the month. For instance if a pay app was submitted on Sept 25th, and the date range is
   * Sept 1st to Sept 20th, this will be true. If the pay app is submitted in the date range, or after
   * the end of the month, this will be false.
   */
  readonly isSubmittedInMonthButOutsideOfRange: Scalars['Boolean']['output']
  /** If true, the contract can be considered billed this month, either because it was submitted or opted out */
  readonly isSubmittedOrOptedOut: Scalars['Boolean']['output']
  readonly projectMetrics: ProjectMetrics
}

export type BillingDashboardContractWithLineItems = {
  readonly __typename: 'BillingDashboardContractWithLineItems'
  readonly billingStatus: DashboardBillingStatus
  readonly contract: Contract
  readonly lineItems: ReadonlyArray<LineItemMetrics>
  readonly projectMetrics: ProjectMetrics
}

export type BillingDashboardSort = {
  readonly criteria: BillingDashboardSortCriteria
  readonly order?: InputMaybe<PaginatedListSortOrder>
}

export { BillingDashboardSortCriteria }

export type BillingDashboardSummary = {
  readonly __typename: 'BillingDashboardSummary'
  /** If undefined, the previous month had no amount billed and no amount in draft */
  readonly amountBilledAndDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Amount of progress billed across all projects this month, including pay apps in draft. Does
   * not include retention billed and does not subtract retention held.
   */
  readonly amountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  /** If undefined, no amount of money was submitted for billing in the previous month */
  readonly amountBilledMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Amount of progress billed across all projects this month, excluding pay apps in draft. Does not
   * include retention billed and does not subtract retention held.
   */
  readonly amountBilledThisMonth: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no draft money outstanding */
  readonly amountInDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Amount of progress billing still in draft as of this month. Does not include retention billed and
   * does not subtract retention held.
   */
  readonly amountInDraftThisMonth: Scalars['SafeInt']['output']
  /** Sum of balance-to-finish across all projects. Powers the billing table footer total. */
  readonly balanceToFinish: Scalars['SafeInt']['output']
  /** Sum of gross completed-thru-month across all projects. Powers the billing table footer total. */
  readonly completedThruMonth: Scalars['SafeInt']['output']
  /** Amount billed each month over the last n months */
  readonly monthlyBillingBreakdown: ReadonlyArray<MonthlyBillingBreakdown>
  /** If undefined, the previous month had no amount billed and no amount in draft */
  readonly netAmountBilledAndDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Net amount billed across all projects this month, including pay apps in draft.
   * Deducts retention held and adds retention billed.
   */
  readonly netAmountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no draft money outstanding */
  readonly netAmountInDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Net amount of progress billing still in draft as of this month.
   * Deducts retention held and adds retention billed.
   */
  readonly netAmountInDraftThisMonth: Scalars['SafeInt']['output']
  /** Sum of net completed-thru-month (minus retention held) across all projects. */
  readonly netCompletedThruMonth: Scalars['SafeInt']['output']
  readonly payAppStatusBreakdown: PayAppStatusBreakdown
  readonly progressBilledAndDraftMinusRetentionHeldMonthOverMonthPercent: Maybe<
    Scalars['Float']['output']
  >
  /**
   * Progress billed this month minus retention held.
   * Retention billed is not included.
   * This includes drafts if payAppStatus includes drafts.
   */
  readonly progressBilledAndDraftMinusRetentionHeldThisMonth: Scalars['SafeInt']['output']
  readonly progressBilledAndDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Progress billed this month, not deducting retention held.
   * Retention billed is not included.
   * This is the same as amountBilledAndDraftThisMonth.
   */
  readonly progressBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  readonly progressBilledMinusRetentionHeldMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Progress billed this month minus retention held.
   * Retention billed is not included.
   * This does not include drafts, even if payAppStatus includes drafts.
   */
  readonly progressBilledMinusRetentionHeldThisMonth: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no project billed */
  readonly projectsBilledMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  readonly projectsBilledThisMonth: Scalars['SafeInt']['output']
  readonly retentionBilledAndDraftMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Retention billed this month, including drafts if payAppStatus includes drafts */
  readonly retentionBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  readonly retentionBilledMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Retention billed this month */
  readonly retentionBilledThisMonth: Scalars['SafeInt']['output']
  /** Percent change in retentionHeldThisMonth. If undefined, the previous month held no retention. */
  readonly retentionHeldMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /**
   * Retention held, including only submitted billing in the given month. This is a gross amount and
   * does not subtract retention billed.
   */
  readonly retentionHeldThisMonth: Scalars['SafeInt']['output']
  /**
   * Total retention held through a given month, from all draft and submitted pay apps. This is net
   * retention and subtracts retention billed, i.e. it is the total amount of retention held at the
   * end of the month.
   */
  readonly retentionHeldThruMonth: Scalars['SafeInt']['output']
  /**
   * Total number of active projects the current user has access to. This includes:
   * 1. All projects billing this month, including quick bills submitted this month
   * 2. All lump sum and unit price projects that did not bill this month
   */
  readonly totalProjectsThisMonth: Scalars['SafeInt']['output']
  /** Sum of contract total value across all projects. Powers the billing table footer total. */
  readonly totalValue: Scalars['SafeInt']['output']
}

export type BillingTotalsData = {
  readonly __typename: 'BillingTotalsData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly month: Scalars['DateTime']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
  readonly submittedPayAppCount: Scalars['SafeInt']['output']
  readonly totalBilledThisMonth: Scalars['Float']['output']
}

export type BillingTotalsInput = {
  readonly endMonth?: InputMaybe<Scalars['String']['input']>
  /** This is in YYYY-MM format */
  readonly startMonth: Scalars['String']['input']
}

/**
 * Single transaction (debit or credit) against a billing account.
 * Payments are always recorded as DEBITs. Not every DEBIT reduces the account balance, e.g.
 * one-off payments charge the card via Stripe and leave the account balance unchanged.
 */
export type BillingTransaction = {
  readonly __typename: 'BillingTransaction'
  readonly amount: Scalars['SafeInt']['output']
  readonly billingAccount: BillingAccount
  readonly completedAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly paymentMethod: Maybe<PaymentMethod>
  readonly relatedEntityId: Maybe<Scalars['ID']['output']>
  readonly relatedEntityType: Maybe<TransactionRelatedEntityType>
  readonly status: TransactionStatus
  readonly stripeChargeId: Maybe<Scalars['String']['output']>
  readonly stripePaymentIntentId: Maybe<Scalars['String']['output']>
  readonly type: TransactionType
  readonly updatedAt: Scalars['DateTime']['output']
  readonly user: User
}

export { BillingType }

export type BulkImportContract = {
  readonly __typename: 'BulkImportContract'
  readonly id: Scalars['ID']['output']
  readonly integrationContractId: Maybe<Scalars['ID']['output']>
  /**
   * If the contract already has an integration linked to the requested companyIntegration,
   * these are the existing integration's project/contract IDs. Both null if no such
   * integration exists.
   */
  readonly integrationProjectId: Maybe<Scalars['ID']['output']>
  readonly internalProjectNumber: Maybe<Scalars['String']['output']>
  readonly projectName: Scalars['String']['output']
  readonly projectNumber: Scalars['String']['output']
}

export { CacheType }

export { CardBrand }

export type CashForecastContract = {
  readonly __typename: 'CashForecastContract'
  readonly contract: Contract
  readonly hasInvoicePredictedPaymentPassed: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly numComments: Scalars['Int']['output']
  readonly paymentPeriods: ReadonlyArray<ContractPaymentPeriod>
}

export type CashForecastPeriod = {
  readonly __typename: 'CashForecastPeriod'
  /**
   * The total amount that has already been billed, is not yet paid, and is predicted to be paid in
   * this period
   */
  readonly amountOutstanding: Scalars['SafeInt']['output']
  readonly period: CashForecastPeriodType
  /**
   * The first day of the period that this represents.
   * If the forecast is monthly and this represents May, startDate will be "<year>-05-01".
   * If the forecast is weekly, start date will be the Monday of the week that this represents.
   * Format: YYYY-MM-DD
   */
  readonly startDate: Scalars['String']['output']
}

export { CashForecastPeriodType }

export type ChangeOrderLogUseData = {
  readonly __typename: 'ChangeOrderLogUseData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly percentProjectsWithChangeOrder: Scalars['Float']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

export type ChangeOrderReport = {
  readonly __typename: 'ChangeOrderReport'
  readonly changeOrderSummaryReport: ChangeOrderSummaryReport
  readonly pendingChangeOrderReport: PendingChangeOrderReport
}

/** Represents a change order request, managed by a subcontractor for submitting to the project's GC for review */
export type ChangeOrderRequest = {
  readonly __typename: 'ChangeOrderRequest'
  /** The current or final amount of the change order request, including any GC adjustments */
  readonly amount: Maybe<Scalars['SafeInt']['output']>
  /** Once approved, the subcontractor may upload the final completed SCO form */
  readonly approvedScoFile: Maybe<StoredFile>
  readonly attachments: ReadonlyArray<ChangeOrderRequestAttachment>
  /** A list of comments on the change order request */
  readonly comments: ReadonlyArray<ChangeOrderRequestComment>
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly emailedContacts: ReadonlyArray<CompanyContact>
  readonly events: ReadonlyArray<ChangeOrderRequestEvent>
  /** Form template version is locked in when the request is sent */
  readonly formTemplateVersion: Maybe<FormTemplateVersion>
  readonly formValues: ReadonlyArray<FormTemplateAnnotationValue>
  readonly generalContractorNumber: Maybe<Scalars['String']['output']>
  /** Whether the contract rate table was swapped or updated since the COR was created */
  readonly hasContractRateTableChanged: Scalars['Boolean']['output']
  /** Whether fees have changed on the contract since the COR was created */
  readonly haveContractFeesChanged: Scalars['Boolean']['output']
  /** Whether taxes have changed on the contract since the COR was created */
  readonly haveContractTaxesChanged: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /** If the COR was imported from a change order log, mark the time it was imported */
  readonly importedAt: Maybe<Scalars['DateTime']['output']>
  readonly internalNumber: Maybe<Scalars['String']['output']>
  /** The last ERP syncs for this change order request, whether successful or not */
  readonly lastErpSyncs: ReadonlyArray<WriteSyncOperation>
  /**
   * Change order requests that the user has linked to this one. COR links are bidirectional and all
   * linked change order requests should have the same set of SOV line items.
   */
  readonly linkedChangeOrderRequests: ReadonlyArray<ChangeOrderRequest>
  /** Return fields missing from the contract or project that are required on the COR form template */
  readonly missingRequiredFields: ReadonlyArray<RequiredFieldForForms>
  readonly name: Scalars['String']['output']
  readonly proceedingWithWork: Scalars['Boolean']['output']
  /** Once the COR is submitted, this is the amount at the time of the most recent submission */
  readonly proposedAmount: Maybe<Scalars['SafeInt']['output']>
  /** Once the SOR is submitted, this is the time of the most recent submission */
  readonly proposedAt: Maybe<Scalars['DateTime']['output']>
  /** Link back to rate table that is used to price the change order request. */
  readonly rateTable: Maybe<RateTable>
  /**
   * Only if pricing the change order.
   * Warning: this includes *all* fees, including group fees.
   */
  readonly rateTableFees: ReadonlyArray<ChangeOrderRequestRateTableFee>
  /** Used for adding pricing and cost estimates to the change order */
  readonly rateTableGroups: ReadonlyArray<ChangeOrderRequestRateTableGroup>
  /** Used for pricing the change order */
  readonly rateTableItems: ReadonlyArray<ChangeOrderRequestRateTableItem>
  readonly reason: Maybe<Scalars['String']['output']>
  /** Amount of time in days (eg. 1 day or 1.5 days). Only used for template variables on forms */
  readonly scheduleImpact: Maybe<Scalars['Float']['output']>
  /** Change order requests do not support forms with physical signatures */
  readonly signature: Maybe<Signature>
  readonly sovLineItems: ReadonlyArray<SovLineItem>
  readonly status: ChangeOrderRequestStatus
  readonly statusChangedAt: Scalars['DateTime']['output']
  readonly statusLogs: ReadonlyArray<ChangeOrderRequestStatusLog>
  /** Total estimated cost of the change order request, including taxes */
  readonly totalCost: Maybe<Scalars['SafeInt']['output']>
  /** The human-readable unit of measurement for each unit, e.g. LF, EA, HR for UNIT_PRICE contract. */
  readonly unitName: Maybe<Scalars['String']['output']>
  /** A price per unit, in cents. This is used for UNIT_PRICE contracts. */
  readonly unitPrice: Maybe<Scalars['Decimal']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  /** Should this COR be included in a log of change orders submitted to GC */
  readonly visibleToGc: Scalars['Boolean']['output']
}

/** Represents a backup document uploaded to a change order request that can be accessed via a URL */
export type ChangeOrderRequestAttachment = {
  readonly __typename: 'ChangeOrderRequestAttachment'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Maybe<Scalars['String']['output']>
  readonly file: StoredFile
  readonly id: Scalars['ID']['output']
  /** Internal-only attachments will never get included in the generated PDF package for the COR */
  readonly isInternalOnly: Scalars['Boolean']['output']
  readonly name: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly uploadId: Scalars['ID']['output']
}

/** Represents a comment from a user on a change order request */
export type ChangeOrderRequestComment = {
  readonly __typename: 'ChangeOrderRequestComment'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly message: Maybe<Scalars['String']['output']>
  readonly user: User
}

/** Represents a single event that occurred on a change order request */
export type ChangeOrderRequestEvent = {
  readonly __typename: 'ChangeOrderRequestEvent'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly id: Scalars['ID']['output']
  /** Values in this dictionary depend on the event type */
  readonly metadata: Scalars['JSONObject']['output']
  readonly type: ChangeOrderRequestEventType
}

export { ChangeOrderRequestEventType }

/** A COR-level or group-level fee on a priced change order request. */
export type ChangeOrderRequestRateTableFee = {
  readonly __typename: 'ChangeOrderRequestRateTableFee'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  /** If provided, this fee applies to a specific group */
  readonly group: Maybe<ChangeOrderRequestRateTableGroup>
  readonly id: Scalars['ID']['output']
  /** If provided, this fee overrides another fee at the COR (global) level. It must be a group fee in this case. */
  readonly overridesFee: Maybe<ChangeOrderRequestRateTableFee>
  readonly percent: Scalars['Float']['output']
  /** Link back to the contract rate table fee that was used to create this fee, if it still exists. */
  readonly rateTableFee: Maybe<ContractRateTableFee>
  readonly updatedAt: Scalars['DateTime']['output']
}

/** A rate table item group on a change order request rate table */
export type ChangeOrderRequestRateTableGroup = {
  readonly __typename: 'ChangeOrderRequestRateTableGroup'
  /** Total amount after all fees and taxes */
  readonly amountPostFeesPostTax: Scalars['SafeInt']['output']
  /** Amount after fees, but before tax applies */
  readonly amountPostFeesPreTax: Scalars['SafeInt']['output']
  /** Amount before any fee or tax applies */
  readonly amountPreFeesPreTax: Scalars['SafeInt']['output']
  readonly changeOrderRequest: ChangeOrderRequest
  /** Total cost after tax applied */
  readonly costPostTax: Scalars['SafeInt']['output']
  /** Total cost before tax applied */
  readonly costPreTax: Scalars['SafeInt']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly fees: ReadonlyArray<ChangeOrderRequestRateTableFee>
  readonly id: Scalars['ID']['output']
  readonly items: ReadonlyArray<ChangeOrderRequestRateTableItem>
  readonly name: Scalars['String']['output']
  /** Link back to the rate table group that was used to create the pay app item, if it still exists. */
  readonly rateTableGroup: Maybe<RateTableGroup>
  /** This is the pinned tax for this group, which is either the default tax group or the category override. */
  readonly taxGroup: Maybe<TaxGroup>
  readonly type: LineItemType
  readonly updatedAt: Scalars['DateTime']['output']
}

/** A line item on a change order request rate table */
export type ChangeOrderRequestRateTableItem = {
  readonly __typename: 'ChangeOrderRequestRateTableItem'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly code: Maybe<Scalars['String']['output']>
  readonly costType: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly currentCostTotal: Scalars['SafeInt']['output']
  readonly currentCostUnits: Scalars['Float']['output']
  readonly currentPriced: Scalars['SafeInt']['output']
  readonly currentUnitsPriced: Scalars['Float']['output']
  readonly description: Scalars['String']['output']
  /** Group that the line item belongs to */
  readonly group: ChangeOrderRequestRateTableGroup
  readonly id: Scalars['ID']['output']
  /**
   * Whether a COR item should be excluded from the pricing table.
   * - If true, it's only for cost estimation, so do not include in the pricing table
   * - If false, the item should also appear in the pricing table
   */
  readonly isCostTableOnly: Scalars['Boolean']['output']
  /** Whether this item was manually added to the COR and doesn't have a matching rate table item */
  readonly isOneOffItem: Scalars['Boolean']['output']
  /** Link back to the rate table item that was used to create the COR item, if it still exists. */
  readonly rateTableItem: Maybe<RateTableItem>
  readonly sortOrder: Scalars['SafeInt']['output']
  readonly unitCost: Scalars['SafeInt']['output']
  readonly unitName: Maybe<Scalars['String']['output']>
  readonly unitRate: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export { ChangeOrderRequestStatus }

/** Represents a log of all statuses for a change order request and when the transition occurred. */
export type ChangeOrderRequestStatusLog = {
  readonly __typename: 'ChangeOrderRequestStatusLog'
  readonly changeOrderRequest: ChangeOrderRequest
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly status: ChangeOrderRequestStatus
  readonly statusUpdatedAt: Scalars['DateTime']['output']
  readonly user: User
}

export type ChangeOrderSummaryReport = {
  readonly __typename: 'ChangeOrderSummaryReport'
  readonly aggregateChangeOrderDataByContract: ReadonlyArray<AggregateChangeOrderDataByContract>
  readonly aggregateChangeOrderTotals: AggregateChangeOrderData
}

export type ChatTool = {
  readonly __typename: 'ChatTool'
  readonly description: Scalars['String']['output']
  readonly name: Scalars['String']['output']
}

export type ChatToolsLoadError = {
  readonly __typename: 'ChatToolsLoadError'
  readonly message: Scalars['String']['output']
  /** Optional shell command an engineer can run to re-initialize this source (e.g. re-seed OAuth tokens for the current env). */
  readonly repairCommand: Maybe<Scalars['String']['output']>
  /** MCP source key (e.g. `slack`, `notion`) — matches the prefix on tool names without the trailing underscore. */
  readonly source: Scalars['String']['output']
}

export type ChatToolsResponse = {
  readonly __typename: 'ChatToolsResponse'
  readonly errors: ReadonlyArray<ChatToolsLoadError>
  readonly tools: ReadonlyArray<ChatTool>
}

export type CloneFormTemplateInput = {
  readonly id: Scalars['ID']['input']
  readonly originalFile?: InputMaybe<Scalars['Upload']['input']>
  readonly userVisibleName: Scalars['String']['input']
}

export type CloudLoggingLogsInput = {
  readonly autoPaginate?: InputMaybe<Scalars['Boolean']['input']>
  readonly filter: Scalars['String']['input']
  readonly orderBy?: InputMaybe<Scalars['String']['input']>
  readonly pageSize: Scalars['Int']['input']
  readonly pageToken?: InputMaybe<Scalars['String']['input']>
}

export type CloudLoggingLogsResponse = {
  readonly __typename: 'CloudLoggingLogsResponse'
  readonly entries: ReadonlyArray<Scalars['JSONObject']['output']>
  readonly nextPageToken: Maybe<Scalars['String']['output']>
}

export { CmicAuthType }

export { CmicIdpProvider }

/**
 * A reusable, company-scoped email template tied to a specific collections notification type.
 * Used to pre-fill subject/body when configuring or sending notifications.
 */
export type CollectionsEmailTemplate = {
  readonly __typename: 'CollectionsEmailTemplate'
  /** Email body */
  readonly body: Scalars['String']['output']
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  /** User who created the custom override, or null for system defaults */
  readonly createdBy: Maybe<User>
  /** Body of this slot's system default, even when a custom override exists */
  readonly defaultBody: Scalars['String']['output']
  /** Subject of this slot's system default, even when a custom override exists */
  readonly defaultSubject: Scalars['String']['output']
  /** Set when this custom override was reverted to the default (soft-deleted). Null for live templates. */
  readonly deletedAt: Maybe<Scalars['DateTime']['output']>
  readonly id: Scalars['ID']['output']
  /** True for the virtual system default; false for a company's custom override row. */
  readonly isDefault: Scalars['Boolean']['output']
  /** User who last edited the custom override (the creator on override), or null for system defaults */
  readonly lastEditedBy: Maybe<User>
  /** Number of the company's active projects whose collections emails route to this template slot */
  readonly linkedProjectsCount: Scalars['Int']['output']
  /** Human-readable name derived from the (notificationType, variant) slot */
  readonly name: Scalars['String']['output']
  /** Which collections notification this template is intended for */
  readonly notificationType: CollectionsNotificationType
  /** Email subject line */
  readonly subject: Scalars['String']['output']
  /** Variables available for interpolation into subject and body */
  readonly templateVariables: ReadonlyArray<CollectionsEmailTemplateVariable>
  readonly updatedAt: Scalars['DateTime']['output']
  /** Which collections template variant this email uses (routing family). */
  readonly variant: CollectionsEmailTemplateVariant
}

/** Resolved email template content for one collections reminder type on a contract */
export type CollectionsEmailTemplatePreview = {
  readonly __typename: 'CollectionsEmailTemplatePreview'
  readonly body: Scalars['String']['output']
  readonly subject: Scalars['String']['output']
  readonly type: CollectionsNotificationType
}

/** A variable that can be interpolated into an email template's subject or body. */
export type CollectionsEmailTemplateVariable = {
  readonly __typename: 'CollectionsEmailTemplateVariable'
  readonly key: Scalars['String']['output']
}

export { CollectionsEmailTemplateVariant }

export { CollectionsNotificationAnchor }

/** The collections notification settings configured at one level, plus their resolved values */
export type CollectionsNotificationConfig = {
  readonly __typename: 'CollectionsNotificationConfig'
  /**
   * Resolved settings after walking the level chain. Every notification type is represented: types
   * with no settings at any level resolve to a single disabled DEFAULT entry, and a type can resolve
   * to several settings when its source level has more than one (e.g. multiple OVERDUE reminders).
   */
  readonly effectiveSettings: ReadonlyArray<EffectiveCollectionsNotificationSetting>
  /** ID of the contract, general contractor, or company this config belongs to */
  readonly entityId: Scalars['ID']['output']
  readonly level: CollectionsNotificationLevel
  /** Settings explicitly configured at this level */
  readonly settings: ReadonlyArray<CollectionsNotificationSetting>
}

export { CollectionsNotificationGranularity }

export { CollectionsNotificationLevel }

export { CollectionsNotificationModifier }

/** A record of sending a collection notification, for a specific pay app and notification type. */
export type CollectionsNotificationSendLog = {
  readonly __typename: 'CollectionsNotificationSendLog'
  readonly gcContacts: ReadonlyArray<CompanyContact>
  readonly id: Scalars['ID']['output']
  readonly internalCcRecipients: ReadonlyArray<User>
  /**
   * This is set when a user manually triggers a notification by clicking 'Send now' on the frontend,
   * and will be empty when the notification is automatically sent at its scheduled time.
   */
  readonly manuallyTriggeredBy: Maybe<User>
  readonly notification: PayAppCollectionsNotification
  readonly sendTime: Scalars['DateTime']['output']
  readonly sender: User
}

/**
 * A collections notification (or reminder) setting for one notification type, configured at a single
 * level: a contract, a general contractor, or a company. A level can hold several settings of the
 * same type (e.g. multiple OVERDUE reminders at different cadences). When resolving a contract's
 * settings for a type, levels are walked contract -> general contractor -> company -> system
 * default; the nearest level with any settings of the type fully defines that type's reminders.
 */
export type CollectionsNotificationSetting = {
  readonly __typename: 'CollectionsNotificationSetting'
  /** Set when this setting is configured at the company (subcontractor) level */
  readonly company: Maybe<Company>
  /** Set when this setting is configured at the contract level */
  readonly contract: Maybe<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * Explicit on/off. A disabled setting still overrides higher levels, so a contract can opt out of
   * reminders enabled for its general contractor or company.
   */
  readonly enabled: Scalars['Boolean']['output']
  /** Set when this setting is configured at the general contractor level */
  readonly generalContractor: Maybe<GeneralContractor>
  readonly id: Scalars['ID']['output']
  /** Number of days/weeks/months */
  readonly intervalAmount: Scalars['SafeInt']['output']
  /** Submission date / due date */
  readonly intervalAnchor: CollectionsNotificationAnchor
  /** Day / week / month */
  readonly intervalGranularity: CollectionsNotificationGranularity
  /** Before / after */
  readonly intervalModifier: CollectionsNotificationModifier
  /** Who last edited this setting */
  readonly lastEditedBy: Maybe<User>
  /** The level this setting is configured at, derived from which relation is set */
  readonly level: CollectionsNotificationLevel
  /** Type of notification to send */
  readonly type: CollectionsNotificationType
  readonly updatedAt: Scalars['DateTime']['output']
}

export { CollectionsNotificationType }

/** A user-provided task for collections on a pay app */
export type CollectionsTask = {
  readonly __typename: 'CollectionsTask'
  readonly createdAt: Scalars['DateTime']['output']
  /** User who created and is assigned to this task */
  readonly createdBy: User
  readonly description: Scalars['String']['output']
  readonly dueDate: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly payApp: PayApp
  readonly status: CollectionsTaskStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

export { CollectionsTaskStatus }

export type CompaniesByRolloutPercentageInput = {
  readonly flagName: FeatureFlagName
  readonly rolloutPercentage: Scalars['Int']['input']
}

/**
 * Represents a single company in the system.
 * Historically it could be any type of company, but over time each company type has been implemented as its own model.
 * Now Company is mostly a Subcontractor, which is our primary focus.
 * Note that for historical reasons, architects/owners/bond providers are still represented as Companies.
 * Vendors and GCs have their own models (Vendor and GeneralContractor respectively).
 */
export type Company = {
  readonly __typename: 'Company'
  /** Setting for determining what reference date to use to calculate A/R aging for this company */
  readonly agingIntervalType: AgingIntervalType
  /**
   * If true, allow overbilling on lump sum projects. By default, overbilling is not allowed. Note
   * that it is allowed for all companies on unit price projects.
   */
  readonly allowLumpSumOverbilling: Scalars['Boolean']['output']
  /**
   * Whether lien rights tracking is enabled for this company, meaning the company is allowed to
   * use lien rights tracking features. This is separate from `defaultLienRightsTracking`, and may be used
   * for gating customer access to the lien rights feature.
   */
  readonly allowsLienRightsTracking: Scalars['Boolean']['output']
  /** Billing accounts for this company (e.g. for mail order payments). One per company for M2. */
  readonly billingAccounts: ReadonlyArray<BillingAccount>
  /** Whether the company does tax calculations, used for reporting */
  readonly calculatesTaxes: Scalars['Boolean']['output']
  /** Reusable email templates available to this company */
  readonly collectionsEmailTemplates: ReadonlyArray<CollectionsEmailTemplate>
  /** Company-wide collections notification settings, plus their resolved values */
  readonly collectionsNotificationConfig: CollectionsNotificationConfig
  /** Integrations for this company. Some of them might be archived. */
  readonly companyIntegrations: ReadonlyArray<CompanyIntegration>
  readonly contacts: ReadonlyArray<CompanyContact>
  readonly createdAt: Scalars['DateTime']['output']
  /** Default change order request templates to use on a new project. */
  readonly defaultChangeOrderLogTemplate: Maybe<FormTemplate>
  /** Default change order request templates to use on a new project. */
  readonly defaultChangeOrderRequestTemplate: Maybe<FormTemplate>
  /**
   * Default number of days prior to actual deadline that will be shown as the internal deadline.
   * Used as the default for new contracts. If not set, defaults to 3 days.
   */
  readonly defaultDaysBeforePayAppDue: Maybe<Scalars['Int']['output']>
  /** Whether lien rights are automatically tracked by default for all new contracts */
  readonly defaultLienRightsTracking: Scalars['Boolean']['output']
  /** If the company sets a custom due date for pay apps, it will be the default for new contracts */
  readonly defaultPayAppDueOnDayOfMonth: Maybe<Scalars['Int']['output']>
  /**
   * Default template to use when creating QUICK pay apps.
   * When creating quick projects, the contract will be set up with this template in its
   * pay app requirements.
   */
  readonly defaultQuickBillingTemplate: Maybe<FormTemplate>
  /** If the company sets a custom default retention percent, it will be the default for new contracts */
  readonly defaultRetentionPercent: Maybe<Scalars['Float']['output']>
  /** Whether new contracts are created with the setting enabled to show audit trail on signed forms */
  readonly defaultShowAuditItemOnSignedPackages: Scalars['Boolean']['output']
  /**
   * If true, the billing worksheet tool is enabled for all projects under this company. This means
   * users will have the ability to add worksheet line items for line items on those projects' SOVs.
   */
  readonly enableBillingWorksheets: Scalars['Boolean']['output']
  readonly enableDailyContractMismatchReport: Scalars['Boolean']['output']
  readonly expectedNumberOfProjects: Maybe<Scalars['SafeInt']['output']>
  readonly formTemplateCollections: ReadonlyArray<CompanyFormTemplateCollection>
  readonly generalContractors: ReadonlyArray<GeneralContractor>
  /** Set to true if the company was a Siteline customer who churned */
  readonly hasChurned: Scalars['Boolean']['output']
  /** Whether the company has any SOVs that use cost codes, used for reporting */
  readonly hasCostCodes: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /**
   * Integration metadata for this company, with mappings of different types for different integration
   * types. Used for storing mappings for related companies, e.g. a sub's general contractors.
   */
  readonly integrationMappings: Scalars['JSONObject']['output']
  /** Whether the company is a demo company */
  readonly isDemoCompany: Scalars['Boolean']['output']
  readonly leadPMs: ReadonlyArray<User>
  readonly lienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  /**
   * Companies that are linked to this one (for instance belonging to the same parent company).
   * This is is inferred from users with the ADMINISTRATOR role on the company.
   */
  readonly linkedCompanies: ReadonlyArray<Company>
  readonly locations: ReadonlyArray<Location>
  readonly metadata: CompanyMetadata
  /** The MFA requirement for the company */
  readonly mfaRequirement: CompanyMfaRequirement
  readonly name: Scalars['String']['output']
  /** Shorter version of the formal company name, shown in the nav bar and included in searches */
  readonly nickname: Maybe<Scalars['String']['output']>
  readonly notaryExpiresAt: Maybe<Scalars['DateTime']['output']>
  readonly notarySignature: Maybe<StoredFile>
  readonly notaryStamp: Maybe<StoredFile>
  /** Used for admin users to tag companies with notary type requirements */
  readonly notaryTags: ReadonlyArray<NotaryTag>
  readonly owners: ReadonlyArray<Owner>
  /**
   * If a pay app is paid slightly short of the amount due, any remaining balance at or under this
   * amount (in cents) is automatically marked as closed so it stops showing in AR aging. This is
   * the default for the company's projects and can be overridden per contract. 0 disables
   * auto-close. Only administrators can change this setting.
   */
  readonly payAppBalanceAutoCloseThresholdCents: Scalars['SafeInt']['output']
  readonly payAppFormTemplateSets: ReadonlyArray<CompanyPayAppFormTemplateSet>
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly picture: Maybe<StoredFile>
  readonly primaryLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  /** The Salesforce unique ID for the corresponding account */
  readonly salesforceCompanyId: Maybe<Scalars['String']['output']>
  readonly secondarySignature: Maybe<StoredFile>
  /** Siteline CSM team member assigned to this company */
  readonly sitelinePointOfContact: Maybe<User>
  /** Company setting for stored materials handling */
  readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
  readonly subTierLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  /** Tax groups that are used by this company. Tax-aware line items must link to one of these tax groups. */
  readonly taxGroups: ReadonlyArray<TaxGroup>
  readonly type: CompanyType
  readonly updatedAt: Scalars['DateTime']['output']
  /** The timeout for user sessions in minutes, where we will automatically log the user out */
  readonly userSessionTimeout: Maybe<Scalars['Int']['output']>
  readonly users: ReadonlyArray<CompanyUser>
  /** Whether automatic vendor lien waiver validation is enabled. False by default. */
  readonly validatesVendorLienWaivers: Scalars['Boolean']['output']
  /** The frequency at which to send automatic vendor lien waiver reminders */
  readonly vendorLienWaiverReminderFrequency: VendorLienWaiverReminderFrequency
  readonly vendorLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  readonly vendors: ReadonlyArray<Vendor>
}

/** Represents a contact at another company who may receive pay apps or primary lien waivers */
export type CompanyContact = {
  readonly __typename: 'CompanyContact'
  /** An archived company contact should not be surfaced to the user, except relating to past documents */
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly company: Company
  readonly companyName: Scalars['String']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly email: Scalars['EmailAddress']['output']
  readonly fullName: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly jobTitle: Maybe<Scalars['String']['output']>
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

export { CompanyContactDocumentLabel }

/** A collection of form template sets of different types that can be used as defaults for new projects */
export type CompanyFormTemplateCollection = {
  readonly __typename: 'CompanyFormTemplateCollection'
  readonly billingType: BillingType
  readonly changeOrderLog: Maybe<FormTemplateVariant>
  readonly changeOrderRequest: Maybe<FormTemplateVariant>
  readonly company: Company
  readonly gc: Maybe<GeneralContractor>
  readonly id: Scalars['ID']['output']
  /** If this is the main default template collection for this company */
  readonly isDefaultTemplateCollection: Scalars['Boolean']['output']
  readonly name: Scalars['String']['output']
  readonly payAppForms: Maybe<CompanyPayAppFormTemplateSet>
  readonly primaryLienWaivers: Maybe<CompanyLienWaiverTemplateSet>
  readonly state: Maybe<Scalars['String']['output']>
  readonly subTierLienWaivers: Maybe<CompanyLienWaiverTemplateSet>
  readonly vendorLienWaivers: Maybe<CompanyLienWaiverTemplateSet>
}

export type CompanyInput = {
  readonly allowsLienRightsTracking?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultLienRightsTracking?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultQuickBillingTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly expectedNumberOfProjects?: InputMaybe<Scalars['SafeInt']['input']>
  readonly isDemoCompany?: InputMaybe<Scalars['Boolean']['input']>
  readonly locations: ReadonlyArray<LocationInput>
  readonly metadata: CompanyMetadataInput
  readonly mfaRequirement?: InputMaybe<CompanyMfaRequirement>
  readonly name: Scalars['String']['input']
  readonly phoneNumber: Scalars['PhoneNumber']['input']
  readonly picture?: InputMaybe<StoredFileInput>
  readonly salesforceCompanyId?: InputMaybe<Scalars['String']['input']>
  readonly type: CompanyType
  readonly userSessionTimeout?: InputMaybe<Scalars['Int']['input']>
}

/**
 * A company-level integration.
 * Each contract integration must reference a company integration.
 * Companies can have multiple integrations of the same type.
 */
export type CompanyIntegration = {
  readonly __typename: 'CompanyIntegration'
  /**
   * When archived, the integration no longer shows up in admin/web
   * and contract integrations linked to it are considered inactive
   */
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  /** Whether the credentials are ready be auto-rotated */
  readonly credentialsReadyForAutoRotation: Scalars['Boolean']['output']
  /** Alias for credentials.updatedAt, necessary because credentials are not exposed to the API */
  readonly credentialsUpdatedAt: Maybe<Scalars['DateTime']['output']>
  readonly id: Scalars['ID']['output']
  /** How change orders should be imported on the SOV, when reading the SOV line items into Siteline */
  readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
  /**
   * For integrations that support "combo jobs", where line items may link to different jobs, this is
   * the method we use to determine how those jobs should be handled in Siteline. Currently applies
   * only to Sage 300 CRE, but all methods may not be supported by all integrations.
   *
   * A "combo job" is a project in an integration where the contract line items link to more than one
   * job. Customers may handle these differently, but often different PMs are responsible for billing
   * only the subset of the SOV linked to a specific job, and the GC may receive one or multiple
   * invoices.
   */
  readonly importComboJobMethod: ImportIntegrationComboJobMethod
  /** Whether to import projects with the name defaulting to the job name or the contract name */
  readonly importProjectNameSource: ImportIntegrationProjectNameSource
  readonly integrations: ReadonlyArray<Integration>
  /** Optional label to differentiate this integration from others of the same type */
  readonly label: Maybe<Scalars['String']['output']>
  /** Returns the last operation group for updating job cost for this company integration */
  readonly lastUpdateJobCostOperationGroup: Maybe<UpdateJobCostOperationGroup>
  /** Indicates that this integration is specific to a company office. If null, it applies to all offices */
  readonly location: Maybe<Location>
  readonly longName: Scalars['String']['output']
  /** Integration specific metadata that applies across projects. Fields depend on the integration type. */
  readonly metadata: Scalars['JSONObject']['output']
  /**
   * Whether to revert pay apps to a DRAFT state when we detect that a Textura invoice is rejected by the GC.
   * Note that this does not affect the case where an invoice is rejected *and* the GC modifies the billing values,
   * in which case the pay app is not reverted (and billing is updated automatically).
   */
  readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Scalars['Boolean']['output']
  readonly shortName: Scalars['String']['output']
  /**
   * Whether to automatically import the SOV for projects when initially onboarded, if supported by
   * this integration type
   */
  readonly shouldImportNewProjectSov: Scalars['Boolean']['output']
  readonly type: IntegrationType
  readonly updatedAt: Scalars['DateTime']['output']
  /**
   * Number of active vendors that carry an integration mapping to this company integration.
   * Used by the vendor migration modals to warn before starting a migration that would move
   * nothing — e.g. when a company's vendors were never imported from the source integration.
   */
  readonly vendorCount: Scalars['SafeInt']['output']
}

/**
 * A lien waiver template set that a company can use as default primary or vendor lien waiver
 * forms on a new project
 */
export type CompanyLienWaiverTemplateSet = {
  readonly __typename: 'CompanyLienWaiverTemplateSet'
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly gc: Maybe<GeneralContractor>
  readonly id: Scalars['ID']['output']
  readonly lienWaivers: Maybe<SubcontractorLienWaiverTemplateSet>
  readonly name: Scalars['String']['output']
  readonly state: Maybe<Scalars['String']['output']>
  readonly type: CompanyLienWaiverTemplateSetType
  readonly updatedAt: Scalars['DateTime']['output']
}

export { CompanyLienWaiverTemplateSetType }

export { CompanyListSortCriteria }

/** Represents unstructured metadata about a given company. */
export type CompanyMetadata = {
  readonly __typename: 'CompanyMetadata'
  /** If true, restricts users from signing up unless their email is in the list of domains. */
  readonly domainSignup: Scalars['Boolean']['output']
  /** This is a list of email domains for a company, which restricts who can sign up by email. */
  readonly domains: ReadonlyArray<Scalars['String']['output']>
  /**
   * Represents what day of the month (up to 28) to remind users to create pay apps. If not set, the
   * email will go out on the 2nd Monday of the month by default.
   */
  readonly monthlyCreatePayAppReminderDate: Maybe<Scalars['Int']['output']>
  /** Represents the specialty subtrade of the contractor, if one exists. */
  readonly subtrade: Maybe<Scalars['String']['output']>
}

export type CompanyMetadataInput = {
  readonly domainSignup: Scalars['Boolean']['input']
  readonly domains: ReadonlyArray<Scalars['String']['input']>
  readonly monthlyCreatePayAppReminderDate?: InputMaybe<Scalars['Int']['input']>
  readonly subtrade?: InputMaybe<Scalars['String']['input']>
}

export { CompanyMfaRequirement }

/**
 * A set of form templates of a certain billing type that a company can use as the default pay app
 * form group for new projects
 */
export type CompanyPayAppFormTemplateSet = {
  readonly __typename: 'CompanyPayAppFormTemplateSet'
  readonly billingType: BillingType
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly gc: Maybe<GeneralContractor>
  readonly id: Scalars['ID']['output']
  readonly name: Scalars['String']['output']
  readonly payAppRequirementGroups: ReadonlyArray<PayAppRequirementGroup>
  readonly state: Maybe<Scalars['String']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Represents metadata around a company that is working on a given project. */
export type CompanyProjectMetadata = {
  readonly __typename: 'CompanyProjectMetadata'
  readonly company: Company
  /**
   * Used if the subcontractor uses a distinct name for the company on this project. If not set, company name
   * will always default to the name on the company model.
   */
  readonly companyName: Maybe<Scalars['String']['output']>
  readonly role: CompanyProjectRole
  readonly selectedAddress: Maybe<Location>
}

export type CompanyProjectMetadataInput = {
  readonly companyId: Scalars['ID']['input']
  readonly selectedAddressId: Scalars['ID']['input']
}

export { CompanyProjectRole }

export type CompanyTemplateUsage = {
  readonly __typename: 'CompanyTemplateUsage'
  readonly collections: ReadonlyArray<CompanyFormTemplateCollection>
  readonly payAppFormTemplateSets: ReadonlyArray<CompanyPayAppFormTemplateSet>
  readonly primaryLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  readonly subTierLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
  readonly vendorLienWaiverTemplateSets: ReadonlyArray<CompanyLienWaiverTemplateSet>
}

export { CompanyType }

/** Represents a user that exists at a company, along with their role. */
export type CompanyUser = {
  readonly __typename: 'CompanyUser'
  /**
   * Billing deadline (internal or accounting) for this user.
   *  - For project managers and field guests, this is internal (accounting).
   *  - For accountants and admins, this is external (GC).
   *  - For supervisors, it can be either.
   */
  readonly billingDeadline: DueToType
  readonly company: Company
  /** The user's office location. Must be one of the company's locations. */
  readonly companyLocation: Location
  /** Count of contracts this user has access to */
  readonly contractCount: Scalars['Int']['output']
  /** IDs of contracts this user has access to */
  readonly contractIds: ReadonlyArray<Scalars['ID']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  /** If provided, emails the user sends from this company will be sent from this email address */
  readonly emailAlias: Maybe<CompanyUserEmailAlias>
  /** Feature flags, if enabled for the user in this company */
  readonly featureFlags: ReadonlyArray<FeatureFlagName>
  readonly id: Scalars['ID']['output']
  readonly isSitelineAdmin: Scalars['Boolean']['output']
  /** Payment methods saved by this user for their company */
  readonly paymentMethods: ReadonlyArray<PaymentMethod>
  readonly permissions: ReadonlyArray<Permission>
  readonly role: CompanyUserRole
  readonly roleLimitedToOffices: ReadonlyArray<Location>
  readonly status: UserStatus
  readonly updatedAt: Scalars['DateTime']['output']
  readonly user: User
}

/**
 * Represents an email alias used by a user who belongs to multiple companies. Used when sending or
 * receiving emails under that company, while their primary email address is still used for login.
 */
export type CompanyUserEmailAlias = {
  readonly __typename: 'CompanyUserEmailAlias'
  readonly companyUser: CompanyUser
  readonly emailAddress: Scalars['EmailAddress']['output']
  readonly id: Scalars['ID']['output']
  readonly isVerified: Scalars['Boolean']['output']
  readonly verificationCodeExpiresAt: Scalars['DateTime']['output']
}

export type CompanyUserInput = {
  readonly billingDeadline: DueToType
  readonly contractIds: ReadonlyArray<Scalars['ID']['input']>
  readonly isSitelineAdmin: Scalars['Boolean']['input']
  readonly permissions: ReadonlyArray<Permission>
  readonly role: CompanyUserRole
  readonly user: UserInput
}

export { CompanyUserRole }

export { ComplianceStatus }

export type ComplianceUseData = {
  readonly __typename: 'ComplianceUseData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly percentProjectsWithComplianceRequirements: Scalars['Float']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

export type Contract = {
  readonly __typename: 'Contract'
  /**
   * Parent list of contacts for this contract, across all modules.
   * Note that this is not necessarily just GC contacts, because customers sometimes submit to insurance, owners, etc.
   * Whenever a customer adds a contact when submitting in any of the module, they are added to this list.
   * Our system never removes contacts from this list, it only adds to it. Customers must explicitly remove contacts from Billing settings.
   */
  readonly allContacts: ReadonlyArray<CompanyContact>
  /** Whether the project has any forms that are marked as not ready for manual stored material handling */
  readonly allFormsReadyForManualStoredMaterials: Scalars['Boolean']['output']
  /** Total amount outstanding on the contract, i.e. billed (and submitted) but unpaid */
  readonly amountOutstanding: Scalars['SafeInt']['output']
  /**
   * Whether taxes are applied to retention held/released.
   * Most ERPs apply tax on the current billed only (not deducting retention), so this is false by default.
   */
  readonly appliesTaxToRetention: Scalars['Boolean']['output']
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  /** Form templates that are associated with this contract */
  readonly associatedFormTemplates: ReadonlyArray<FormTemplateAssociatedContract>
  /** Rolling average number of days from pay app submission to paid, over the last 6 months */
  readonly averageDaysToPaid: Scalars['Float']['output']
  /** The forecast, or billing projection, for this contract */
  readonly billingForecast: Maybe<ContractBillingForecast>
  readonly billingType: BillingType
  readonly category: Maybe<ContractCategory>
  /**
   * Optional form templates to use for keeping track of change order logs.
   * If there is more than one, user will be asked to select one before generating the COR log.
   */
  readonly changeOrderLogTemplates: ReadonlyArray<FormTemplate>
  /**
   * Contains a default list of contacts to submit CORs to.
   * It is updated on each COR submission, and it is always a subset of `allContacts`.
   */
  readonly changeOrderRequestContacts: ReadonlyArray<CompanyContact>
  /** Templates to use for creating and submitting change order requests */
  readonly changeOrderRequestTemplates: ReadonlyArray<FormTemplate>
  /** List of change order requests for this contract. */
  readonly changeOrderRequests: ReadonlyArray<ChangeOrderRequest>
  /** Total amount collected on the contract to date */
  readonly collectedToDate: Scalars['SafeInt']['output']
  /** Internal team members CC'd on DUE_DATE_UPCOMING collections reminders on this contract */
  readonly collectionsDueSoonCcUsers: ReadonlyArray<User>
  /**
   * Recipients of DUE_DATE_UPCOMING collections reminders on this contract.
   * It is always a subset of `allContacts`. When empty, that reminder type is not sent.
   */
  readonly collectionsDueSoonContacts: ReadonlyArray<CompanyContact>
  /**
   * Team member DUE_DATE_UPCOMING collections reminders are sent on behalf of.
   * When null, that reminder type is not sent.
   */
  readonly collectionsDueSoonSender: Maybe<User>
  /**
   * Resolved email templates for each collections reminder type on this contract.
   * Custom company templates apply when CUSTOM_EMAIL_TEMPLATES is enabled.
   */
  readonly collectionsEmailTemplatePreviews: ReadonlyArray<CollectionsEmailTemplatePreview>
  /** Collections notification settings configured on this contract, plus their resolved values */
  readonly collectionsNotificationConfig: CollectionsNotificationConfig
  /** Internal team members CC'd on OVERDUE collections reminders on this contract */
  readonly collectionsOverdueCcUsers: ReadonlyArray<User>
  /**
   * Recipients of OVERDUE collections reminders on this contract.
   * It is always a subset of `allContacts`. When empty, that reminder type is not sent.
   */
  readonly collectionsOverdueContacts: ReadonlyArray<CompanyContact>
  /**
   * Team member OVERDUE collections reminders are sent on behalf of.
   * When null, that reminder type is not sent.
   */
  readonly collectionsOverdueSender: Maybe<User>
  /** Internal team members CC'd on SUBMISSION_ACKNOWLEDGEMENT collections reminders on this contract */
  readonly collectionsSubmissionAckCcUsers: ReadonlyArray<User>
  /**
   * Recipients of SUBMISSION_ACKNOWLEDGEMENT collections reminders on this contract.
   * It is always a subset of `allContacts`. When empty, that reminder type is not sent.
   */
  readonly collectionsSubmissionAckContacts: ReadonlyArray<CompanyContact>
  /**
   * Team member SUBMISSION_ACKNOWLEDGEMENT collections reminders are sent on behalf of.
   * When null, that reminder type is not sent.
   */
  readonly collectionsSubmissionAckSender: Maybe<User>
  readonly comments: ReadonlyArray<ContractComment>
  readonly company: Company
  readonly completedLienRightsKeyDates: ReadonlyArray<ContractLienRightsCompletedKeyDate>
  readonly completedLienRightsMilestones: ReadonlyArray<ContractLienRightsCompletedMilestone>
  readonly complianceStatus: Maybe<ComplianceStatus>
  /** Start date of the contract */
  readonly contractDate: Maybe<Scalars['DateTime']['output']>
  readonly contractNumber: Maybe<Scalars['String']['output']>
  /** Custom template variables, accessible in the `contract` key. Default to {}. */
  readonly contractTemplateVariables: Scalars['JSONObject']['output']
  /** Cost analysis derived from ERP or manually entered by user */
  readonly cost: Maybe<ContractCost>
  /** The county this project is located in, based on the project location */
  readonly county: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  /** Returns an active, i.e. unresumed, work stoppage if one exists */
  readonly currentWorkStoppage: Maybe<ContractWorkStoppage>
  /**
   * Represents the number of days before the pay app is due. Used to notify sub PMs to update their
   * invoice before the deadline.
   */
  readonly daysBeforePayAppDue: Scalars['Int']['output']
  /** Contains the last list of Users notified for requesting review on a COR or the COR log */
  readonly defaultChangeOrderRequestReviewContacts: ReadonlyArray<User>
  /** Team members who are notified when forms have been partially completed */
  readonly defaultFormsReviewContacts: ReadonlyArray<User>
  /** Contains the last list of User references that were notified that the invoice is ready for review */
  readonly defaultInvoiceReviewContacts: ReadonlyArray<User>
  /** Tracks what initial retention % to use on the first pay app. Range 0-1. */
  readonly defaultRetentionPercent: Maybe<Scalars['Float']['output']>
  /**
   * Default tax group to use for all new line items on this contract.
   * Tax groups can be later updated on individual line items.
   */
  readonly defaultTaxGroup: Maybe<TaxGroup>
  /**
   * Only set for contracts loaded `withDeleted`, which a few historical-record queries do
   * (e.g. lien rights mail sends still reference contracts that were deleted after the mail
   * was sent). Lets those views label the contract as deleted.
   */
  readonly deletedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * The billing end of the earliest pay app to be submitted on Siteline, or null if no pay apps are
   * submitted. Note that the earliest pay app may not be Pay App #1, since there may be pre-Siteline
   * billing. It's possible for this to be null but `hasStartedBilling` to be true (if there is
   * pre-Siteline billing but there are no pay apps or pre-Siteline pay apps), so this shouldn't be
   * used as a proxy for whether billing has started on a contract.
   */
  readonly earliestPayAppBillingEnd: Maybe<Scalars['DateTime']['output']>
  /**
   * If true, will automatically mark pay apps as paid when detected from integrations.
   * Default is true. This can be disabled in contract settings.
   */
  readonly enableAutoMarkAsPaidFromIntegrations: Scalars['Boolean']['output']
  readonly events: ReadonlyArray<ContractEvent>
  /** Files stored on the contract */
  readonly files: ReadonlyArray<StoredFile>
  /**
   * The billing end of Pay App #1, which may be a Siteline pay app or pre-Siteline pay app. Null
   * if no pay apps or the first pay app's date is not known.
   */
  readonly firstPayAppBillingEnd: Maybe<Scalars['DateTime']['output']>
  /** True if any pay apps are in draft and have progress or retention billing */
  readonly hasDraftPayAppBilling: Scalars['Boolean']['output']
  /** True if there is a past pay app count or any pay apps have been submitted on Siteline */
  readonly hasStartedBilling: Scalars['Boolean']['output']
  /**
   * If any of the pay app requirement forms on this contract are tagged with SWORN_STATEMENT,
   * regardless of whether they have finished processing, this will be true.
   */
  readonly hasSwornStatementForms: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /** Whether to generate the change order log as part of the pay app package for every pay app */
  readonly includeChangeOrderLogInPayAppPackage: Maybe<Scalars['Boolean']['output']>
  readonly integrations: ReadonlyArray<Integration>
  /** Internal project billing notes and reminders added by users on the project */
  readonly internalNotes: Maybe<Scalars['String']['output']>
  /**
   * Project number as defined by the subcontractor. This is the project number that customers use to
   * identify the project and it is rare for them to use `project.projectNumber`.
   */
  readonly internalProjectNumber: Maybe<Scalars['String']['output']>
  /** The total amount due across pay apps that have been submitted but not yet paid out */
  readonly invoiceAmountOutstanding: Scalars['SafeInt']['output']
  /** Whether progress billing on this contract has been manually marked as closed out */
  readonly isBillingClosedOut: Maybe<Scalars['Boolean']['output']>
  /**
   * Whether the subcontractor is receiving payment via joint check. Inferred from joint check settings
   * on the contract's vendor lien waivers.
   */
  readonly isJointCheck: Scalars['Boolean']['output']
  /** Defaults to the company's `defaultLienRightsTracking` setting */
  readonly isTrackingLienRights: Scalars['Boolean']['output']
  readonly lastEditedAt: Maybe<Scalars['DateTime']['output']>
  readonly lastEditedBy: Maybe<User>
  /** The latest total value of the contract, including change orders. Denormalized: maintained as the sum of its line items' latestTotalValue on every SOV change. */
  readonly latestTotalValue: Scalars['SafeInt']['output']
  readonly leadPMs: ReadonlyArray<User>
  /**
   * Contains a list of CompanyContact references that were emailed the legal documents for a
   * contract on the project.
   * It is updated on each compliance submission, and it is always a subset of `allContacts`.
   */
  readonly legalRequirementContacts: ReadonlyArray<CompanyContact>
  /** Contains a list of all Legal requirements for a contract on the project. */
  readonly legalRequirements: ReadonlyArray<LegalRequirement>
  readonly lienRightsEvents: ReadonlyArray<LienRightsContractEvent>
  /**
   * Returns the most recently used mail address for a contract if one exists. Otherwise, falls back to
   * the office primary office address.
   */
  readonly lienRightsMailAddress: Maybe<MailAddressWithName>
  /** The status of the contract's lien rights protection */
  readonly lienRightsStatus: ContractLienRightsStatus
  /** A summary of the contract's lien rights requirements, milestones, and deadlines */
  readonly lienRightsSummary: Maybe<ContractLienRightsSummary>
  /** Primary lien waiver templates */
  readonly lienWaiverTemplates: Maybe<SubcontractorLienWaiverTemplateSet>
  /**
   * The day of the month to use as thru date for all lien waiver requests on this project.
   * If undefined, will use the last day of the month. If defined, max date is 28.
   */
  readonly lienWaiverThroughDate: Maybe<Scalars['SafeInt']['output']>
  /** All lien waivers associated with this contract */
  readonly lienWaivers: ReadonlyArray<LienWaiver>
  /** The sum of amounts on all conditional lien waivers requested for this contract */
  readonly lowerTierConditionalAmountWaived: Scalars['SafeInt']['output']
  /** Vendor lien waiver templates */
  readonly lowerTierLienWaiverTemplates: Maybe<SubcontractorLienWaiverTemplateSet>
  /** The sum of amounts on all unconditional lien waivers requested for this contract */
  readonly lowerTierUnconditionalAmountWaived: Scalars['SafeInt']['output']
  /** Fields missing that are required to generate this contract's vendor lien waiver forms */
  readonly missingRequiredVendorLienWaiverFields: ReadonlyArray<RequiredFieldForForms>
  /** The next incomplete lien rights milestone on the contract */
  readonly nextLienRightsMilestone: Maybe<ContractLienRightsMilestone>
  /** Tracks the status of onboarding legal requirements for a project from the Compliance module */
  readonly onboardedProjectComplianceStatus: OnboardedProjectComplianceStatus
  /** Tracks the status of onboarding vendors/lien waivers for a project from the Vendor module */
  readonly onboardedProjectVendorsStatus: OnboardedProjectVendorsStatus
  /** Tracks the status of the onboarding steps for a new contract. */
  readonly onboardedStatus: OnboardedProjectContractStatus
  /** Skipped pay app months, including reasons for not billing */
  readonly optedOutMonths: ReadonlyArray<ContractOptedOutMonth>
  /** The original total value of the contract, excluding change orders. Denormalized: maintained as the sum of its non-change-order line items' latestTotalValue on every SOV change. */
  readonly originalTotalValue: Scalars['SafeInt']['output']
  /**
   * The contract's outstanding balance: like `invoiceAmountOutstanding`, but only counting pay apps
   * whose aging has started, so billed-but-not-yet-aging amounts are excluded. Matches the customers
   * page outstanding totals.
   */
  readonly outstandingBalance: Scalars['SafeInt']['output']
  /**
   * The total amount requested across conditional vendor lien waivers on this contract minus the total
   * amount requested in unconditional vendor lien waivers on this contract
   */
  readonly outstandingVendorLienWaiverAmount: Scalars['SafeInt']['output']
  /**
   * If a project is onboarded midway through, this number indicates how many pay apps have
   * already been processed. i.e. If the project has 6 completed pay apps and will start using
   * Siteline on its 7th pay app, this number will be set to 6. For new projects, the number is
   * left as null. For new projects, this number is set to 0.
   */
  readonly pastPayAppCount: Scalars['Int']['output']
  /**
   * Per-project override of the company's pay app balance auto-close threshold (in cents). When a
   * pay app is paid slightly short, any remaining balance at or under this amount is automatically
   * marked as closed. Null inherits the company-level default. Only administrators can change this.
   */
  readonly payAppBalanceAutoCloseThresholdCents: Maybe<Scalars['SafeInt']['output']>
  /**
   * Contains a default list of contacts to cc on the pay app.
   * It is updated on each pay app submission, and it is always a subset of `allContacts`.
   */
  readonly payAppCcContacts: ReadonlyArray<CompanyContact>
  /**
   * Default email address used as the reply-to for pay app submission emails.
   * If null, the submitting user's email is used. Updated automatically on each submission.
   */
  readonly payAppDefaultReplyToEmail: Maybe<Scalars['EmailAddress']['output']>
  /** Contains a list of all PayApp requirements for a contract on the project. */
  readonly payAppRequirementGroups: ReadonlyArray<PayAppRequirementGroup>
  /**
   * Contains a default list of contacts to submit pay apps to.
   * It is updated on each pay app submission, and it is always a subset of `allContacts`.
   */
  readonly payAppSubmitToContacts: ReadonlyArray<CompanyContact>
  readonly payApps: ReadonlyArray<PayApp>
  /**
   * The number of days corresponding to the type of payment terms. If `paymentTermsType` is:
   * - NetPayment, then this is the contractual number of days to be paid (i.e. if NET30, this is 30)
   * - PayWhenPaid, then this is the expected number of days to receive payment
   */
  readonly paymentTerms: Maybe<Scalars['SafeInt']['output']>
  readonly paymentTermsType: Maybe<ContractPaymentTermsType>
  /**
   * The percent complete for this contract. Will return null if billingType is equal to QUICK.
   * Range 0-1.
   */
  readonly percentComplete: Maybe<Scalars['Float']['output']>
  /**
   * Amount billed pre-siteline.
   * This is only for T&M contracts. Other contracts must use the SOV to indicate pre-siteline billed.
   */
  readonly preSitelineBilled: Maybe<Scalars['SafeInt']['output']>
  readonly preSitelinePayApps: ReadonlyArray<PreSitelinePayApp>
  /**
   * Pre-siteline retention override amount in cents.
   * This is required for standard/line-item tracking.
   */
  readonly preSitelineRetentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  /** Primary lien waivers for a contract. */
  readonly primaryLienWaivers: ReadonlyArray<LienWaiver>
  /** The amount billed in progress to date for this contract, but not yet paid out */
  readonly progressAmountOutstanding: Scalars['SafeInt']['output']
  /**
   * Progress remaining to bill after the last submitted pay app. If no pay apps are submitted,
   * this is the progress remaining after any pre-Siteline progress completed.
   */
  readonly progressRemaining: Scalars['SafeInt']['output']
  readonly project: Project
  /**
   * For T&M contracts, the rate table to use when creating new pay apps. For lump sum and unit price
   * contracts, the rate table to use for pricing change order requests.
   */
  readonly rateTable: Maybe<RateTable>
  /** Default tax group to use for all rate table groups that don't have a `rateTableTaxGroup` override. */
  readonly rateTableDefaultTaxGroup: Maybe<TaxGroup>
  /**
   * Contract-level fees that apply to the current rate table.
   * These are copied when creating a new pay app or pricing a new change order request.
   * Warning: this includes *all* fees, including group fees.
   */
  readonly rateTableFees: ReadonlyArray<ContractRateTableFee>
  /**
   * Tax calculation type for rate table groups on T&M contracts, or for the COR pricing tool.
   * As opposed to `taxCalculationType`, this field only applies to rate table groups and does not
   * affect SOV line items or quick bills.
   */
  readonly rateTableTaxCalculationType: TaxCalculationType
  /**
   * Contract-level tax groups that apply to a specific rate table group, overriding the default tax group.
   * These are copied when creating a new pay app or pricing a new change order request.
   */
  readonly rateTableTaxGroups: ReadonlyArray<ContractRateTableTaxGroup>
  /** Attachments that should be copied to pay apps as backup when they're created */
  readonly recurringPayAppAttachments: ReadonlyArray<ContractPayAppAttachment>
  /** The amount billed in retention to date for this contract, but not yet paid out */
  readonly retentionAmountOutstanding: Scalars['SafeInt']['output']
  /** Total amount of retention held on the SOV to date, derived only from submitted pay apps */
  readonly retentionHeldOnBilledPayApps: Scalars['SafeInt']['output']
  /** Denormalized retention held pre-siteline for this contract. */
  readonly retentionHeldPreSiteline: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldPreSiteline. */
  readonly retentionHeldPreSitelinePercent: Scalars['Float']['output']
  /** Tax on retentionHeldPreSiteline. */
  readonly retentionHeldPreSitelineTax: Scalars['SafeInt']['output']
  /** Total amount of retention held on the SOV to date, from all pay apps including draft */
  readonly retentionHeldTotal: Scalars['SafeInt']['output']
  /** Track retention at the pay app level instead of at the line item progress level */
  readonly retentionTrackingLevel: RetentionTrackingLevel
  readonly role: CompanyProjectRole
  /** Whether to round all retention values for each line item to the nearest dollar. */
  readonly roundRetention: Scalars['Boolean']['output']
  /** One of the addresses on the subcontractor */
  readonly selectedAddress: Location
  /** Whether signed packages generated from this contract should contain an audit page */
  readonly showAuditItemOnSignedPackages: Scalars['Boolean']['output']
  /** A list of months in MM-YYYY format for months that are not being billed for. */
  readonly skippedPayAppMonths: ReadonlyArray<Scalars['String']['output']>
  /** Project 'snapshot' data for this contract, including a project health score */
  readonly snapshot: ContractSnapshot
  /** Not provided if billingType is QUICK */
  readonly sov: Maybe<Sov>
  /** The state this project is located in, based on the project location */
  readonly state: Scalars['String']['output']
  readonly status: ContractStatus
  /** Contract level setting for stored materials handling. This overrides company settings */
  readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
  /** Sub-tier lien waiver templates */
  readonly subTierLienWaiverTemplates: Maybe<SubcontractorLienWaiverTemplateSet>
  /**
   * Tax calculation type for line items on Lump-Sum, Unit-price, or Quick bill contracts.
   * As opposed to `rateTableTaxCalculationType`, this field only applies to SOV line items or Quick bills,
   * and it does not affect the pricing tool or T&M contracts.
   */
  readonly taxCalculationType: TaxCalculationType
  readonly timeZone: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  /** List of all users who are working on this contract */
  readonly users: ReadonlyArray<ContractUser>
  readonly vendorContracts: ReadonlyArray<VendorContract>
  /** All vendor invoice import operations for this contract. Global imports are not included. */
  readonly vendorInvoiceImportOperations: ReadonlyArray<VendorInvoiceImportOperation>
  /** Vendor number for this contract, as defined by the General Contractor */
  readonly vendorNumber: Maybe<Scalars['String']['output']>
  /**
   * List of GC recipients who will receive vendor materials, e.g., lien waivers & legal docs
   *  It is updated on each vendor document submission, and it is always a subset of `allContacts`.
   */
  readonly vendorSubmitToContacts: ReadonlyArray<CompanyContact>
  /**
   * Internal project vendors module ('lower tier') bulletin board. Notes and reminders are added
   * here by users on the project.
   */
  readonly vendorsInternalNotes: Maybe<Scalars['String']['output']>
  /** Record of work stoppages on the project, used primarily in lien rights tracking */
  readonly workStoppages: ReadonlyArray<ContractWorkStoppage>
}

export type ContractPayAppsArgs = {
  months?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
}

export type ContractBilledPerTaxGroup = {
  readonly __typename: 'ContractBilledPerTaxGroup'
  readonly contract: Contract
  readonly scheduledValue: Scalars['SafeInt']['output']
  readonly state: Scalars['String']['output']
  readonly taxAmountThisPeriod: Scalars['SafeInt']['output']
  readonly taxGroup: TaxGroup
}

/** A billing projection over a series of months for a single contract */
export type ContractBillingForecast = {
  readonly __typename: 'ContractBillingForecast'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * The curve used to generate the projection amounts. If the user edits the amounts after
   * generating the curve, it will be saved as a CUSTOM curve.
   */
  readonly curve: ForecastCurve
  /**
   * The first month that was editable when the forecast was created. This is used for clients to
   * determine when the user started projecting monthly values, as opposed to values that shouldn't be
   * included in the projection because they weren't editable at the time of creation (those values
   * may still be included as zeroes in `projectedAmountPerMonth` because the total forecast starts
   * at the contract's first billing month. Note that this may not be the same as the `createdAt`
   * month, since current or future pay apps could have been submitted already when the forecast was
   * created.
   */
  readonly firstEditableMonthWhenCreated: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lastEditedBy: User
  /**
   * The projected billing amounts for each month. Each element in the array corresponds to a
   * consecutive month, starting with `startingMonth`.
   */
  readonly projectedAmountPerMonth: ReadonlyArray<Scalars['SafeInt']['output']>
  /**
   * The first month to include in the forecast. The first element in the `amountsProjected` array
   * corresponds to this month.
   */
  readonly startingMonth: Scalars['DateTime']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export { ContractCategory }

/**
 * Deprecated. Superseded by the multi-level CollectionsNotificationSetting model. Retained for
 * pre-deploy web clients; maps contract-level settings and their resolved recipients/templates.
 */
export type ContractCollectionsNotification = {
  readonly __typename: 'ContractCollectionsNotification'
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly bodyTemplate: Scalars['String']['output']
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly gcContacts: ReadonlyArray<CompanyContact>
  readonly id: Scalars['ID']['output']
  readonly internalCcRecipients: ReadonlyArray<User>
  readonly intervalAmount: Scalars['SafeInt']['output']
  readonly intervalAnchor: CollectionsNotificationAnchor
  readonly intervalGranularity: CollectionsNotificationGranularity
  readonly intervalModifier: CollectionsNotificationModifier
  readonly lastEditedBy: Maybe<User>
  readonly payAppNotifications: ReadonlyArray<PayAppCollectionsNotification>
  /** The contract's per-type sender, falling back to the setting's last editor */
  readonly sender: User
  readonly subjectTemplate: Scalars['String']['output']
  readonly type: CollectionsNotificationType
  readonly updatedAt: Scalars['DateTime']['output']
}

export type ContractComment = {
  readonly __typename: 'ContractComment'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly message: Scalars['String']['output']
  readonly type: ContractCommentType
  readonly user: User
}

export { ContractCommentType }

/**
 * Cost analysis for a single contract.
 * Can be read from ERP or manually entered.
 */
export type ContractCost = {
  readonly __typename: 'ContractCost'
  readonly additionalCommittedCost: Scalars['SafeInt']['output']
  readonly billingsInExcessOfCost: Scalars['SafeInt']['output']
  readonly contract: Contract
  readonly contractTotalBilled: Scalars['SafeInt']['output']
  readonly contractTotalValue: Scalars['SafeInt']['output']
  readonly costToDate: Scalars['SafeInt']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly earnedRevenue: Scalars['SafeInt']['output']
  readonly id: Scalars['ID']['output']
  readonly manuallyUpdatedBy: Maybe<User>
  readonly totalEstimatedCost: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly updatedFromIntegrationType: Maybe<IntegrationType>
}

export type ContractEvent = {
  readonly __typename: 'ContractEvent'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly id: Scalars['ID']['output']
  readonly isAdmin: Scalars['Boolean']['output']
  readonly metadata: Scalars['JSONObject']['output']
  readonly type: ContractEventType
}

export { ContractEventType }

/**
 * Project lifecycle dates that may be required as part of lien rights tracking. They
 * are typically entered only if needed based on the state's lien rights laws.
 */
export type ContractLienRightsCompletedKeyDate = {
  readonly __typename: 'ContractLienRightsCompletedKeyDate'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly date: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly type: LienRightsKeyDateType
  readonly updatedAt: Scalars['DateTime']['output']
}

/**
 * A completed milestone in a contract's lien rights lifecycle. This generally corresponds
 * to the filing of a certain document by the subcontractor, but may also be an action
 * taken by the owner (e.g. a notice filed).
 */
export type ContractLienRightsCompletedMilestone = {
  readonly __typename: 'ContractLienRightsCompletedMilestone'
  /** The amount of the milestone, if applicable */
  readonly amount: Maybe<Scalars['SafeInt']['output']>
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /** The date corresponding to the milestone, usually a filing date */
  readonly date: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /**
   * If the type is OWNER_NOTICE_FILED, this is a reference to the corresponding
   * state requirement, which will have information on the type of notice and
   * consequences of filing.
   */
  readonly noticeRequirement: Maybe<LienDeadlineNoticeRequirement>
  /**
   * If the type is PRE_LIEN_FILED and the pre-lien requirement is monthly, this is a
   * reference to the pay app or pre-siteline pay app that the pre-lien is based on
   */
  readonly payApp: Maybe<PayApp>
  readonly preSitelinePayApp: Maybe<PreSitelinePayApp>
  readonly type: LienRightsMilestoneType
  readonly updatedAt: Scalars['DateTime']['output']
  /** A file relevant to the milestone, usually the document filed */
  readonly uploadedFile: Maybe<StoredFile>
}

/**
 * A key date that is required for a contract based on its state's lien rights requirements.
 * The date will be provided if already completed, or empty if still unknown.
 */
export type ContractLienRightsKeyDate = {
  readonly __typename: 'ContractLienRightsKeyDate'
  /** The id of the completed key date record when date is set; used for reverting. */
  readonly completedKeyDate: Maybe<ContractLienRightsCompletedKeyDate>
  readonly date: Maybe<Scalars['DateTime']['output']>
  readonly type: LienRightsKeyDateType
}

/**
 * A milestone in the lien rights lifecycle that will be required for this contract
 * based on its state's lien rights requirements. The milestone may already be completed,
 * or may have a known or unknown deadline in the future.
 */
export type ContractLienRightsMilestone = {
  readonly __typename: 'ContractLienRightsMilestone'
  /** Additional context or details on this milestone's requirements */
  readonly additionalNotes: Maybe<Scalars['String']['output']>
  /**
   * If this milestone is dependent on other milestones, for example:
   * - A notice of commencement filing milestone, if this is a preliminary notice contingent on that notice
   * - An owner notice filing milestone, if this is a pre-lien, lien, or enforcement deadline that is shortened
   *   by the filing of that notice
   */
  readonly affectedByMilestone: Maybe<ContractLienRightsCompletedMilestone>
  /** If the milestone has already been completed, this is a reference to the completed milestone */
  readonly completedByMilestone: Maybe<ContractLienRightsCompletedMilestone>
  /**
   * If this deadline is contingent on the filing of another notice (e.g. for prelims), this is
   * the name of that notice. (If it has been filed, there will be a completed milestone provided
   * under `completedByMilestone`.)
   */
  readonly contingentOnNotice: Maybe<Scalars['String']['output']>
  /**
   * The actual deadline for this contract, if known based on key dates. This is calculated based
   * on the deadline interval, granularity, modifier, and anchor, where the anchor corresponds to
   * a completed key date. There may be an exception if a notice was filed and the deadline was
   * adjusted based on a `LienDeadlineNoticeRequirementNewDeadline`.
   */
  readonly contractDeadline: Maybe<Scalars['DateTime']['output']>
  readonly deadlineAnchor: Maybe<LienRightsDeadlineAnchor>
  readonly deadlineGranularity: Maybe<LienRightsDeadlineGranularity>
  /**
   * A description of the canonical deadline, in reference to an anchor date. A deadline
   * should exist for all milestones except of type PRELIMINARY_NOTICE_CONTINGENT_NOTICE_FILED
   * and OWNER_NOTICE_FILED, which are included only if they are completed milestones.
   */
  readonly deadlineInterval: Maybe<Scalars['SafeInt']['output']>
  readonly deadlineModifier: Maybe<LienRightsDeadlineModifier>
  readonly lateDeadlineGranularity: Maybe<LienRightsDeadlineGranularity>
  /**
   * If late filing is allowed, this is the amount of time relative to filing that the filer is protected.
   *  Late filing only applies to preliminary notice deadlines.
   */
  readonly lateDeadlineInterval: Maybe<Scalars['SafeInt']['output']>
  readonly lateDeadlineModifier: Maybe<LienRightsDeadlineModifier>
  /** If the milestone has metadata, this is a reference to the metadata - for example, generated forms */
  readonly metadata: Maybe<ContractLienRightsMilestoneMetadata>
  /** The name of the document required. Customizable only for some milestone types. */
  readonly name: Maybe<Scalars['String']['output']>
  /** If the milestone is a monthly pre-lien, it is based on either a pay app or pre-siteline pay app */
  readonly payApp: Maybe<PayApp>
  /**
   * Any shortened deadlines due to owner notice that may affect this deadline. This will be the complete
   * list based on state requirements, regardless of whether any notices have actually been filed.
   */
  readonly possibleDeadlineExceptions: ReadonlyArray<LienDeadlineNoticeRequirementNewDeadline>
  readonly preSitelinePayApp: Maybe<PreSitelinePayApp>
  /**
   * The requirement type for this milestone. Note that this is only a reflection of the canonical state law for
   * this milestone, NOT whether or not this specific milestone is required based on project status or aging pay apps.
   */
  readonly requirementType: LienMilestoneRequirementType
  readonly type: LienRightsMilestoneType
}

/**
 * This allows us to track additional fields on a milestone before it is completed. Notably,
 * if a form was generated in Siteline that needs to be tied to the milestone, we can hold
 * the form information here. Some of these fields are repeats from ContractLienRightsCompletedMilestone.
 * These are fields that we use to tie the correct stored metadata to the computed milestone.
 */
export type ContractLienRightsMilestoneMetadata = {
  readonly __typename: 'ContractLienRightsMilestoneMetadata'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /** Form template variant that is used to generate the document. Can be null if document was filed outside of Siteline. */
  readonly formTemplateVariant: Maybe<FormTemplateVariant>
  /** Form template version that is used to generate the document. Can be null if document was filed outside of Siteline. */
  readonly formTemplateVersion: Maybe<FormTemplateVersion>
  /** A list of all user-entered values for the form on the milestone */
  readonly formValues: ReadonlyArray<FormTemplateAnnotationValue>
  readonly id: Scalars['ID']['output']
  /** Mail order for sending this milestone document via USPS, if one exists. */
  readonly mailOrder: Maybe<MailOrder>
  /**
   * If the type is OWNER_NOTICE_FILED, this is a reference to the corresponding
   * state requirement, which will have information on the type of notice and
   * consequences of filing.
   */
  readonly noticeRequirement: Maybe<LienDeadlineNoticeRequirement>
  /**
   * If the type is PRE_LIEN_FILED and the pre-lien requirement is monthly, this is a
   * reference to the pay app or pre-siteline pay app that the pre-lien is based on
   */
  readonly payApp: Maybe<PayApp>
  /** Includes information about the physical signatures required on this milestone document (if generated in Siteline). */
  readonly physicalSignatureRequired: PhysicalSignatureRequired
  readonly preSitelinePayApp: Maybe<PreSitelinePayApp>
  /**
   * Name of the project this milestone belongs to. Computed rather than read through
   * `contract.project` so it still resolves once the contract or project has been deleted:
   * mail that was already sent must stay visible in the lien rights export.
   */
  readonly projectName: Scalars['String']['output']
  /** Project number, preferring the contract's internal project number when it's set. */
  readonly projectNumber: Scalars['String']['output']
  readonly signature: Maybe<Signature>
  readonly type: LienRightsMilestoneType
  readonly updatedAt: Scalars['DateTime']['output']
  /** If provided, we'll use this file instead of generating it on the fly (e.g. notarized forms) */
  readonly uploadedFile: Maybe<StoredFile>
}

export { ContractLienRightsStatus }

/**
 * A summary of lien rights requirements for a specific contract, based on the
 * state's lien requirements
 */
export type ContractLienRightsSummary = {
  readonly __typename: 'ContractLienRightsSummary'
  /** All key dates referenced by state lien requirements, whether known or not */
  readonly keyDates: ReadonlyArray<ContractLienRightsKeyDate>
  /** All milestones referenced by state lien requirements, whether completed or not */
  readonly milestones: ReadonlyArray<ContractLienRightsMilestone>
  /** The canonical lien requirements for this contract's state */
  readonly requirementsSummary: StateLienRequirementsSummary
}

export { ContractListBillingClosedOutFilter }

export { ContractListContractStatusFilter }

export { ContractListNextLienRightsMilestoneFilter }

export type ContractListOverview = {
  readonly __typename: 'ContractListOverview'
  readonly activeCount: Scalars['Int']['output']
  readonly archivedCount: Scalars['Int']['output']
  readonly fullyBilledCount: Scalars['Int']['output']
  readonly onboardingCount: Scalars['Int']['output']
}

export { ContractListPayAppStatusFilter }

export { ContractListSortCriteria }

export { ContractListSubmitViaFilter }

export type ContractMismatchReportOperation = {
  readonly __typename: 'ContractMismatchReportOperation'
  readonly company: Company
  readonly contract: Contract
  readonly contractMismatchReportOperationGroup: Maybe<ContractMismatchReportOperationGroup>
  readonly createdAt: Scalars['DateTime']['output']
  /** There can be one error per integration */
  readonly errors: ReadonlyArray<Scalars['String']['output']>
  /** Maps to a group, similar to the bulk import group */
  readonly groupId: Scalars['ID']['output']
  readonly id: Scalars['ID']['output']
  /** Report is null if the operation has not completed */
  readonly report: Maybe<Scalars['JSONObject']['output']>
  /** Timestamp when the report was completed and saved. This is used to prevent multiple emails from being sent. */
  readonly reportCompletedAt: Maybe<Scalars['DateTime']['output']>
  /** The user who requested this operation. Null if queued by cron job. */
  readonly requestedBy: Maybe<User>
  readonly status: ContractMismatchReportOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

export type ContractMismatchReportOperationGroup = {
  readonly __typename: 'ContractMismatchReportOperationGroup'
  readonly company: Company
  /** Timestamp of the earliest operation in this group. */
  readonly firstOperationCreatedAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lastOperationCompletedId: Maybe<Scalars['ID']['output']>
  /** Timestamp of the most recently updated operation in this group. */
  readonly mostRecentOperationUpdatedAt: Scalars['DateTime']['output']
  readonly numFailed: Scalars['SafeInt']['output']
  readonly numSuccessful: Scalars['SafeInt']['output']
  /** The user who requested this report. Null if queued by cron job. */
  readonly requestedBy: Maybe<User>
  readonly status: ContractMismatchReportOperationGroupStatus
  readonly totalOperations: Scalars['SafeInt']['output']
}

export { ContractMismatchReportOperationGroupStatus }

export { ContractMismatchReportOperationStatus }

export { ContractMonthlyStatusFilter }

export type ContractOptedOutMonth = {
  readonly __typename: 'ContractOptedOutMonth'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** Month in MM-YYYY format that is not being billed for */
  readonly month: Scalars['String']['output']
  readonly reason: Maybe<Scalars['String']['output']>
  /** The user who opted out of billing for the month */
  readonly user: Maybe<User>
}

/** Represents an attachment that will be copied as backup on every pay app created on a contract */
export type ContractPayAppAttachment = {
  readonly __typename: 'ContractPayAppAttachment'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Maybe<Scalars['String']['output']>
  readonly file: StoredFile
  readonly id: Scalars['ID']['output']
  readonly isEmailAttachment: Scalars['Boolean']['output']
  readonly isInternalOnly: Scalars['Boolean']['output']
  readonly name: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type ContractPaymentPeriod = {
  readonly __typename: 'ContractPaymentPeriod'
  readonly dateRange: Maybe<PaymentPeriodDateRange>
  readonly hasRetentionOnlyPayApps: Scalars['Boolean']['output']
  readonly payApps: ReadonlyArray<PayApp>
  readonly predictedPaymentAmount: Scalars['SafeInt']['output']
}

export { ContractPaymentTermsType }

export type ContractRateTableFee = {
  readonly __typename: 'ContractRateTableFee'
  readonly contract: Contract
  /** The name of the fee, e.g. Overhead, Markup, Profit */
  readonly description: Scalars['String']['output']
  /** If provided, this fee applies to a specific group */
  readonly group: Maybe<RateTableGroup>
  readonly id: Scalars['ID']['output']
  /** If provided, this fee overrides another fee at the contract (global) level. It must be a group fee in this case. */
  readonly overridesFee: Maybe<ContractRateTableFee>
  /** This fee is added to the amount billed on a line item */
  readonly percent: Scalars['Float']['output']
}

export type ContractRateTableTaxGroup = {
  readonly __typename: 'ContractRateTableTaxGroup'
  readonly contract: Contract
  readonly id: Scalars['ID']['output']
  readonly rateTableGroup: RateTableGroup
  readonly taxGroup: TaxGroup
}

export type ContractSnapshot = {
  readonly __typename: 'ContractSnapshot'
  /** Equivalent to `ContractCost.billingsInExcessOfCost` */
  readonly billingsInExcessOfCost: Maybe<Scalars['SafeInt']['output']>
  /**
   * collectedToDate - costToDate. Also called "cash position".
   * When positive, cash position is positive
   * When negative, cash position is negative
   */
  readonly collectedInExcessOfCost: Maybe<Scalars['SafeInt']['output']>
  /** Equivalent to `Contract.collectedToDate` */
  readonly collectedToDate: Scalars['SafeInt']['output']
  /** Equivalent to `ContractCost.contractTotalBilled`. Null if no cost data. */
  readonly contractTotalBilled: Maybe<Scalars['SafeInt']['output']>
  /** Equivalent to `ContractCost.contractTotalValue`. Null if no cost data. */
  readonly contractTotalValue: Maybe<Scalars['SafeInt']['output']>
  /** Equivalent to `ContractCost.costToDate` */
  readonly costToDate: Maybe<Scalars['SafeInt']['output']>
  /** Equivalent to `ContractCost.totalEstimatedCost` */
  readonly currentBudget: Maybe<Scalars['SafeInt']['output']>
  /** contractTotalBilled - costToDate. Null if no cost data. */
  readonly currentGrossProfit: Maybe<Scalars['SafeInt']['output']>
  /** Equivalent to `ContractCost.earnedRevenue`. Null if no cost data. */
  readonly earnedRevenue: Maybe<Scalars['SafeInt']['output']>
  /** If any pay apps are past due, this is the due date of the most recently due pay app */
  readonly latestPastDuePayAppDueDate: Maybe<Scalars['DateTime']['output']>
  /** Max days since created for CORs that are not yet submitted */
  readonly maxChangeOrderRequestDaysSinceCreation: Maybe<Scalars['SafeInt']['output']>
  /** Max days since submission for CORs that are not yet approved */
  readonly maxChangeOrderRequestDaysSinceSubmitted: Maybe<Scalars['SafeInt']['output']>
  /** Max days overdue across pay apps with an open balance */
  readonly maxDaysNonRetentionPayAppsPaymentOverdue: Maybe<Scalars['SafeInt']['output']>
  /** An individual score based on `maxDaysNonRetentionPayAppsPaymentOverdue`, or outstanding collections */
  readonly outstandingCollectionsScore: Maybe<ContractSnapshotScore>
  /** An individual score based on`billingsInExcessOfCost`, or over/under billing */
  readonly overUnderBillingScore: Maybe<ContractSnapshotScore>
  /** contractTotalValue - currentBudget. Null if no cost data. */
  readonly projectedGrossProfit: Maybe<Scalars['SafeInt']['output']>
  /** A score representing the health of the project. Null if no cost data or payment terms. */
  readonly score: Maybe<ContractSnapshotScore>
  /** Total amount of CORs that are submitted but not approved */
  readonly unapprovedChangeOrderRequestAmount: Maybe<Scalars['SafeInt']['output']>
  /** An individual score based on `maxChangeOrderRequestDaysSinceSubmitted`, or unapproved change orders */
  readonly unapprovedChangeOrdersScore: Maybe<ContractSnapshotScore>
  /** An individual score based on `maxChangeOrderRequestDaysSinceCreation`, or unsubmitted change orders */
  readonly unsubmittedChangeOrdersScore: Maybe<ContractSnapshotScore>
}

export { ContractSnapshotScore }

export { ContractStatus }

/** Users who are members of the provided contract */
export type ContractUser = {
  readonly __typename: 'ContractUser'
  readonly contract: Contract
  readonly id: Scalars['ID']['output']
  readonly role: ContractUserRole
  readonly user: User
}

export { ContractUserRole }

export type ContractWorkStoppage = {
  readonly __typename: 'ContractWorkStoppage'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** An optional reason for the work stoppage */
  readonly reason: Maybe<Scalars['String']['output']>
  /** If the stoppage has ended, the date work resumed */
  readonly resumedAt: Maybe<Scalars['DateTime']['output']>
  /** Date of work stoppage */
  readonly stoppedAt: Scalars['DateTime']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type ContractsByIdInput = {
  readonly contractIds: ReadonlyArray<Scalars['ID']['input']>
}

export type ConvertRetentionTrackingLevelInput = {
  readonly contractId: Scalars['ID']['input']
  readonly retentionTrackingLevel: RetentionTrackingLevel
}

export type CostCodeReport = {
  readonly __typename: 'CostCodeReport'
  readonly billedByCostCodeAndJobAllTime: ReadonlyArray<BillingByCostCodeAndJob>
  readonly billedByCostCodeAndJobThisMonth: ReadonlyArray<BillingByCostCodeAndJob>
  readonly billedPerCostCode: ReadonlyArray<BilledPerCostCode>
  readonly costCodeSummary: BillingDashboardSummary
}

export type CreateCompanyContactInput = {
  readonly companyId: Scalars['ID']['input']
  readonly companyName: Scalars['String']['input']
  readonly email: Scalars['EmailAddress']['input']
  readonly fullName: Scalars['String']['input']
}

export type CreateCompanyFormTemplateCollectionInput = {
  readonly billingType: BillingType
  readonly changeOrderLogVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly changeOrderRequestVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly companyId: Scalars['ID']['input']
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly name: Scalars['String']['input']
  readonly payAppTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly primaryLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly subTierLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly vendorLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
}

export type CreateFeatureFlagInput = {
  readonly description: Scalars['String']['input']
  readonly name: FeatureFlagName
}

export type CreateFormAnnotationInput = {
  readonly annotation: FormAnnotationInput
  /** The form template version on which this annotation is being created */
  readonly formTemplateVersionId: Scalars['ID']['input']
}

export type CreateFormAnnotationsInput = {
  readonly annotations: ReadonlyArray<FormAnnotationInput>
  readonly formTemplateVersionId: Scalars['ID']['input']
}

export type CreateFormTemplateInput = {
  readonly type: FormTemplateType
  readonly userVisibleName: Scalars['String']['input']
}

export type CreateFormTemplateVersionInput = {
  readonly file: Scalars['Upload']['input']
  readonly formTemplateId: Scalars['ID']['input']
}

export type CreateLienWaiverFormTemplateSetInput = {
  readonly companyId: Scalars['ID']['input']
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly lienWaivers: SubcontractorLienWaiverTemplateSetInput
  readonly name: Scalars['String']['input']
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly type: CompanyLienWaiverTemplateSetType
}

export type CreateLocationInput = {
  readonly companyId: Scalars['ID']['input']
  readonly location: LocationInput
}

/** Response from creating a mail order, including payment details when payment is required */
export type CreateMailOrderResponse = {
  readonly __typename: 'CreateMailOrderResponse'
  readonly mailOrder: MailOrder
  /** Stripe client secret for PaymentIntent confirmation */
  readonly stripePaymentIntentClientSecret: Maybe<Scalars['String']['output']>
}

export type CreatePayAppFormTemplateSetInput = {
  readonly billingType: BillingType
  readonly companyId: Scalars['ID']['input']
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly name: Scalars['String']['input']
  readonly requirementGroups: ReadonlyArray<UpdatePayAppRequirementGroupInput>
  readonly state?: InputMaybe<Scalars['String']['input']>
}

export type CreateSovLineItemGroupInput = {
  readonly contractId: Scalars['ID']['input']
  readonly groupCode?: InputMaybe<Scalars['String']['input']>
  readonly groupName: Scalars['String']['input']
}

export type CreateTemplateVariantInput = {
  readonly formTemplateId: Scalars['ID']['input']
  readonly internalName: Scalars['String']['input']
  readonly userVisibleName?: InputMaybe<Scalars['String']['input']>
}

export type CreateTestTemplateInput = {
  readonly file: Scalars['Upload']['input']
}

export type CreateUserEducationCampaignInput = {
  readonly anchorSelector?: InputMaybe<Scalars['String']['input']>
  readonly buttonLabel?: InputMaybe<Scalars['String']['input']>
  readonly buttonLink?: InputMaybe<Scalars['String']['input']>
  readonly endDate: Scalars['DateTime']['input']
  readonly includeNewTag: Scalars['Boolean']['input']
  readonly message: Scalars['String']['input']
  readonly name: Scalars['String']['input']
  readonly startDate: Scalars['DateTime']['input']
  readonly targetPermissions: ReadonlyArray<Permission>
  readonly title: Scalars['String']['input']
}

export { DashboardBillingStatus }

export type DeleteAnnotationsFromAiSuggestionInput = {
  /**
   * The form template version whose AI-originated annotations should be removed. Soft-removes every
   * annotation on the version with isFromAiSuggestion = true, regardless of its current type
   * (so converted TEMPLATE_VARIABLE / USER_ENTERED_FIELD / SIGNATURE / IMAGE rows are removed too,
   * as long as they started as an AI_SUGGESTION).
   */
  readonly formTemplateVersionId: Scalars['ID']['input']
}

export type DeleteCacheKeysInput = {
  readonly pattern: Scalars['String']['input']
  readonly type: CacheType
}

export type DeleteCompanyFormTemplateCollectionInput = {
  readonly collectionId: Scalars['ID']['input']
}

export type DeleteIntegrationCredentialInput = {
  readonly companyId: Scalars['ID']['input']
  readonly type: IntegrationType
}

export type DeleteLienWaiverFormTemplateSetInput = {
  readonly templateSetId: Scalars['ID']['input']
}

export type DeleteLienWaiverRequestsForMonthInput = {
  readonly companyId: Scalars['ID']['input']
  readonly month: Scalars['SafeInt']['input']
  readonly year: Scalars['SafeInt']['input']
}

export type DeletePayAppFormTemplateSetInput = {
  readonly templateSetId: Scalars['ID']['input']
}

export type DeletionResult = {
  readonly __typename: 'DeletionResult'
  /** The ID of the entity that was deleted */
  readonly id: Scalars['ID']['output']
}

export type DisableUserInput = {
  readonly companyId: Scalars['ID']['input']
  readonly userId: Scalars['ID']['input']
}

export { DocumentExpirationFrequency }

export { DocumentRequestStatus }

/** Represents a single send action of a legal document to a contact at a GC */
export type DocumentSendLog = {
  readonly __typename: 'DocumentSendLog'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly legalDocument: LegalDocument
  readonly recipients: ReadonlyArray<CompanyContact>
  readonly sender: User
}

export { DocumentType }

/** Represents an unsaved location object that was imported. */
export type DraftLocation = {
  readonly __typename: 'DraftLocation'
  readonly city: Scalars['String']['output']
  readonly coordinates: Scalars['LatLng']['output']
  readonly country: Scalars['String']['output']
  readonly county: Maybe<Scalars['String']['output']>
  readonly postalCode: Maybe<Scalars['String']['output']>
  readonly state: Scalars['String']['output']
  readonly street1: Maybe<Scalars['String']['output']>
  readonly street2: Maybe<Scalars['String']['output']>
  readonly timeZone: Scalars['String']['output']
}

export { DueToType }

/**
 * A collections notification setting resolved by walking the level chain (contract -> general
 * contractor -> company -> system default). A notification type resolves to every setting at the
 * nearest level that has any settings of that type, so a type can appear multiple times (e.g.
 * several OVERDUE reminders), all from the same source level.
 */
export type EffectiveCollectionsNotificationSetting = {
  readonly __typename: 'EffectiveCollectionsNotificationSetting'
  /** Whether this notification is effectively enabled */
  readonly enabled: Scalars['Boolean']['output']
  /** Number of days/weeks/months */
  readonly intervalAmount: Scalars['SafeInt']['output']
  /** Submission date / due date */
  readonly intervalAnchor: CollectionsNotificationAnchor
  /** Day / week / month */
  readonly intervalGranularity: CollectionsNotificationGranularity
  /** Before / after */
  readonly intervalModifier: CollectionsNotificationModifier
  /** The winning setting row, when source is not DEFAULT */
  readonly settingId: Maybe<Scalars['ID']['output']>
  /** The level the whole setting came from */
  readonly source: CollectionsNotificationLevel
  readonly type: CollectionsNotificationType
}

export { EmailType }

export type EnableIntegrationCredentialAutoRotationInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly emailAddress: Scalars['EmailAddress']['input']
  readonly onePasswordItemId: Scalars['String']['input']
  readonly onePasswordVaultId: Scalars['String']['input']
}

export type EnableLienWaiverInput = {
  readonly contractId: Scalars['ID']['input']
  readonly templates: SubcontractorLienWaiverTemplateSetInput
}

export type EnableUserInput = {
  readonly companyId: Scalars['ID']['input']
  readonly userId: Scalars['ID']['input']
}

export type EstimatedPayAppPaymentDate = {
  readonly __typename: 'EstimatedPayAppPaymentDate'
  readonly estimationMethod: PaymentDateEstimationType
  readonly paymentDate: Scalars['DateTime']['output']
}

export type ExportIntegrationCredentialsToPostmanInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
}

/** Feature flags control feature visibility and rollout */
export type FeatureFlag = {
  readonly __typename: 'FeatureFlag'
  /**
   * When enabled is true, check for company IDs.
   * If the array is empty and rolloutPercentage is 100, then it's enabled for all companies.
   * If the array is empty and rolloutPercentage is 0 or null, then it's enabled for no companies.
   * If the array has specific IDs in it, then the flag is enabled for those companies only.
   */
  readonly companyIds: ReadonlyArray<Scalars['ID']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: Maybe<User>
  /** Description of what this feature flag controls */
  readonly description: Scalars['String']['output']
  /** When false, disabled for all */
  readonly enabled: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly name: FeatureFlagName
  /**
   * Percentage of companies to enable (0-100).
   * Used just to record the percentage, not to determine which companies have the flag enabled.
   * Null if the flag is not being rolled out by percentage.
   * Uses the feature flag name as a seed so that rolling back and then back up
   * will select the same companies as before.
   */
  readonly rolloutPercentage: Maybe<Scalars['Int']['output']>
  /**
   * Used to restrict a feature to siteline users only.
   * Stacks on top of company filter - for example, if a feature is
   * enabled only for one company and siteline users only is set to true,
   * Siteline users will only see the feature on that one company, and no
   * one else will see it.
   */
  readonly sitelineTeamMembersOnly: Scalars['Boolean']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly updatedBy: Maybe<User>
}

export { FeatureFlagName }

export { ForecastCurve }

export type FormAnnotationInput = {
  readonly copyDefaultValueFromPreviousAnnotationValue: Scalars['Boolean']['input']
  readonly defaultValueKey?: InputMaybe<Scalars['String']['input']>
  readonly doNotRetainOnReset: Scalars['Boolean']['input']
  readonly dynamicFieldTag?: InputMaybe<Scalars['String']['input']>
  readonly fieldType?: InputMaybe<FormTemplateAnnotationMetadataFieldType>
  readonly fontColor: Scalars['String']['input']
  readonly fontFamily: FormTemplateFont
  readonly height: Scalars['Float']['input']
  readonly id: Scalars['ID']['input']
  readonly imageType?: InputMaybe<FormTemplateAnnotationImageType>
  readonly isOptional: Scalars['Boolean']['input']
  /** If the form has more than one page, this is the 1-indexed page the annotation is on */
  readonly pageNumber: Scalars['Int']['input']
  readonly prefix?: InputMaybe<Scalars['String']['input']>
  readonly selectedKey?: InputMaybe<Scalars['String']['input']>
  readonly signatureType?: InputMaybe<SignatureAnnotationType>
  readonly suffix?: InputMaybe<Scalars['String']['input']>
  readonly textAlignment: TextAlignment
  readonly type: FormTemplateAnnotationType
  readonly userVisibleName: Scalars['String']['input']
  readonly width: Scalars['Float']['input']
  readonly wrapText: Scalars['Boolean']['input']
  readonly xStart: Scalars['Float']['input']
  readonly yStart: Scalars['Float']['input']
}

/**
 * Represents a single template that can be used on many pay apps across many companies.
 * One template has one version or more. The latest version is used when rendering entities that don't
 * have pinned templates. For instance, a legal requirement will render using the latest version
 * of its template, unless the document has a pinned `formTemplateVersion` field.
 */
export type FormTemplate = {
  readonly __typename: 'FormTemplate'
  /**
   * The subcontractor, GC, or owner that created the original form. For example, the AGA G702's
   * associated company is AGA while the Webcor Cover Sheet's associated company would be Webcor (not
   * the sub that sent us the form to onboard). If no company is associated (i.e. the Base G702), this
   * would be undefined.
   */
  readonly associatedCompany: Maybe<Company>
  /** Contracts that this template is being built for */
  readonly associatedContracts: ReadonlyArray<FormTemplateAssociatedContract>
  /** User who will build the FormTemplate */
  readonly builder: User
  /** Free form comments on the form template. */
  readonly comments: ReadonlyArray<FormTemplateComment>
  readonly createdAt: Scalars['DateTime']['output']
  /** Target date to have the form built by */
  readonly dueDate: Maybe<Scalars['DateTime']['output']>
  /** If this template is a duplicate, this is a reference to the built duplicate template. */
  readonly duplicateTemplate: Maybe<FormTemplate>
  /**
   * The GC that created the original form (if any).
   * Note that GCs are scoped to specific subcontractors so this might not be reachable to other subs.
   */
  readonly gc: Maybe<GeneralContractor>
  readonly id: Scalars['String']['output']
  /**
   * Whether the form template is ready to be shown to customers and used when generating forms.
   * True if the form template status is COMPLETED or if `skippedValidation` is true.
   */
  readonly isCustomerReady: Scalars['Boolean']['output']
  readonly latestVersion: Maybe<FormTemplateVersion>
  /** The original template that was submitted by the customer */
  readonly originalFile: Maybe<StoredFile>
  /** Form manager during the build/validator process. Usually a CSM. */
  readonly owner: User
  /** Which company, if any, requested this form template to be built */
  readonly requestingCompany: Maybe<Company>
  /**
   * Sometimes a customer needs a form onboarded ASAP before we have time to validate. In that case,
   * the owner is allowed to skip validation on the form and add it to a project immediately. However,
   * the form remains in the same state it was before so that it can be finished. i.e. if it was in
   * validation state, it will stay in that state until it is validated. Once the form is completed,
   * this boolean will revert to false.
   */
  readonly skippedValidation: Scalars['Boolean']['output']
  /** Latest status in FormTemplateStatusLog */
  readonly status: FormTemplateStatus
  /** Insertion time of the latest status in FormTemplateStatusLog */
  readonly statusChangedAt: Scalars['DateTime']['output']
  /** The current status of the template. Only COMPLETED forms should be added to live projects. */
  readonly statusLogs: ReadonlyArray<FormTemplateStatusLog>
  /** Tags for a template. i.e. a template could have NOTARIZED and G702. */
  readonly tags: ReadonlyArray<FormTemplateTag>
  readonly type: FormTemplateType
  readonly updatedAt: Scalars['DateTime']['output']
  /** This is the name of the form under the thumbnail on the sign page */
  readonly userVisibleName: Scalars['String']['output']
  /** User who will validate the FormTemplate */
  readonly validator: Maybe<User>
  readonly variants: ReadonlyArray<FormTemplateVariant>
  readonly versions: ReadonlyArray<FormTemplateVersion>
}

/** Represents a single annotation that will be rendered on top of a PDF FormTemplate. */
export type FormTemplateAnnotation = {
  readonly __typename: 'FormTemplateAnnotation'
  /**
   * Only for type USER_ENTERED_FIELD. Indicates whether the default value of this annotation
   * Should be copied from the previous annotation value (using the permanent ID).
   */
  readonly copyDefaultValueFromPreviousAnnotationValue: Scalars['Boolean']['output']
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * Only for type USER_ENTERED_FIELD. Indicates the template variable path/key to use as a
   * default annotation value.
   */
  readonly defaultValueKey: Maybe<Scalars['String']['output']>
  /**
   * Only for type AI_SUGGESTION. A longer natural-language description of this fillable
   * field produced by the form extractor.
   */
  readonly description: Maybe<Scalars['String']['output']>
  /**
   * Only for type USER_ENTERED_FIELD. Must also have defaultValueKey set. Indicates whether
   * this value should always be cleared when retaining annotations.
   */
  readonly doNotRetainOnReset: Scalars['Boolean']['output']
  /**
   * Used for dynamic templates to match annotations to template tags.
   * Usage in XLSX/DOCX: {$field}
   * Usage in annotation metadata: field
   */
  readonly dynamicFieldTag: Maybe<Scalars['String']['output']>
  /**
   * Only for type USER_ENTERED_FIELD. Known type of an annotation.
   * Annotations are opaque by default and we don't know what they mean. It makes it difficult to
   * make sense of what an annotation value represents – which is fine for most annotations but
   * not when we need to extract things like "lien-waiver amount".
   * To workaround that, `metadata.fieldType` allows to tag specific annotations for meaningful
   * processing of annotation values.
   */
  readonly fieldType: Maybe<FormTemplateAnnotationMetadataFieldType>
  /**
   * This is the 6 digit hex code of the color, which will get transformed to the rgb() equivalent
   * when we actually render in the PDF because that's what the library requires.
   */
  readonly fontColor: Scalars['String']['output']
  readonly fontFamily: FormTemplateFont
  readonly formTemplateVersion: FormTemplateVersion
  readonly height: Scalars['Float']['output']
  readonly id: Scalars['ID']['output']
  /** Only for type IMAGE: type of image to render. */
  readonly imageType: Maybe<FormTemplateAnnotationImageType>
  /**
   * True when this annotation was first created via the AI form-extractor (ie. as an AI_SUGGESTION
   * row). The flag is set once at creation and never updated, so it stays true even after the
   * annotation is converted into a TEMPLATE_VARIABLE / USER_ENTERED_FIELD / SIGNATURE / IMAGE.
   * Used by tooling that wants to bulk-remove everything the model contributed.
   */
  readonly isFromAiSuggestion: Scalars['Boolean']['output']
  /** Whether the annotation must have a value. */
  readonly isOptional: Scalars['Boolean']['output']
  /**
   * Only for type AI_SUGGESTION. A short label for this fillable field, derived from the
   * surrounding PDF region by the form extractor.
   */
  readonly label: Maybe<Scalars['String']['output']>
  /**
   * If a form has more than one page, this is the page number that the annotation is on. This
   * number is NOT zero-indexed, it begins at 1 because that is how pdf.js handles it.
   */
  readonly pageNumber: Scalars['Int']['output']
  /**
   * An identifier that persists across versions of the template, used to match annotations together
   * after a template version was cloned.
   */
  readonly permanentId: Scalars['ID']['output']
  /** Only for type TEMPLATE_VARIABLE. Text to insert before the template variable. */
  readonly prefix: Maybe<Scalars['String']['output']>
  /** Only for type TEMPLATE_VARIABLE. Indicates the template variable path/key. */
  readonly selectedKey: Maybe<Scalars['String']['output']>
  /** Only for type SIGNATURE: type of signature to render. */
  readonly signatureType: Maybe<SignatureAnnotationType>
  /** Only for type TEMPLATE_VARIABLE. Text to insert after the template variable. */
  readonly suffix: Maybe<Scalars['String']['output']>
  /**
   * Only for type AI_SUGGESTION. Short rationale produced by the LLM explaining the template
   * variable it picked (which is then written to selectedKey or defaultValueKey on conversion).
   * Useful for debugging; safe to ignore in the UI.
   */
  readonly suggestedTemplateVariableReason: Maybe<Scalars['String']['output']>
  /**
   * Used to sync annotations on the same template and across different templates.
   * An annotation changes its value automatically when the user types in another annotation with
   * the same sync tag.
   */
  readonly syncTag: Maybe<Scalars['String']['output']>
  /** Horizontal alignment of text within the annotation bounds. Defaults to LEFT */
  readonly textAlignment: TextAlignment
  readonly type: FormTemplateAnnotationType
  readonly updatedAt: Scalars['DateTime']['output']
  /**
   * When we ask the user to type something into the annotation for the FormTemplateAnnotationValue, we
   * need to tell them what specifically they're typing in (eg. invoice number, etc).
   */
  readonly userVisibleName: Scalars['String']['output']
  readonly width: Scalars['Float']['output']
  /** Whether text should wrap within the annotation bounds. Defaults to false. Font size will not be reduced to fit. */
  readonly wrapText: Scalars['Boolean']['output']
  readonly xStart: Scalars['Float']['output']
  readonly yStart: Scalars['Float']['output']
}

export { FormTemplateAnnotationImageType }

export { FormTemplateAnnotationMetadataFieldType }

export { FormTemplateAnnotationType }

/**
 * Represents a user-entered value for any FormTemplateAnnotation that is of type
 * FormTemplateAnnotationType.USER_ENTERED_FIELD.
 */
export type FormTemplateAnnotationValue = {
  readonly __typename: 'FormTemplateAnnotationValue'
  readonly annotation: FormTemplateAnnotation
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: Maybe<User>
  readonly id: Scalars['ID']['output']
  readonly metadata: Scalars['JSONObject']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly value: Scalars['String']['output']
}

export type FormTemplateAssociatedContract = {
  readonly __typename: 'FormTemplateAssociatedContract'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly formTemplate: FormTemplate
  readonly id: Scalars['String']['output']
  /**
   * If the form template will not be used in the way it was provided, this field can be flipped to
   * true. When flipped to true, this form template will no longer block the contract's onboarding
   * status from flipping to "done", since this form template is not expected to be used for the type
   * it was provided.
   */
  readonly ignoreProvidedAsFormType: Scalars['Boolean']['output']
  readonly providedAsFormType: Maybe<ProjectOnboardingFormType>
}

/** Represents a comment from a user on a FormTemplate. */
export type FormTemplateComment = {
  readonly __typename: 'FormTemplateComment'
  readonly createdAt: Scalars['DateTime']['output']
  readonly formTemplate: FormTemplate
  readonly id: Scalars['ID']['output']
  readonly isSystemGenerated: Scalars['Boolean']['output']
  readonly message: Scalars['String']['output']
  readonly user: User
}

export { FormTemplateFont }

export { FormTemplateOnboardingSignatureType }

export { FormTemplateStatus }

/** Represents a log of all statuses for a form template and when the transition occurred. */
export type FormTemplateStatusLog = {
  readonly __typename: 'FormTemplateStatusLog'
  readonly createdAt: Scalars['DateTime']['output']
  readonly formTemplate: FormTemplate
  readonly id: Scalars['ID']['output']
  readonly status: FormTemplateStatus
  readonly statusUpdatedAt: Scalars['DateTime']['output']
  readonly user: User
}

/** Tracks an asynchronous run of the form-template AI suggestion pipeline */
export type FormTemplateSuggestionsRun = {
  readonly __typename: 'FormTemplateSuggestionsRun'
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  /** Populated when phase is FAILED. Null otherwise. */
  readonly error: Maybe<Scalars['String']['output']>
  readonly formTemplateVersion: FormTemplateVersion
  readonly id: Scalars['ID']['output']
  readonly phase: FormTemplateSuggestionsRunPhase
  readonly updatedAt: Scalars['DateTime']['output']
}

export { FormTemplateSuggestionsRunPhase }

export { FormTemplateTag }

export { FormTemplateType }

/**
 * A template variant.
 * A single template has 1 or more variants, and each variant can override the annotations of the
 * the original template.
 */
export type FormTemplateVariant = {
  readonly __typename: 'FormTemplateVariant'
  readonly annotationOverrides: ReadonlyArray<AnnotationOverride>
  /** Per-customer metadata for this variant, including validation and archival status */
  readonly customerMetadata: Maybe<FormTemplateVariantCustomerMetadata>
  /** Whether $0 amounts should render as empty strings */
  readonly hidesZeroDollarAmounts: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly internalName: Scalars['String']['output']
  /** Returns whether the variant has been validated (reviewed) by a specific customer */
  readonly isCustomerValidated: Scalars['Boolean']['output']
  readonly isDefaultVariant: Scalars['Boolean']['output']
  /**
   * Whether percentages should be rounded.
   * By default, percentages are displayed with 2 decimal places.
   * Note that this does not affect tax and fee percentages, which have their own precision.
   */
  readonly roundPercentages: Maybe<Scalars['Boolean']['output']>
  readonly template: FormTemplate
  /** If true, use the company's notary signature image if available and skip the notary flow (download + upload). */
  readonly useCompanyNotarySignatureIfAvailable: Maybe<Scalars['Boolean']['output']>
  readonly userVisibleName: Maybe<Scalars['String']['output']>
}

/**
 * A template variant.
 * A single template has 1 or more variants, and each variant can override the annotations of the
 * the original template.
 */
export type FormTemplateVariantCustomerMetadataArgs = {
  companyId: Scalars['ID']['input']
}

/**
 * A template variant.
 * A single template has 1 or more variants, and each variant can override the annotations of the
 * the original template.
 */
export type FormTemplateVariantCustomerValidationArgs = {
  companyId: Scalars['ID']['input']
}

/**
 * A template variant.
 * A single template has 1 or more variants, and each variant can override the annotations of the
 * the original template.
 */
export type FormTemplateVariantIsCustomerValidatedArgs = {
  companyId: Scalars['ID']['input']
}

/**
 * Per-customer metadata for a template variant. Tracks validation (acknowledgement) and archival status.
 * Form template variants can be shared between customers, so archiving is per-customer rather than global.
 */
export type FormTemplateVariantCustomerMetadata = {
  readonly __typename: 'FormTemplateVariantCustomerMetadata'
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly validatedBy: Maybe<User>
  readonly variant: FormTemplateVariant
}

/**
 * An acknowledgement/validation of a template variant by a customer, for a specific company.
 * This is only used for UI purposes, to show the "Ready for review" status".
 * It does not affect whether a template can be used on a contract.
 * **IMPORTANT**: To avoid inserting a bunch of rows, we did not backfill customer validations when
 * deploying the `isCustomerValidated` field. Instead we use a cutoff date and return `isCustomerValidated = true`
 * for all variants that were created before the cutoff date.
 */
export type FormTemplateVariantCustomerValidation = {
  readonly __typename: 'FormTemplateVariantCustomerValidation'
  readonly company: Company
  /** Use this as the validation date */
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly validatedBy: User
  readonly variant: FormTemplateVariant
}

export { FormTemplateVariantStatus }

/**
 * Version of a form template. Used by pay-apps/lien-waivers/legal-documents to pin templates to
 * one version in time.
 */
export type FormTemplateVersion = {
  readonly __typename: 'FormTemplateVersion'
  /** This is only used with static PDF templates, or when type equals StoredFileType.PDF */
  readonly annotations: ReadonlyArray<FormTemplateAnnotation>
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * The currently in-flight AI suggestion run for this version, if any. Null
   * once the most recent run reaches COMPLETED or FAILED.
   */
  readonly currentSuggestionsRun: Maybe<FormTemplateSuggestionsRun>
  readonly file: StoredFile
  readonly formTemplate: FormTemplate
  readonly id: Scalars['ID']['output']
  /** Whether this version uses the correct template variables for manual stored materials */
  readonly isReadyForManualStoredMaterials: Scalars['Boolean']['output']
  /** All AI suggestion runs that have been queued for this version. */
  readonly suggestionsRuns: ReadonlyArray<FormTemplateSuggestionsRun>
  /** Text extracted from this version */
  readonly text: Maybe<FormTemplateVersionText>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly versionNumber: Scalars['Int']['output']
}

/**
 * Text extracted from a form template version file, via OCR.
 * All lines of text and pages are concatenated together, with a newline character separating line or page.
 * We use this to run form matching on the whole set of templates.
 * The text field is indexed with a gin index, so it can be searched for text efficiently.
 */
export type FormTemplateVersionText = {
  readonly __typename: 'FormTemplateVersionText'
  readonly id: Scalars['ID']['output']
  readonly text: Scalars['String']['output']
  readonly version: FormTemplateVersion
}

export type FormTrackerData = {
  readonly __typename: 'FormTrackerData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly completedFormIds: ReadonlyArray<Scalars['ID']['output']>
  readonly completedFormsCount: Scalars['SafeInt']['output']
  readonly formsCompletedRatio: Scalars['Float']['output']
  readonly requestedFormIds: ReadonlyArray<Scalars['ID']['output']>
  readonly requestedFormsCount: Scalars['SafeInt']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

export type FormTrackerInput = {
  /**
   * Optional start date so that you can narrow in on companies that may have submitted a new set of
   * forms recently
   */
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type FormTurnaroundData = {
  readonly __typename: 'FormTurnaroundData'
  /** Basic info for all companies whose IDs are referenced in the forms list */
  readonly companies: ReadonlyArray<MinimalFormTurnaroundCompany>
  readonly forms: ReadonlyArray<FormTurnaroundFormData>
  /** Basic info for all users whose IDs are referenced in the forms list */
  readonly users: ReadonlyArray<MinimalFormTurnaroundUser>
}

export type FormTurnaroundDataInput = {
  readonly endDate: Scalars['DateTime']['input']
  readonly endStatus?: InputMaybe<FormTemplateStatus>
  readonly formWorkerId?: InputMaybe<Scalars['ID']['input']>
  readonly formWorkerRole?: InputMaybe<FormWorkerRole>
  readonly requestingCompanyId?: InputMaybe<Scalars['ID']['input']>
  readonly startDate: Scalars['DateTime']['input']
  readonly startStatus?: InputMaybe<FormTemplateStatus>
}

/** Data about a form template and the dates it was processed */
export type FormTurnaroundFormData = {
  readonly __typename: 'FormTurnaroundFormData'
  readonly endDate: Scalars['DateTime']['output']
  readonly formTemplate: MinimalFormTurnaroundFormTemplate
  readonly startDate: Scalars['DateTime']['output']
}

export { FormWorkerRole }

export type G702Values = {
  readonly __typename: 'G702Values'
  readonly amountDuePostTax: Scalars['SafeInt']['output']
  readonly amountDuePreTax: Scalars['SafeInt']['output']
  readonly amountDueTaxAmount: Scalars['SafeInt']['output']
  readonly balanceToFinish: Maybe<Scalars['SafeInt']['output']>
  readonly balanceToFinishWithRetention: Maybe<Scalars['SafeInt']['output']>
  readonly balanceToFinishWithRetentionPostTax: Maybe<Scalars['SafeInt']['output']>
  readonly contractSumToDate: Scalars['SafeInt']['output']
  readonly materialsRetentionAmount: Scalars['SafeInt']['output']
  readonly materialsRetentionPercent: Scalars['Float']['output']
  readonly netChangeByChangeOrders: Scalars['SafeInt']['output']
  readonly originalContractSum: Scalars['SafeInt']['output']
  readonly previousPayments: Scalars['SafeInt']['output']
  readonly progressRetentionAmount: Scalars['SafeInt']['output']
  readonly progressRetentionPercent: Scalars['Float']['output']
  readonly totalCompletedToDate: Scalars['SafeInt']['output']
  readonly totalLessRetainage: Scalars['SafeInt']['output']
  readonly totalRetention: Scalars['SafeInt']['output']
}

export type GeneralContractor = {
  readonly __typename: 'GeneralContractor'
  /** All-time average days from billing/submission to payment across this GC's paid invoices */
  readonly averageDaysToPaid: Scalars['Float']['output']
  /** Collections notification settings configured for this GC, plus their resolved values */
  readonly collectionsNotificationConfig: CollectionsNotificationConfig
  readonly company: Company
  readonly companyEmail: Maybe<Scalars['EmailAddress']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly locations: ReadonlyArray<Location>
  readonly name: Scalars['String']['output']
  readonly notes: Maybe<Scalars['String']['output']>
  /** Number of distinct projects with this GC that have an active contract */
  readonly numActiveProjects: Scalars['Int']['output']
  /** Total post-tax outstanding (unpaid) amount across all of this GC's contracts, in cents */
  readonly outstandingContractValue: Scalars['SafeInt']['output']
  /** Total past-due (overdue) amount across all of this GC's contracts, in cents */
  readonly pastDueAmount: Scalars['SafeInt']['output']
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  /** The address designated as this customer's primary address, if any. */
  readonly primaryLocation: Maybe<Location>
  /** Sum of the latest contract values across this GC's active contracts, in cents */
  readonly totalContractValue: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

/**
 * One contact associated with a general contractor (customer), aggregated across all of the GC's
 * projects. Surfaced on the customer detail page.
 */
export type GeneralContractorContact = {
  readonly __typename: 'GeneralContractorContact'
  /** The underlying company contact */
  readonly contact: CompanyContact
  /** Which document categories this contact receives across the GC's projects (may be empty) */
  readonly documentLabels: ReadonlyArray<CompanyContactDocumentLabel>
  /** Number of distinct projects with this GC the contact appears on */
  readonly numProjects: Scalars['Int']['output']
}

/**
 * One project a general contractor contact is associated with, and the document categories they
 * receive on that specific project. Surfaced in the contact-details dialog on the customer detail page.
 */
export type GeneralContractorContactProject = {
  readonly __typename: 'GeneralContractorContactProject'
  /** Which document categories this contact receives on this specific project (may be empty) */
  readonly documentLabels: ReadonlyArray<CompanyContactDocumentLabel>
  /** The project (only id/name/projectNumber are populated) */
  readonly project: Project
}

export type GeneralContractorForDedupe = {
  readonly __typename: 'GeneralContractorForDedupe'
  readonly contractCount: Scalars['SafeInt']['output']
  readonly generalContractor: GeneralContractor
}

export { GeneralContractorsSortCriteria }

export type GetCacheKeysInput = {
  readonly pattern: Scalars['String']['input']
  readonly type: CacheType
}

export type GetPaginatedCompaniesInput = {
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly hasChurned?: InputMaybe<Scalars['Boolean']['input']>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly sortCriteria?: InputMaybe<CompanyListSortCriteria>
  readonly sortOrder?: InputMaybe<PaginatedListSortOrder>
  readonly type?: InputMaybe<CompanyType>
}

export type GetPaginatedContractMismatchReportOperationGroupsInput = {
  readonly companyId?: InputMaybe<Scalars['ID']['input']>
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetPaginatedContractsInput = {
  readonly billingType?: InputMaybe<BillingType>
  readonly complianceStatus?: InputMaybe<ComplianceStatus>
  readonly contractStatus?: InputMaybe<ContractListContractStatusFilter>
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly generalContractorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  /** Filter returned contracts based on whether or not they have a billing forecast */
  readonly hasBillingForecast?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter returned contracts based on whether or not they have any forms still being processed by the admin team */
  readonly isProcessingForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly leadPMIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly month?: InputMaybe<Scalars['String']['input']>
  readonly officeIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly payAppStatus?: InputMaybe<ContractListPayAppStatusFilter>
  readonly projectIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly sortCriteria?: InputMaybe<ContractListSortCriteria>
  readonly sortOrder?: InputMaybe<PaginatedListSortOrder>
  readonly submitVia?: InputMaybe<ContractListSubmitViaFilter>
  readonly templateIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type GetPaginatedGeneralContractorContactsInput = {
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly generalContractorId: Scalars['ID']['input']
  readonly limit?: InputMaybe<Scalars['Int']['input']>
}

export type GetPaginatedIntegrationRequestsInput = {
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly integrationType?: InputMaybe<IntegrationType>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetPaginatedTemplatesInput = {
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>
  readonly associatedContractId?: InputMaybe<Scalars['ID']['input']>
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly includeInactive?: InputMaybe<Scalars['Boolean']['input']>
  readonly isUnused?: InputMaybe<Scalars['Boolean']['input']>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  /** Associated company or requesting company */
  readonly relatedCompanyId?: InputMaybe<Scalars['ID']['input']>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly sortCriteria?: InputMaybe<TemplateListSortCriteria>
  readonly sortOrder?: InputMaybe<PaginatedListSortOrder>
  readonly status?: InputMaybe<TemplateListStatusFilter>
  readonly tags?: InputMaybe<ReadonlyArray<FormTemplateTag>>
  readonly type?: InputMaybe<FormTemplateType>
  readonly waitingOnId?: InputMaybe<Scalars['ID']['input']>
}

export type GetPaginatedWriteSyncOperationsInput = {
  readonly cursor?: InputMaybe<Scalars['ID']['input']>
  readonly includeFileBasedExports?: InputMaybe<Scalars['Boolean']['input']>
  readonly includeManualSyncOperations?: InputMaybe<Scalars['Boolean']['input']>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly search?: InputMaybe<Scalars['String']['input']>
  readonly sort?: InputMaybe<WriteSyncOperationsSort>
  readonly status?: InputMaybe<WriteSyncOperationStatus>
}

export type IgnoreFormTemplateProvidedTypeInput = {
  readonly formTemplateAssociatedContractId: Scalars['ID']['input']
}

export { ImportIntegrationChangeOrdersMethod }

export { ImportIntegrationComboJobMethod }

export { ImportIntegrationProjectNameSource }

export { ImportOperationStatus }

/** All relevant metadata returned about a project that was imported from an integration. */
export type ImportProjectOnboardingMetadata = {
  readonly __typename: 'ImportProjectOnboardingMetadata'
  readonly architect: Maybe<IntegrationCompany>
  readonly companyIntegrationId: Scalars['ID']['output']
  readonly contract: IntegrationContract
  readonly gc: Maybe<IntegrationGeneralContractor>
  readonly integrationAssociatedCompanyId: Maybe<Scalars['String']['output']>
  readonly ownerEntity: Maybe<IntegrationOwner>
  readonly project: IntegrationProjectDetails
  readonly taxCalculationType: TaxCalculationType
  readonly taxGroup: Maybe<IntegrationTaxGroup>
  readonly type: IntegrationType
}

export type ImportSovFromIntegrationInput = {
  readonly integrationId: Scalars['ID']['input']
}

/**
 * Note: because an AP invoice can belong to multiple contracts,
 * there can be multiple instances of the same ERP invoice in Siteline,
 * with the same `integrationInvoiceId` but a different `integrationContractId`.
 *
 * Note: We need a unique index on the import operation + invoice so that we don't insert duplicates
 * on inngest retries. This index must ignore null invoice IDs (manual imports).
 */
export type ImportedVendorInvoice = {
  readonly __typename: 'ImportedVendorInvoice'
  /** May be a partial amount if the full invoice has not been paid */
  readonly amountPaid: Scalars['Float']['output']
  /**
   * The total amount of change orders as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly changeOrderTotalAsOfInvoiceDate: Scalars['Float']['output']
  readonly code: Scalars['String']['output']
  /** The CompanyIntegration this invoice was imported from. Null for manual/Excel imports. */
  readonly companyIntegration: Maybe<CompanyIntegration>
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  readonly grossAmount: Scalars['Float']['output']
  /**
   * Payment date of when the gross invoice amount is fully paid, i.e.
   * if retention is held then the date all retention has been released.
   * Format is YYYY-MM-DD. Null if gross amount not fully paid.
   */
  readonly grossPaidAt: Maybe<Scalars['String']['output']>
  readonly importOperation: VendorInvoiceImportOperation
  /** ERP's native contract commitment (subcontract/PO) id that this invoice was billed against, if any. */
  readonly integrationContractCommitmentId: Maybe<Scalars['String']['output']>
  /** Provided when imported from ERP */
  readonly integrationContractId: Maybe<Scalars['String']['output']>
  /** Provided when imported from ERP. Not unique because an invoice may have line items across multiple jobs */
  readonly integrationInvoiceId: Maybe<Scalars['String']['output']>
  /** Provided when imported from ERP */
  readonly integrationProjectId: Maybe<Scalars['String']['output']>
  /** Provided when imported from ERP */
  readonly integrationVendorCode: Maybe<Scalars['String']['output']>
  /** Provided when imported from ERP */
  readonly integrationVendorId: Maybe<Scalars['String']['output']>
  /**
   * Internal project number that we'll use to link the invoice to a Siteline project.
   * This is used only if the integration fields are not provided, since they are more accurate.
   * Note that we can import invoices that don't have a matching Siteline contract, so there is no
   * guarantee that this project number exists in Siteline.
   */
  readonly internalProjectNumber: Maybe<Scalars['String']['output']>
  /** Format is YYYY-MM-DD */
  readonly invoiceDate: Scalars['String']['output']
  /** True if the gross invoice amount has been fully paid */
  readonly isGrossFullyPaid: Scalars['Boolean']['output']
  /**
   * True if the net invoice amount is fully paid. If retention is held,
   * this may be true even if retention has not been released.
   */
  readonly isNetFullyPaid: Scalars['Boolean']['output']
  /**
   * Payment date of when the net invoice amount is fully paid.
   * Format is YYYY-MM-DD. Null if net amount not fully paid.
   */
  readonly netPaidAt: Maybe<Scalars['String']['output']>
  /** All payment dates for the invoice. Note that the invoice may be partially paid. */
  readonly paymentDates: ReadonlyArray<Scalars['String']['output']>
  /** All payment numbers for the invoice. Note that the invoice may be partially paid. */
  readonly paymentNumbers: ReadonlyArray<Scalars['String']['output']>
  readonly retentionAmount: Scalars['Float']['output']
  /**
   * If a vendor in Siteline (belonging to the current user's company) is linked to this vendor in the
   * integration, this is the vendor's Siteline ID
   */
  readonly sitelineVendorId: Maybe<Scalars['ID']['output']>
  /**
   * The total amount billed by the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalBilledAsOfInvoiceDate: Scalars['Float']['output']
  /**
   * The total amount paid to the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalPaidAsOfInvoiceDate: Scalars['Float']['output']
  /**
   * The total amount of retention held on the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalRetentionAsOfInvoiceDate: Scalars['Float']['output']
  readonly vendorName: Scalars['String']['output']
}

/** A contract-level integration (textura, gcpay, etc) */
export type Integration = {
  readonly __typename: 'Integration'
  /**
   * If true, allow editing the SOV even if this is a GC portal integration and ignore all changes to
   * existing line items when importing the SOV from the integration
   */
  readonly allowGcPortalManualSovEditing: Scalars['Boolean']['output']
  readonly companyIntegration: CompanyIntegration
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly credentialsUpdatedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * Visual order of this integration compared to other ERP integrations.
   * Used for importing line items across multiple ERP contracts.
   * For ERPs, the default is 1. For GC portals, this is always 0 (to avoid nullable fields).
   */
  readonly erpSortOrder: Scalars['Int']['output']
  readonly id: Scalars['ID']['output']
  readonly isActive: Scalars['Boolean']['output']
  readonly longName: Scalars['String']['output']
  /** Mappings of Siteline entities to Integration entities. Fields depend on the integration type. */
  readonly mappings: Scalars['JSONObject']['output']
  /**
   * Integration specific metadata, primarly for file-based integrations. Fields depend on the
   * integration type. Kept separate from mappings because this can be updated by the frontend.
   */
  readonly metadata: Scalars['JSONObject']['output']
  readonly shortName: Scalars['String']['output']
  readonly type: IntegrationType
  readonly writeSyncOperations: ReadonlyArray<WriteSyncOperation>
}

/** An AR invoice that already exists in the ERP for a contract, used to warn before creating another one. */
export type IntegrationArInvoice = {
  readonly __typename: 'IntegrationArInvoice'
  readonly integrationInvoiceId: Scalars['ID']['output']
  /** Total invoice amount in cents, net of retention. */
  readonly invoiceAmount: Scalars['Float']['output']
  readonly invoiceDate: Scalars['String']['output']
  /** Human-readable invoice number as shown in the ERP. */
  readonly invoiceNumber: Scalars['String']['output']
  /** Retention held on the invoice, in cents, if known. */
  readonly invoiceRetentionHeld: Maybe<Scalars['Float']['output']>
  /** Whether the invoice is in Vista's JB Billing module (true) or the AR module (false). Always false for integrations without that distinction. */
  readonly isJbBillingInvoice: Scalars['Boolean']['output']
  /** Raw invoice status as reported by the ERP (e.g. "Posted", "Pending"). */
  readonly status: Scalars['String']['output']
}

export type IntegrationCompany = {
  readonly __typename: 'IntegrationCompany'
  readonly companyAddress: Maybe<DraftLocation>
  readonly companyName: Maybe<Scalars['String']['output']>
  readonly sitelineCompanyId: Maybe<Scalars['String']['output']>
  readonly sitelineLocation: Maybe<Location>
}

export type IntegrationContract = {
  readonly __typename: 'IntegrationContract'
  readonly billingType: Maybe<BillingType>
  readonly contractDate: Maybe<Scalars['DateTime']['output']>
  readonly contractName: Maybe<Scalars['String']['output']>
  readonly contractNumber: Maybe<Scalars['String']['output']>
  /**
   * Some integrations (e.g. Foundation) will not have a contract for every project. We still
   * use this contract object, as some contract data may be available from the job setup, but do
   * not require a contract ID.
   */
  readonly integrationContractId: Maybe<Scalars['String']['output']>
  readonly latestPayAppNumber: Maybe<Scalars['SafeInt']['output']>
  readonly payAppDueDate: Maybe<Scalars['SafeInt']['output']>
  readonly paymentTerms: Maybe<Scalars['SafeInt']['output']>
  readonly paymentTermsType: Maybe<ContractPaymentTermsType>
  /**
   * Amount billed pre-siteline.
   * This is only for T&M contracts. Other contracts must use the SOV to indicate pre-siteline billed.
   */
  readonly preSitelineBilled: Maybe<Scalars['SafeInt']['output']>
  readonly retentionPercent: Maybe<Scalars['Float']['output']>
  readonly retentionTrackingLevel: Maybe<RetentionTrackingLevel>
  readonly roundRetention: Maybe<Scalars['Boolean']['output']>
  readonly storedMaterialsCarryoverType: Maybe<StoredMaterialsCarryoverType>
  /** The number the GC uses to identify the subcontractor on this contract, when the ERP knows it */
  readonly vendorNumber: Maybe<Scalars['String']['output']>
}

export type IntegrationCostCode = {
  readonly __typename: 'IntegrationCostCode'
  readonly code: Scalars['String']['output']
  readonly companyIntegration: CompanyIntegration
  readonly integrationCostCodeId: Scalars['String']['output']
  readonly name: Maybe<Scalars['String']['output']>
}

export type IntegrationCostCodeWithCostTypes = {
  readonly __typename: 'IntegrationCostCodeWithCostTypes'
  readonly costTypes: ReadonlyArray<IntegrationCostType>
  readonly integrationCostCodeId: Scalars['String']['output']
}

export type IntegrationCostType = {
  readonly __typename: 'IntegrationCostType'
  readonly code: Scalars['String']['output']
  readonly companyIntegration: CompanyIntegration
  readonly integrationCostTypeId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
}

export type IntegrationCredentialInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
}

export type IntegrationCustomer = {
  readonly __typename: 'IntegrationCustomer'
  readonly code: Maybe<Scalars['String']['output']>
  readonly integrationCustomerId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
}

export type IntegrationGeneralContractor = {
  readonly __typename: 'IntegrationGeneralContractor'
  readonly companyAddress: Maybe<DraftLocation>
  readonly companyName: Maybe<Scalars['String']['output']>
  readonly sitelineGeneralContractorId: Maybe<Scalars['String']['output']>
  readonly sitelineLocation: Maybe<Location>
}

export type IntegrationGeneralLedgerAccount = {
  readonly __typename: 'IntegrationGeneralLedgerAccount'
  readonly code: Scalars['String']['output']
  readonly integrationAccountId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
  readonly parentCode: Maybe<Scalars['String']['output']>
  readonly parentId: Maybe<Scalars['String']['output']>
  readonly parentName: Maybe<Scalars['String']['output']>
}

export type IntegrationIncomeTypeNumber = {
  readonly __typename: 'IntegrationIncomeTypeNumber'
  readonly description: Scalars['String']['output']
  readonly incomeTypeNumber: Scalars['String']['output']
  readonly integrationIncomeTypeNumberId: Scalars['String']['output']
}

export type IntegrationInvoiceType = {
  readonly __typename: 'IntegrationInvoiceType'
  readonly hasAutoNumberingEnabled: Scalars['Boolean']['output']
  readonly invoiceType: Scalars['String']['output']
}

export type IntegrationInvoiceTypesInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
}

/** A location entity from an integration */
export type IntegrationLocation = {
  readonly __typename: 'IntegrationLocation'
  /**
   * The unique identifier in the integration. This is a native ERP ID
   * (e.g., Sage Intacct LOCATIONID), not an Agave-normalized UUID.
   */
  readonly integrationLocationId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
}

export type IntegrationOauthAuthorizeUrlInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly useSandbox: Scalars['Boolean']['input']
}

export type IntegrationOnePasswordItem = {
  readonly __typename: 'IntegrationOnePasswordItem'
  readonly itemId: Scalars['ID']['output']
  readonly title: Scalars['String']['output']
  readonly vaultId: Scalars['ID']['output']
}

export type IntegrationOwner = {
  readonly __typename: 'IntegrationOwner'
  readonly companyAddress: Maybe<DraftLocation>
  readonly companyName: Maybe<Scalars['String']['output']>
  readonly sitelineLocation: Maybe<Location>
  readonly sitelineOwnerId: Maybe<Scalars['String']['output']>
}

export type IntegrationProjectDetails = {
  readonly __typename: 'IntegrationProjectDetails'
  readonly integrationProjectId: Maybe<Scalars['String']['output']>
  readonly internalNotes: Maybe<Scalars['String']['output']>
  readonly internalProjectNumber: Maybe<Scalars['String']['output']>
  readonly projectAddress: Maybe<DraftLocation>
  readonly projectName: Scalars['String']['output']
  readonly projectNumber: Maybe<Scalars['String']['output']>
  /** The Siteline User IDs of users who should be added to the project as lead PM */
  readonly sitelineLeadPMIds: Maybe<ReadonlyArray<Scalars['String']['output']>>
}

export type IntegrationProjectMigrationSummary = {
  readonly __typename: 'IntegrationProjectMigrationSummary'
  /** Contracts with an integration of the right type where no clear match was found to migrate */
  readonly contractsIgnored: ReadonlyArray<Contract>
  /** Contracts where a match was found and a project import operation was queued */
  readonly contractsQueued: ReadonlyArray<Contract>
}

export type IntegrationProjectSummary = {
  readonly __typename: 'IntegrationProjectSummary'
  readonly contractName: Maybe<Scalars['String']['output']>
  readonly generalContractorName: Maybe<Scalars['String']['output']>
  readonly integrationAssociatedCompanyId: Maybe<Scalars['String']['output']>
  /**
   * "
   * If a contract ID is not provided, the integration may not require contracts for every job and
   * we will still allow onboarding the project with the information we have
   */
  readonly integrationContractId: Maybe<Scalars['String']['output']>
  readonly integrationProjectId: Maybe<Scalars['String']['output']>
  readonly projectName: Scalars['String']['output']
  readonly projectNumber: Maybe<Scalars['String']['output']>
  readonly sitelineContractId: Maybe<Scalars['String']['output']>
  /** Provided if already onboarded to Siteline */
  readonly sitelineProjectId: Maybe<Scalars['String']['output']>
}

export type IntegrationProjectsFilter = {
  readonly __typename: 'IntegrationProjectsFilter'
  /**
   * Should match one of the values in the `options` array. If not provided, will
   * default to the first option, or 'All' if `showAllOption` is true.
   */
  readonly defaultValue: Maybe<Scalars['String']['output']>
  readonly field: IntegrationProjectsFilterField
  /** If multiple options can be selected at once */
  readonly multiple: Scalars['Boolean']['output']
  /** These are the options to show for a specific integration */
  readonly options: ReadonlyArray<IntegrationProjectsFilterOption>
  /**
   * If true, an 'All' option is shown. This would be the default option if true.
   * Note that if this is false but `multiple` is true, it will still be possible
   * to select every option. But a single 'All' option would not be shown.
   */
  readonly showAllOption: Scalars['Boolean']['output']
}

export { IntegrationProjectsFilterField }

export type IntegrationProjectsFilterOption = {
  readonly __typename: 'IntegrationProjectsFilterOption'
  /** A label to show in the UI for this option. Can be the same as the value. */
  readonly label: Scalars['String']['output']
  /** The unique value that will be used for filtering on the corresponding field */
  readonly value: Scalars['String']['output']
}

/** Records an integration API request and response for auditing and debugging purposes */
export type IntegrationRequest = {
  readonly __typename: 'IntegrationRequest'
  readonly companyIntegration: Maybe<CompanyIntegration>
  readonly endedAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly integrationType: Maybe<IntegrationType>
  readonly request: Scalars['JSONObject']['output']
  readonly response: Maybe<Scalars['JSONObject']['output']>
  readonly startedAt: Scalars['DateTime']['output']
  readonly type: IntegrationRequestType
}

export { IntegrationRequestType }

export type IntegrationSov = {
  readonly __typename: 'IntegrationSov'
  readonly lineItems: ReadonlyArray<IntegrationSovLineItem>
}

export type IntegrationSovLineItem = {
  readonly __typename: 'IntegrationSovLineItem'
  /** Total value in cents billed to date */
  readonly billedToDate: Scalars['Float']['output']
  readonly code: Scalars['String']['output']
  readonly description: Scalars['String']['output']
  /** Could be null if the integration doesn't have IDs */
  readonly integrationLineItemId: Maybe<Scalars['String']['output']>
  readonly integrationTaxGroup: Maybe<IntegrationTaxGroup>
  /** Total value of retention in cents to date */
  readonly retentionToDate: Scalars['Float']['output']
  readonly scheduledValue: Scalars['Float']['output']
  /** Total unit price in cents, same as scheduledValue if not a unit price contract */
  readonly unitPrice: Scalars['Decimal']['output']
  /**
   * Vista only: total value in cents billed through the Job Billing (JB) module to date, summed from
   * JB invoice lines. Distinct from `billedToDate` (AR billing) since pending JB bills aren't yet
   * posted to AR. Null for non-Vista integrations and Vista AR contracts. Used to gate overbilling
   * on JB billing syncs.
   */
  readonly vistaJbPreviousBilled: Maybe<Scalars['Float']['output']>
}

export { IntegrationSyncResultCode }

export type IntegrationTaxGroup = {
  readonly __typename: 'IntegrationTaxGroup'
  readonly integrationTaxGroupId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
  /** Tax percentage for this group, between 0 and 1 */
  readonly taxPercent: Scalars['Float']['output']
}

export { IntegrationType }

export type IntegrationVendor = {
  readonly __typename: 'IntegrationVendor'
  readonly address: Maybe<Scalars['String']['output']>
  readonly contacts: ReadonlyArray<IntegrationVendorContact>
  readonly integrationVendorId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
}

export type IntegrationVendorContact = {
  readonly __typename: 'IntegrationVendorContact'
  readonly email: Maybe<Scalars['EmailAddress']['output']>
  readonly integrationVendorContactId: Scalars['String']['output']
  readonly name: Maybe<Scalars['String']['output']>
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly title: Maybe<Scalars['String']['output']>
}

/** Represents an unsaved vendor contract commitment that's been imported */
export type IntegrationVendorContractCommitment = {
  readonly __typename: 'IntegrationVendorContractCommitment'
  readonly amount: Scalars['SafeInt']['output']
  readonly closedAt: Maybe<Scalars['DateTime']['output']>
  readonly commitmentType: VendorContractCommitmentType
  readonly date: Maybe<Scalars['String']['output']>
  readonly integrationCommitmentId: Scalars['String']['output']
  readonly integrationMappings: Scalars['JSONObject']['output']
  readonly number: Scalars['String']['output']
  readonly payWhenPaid: Scalars['Boolean']['output']
  readonly paymentTerms: Maybe<Scalars['SafeInt']['output']>
  readonly vendorContract: Maybe<VendorContract>
}

export type IntegrationVendorInvoice = {
  readonly __typename: 'IntegrationVendorInvoice'
  /** May be a partial amount if the full invoice has not been paid */
  readonly amountPaid: Scalars['Float']['output']
  /** The total amount of change orders as of the invoice date, in cents. */
  readonly changeOrderTotalAsOfInvoiceDate: Scalars['Float']['output']
  readonly code: Scalars['String']['output']
  /**
   * The CompanyIntegration representing the ERP this invoice was fetched from, when sourced directly from an integration.
   * Null for invoices that didn't come from a live ERP (e.g. imported from an excel sheet).
   */
  readonly companyIntegrationId: Maybe<Scalars['ID']['output']>
  readonly description: Scalars['String']['output']
  /**
   * The gross invoice amount, not deducting any retention held but including
   * any tax amount
   */
  readonly grossAmount: Scalars['Float']['output']
  /**
   * Payment date of when the gross invoice amount is fully paid, i.e.
   * if retention is held then the date all retention has been released.
   * Format is YYYY-MM-DD. Null if gross amount not fully paid.
   */
  readonly grossPaidAt: Maybe<Scalars['String']['output']>
  /**
   * Per-invoice subcontract/commitment id from the ERP, when the integration exposes one.
   * Used to link lien waivers back to a specific commitment on multi-integration contracts.
   */
  readonly integrationContractCommitmentId: Maybe<Scalars['String']['output']>
  readonly integrationContractId: Maybe<Scalars['String']['output']>
  readonly integrationInvoiceId: Scalars['String']['output']
  readonly integrationProjectId: Scalars['String']['output']
  readonly integrationVendorCode: Scalars['String']['output']
  readonly integrationVendorId: Scalars['String']['output']
  /** Format is YYYY-MM-DD */
  readonly invoiceDate: Scalars['String']['output']
  /** True if the gross invoice amount has been fully paid */
  readonly isGrossFullyPaid: Scalars['Boolean']['output']
  /**
   * True if the net invoice amount is fully paid. If retention is held,
   * this may be true even if retention has not been released.
   */
  readonly isNetFullyPaid: Scalars['Boolean']['output']
  /**
   * Payment date of when the net invoice amount is fully paid.
   * Format is YYYY-MM-DD. Null if net amount not fully paid.
   */
  readonly netPaidAt: Maybe<Scalars['String']['output']>
  /** All payment dates for the invoice. Note that the invoice may be partially paid. */
  readonly paymentDates: ReadonlyArray<Scalars['String']['output']>
  /** All payment numbers for the invoice. Note that the invoice may be partially paid. */
  readonly paymentNumbers: ReadonlyArray<Scalars['String']['output']>
  readonly retentionAmount: Scalars['Float']['output']
  /**
   * If a vendor in Siteline (belonging to the current user's company) is linked to this vendor in the
   * integration, this is the vendor's Siteline ID
   */
  readonly sitelineVendorId: Maybe<Scalars['ID']['output']>
  /** The total amount billed by the vendor as of the invoice date, in cents. Cumulative. */
  readonly totalBilledAsOfInvoiceDate: Scalars['Float']['output']
  /** The total amount paid to the vendor as of the invoice date, in cents. Cumulative. */
  readonly totalPaidAsOfInvoiceDate: Scalars['Float']['output']
  /** The total amount of retention held on the vendor as of the invoice date, in cents. Cumulative. */
  readonly totalRetentionAsOfInvoiceDate: Scalars['Float']['output']
  readonly vendorName: Scalars['String']['output']
}

export type IntegrationVendorMigrationSummary = {
  readonly __typename: 'IntegrationVendorMigrationSummary'
  /** Vendors with an integration mapping of the right type where no clear match was found to migrate */
  readonly vendorsIgnored: ReadonlyArray<Vendor>
  /** Vendors where a match was found and a vendor import operation was queued */
  readonly vendorsQueued: ReadonlyArray<Vendor>
}

export type InviteCompanyUserInput = {
  readonly companyId: Scalars['String']['input']
  readonly companyUser: CompanyUserInput
}

/** Represents a document for a legal requirement that can be accessed by a URL */
export type LegalDocument = {
  readonly __typename: 'LegalDocument'
  readonly createdAt: Scalars['DateTime']['output']
  /** A list of each time the document has been sent. */
  readonly documentSentLog: Maybe<ReadonlyArray<DocumentSendLog>>
  /** Files can be uploaded by users or by lower-tier subs, who are not users */
  readonly file: Maybe<StoredFile>
  /**
   * Version of a template that this document must be rendered with. If null, the legal requirement
   * form template will be used instead. This cannot be provided if isUploaded is true.
   */
  readonly formTemplateVersion: Maybe<FormTemplateVersion>
  /** A list of all user-entered values for the form on the LegalRequirement */
  readonly formValues: ReadonlyArray<FormTemplateAnnotationValue>
  readonly id: Scalars['ID']['output']
  readonly isUploaded: Scalars['Boolean']['output']
  /** The time that this document was last sent in an email, if relevant */
  readonly lastSendTime: Maybe<Scalars['DateTime']['output']>
  /** The last write sync for this entity. Null if not successful */
  readonly lastSyncIfSuccessful: Maybe<WriteSyncOperation>
  /** All requests that exist for this legal document */
  readonly legalDocumentRequests: ReadonlyArray<LegalDocumentRequest>
  readonly legalRequirement: LegalRequirement
  readonly name: Scalars['String']['output']
  /**
   * This represents the end of the recurring period or the user-input expiration
   * date. This will be set unless the expiration frequency is set to NEVER.
   */
  readonly periodEnd: Maybe<Scalars['DateTime']['output']>
  /** For recurring documents, this is the start of the recurring period. */
  readonly periodStart: Maybe<Scalars['DateTime']['output']>
  /** Signature of the user who signed. This is also used for when the signature was added. */
  readonly signature: Maybe<Signature>
  readonly updatedAt: Scalars['DateTime']['output']
  /** Files can be uploaded by users or by lower-tier subs, who are not users */
  readonly uploadedBy: Maybe<User>
  /** If this legal document is for a vendor legal requirement, the vendor contract will be specified here. */
  readonly vendorContract: Maybe<VendorContract>
}

/** Request of a legal document from a vendor contact. */
export type LegalDocumentRequest = {
  readonly __typename: 'LegalDocumentRequest'
  readonly actionTakenAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly legalDocument: LegalDocument
  readonly legalRequirement: LegalRequirement
  /** List of users who have created or modified this legal document request. */
  readonly modifiedBy: ReadonlyArray<User>
  readonly status: DocumentRequestStatus
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContact: VendorContact
  readonly vendorContract: VendorContract
}

export { LegalDocumentStatus }

/** Represents a single legal requirement for a project */
export type LegalRequirement = {
  readonly __typename: 'LegalRequirement'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly documents: ReadonlyArray<LegalDocument>
  /** [Optional] The last date to get a recurring requirement. */
  readonly endDate: Maybe<Scalars['DateTime']['output']>
  readonly expirationFrequency: DocumentExpirationFrequency
  /** An optional template that can be filled out on Siteline */
  readonly formTemplate: Maybe<FormTemplate>
  readonly id: Scalars['ID']['output']
  /** Whether this is a requirement from the subcontractor to lower-tier vendors */
  readonly isVendorRequirement: Scalars['Boolean']['output']
  /** Fields missing that are required to generate this legal requirement's forms */
  readonly missingRequiredFields: ReadonlyArray<RequiredFieldForForms>
  readonly name: Scalars['String']['output']
  readonly skippedPeriods: ReadonlyArray<Scalars['String']['output']>
  /** The first date for a recurring requirement. */
  readonly startDate: Maybe<Scalars['DateTime']['output']>
  readonly timeZone: Scalars['String']['output']
  /** Type of legal document */
  readonly type: DocumentType
  readonly updatedAt: Scalars['DateTime']['output']
  /** For vendor legal requirements, a blank form template may be provided for the vendor to download */
  readonly vendorTemplate: Maybe<StoredFile>
}

/**
 * A document that, by state law, may be issued to a contractor that would shorten one or
 * multiple lien deadlines
 */
export type LienDeadlineNoticeRequirement = {
  readonly __typename: 'LienDeadlineNoticeRequirement'
  /**
   * If a notice requirement is removed for a state (e.g. because the law changes), but has already been referenced
   * by a completed milestone, we archive it instead of deleting it in the database. Otherwise we may create a
   * broken reference from the completed milestone, or have to delete a valid notice filing from the past.
   */
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly documentName: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  /** A single document may affect one or multiple deadlines (e.g. shorten lien and lien enforcement) */
  readonly newDeadlines: ReadonlyArray<LienDeadlineNoticeRequirementNewDeadline>
  readonly stateLienRequirementsSummary: StateLienRequirementsSummary
  readonly updatedAt: Scalars['DateTime']['output']
}

export type LienDeadlineNoticeRequirementInput = {
  readonly documentName: Scalars['String']['input']
  /**
   * If the requirement already exists, pass the ID to update it. This is important for preserving
   * the state of existing projects that have this requirement.
   */
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly newDeadlines: ReadonlyArray<LienDeadlineNoticeRequirementNewDeadlineInput>
}

/** A new lien deadline that takes precedence over existing deadlines based on an owner notice */
export type LienDeadlineNoticeRequirementNewDeadline = {
  readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
  readonly anchor: LienRightsDeadlineAnchor
  readonly granularity: LienRightsDeadlineGranularity
  readonly interval: Scalars['SafeInt']['output']
  readonly modifier: LienRightsDeadlineModifier
  readonly noticeRequirement: LienDeadlineNoticeRequirement
  readonly type: LienDeadlineNoticeRequirementType
}

export type LienDeadlineNoticeRequirementNewDeadlineInput = {
  readonly anchor: LienRightsDeadlineAnchor
  readonly granularity: LienRightsDeadlineGranularity
  /** If the deadline already exists, pass the ID to update it. */
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly interval: Scalars['SafeInt']['input']
  readonly modifier: LienRightsDeadlineModifier
  readonly type: LienDeadlineNoticeRequirementType
}

export { LienDeadlineNoticeRequirementType }

export { LienMilestoneRequirementType }

export type LienRightsContractEvent = {
  readonly __typename: 'LienRightsContractEvent'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly id: Scalars['ID']['output']
  readonly metadata: Scalars['JSONObject']['output']
  readonly type: LienRightsContractEventType
}

export { LienRightsContractEventType }

export { LienRightsDeadlineAnchor }

export { LienRightsDeadlineGranularity }

export { LienRightsDeadlineModifier }

export { LienRightsKeyDateType }

export { LienRightsMilestoneType }

/** Represents a single lien waiver on a pay app. */
export type LienWaiver = {
  readonly __typename: 'LienWaiver'
  /** Actual check amount entered on a vendor lien waiver form. */
  readonly amount: Maybe<Scalars['SafeInt']['output']>
  /**
   * This is intentionally a string as the claimant could be a sub-sub who is not a user of our system.
   * We will auto-populate with the subcontractor information but if this is a sub-sub, we will ask
   * them to type in their legal name.
   */
  readonly claimant: Scalars['String']['output']
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly customer: Scalars['String']['output']
  readonly date: Scalars['DateTime']['output']
  /**
   * Default check amount to fill lower-tier lien waivers with.
   * We use these values to populate the LIEN_WAIVER_AMOUNT form annotation values.
   * The value of this annotation depends on whehether the amount / text / both are provided by the sub.
   * This is irrelevant for primary lien waivers.
   */
  readonly defaultAmount: Maybe<Scalars['SafeInt']['output']>
  readonly defaultAmountText: Maybe<Scalars['String']['output']>
  /** Default exceptions to fill lower-tier lien waivers with. This is irrelevant for primary lien waivers. */
  readonly defaultExceptionAmounts: Maybe<Scalars['String']['output']>
  readonly defaultExceptionDates: Maybe<Scalars['String']['output']>
  /**
   * Default vendor contacts to send lien waiver requests to. We allow saving the default list so users
   * can edit and persist the recipients prior to sending the requests. If empty, the frontend will
   * defer to `hasSelectedDefaultVendorContacts`: if that field is true, the frontend will show no
   * recipients, and if that field is false, it will show a default list of recipients based on the
   * vendor contract and past lien waivers.
   */
  readonly defaultVendorContacts: ReadonlyArray<VendorContact>
  /** Form template variant that is used to generate the lien waiver. Can be null if lien waiver is uploaded manually. */
  readonly formTemplateVariant: Maybe<FormTemplateVariant>
  /** Form template version that is used to generate the lien waiver. Can be null if lien waiver is uploaded manually. */
  readonly formTemplateVersion: Maybe<FormTemplateVersion>
  /** A list of all user-entered values for this lien waiver. */
  readonly formValues: ReadonlyArray<FormTemplateAnnotationValue>
  /**
   * See above. This field is necessary because we can't distinguish between `defaultVendorContracts`
   * being unset vs empty (since null and an empty array are indistinguishable for @manyToMany fields).
   */
  readonly hasSelectedDefaultVendorContacts: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /**
   * If true, a summary of linked AP invoices will be included in the email body for all
   * requests, and on the vendor landing page. Applies only to vendor lien waivers.
   */
  readonly includeLinkedApInvoiceSummary: Scalars['Boolean']['output']
  /** Refers to whether or not a lien waiver is for a joint check */
  readonly isJointCheck: Scalars['Boolean']['output']
  /**
   * If true, the uploaded file was provided by the subcontractor instead of the vendor.
   * Defaults to false when the file is not provided.
   */
  readonly isUploadedBySubcontractor: Scalars['Boolean']['output']
  readonly jobLocation: Location
  /** The time that this document was last sent in an email. */
  readonly lastSendTime: Maybe<Scalars['DateTime']['output']>
  /** The last write sync for this entity. Null if not successful */
  readonly lastSyncIfSuccessful: Maybe<WriteSyncOperation>
  /** List of LienWaiverRequests from lower-tier companies */
  readonly lienWaiverRequests: ReadonlyArray<LienWaiverRequest>
  /**
   * All commitments associated with the same contract and vendor as the lien waiver.
   * If only one is available, it will be the same one as vendorContractCommitment.
   */
  readonly linkableCommitments: ReadonlyArray<VendorContractCommitment>
  /** AP invoices linked to this lien waiver, either from an integration or Excel upload */
  readonly linkedApInvoices: Maybe<ReadonlyArray<LienWaiverLinkedApInvoice>>
  /**
   * Name of who makes the check. Generally this is the same as the customer, but for vendor joint
   * checks, this will be the general contractor instead of the subcontractor.
   */
  readonly makerOfCheck: Scalars['String']['output']
  /** A note the subcontractor writes to include the email request body */
  readonly message: Maybe<Scalars['String']['output']>
  readonly owner: Scalars['String']['output']
  readonly payApps: ReadonlyArray<PayApp>
  /**
   * Name of who the check is made to. Generally this is the same as the claimant, but for vendor
   * joint checks, this will be both the subcontractor and the vendor instead of just the vendor.
   */
  readonly payableTo: Scalars['String']['output']
  /** Includes information about the physical signatures required on this lien waiver. */
  readonly physicalSignatureRequired: PhysicalSignatureRequired
  readonly preSitelinePayApp: Maybe<PreSitelinePayApp>
  /** File(s) that will be attached to vendor requests for this lien waiver */
  readonly requestAttachments: ReadonlyArray<StoredFile>
  /** A list of each time the signed lien waiver has been sent. */
  readonly sentLog: ReadonlyArray<LienWaiverSendLog>
  readonly signature: Maybe<Signature>
  /** Full name of the signer, entered when uploading a form */
  readonly signerFullName: Maybe<Scalars['String']['output']>
  /** The email subject of the latest lien waiver request */
  readonly subject: Maybe<Scalars['String']['output']>
  readonly timeZone: Scalars['String']['output']
  readonly type: LienWaiverType
  readonly updatedAt: Scalars['DateTime']['output']
  /** If provided, we'll use this file instead of generating it on the fly */
  readonly uploadedFile: Maybe<StoredFile>
  /**
   * VendorContract is optional because a LW can be for a primary subcontractor or for a lower-tier. Only the
   * lower-tier is associated with a VendorContract.
   */
  readonly vendorContract: Maybe<VendorContract>
  /** The specific commitment linked to this lien waiver, if any. */
  readonly vendorContractCommitment: Maybe<VendorContractCommitment>
}

export { LienWaiverCategory }

/**
 * Details for a single point-in-time AP invoice linked to a vendor lien waiver.
 * This represents the state of an invoice when it was imported to request a lien waiver.
 *
 * The same actual invoice may be represented by multiple records, as it may have line items on
 * multiple contracts or be linked to a conditional and unconditional (likely with different
 * amounts paid).
 *
 * Note that the amounts on this invoice pertain only to this lien waiver, i.e. the
 * project this lien waiver is collected on. The actual invoice may have a different
 * total amount, but we care only about the amounts due and paid for this project.
 */
export type LienWaiverLinkedApInvoice = {
  readonly __typename: 'LienWaiverLinkedApInvoice'
  /** Current amount paid. May be less than the net invoice amount if partially paid. */
  readonly amountPaid: Scalars['Float']['output']
  /**
   * The total amount of change orders as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly changeOrderTotalAsOfInvoiceDate: Scalars['Float']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  /**
   * The gross invoice amount, not deducting any retention held but including
   * any tax amount
   */
  readonly grossAmount: Scalars['Float']['output']
  /**
   * Payment date of when the gross invoice amount is fully paid, i.e.
   * if retention is held then the date all retention has been released.
   * Format is YYYY-MM-DD. Null if gross amount not fully paid.
   */
  readonly grossPaidAt: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  /**
   * ERP-specific mapping back to the source AP invoice and (when applicable) the
   * commitment/subcontract the invoice was billed against. Populated at the time a
   * lien waiver is created from integration-sourced invoices. See
   * `VendorContractCommitment.integrationMappings` for the corresponding commitment-side
   * mapping that the calculated `vendorContractCommitment` field joins against.
   */
  readonly integrationMappings: Maybe<Scalars['JSONObject']['output']>
  readonly invoiceCode: Scalars['String']['output']
  /** Format is YYYY-MM-DD */
  readonly invoiceDate: Scalars['String']['output']
  /** True if the gross invoice amount has been fully paid */
  readonly isGrossFullyPaid: Scalars['Boolean']['output']
  /**
   * True if the net invoice amount is fully paid. If retention is held,
   * this may be true even if retention has not been released.
   */
  readonly isNetFullyPaid: Scalars['Boolean']['output']
  readonly lienWaiver: LienWaiver
  /**
   * Payment date of when the net invoice amount is fully paid.
   * Format is YYYY-MM-DD. Null if net amount not fully paid.
   */
  readonly netPaidAt: Maybe<Scalars['String']['output']>
  /** All payment dates for the invoice. Note that the invoice may be partially paid. */
  readonly paymentDates: ReadonlyArray<Scalars['String']['output']>
  /** All payment numbers for the invoice. Note that the invoice may be partially paid. */
  readonly paymentNumbers: ReadonlyArray<Scalars['String']['output']>
  /** Amount of retention held currently held on this invoice */
  readonly retentionAmount: Scalars['Float']['output']
  /**
   * The total amount billed by the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalBilledAsOfInvoiceDate: Scalars['Float']['output']
  /**
   * The total amount paid to the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalPaidAsOfInvoiceDate: Scalars['Float']['output']
  /**
   * The total amount of retention held on the vendor as of the invoice date, in cents.
   *
   * NOTE this is a cumulative amount, so do *not* sum across invoices.
   */
  readonly totalRetentionAsOfInvoiceDate: Scalars['Float']['output']
  /**
   * The Siteline vendor contract commitment (if any) that this linked AP invoice was
   * billed against, resolved via `integrationMappings.integrationContractCommitmentId`
   * and the matching ERP-specific commitment mapping.
   */
  readonly vendorContractCommitment: Maybe<VendorContractCommitment>
}

/** Represents a request to have a Lien Waiver signed by a lower-tier company. */
export type LienWaiverRequest = {
  readonly __typename: 'LienWaiverRequest'
  /**
   * This date is displayed on the UI when a user checks their request status. We intentionally
   * don't use the updatedAt field because if the LienWaiverRequest document metadata isn't modified
   * by a user-driven action then we wouldn't want the date to change. Therefore we explicitly update
   * the actionTakenAt field.
   */
  readonly actionTakenAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lienWaiver: LienWaiver
  /** The most recent user to send this request */
  readonly requestedBy: Maybe<User>
  readonly status: DocumentRequestStatus
  readonly statusLogs: ReadonlyArray<LienWaiverRequestStatusLog>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly validation: Maybe<LienWaiverRequestValidation>
  readonly vendorContact: VendorContact
}

export type LienWaiverRequestData = {
  readonly __typename: 'LienWaiverRequestData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly lienWaiversRequested: Scalars['SafeInt']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

/** Represents a log of all statuses for a lien waiver request  and when the transition occurred. */
export type LienWaiverRequestStatusLog = {
  readonly __typename: 'LienWaiverRequestStatusLog'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly ipAddress: Maybe<Scalars['String']['output']>
  readonly lienWaiverRequest: LienWaiverRequest
  readonly status: DocumentRequestStatus
  readonly statusUpdatedAt: Scalars['DateTime']['output']
  /** Person who made the change. If no user or contact is provided, change was made by the system. */
  readonly user: Maybe<User>
  /** Vendor contact who made the change. If no user or contact is provided, change was made by the system. */
  readonly vendorContact: Maybe<VendorContact>
}

/**
 * Automated validation of a lien waiver request, to detect discrepancies between the submitted
 * lien waiver and the template, amount, through date, or signature.
 */
export type LienWaiverRequestValidation = {
  readonly __typename: 'LienWaiverRequestValidation'
  /**
   * List of human-friendly validation errors that were detected by the system.
   * This does not include internal errors like failing to talk to a 3rd-party service during validation.
   */
  readonly amountErrors: ReadonlyArray<Scalars['String']['output']>
  /** Amount detected in the submitted lien waiver */
  readonly detectedAmount: Maybe<Scalars['SafeInt']['output']>
  /**
   * Full name from the signature detected in the submitted lien waiver. We do not detect signatures from uploaded files,
   * so this will only be populated for digitally signed lien waivers.
   */
  readonly detectedSignature: Maybe<Scalars['String']['output']>
  /**
   * Through date detected in the submitted lien waiver
   * Format: YYYY-MM-DD
   */
  readonly detectedThroughDate: Maybe<Scalars['String']['output']>
  /** Amount provided by the subcontractor when requesting the lien waiver */
  readonly expectedAmount: Maybe<Scalars['SafeInt']['output']>
  /**
   * Expected (valid) signatures for the lien waiver request. This not only includes the vendor contact for this request, but also any others
   * that recevied a lien waiver request for this lien waiver and are valid signers.
   */
  readonly expectedSignatures: ReadonlyArray<Scalars['String']['output']>
  /**
   * Expected through date of the lien waiver – which is set to the pay app billing end
   * Format: YYYY-MM-DD
   */
  readonly expectedThroughDate: Maybe<Scalars['String']['output']>
  /**
   * Similarity score between the submitted lien waiver and its source template
   * Value is between 0 and 1, where 1 is a perfect match
   */
  readonly formSimilarity: Maybe<Scalars['Float']['output']>
  readonly formSimilarityErrors: ReadonlyArray<Scalars['String']['output']>
  readonly lienWaiverRequest: LienWaiverRequest
  readonly signatureErrors: ReadonlyArray<Scalars['String']['output']>
  readonly status: LienWaiverRequestValidationStatus
  readonly throughDateErrors: ReadonlyArray<Scalars['String']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

export { LienWaiverRequestValidationStatus }

export type LienWaiverRequestWithToken = {
  readonly __typename: 'LienWaiverRequestWithToken'
  readonly lienWaiverRequest: LienWaiverRequest
  readonly token: Scalars['String']['output']
}

/**
 * Represents a single send action of a lien waiver to a contact at a GC. This will be updated any time
 * a lien waiver is sent as part of a PayApp package or independently outside of it.
 */
export type LienWaiverSendLog = {
  readonly __typename: 'LienWaiverSendLog'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lienWaiver: LienWaiver
  readonly recipients: ReadonlyArray<CompanyContact>
  readonly sender: User
}

export type LienWaiverTotalsByVendorAndProjectForVendorReport = {
  readonly __typename: 'LienWaiverTotalsByVendorAndProjectForVendorReport'
  readonly conditionalWaived: Scalars['SafeInt']['output']
  readonly internalProjectNumber: Scalars['String']['output']
  readonly openCommitmentsAmount: Scalars['SafeInt']['output']
  readonly project: Project
  readonly requestsSent: Scalars['SafeInt']['output']
  /** The number of days it took to return each lien waiver, saved as an array of numbers to enable averaging */
  readonly returnDays: ReadonlyArray<Scalars['SafeInt']['output']>
  readonly unconditionalWaived: Scalars['SafeInt']['output']
  readonly vendor: Vendor
  readonly waiversReturned: Scalars['SafeInt']['output']
}

export { LienWaiverType }

export type LienWaiverWithStatusForVendorReport = {
  readonly __typename: 'LienWaiverWithStatusForVendorReport'
  /** Actual check amount entered on the lien waiver form, in cents */
  readonly amount: Maybe<Scalars['SafeInt']['output']>
  /** Pre-calculated default amount for the lien waiver, in cents */
  readonly defaultAmount: Maybe<Scalars['SafeInt']['output']>
  readonly internalProjectNumber: Scalars['String']['output']
  readonly lienWaiverId: Scalars['ID']['output']
  readonly lienWaiverType: LienWaiverType
  readonly monthYear: Scalars['String']['output']
  /** This includes REQUESTED, REMINDED, and SIGNED, which are not valid DocumentRequestStatus enum values */
  readonly mostRecentStatus: LegalDocumentStatus
  readonly project: Project
  readonly vendorName: Scalars['String']['output']
}

/** DEPRECATED */
export type LienWaiversByMonth = {
  readonly __typename: 'LienWaiversByMonth'
  readonly lienWaivers: ReadonlyArray<LienWaiver>
  /**
   * This is the month that the lien waiver through date corresponds to
   * in the timezone of the lien waiver's project
   */
  readonly month: Scalars['SafeInt']['output']
  readonly year: Scalars['SafeInt']['output']
}

/**
 * The data for a single cell in the vendor lien waivers tracker, corresponding to a vendor contract
 * for a single month in a given category. There may be zero or one lien waiver for that month in the
 * category, and we also return whether the final lien waiver was previously collected.
 */
export type LienWaiversMonth = {
  readonly __typename: 'LienWaiversMonth'
  /** True if a final LW was requested in a prior month and no LWs have been created since */
  readonly hasCollectedFinalLienWaiver: Scalars['Boolean']['output']
  readonly lienWaiver: Maybe<LienWaiver>
}

/**
 * A summary of lien waivers for tracking in a given month. Depending on the query, this may correspond
 * to a contract or a vendor, and will encompass lien waivers in a certain category.
 */
export type LienWaiversMonthSummary = {
  readonly __typename: 'LienWaiversMonthSummary'
  readonly aggregateStatus: AggregateLienWaiverStatus
  /** True if the given month was skipped for billing and no lien waivers exist */
  readonly isMonthSkipped: Scalars['Boolean']['output']
  /** Total number of lien waivers */
  readonly numLienWaivers: Scalars['Int']['output']
  /** The number of lien waivers that have not yet been signed */
  readonly numPendingLienWaivers: Scalars['Int']['output']
}

export type LineItemAddition = {
  readonly __typename: 'LineItemAddition'
  readonly new: SovChangeSetCreateLineItem
}

export type LineItemDeletion = {
  readonly __typename: 'LineItemDeletion'
  readonly oldId: Scalars['ID']['output']
}

export type LineItemGroupAddition = {
  readonly __typename: 'LineItemGroupAddition'
  readonly new: SovChangeSetCreateLineItemGroup
  readonly newId: Scalars['ID']['output']
}

export type LineItemGroupDeletion = {
  readonly __typename: 'LineItemGroupDeletion'
  readonly oldId: Scalars['ID']['output']
}

export type LineItemGroupUpdate = {
  readonly __typename: 'LineItemGroupUpdate'
  readonly new: SovChangeSetUpdateLineItemGroup
  readonly oldId: Scalars['ID']['output']
}

/**
 * Similar to `ProjectMetrics`, but per SOV line item or amount line item on a contract. Every field
 * should be provided for lump sum and unit price projects but only amountBilledAndDraftThisMonth will
 * be provided for quick bills (which is why its the only required field), and only
 * amountBilledAndDraftThisMonth and completedThruMonth will be provided for T&M line items.
 */
export type LineItemMetrics = {
  readonly __typename: 'LineItemMetrics'
  readonly amountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  readonly balanceToFinish: Maybe<Scalars['SafeInt']['output']>
  readonly completedThruMonth: Maybe<Scalars['SafeInt']['output']>
  /** The cost code for the line item */
  readonly costCode: Maybe<Scalars['String']['output']>
  /** The name for SOV line items or the description for quick bill amount line items */
  readonly name: Scalars['String']['output']
  /** The code for SOV line items or the sort order for quick bill amount line items */
  readonly number: Scalars['String']['output']
  readonly percentCompletedThruMonth: Maybe<Scalars['Float']['output']>
  readonly totalValue: Maybe<Scalars['SafeInt']['output']>
}

export { LineItemType }

export type LineItemUpdate = {
  readonly __typename: 'LineItemUpdate'
  readonly new: SovChangeSetUpdateLineItem
  readonly oldId: Scalars['ID']['output']
}

/**
 * A "company" exposed by a multi-company source system (Vista's HQCo, Sage 300's
 * company code, Spectrum's company, …). Naming mirrors Agave's `/link/companies`.
 * Used during peyote setup so the user can pick which one this Siteline integration
 * is scoped to.
 */
export type LinkCompany = {
  readonly __typename: 'LinkCompany'
  /** Opaque identifier the client passes back to phase 2 — Agave UUID or peyote ID. */
  readonly integrationId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
  /** Native vendor-side identifier as a string (e.g. Vista HQCo decimal) */
  readonly sourceCompanyId: Scalars['String']['output']
}

/** Represents a location in the real world. Currently used by a company or a project. */
export type Location = {
  readonly __typename: 'Location'
  readonly city: Scalars['String']['output']
  readonly coordinates: Scalars['LatLng']['output']
  readonly country: Scalars['String']['output']
  readonly county: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly integrationMappings: Maybe<Scalars['JSONObject']['output']>
  /** Optional nickname for this location. */
  readonly nickname: Maybe<Scalars['String']['output']>
  readonly postalCode: Maybe<Scalars['String']['output']>
  readonly state: Scalars['String']['output']
  readonly street1: Maybe<Scalars['String']['output']>
  readonly street2: Maybe<Scalars['String']['output']>
  readonly timeZone: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type LocationInput = {
  readonly city: Scalars['String']['input']
  readonly coordinates: Scalars['LatLng']['input']
  readonly country: Scalars['String']['input']
  readonly county?: InputMaybe<Scalars['String']['input']>
  readonly nickname?: InputMaybe<Scalars['String']['input']>
  readonly postalCode?: InputMaybe<Scalars['String']['input']>
  readonly state: Scalars['String']['input']
  readonly street1?: InputMaybe<Scalars['String']['input']>
  readonly street2?: InputMaybe<Scalars['String']['input']>
}

export type LowerTierToVendorContract = {
  readonly __typename: 'LowerTierToVendorContract'
  readonly vendorContractId: Scalars['ID']['output']
  readonly vendorId: Scalars['ID']['output']
  readonly vendorName: Scalars['ID']['output']
}

/** Suggested address from address verification */
export type MailAddress = {
  readonly __typename: 'MailAddress'
  readonly city: Maybe<Scalars['String']['output']>
  readonly country: Maybe<Scalars['String']['output']>
  readonly line1: Scalars['String']['output']
  readonly line2: Maybe<Scalars['String']['output']>
  readonly postalOrZip: Maybe<Scalars['String']['output']>
  readonly provinceOrState: Maybe<Scalars['String']['output']>
}

/** Mail address for shipping, including company name and/or first and last name */
export type MailAddressWithName = {
  readonly __typename: 'MailAddressWithName'
  readonly city: Maybe<Scalars['String']['output']>
  readonly companyName: Maybe<Scalars['String']['output']>
  readonly country: Maybe<Scalars['String']['output']>
  readonly firstName: Maybe<Scalars['String']['output']>
  /** True if address comes from a prior mail order, false if from office/location fallback */
  readonly isVerified: Scalars['Boolean']['output']
  readonly lastName: Maybe<Scalars['String']['output']>
  readonly line1: Scalars['String']['output']
  readonly line2: Maybe<Scalars['String']['output']>
  readonly postalOrZip: Maybe<Scalars['String']['output']>
  readonly provinceOrState: Maybe<Scalars['String']['output']>
}

/** Represents a mail order for sending physical mail via PostGrid */
export type MailOrder = {
  readonly __typename: 'MailOrder'
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  /** Set when the order is for a compliance LegalDocument; null when using lienRightsMetadata (lien rights mail). */
  readonly document: Maybe<LegalDocument>
  readonly id: Scalars['ID']['output']
  /** Set when the order is for a lien rights milestone; null when using document. */
  readonly lienRightsMetadata: Maybe<ContractLienRightsMilestoneMetadata>
  readonly shipments: ReadonlyArray<MailOrderShipment>
  readonly status: MailOrderStatus
  readonly totalAmount: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly user: User
}

export { MailOrderDocumentType }

export { MailOrderOptionType }

/** Represents a pricing option for mail orders (e.g. print, tracking, shipping) */
export type MailOrderPricingOption = {
  readonly __typename: 'MailOrderPricingOption'
  /** Additional page price in cents (for print options only; null for tracking/shipping) */
  readonly additionalPagePriceCents: Maybe<Scalars['SafeInt']['output']>
  /** Stable identifier for the option (e.g. black_and_white, color, certified_nrr, certified_err, priority_mail) */
  readonly code: Scalars['String']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** Category of option for UI grouping (print, tracking, or shipping) */
  readonly optionType: MailOrderOptionType
  /** Base price in cents (e.g. first page for print options, flat price for add-ons) */
  readonly priceCents: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Represents a single shipment/recipient within a PostGrid mail order */
export type MailOrderShipment = {
  readonly __typename: 'MailOrderShipment'
  readonly amount: Scalars['SafeInt']['output']
  readonly createdAt: Scalars['DateTime']['output']
  /** PostGrid extra service: certified, certified_return_receipt, or null */
  readonly extraService: Maybe<Scalars['String']['output']>
  readonly fromAddress: Scalars['JSONObject']['output']
  readonly id: Scalars['ID']['output']
  readonly mailOrder: MailOrder
  readonly postgridEvents: ReadonlyArray<Scalars['JSONObject']['output']>
  readonly postgridLetterId: Maybe<Scalars['String']['output']>
  readonly status: MailOrderShipmentStatus
  readonly toAddress: Scalars['JSONObject']['output']
  readonly trackingNumber: Maybe<Scalars['String']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly useColor: Scalars['Boolean']['output']
  readonly useDoubleSided: Scalars['Boolean']['output']
  readonly useExpress: Scalars['Boolean']['output']
}

export { MailOrderShipmentStatus }

export { MailOrderStatus }

export type MarkFormTemplateAsDuplicateInput = {
  readonly duplicateTemplateId: Scalars['ID']['input']
  readonly id: Scalars['ID']['input']
}

export type MarkLienWaiverRequestsAsSubmittedForMonthInput = {
  readonly companyId: Scalars['ID']['input']
  readonly month: Scalars['SafeInt']['input']
  readonly year: Scalars['SafeInt']['input']
}

export type MarkOldSubmittedPayAppsAsPaidInput = {
  readonly companyId: Scalars['ID']['input']
}

export type MarkWriteSyncAsFailedInput = {
  readonly notifyUser: Scalars['Boolean']['input']
  readonly writeSyncOperationId: Scalars['ID']['input']
}

export type MergeGeneralContractorsInput = {
  readonly destinationId: Scalars['ID']['input']
  readonly sourceIds: ReadonlyArray<Scalars['ID']['input']>
}

export type MigrateIntegrationContractsInput = {
  readonly fromCompanyIntegrationId: Scalars['ID']['input']
  readonly isSameInstance: Scalars['Boolean']['input']
  readonly toCompanyIntegrationId: Scalars['ID']['input']
}

export type MigrateIntegrationVendorsInput = {
  readonly fromCompanyIntegrationId: Scalars['ID']['input']
  readonly isSameInstance: Scalars['Boolean']['input']
  readonly toCompanyIntegrationId: Scalars['ID']['input']
}

/** A company linked to a form template as the requesting company */
export type MinimalFormTurnaroundCompany = {
  readonly __typename: 'MinimalFormTurnaroundCompany'
  readonly id: Scalars['ID']['output']
  readonly name: Scalars['String']['output']
}

export type MinimalFormTurnaroundFormTemplate = {
  readonly __typename: 'MinimalFormTurnaroundFormTemplate'
  readonly builderId: Maybe<Scalars['ID']['output']>
  readonly id: Scalars['ID']['output']
  readonly ownerId: Maybe<Scalars['ID']['output']>
  readonly requestingCompanyId: Maybe<Scalars['ID']['output']>
  readonly userVisibleName: Scalars['String']['output']
  readonly validatorId: Maybe<Scalars['ID']['output']>
}

/** A user attached to a form template, either as owner, validator, or builder */
export type MinimalFormTurnaroundUser = {
  readonly __typename: 'MinimalFormTurnaroundUser'
  readonly firstName: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly lastName: Scalars['String']['output']
}

export type ModifyEmailPreferencesInput = {
  readonly block: Scalars['Boolean']['input']
  readonly emailTypes: ReadonlyArray<EmailType>
  readonly userId: Scalars['ID']['input']
}

export type ModifyNotificationPreferencesInput = {
  readonly block: Scalars['Boolean']['input']
  readonly notificationTypes: ReadonlyArray<NotificationType>
  readonly userId: Scalars['ID']['input']
}

/** Breakdown of amount billed and amount billed plus draft across all projects in a single month */
export type MonthlyBillingBreakdown = {
  readonly __typename: 'MonthlyBillingBreakdown'
  /**
   * Amount of progress billed across all projects that have pay apps submitted or in draft in a
   * single month. Does not include retention billed and does not subtract retention held.
   */
  readonly amountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  /**
   * Amount of progress billed across all projects in a single month, excluding projects in draft. Does
   * not include retention billed and does not subtract retention held.
   */
  readonly amountBilledThisMonth: Scalars['SafeInt']['output']
  readonly month: Scalars['DateTime']['output']
}

export type Mutation = {
  readonly __typename: 'Mutation'
  /** Adds an integration to a company. There can be multiple integrations of the same type per company. */
  readonly addCompanyIntegration: CompanyIntegration
  /** Adds a comment to a FormTemplate */
  readonly addFormTemplateComment: FormTemplateComment
  /** Applies a set of overrides to an annotation and variant */
  readonly applyAnnotationOverride: AnnotationOverride
  /** Archives a company integration. Syncs will no longer be run for this integration. */
  readonly archiveCompanyIntegration: CompanyIntegration
  /** Deletes all of the contacts (GC contacts) from a company object. */
  readonly clearCompanyContacts: Company
  /** Clears all events for a pay app to wipe the activity feed */
  readonly clearPayAppEvents: PayApp
  /** Clones a form template. Mostly used to split out a template request into many different templates */
  readonly cloneFormTemplate: FormTemplate
  /** Clones a form template version and associated form annotations */
  readonly cloneFormTemplateVersion: FormTemplateVersion
  /** Changes a contract's retention tracking lever and adds/removes the relevant retention changelogs */
  readonly convertRetentionTrackingLevel: Contract
  /** Creates a dummy admin user object if one doesn't already exist */
  readonly createAdminUser: User
  /** Creates a company with no users */
  readonly createCompany: Company
  /** Creates a company contact. */
  readonly createCompanyContact: CompanyContact
  /** Creates a new company form template collection */
  readonly createCompanyFormTemplateCollection: Company
  /** Creates a new feature flag */
  readonly createFeatureFlag: FeatureFlag
  /** Adds a form template */
  readonly createFormTemplate: FormTemplate
  /** Creates a form template annotation for an existing form template. */
  readonly createFormTemplateAnnotation: FormTemplateAnnotation
  /** Creates multiple template annotations for an existing form template. */
  readonly createFormTemplateAnnotations: ReadonlyArray<FormTemplateAnnotation>
  /** Adds a form template version and associated form annotations */
  readonly createFormTemplateVersion: FormTemplateVersion
  /** Creates a new lien waiver template set for a company */
  readonly createLienWaiverFormTemplateSet: Company
  /** Creates a new location in the database, specific to a company. */
  readonly createLocation: Location
  /** Creates a new pay app template set for a company */
  readonly createPayAppFormTemplateSet: Company
  /** Creates a new SOV line item group */
  readonly createSovLineItemGroup: SovLineItemGroup
  /** Creates a new template variant */
  readonly createTemplateVariant: FormTemplateVariant
  /** Quickly creates a template for test purposes */
  readonly createTestTemplate: FormTemplate
  /** Creates a new user education campaign, effective immediately until its expiration date */
  readonly createUserEducationCampaign: UserEducationCampaign
  /**
   * Deletes ALL projects for a company (based on contracts.company_id).
   * Requires typing a confirmation phrase.
   */
  readonly deleteAllContractsForCompany: Company
  /**
   * Removes every annotation on the version that was originally suggested by AI, including ones
   * that have since been converted into a real annotation type. Returns the deleted annotation ids.
   */
  readonly deleteAnnotationsFromAiSuggestion: FormTemplateVersion
  /** Deletes keys from the generic or files cache */
  readonly deleteCacheKeys: Scalars['Boolean']['output']
  /** Deletes a company. Only allows if company does not belong to a project. */
  readonly deleteCompany: DeletionResult
  /** Deletes a company form template collection */
  readonly deleteCompanyFormTemplateCollection: Company
  /** Delete a form template. There can't be any usages of it to delete it. */
  readonly deleteFormTemplate: DeletionResult
  /** Deletes multiple form template annotations. */
  readonly deleteFormTemplateAnnotations: ReadonlyArray<DeletionResult>
  /** Deletes a comment from a FormTemplate */
  readonly deleteFormTemplateComment: DeletionResult
  /** Delete a form template version. There can't be any usages of it to delete it. */
  readonly deleteFormTemplateVersion: DeletionResult
  /** Deletes an integration from a contract */
  readonly deleteIntegration: DeletionResult
  /** Deletes a lien waiver template set for a company */
  readonly deleteLienWaiverFormTemplateSet: Company
  /** Removes all lien waiver requests for a specific month, across an entire company. Used for demos. */
  readonly deleteLienWaiverRequestsForMonth: Scalars['Boolean']['output']
  /** Deletes a pay-app. Only allowed if pay-app is DRAFT. */
  readonly deletePayApp: DeletionResult
  /** Deletes a pay app template set for a company */
  readonly deletePayAppFormTemplateSet: Company
  /** Deletes a project */
  readonly deleteProject: DeletionResult
  /** Deletes a line item, assuming it hasn't been billed for. */
  readonly deleteSovLineItem: DeletionResult
  /** Deletes an SOV line item group */
  readonly deleteSovLineItemGroup: DeletionResult
  /** Deletes a template variant */
  readonly deleteTemplateVariant: DeletionResult
  /** Fully deletes a vendor, its contacts, and all lien waivers / documents related to it */
  readonly deleteVendor: DeletionResult
  /** Disables lower-tier lien-waivers for a contract */
  readonly disableLowerTierLienWaivers: Contract
  /** Disables primary lien-waivers for a contract */
  readonly disablePrimaryLienWaivers: Contract
  /** Disables sub-tier lien-waivers for a contract */
  readonly disableSubTierLienWaivers: Contract
  /** Suspends a user by removing their access and disabling their account */
  readonly disableUser: User
  /** Updates an integration credential */
  readonly enableIntegrationCredentialAutoRotation: CompanyIntegration
  /** Enables lower-tier lien-waivers for a contract, by passing a set of templates */
  readonly enableLowerTierLienWaivers: Contract
  /** Enables primary lien-waivers for a contract, by passing a set of templates */
  readonly enablePrimaryLienWaivers: Contract
  /** Enables sub-tier lien-waivers for a contract, by passing a set of templates */
  readonly enableSubTierLienWaivers: Contract
  /** Re-enables a user in the database and on Firebase */
  readonly enableUser: User
  /** Exports credentials for a company integration to Postman environments. */
  readonly exportIntegrationCredentialsToPostman: Scalars['Boolean']['output']
  /** Sends an email to the users on the given contract notifying them that their forms are ready. */
  readonly finishedOnboardingForms: Contract
  /** Generates a pairing code for the Sage 100 Contractor Peyote on-prem connector */
  readonly generateSage100PeyotePairingCode: Scalars['String']['output']
  /** Updates a form template <> contract association to ignore the uploaded form template type */
  readonly ignoreFormTemplateProvidedType: Contract
  /** Imports a SOV from an integration including adding, deleting, or updating existing line items. */
  readonly importSovFromIntegration: Sov
  /** Creates a user, associates it with the provided company, and send them an invite email */
  readonly inviteCompanyUser: CompanyUser
  /**
   * Marks a company as churned and archives all of its company integrations.
   * Requires typing a confirmation phrase.
   */
  readonly markCompanyAsChurned: Company
  /** Marks a template as a duplicate of another template */
  readonly markFormTemplateAsDuplicate: FormTemplate
  /** Marks all lien waiver requests as submitted for a specific month, across an entire company. Used for demos. */
  readonly markLienWaiverRequestsAsSubmittedForMonth: Scalars['Boolean']['output']
  /** Marks all old (>75 days) submitted pay apps as paid, across an entire company. Used for demos. */
  readonly markOldSubmittedPayAppsAsPaid: Scalars['Boolean']['output']
  /**
   * Marks a write sync as failed and notifies the person who initiated the sync.
   * This is useful when syncs are stuck in NOT_STARTED state and weren't processed by the integrations service.
   */
  readonly markWriteSyncAsFailed: WriteSyncOperation
  /** Merges multiple GCs to a single destination GC, updating all references to the old ones */
  readonly mergeGeneralContractors: Scalars['Boolean']['output']
  /**
   * For every active contract linked to a certain integration, attempts to create a new integration
   * linking the contract to a different system. If successful, marks the first integration inactive.
   */
  readonly migrateIntegrationContracts: Scalars['String']['output']
  /**
   * For every active vendor linked to a certain integration, attempts to remove the current mapping
   * and create a new mapping to the target integration.
   */
  readonly migrateIntegrationVendors: Scalars['String']['output']
  /** Blocks email notifications for a given type. */
  readonly modifyEmailPreferences: User
  /** Blocks push notifications for a given type. */
  readonly modifyNotificationPreferences: User
  /** Lists database roles and permissions for the user. */
  readonly peyoteCheckDatabasePermissions: PeyoteSqlDebuggerResult
  /** Verifies TCP reachability via the egress proxy. */
  readonly peyoteCheckNetworkConnection: PeyoteSqlDebuggerResult
  /** Validates credentials, returns DB metadata. */
  readonly peyoteCheckUsernamePassword: PeyoteSqlDebuggerResult
  /** Refreshes mappings for an integration by querying the third-party and running a matching algorithm */
  readonly refreshIntegrationMappings: Integration
  /** Replaces all annotations of a template version with the provided annotations. */
  readonly replaceFormTemplateAnnotations: ReadonlyArray<FormTemplateAnnotation>
  /**
   * Adds a write sync back to the Cloud Task queue.
   * This is useful when a sync is stuck and needs to be requeued.
   * You should not use this when a sync fails. Instead you should create a new sync from the main app.
   */
  readonly requeueWriteSync: WriteSyncOperation
  /** Resends an invite email to the specified user */
  readonly resendUserInvite: User
  /** Clear a pay-app entirely and set its status to DRAFT */
  readonly resetPayApp: PayApp
  /** Removes MFA enrollment for a user in Firebase */
  readonly resetUserMfa: User
  /** Retract a pay-app and set it to DRAFT */
  readonly retractPayApp: PayApp
  /**
   * Rotates the external API token for a company. It returns the token that was generated.
   * The token cannot be read from the database after it is generated.
   */
  readonly rotateExternalApiToken: Scalars['String']['output']
  /** Rotates the credentials for a company integration automatically */
  readonly rotateIntegrationCredential: CompanyIntegration
  /**
   * Kicks off the AI annotation pipeline for a form template version
   * - Extraction sends the source PDF to Reducto and writes the inferred fillable fields as AI_SUGGESTION annotations
   * - LLM classification then asks Claude to assign each row a type (TEMPLATE_VARIABLE, USER_ENTERED_FIELD, SIGNATURE, IMAGE) along with the relevant
   * key fields (selectedKey, defaultValueKey, signatureType, imageType) plus an audit row in suggestedTemplateVariableReason
   *
   * Rows the model can't classify confidently stay as AI_SUGGESTION
   *
   * Returns the run in QUEUED phase; the worker publishes phase updates over `formTemplateSuggestionsRunUpdated` until COMPLETED or FAILED
   */
  readonly runFormTemplateSuggestions: FormTemplateSuggestionsRun
  /** Sends a test monthly report email for a given company */
  readonly sendCompanyMonthlyReportTestEmail: ReadonlyArray<User>
  /** Set internal siteline notes for a company */
  readonly setCompanyInternalSitelineNotes: Scalars['Boolean']['output']
  /** Adds a list of FormTemplateTags to the given FormTemplate */
  readonly setFormTemplateTags: FormTemplate
  /** Sets a Legal Document as SYNCED manually. */
  readonly setLegalDocumentSynced: LegalRequirement
  /** Sets which SovLineItems are in an SovLineItemGroup. */
  readonly setLineItemsInGroup: SovLineItemGroup
  /** Sets a pay-app to PROPOSED manually */
  readonly setPayAppProposed: PayApp
  /** Sets a pay-app to SYNCED manually */
  readonly setPayAppSynced: PayApp
  /** Skips validation on a form template to allow it to be added to projects */
  readonly skipFormTemplateValidation: FormTemplate
  /** Tests the connection to the Sage 100 Contractor Peyote on-prem connector */
  readonly testSage100PeyoteConnectorConnection: PeyoteConnectorStatus
  /** Un-archives a company integration. Syncs will be able to run again for this integration. */
  readonly unarchiveCompanyIntegration: CompanyIntegration
  /** Saves an Acumatica Peyote instance's connected-app config (before the OAuth authorize flow) */
  readonly updateAcumaticaPeyoteCredentials: CompanyIntegration
  /** Updates an Agave specific integration credential */
  readonly updateAgaveIntegrationCredential: CompanyIntegration
  /** Updates the change order log form on a project */
  readonly updateChangeOrderLogForm: Contract
  /** Updates the change order forms on a project */
  readonly updateChangeOrderRequestForm: Contract
  /**
   * Saves CMiC Peyote Basic Auth credentials, after verifying them against the customer's
   * instance. Setup continues with picking the GL company to read from.
   */
  readonly updateCmicPeyoteBasicCredentials: Scalars['Boolean']['output']
  /**
   * Saves the CMiC Peyote instance's OAuth client config. Written before the authorize flow
   * runs, so any tokens from a prior authorization of the same client are preserved.
   */
  readonly updateCmicPeyoteOauthCredentials: Scalars['Boolean']['output']
  /** Updates a company */
  readonly updateCompany: Company
  /** Updates a company contact */
  readonly updateCompanyContact: CompanyContact
  /** Updates a company form template collection */
  readonly updateCompanyFormTemplateCollection: Company
  /** Updates a company integration */
  readonly updateCompanyIntegration: CompanyIntegration
  /** Updates the metadata for a contract on a project */
  readonly updateContract: Contract
  /** Updates the list of users on a project */
  readonly updateContractUsers: Contract
  /** Sets the default change order log templates for a company. */
  readonly updateDefaultChangeOrderLogForm: Company
  /** Sets the default change order request templates for a company. */
  readonly updateDefaultChangeOrderRequestForm: Company
  /** Updates an existing feature flag */
  readonly updateFeatureFlag: FeatureFlag
  /** Updates the form template metadata */
  readonly updateFormTemplate: FormTemplate
  /** Updates form template annotations that on an existing form template. */
  readonly updateFormTemplateAnnotations: ReadonlyArray<FormTemplateAnnotation>
  /** Updates the associated company on a FormTemplate */
  readonly updateFormTemplateAssociatedCompany: FormTemplate
  /** Updates the associated contracts on a FormTemplate */
  readonly updateFormTemplateAssociatedContracts: FormTemplate
  /** Updates the builder of a template */
  readonly updateFormTemplateBuilder: FormTemplate
  /** Updates the due date of a template */
  readonly updateFormTemplateDueDate: FormTemplate
  /** Updates the original file of a template */
  readonly updateFormTemplateOriginalFile: FormTemplate
  /** Updates the owner of a template */
  readonly updateFormTemplateOwner: FormTemplate
  /** Updates the requesting company on a FormTemplate */
  readonly updateFormTemplateRequestingCompany: FormTemplate
  /** Updates the status of a Form Template. */
  readonly updateFormTemplateStatus: FormTemplate
  /** Updates the validator of a template */
  readonly updateFormTemplateValidator: FormTemplate
  /** Updates the form template version metadata, but not the annotations. */
  readonly updateFormTemplateVersion: FormTemplateVersion
  /** Saves Foundation Peyote DB credentials (host/port/database/user/password) */
  readonly updateFoundationPeyoteCredentials: Scalars['Boolean']['output']
  /** Updates an integration credential */
  readonly updateIntegrationCredential: CompanyIntegration
  /** Updates mappings for an integration */
  readonly updateIntegrationMappings: Integration
  /** Updates the legal requirements on a project */
  readonly updateLegalRequirements: Contract
  /** Updates a lien waiver template set for a company */
  readonly updateLienWaiverFormTemplateSet: Company
  /**
   * Sets the chosen source-system company on a peyote integration's saved credentials
   * (e.g. Vista's HQCo). `sourceCompanyId` is the native vendor-side identifier from
   * a `LinkCompany` row. Phase 2 of the peyote setup flow.
   */
  readonly updateLinkCompany: Scalars['Boolean']['output']
  /** Updates an existing location in the database. User must be a member of company to update. */
  readonly updateLocation: Location
  /** Update individual onboarding flags on the contract */
  readonly updateOnboardedProjectContractStatus: Contract
  /** Edit details about a pay app that was created. */
  readonly updatePayApp: PayApp
  /** Updates a pay app template set for a company */
  readonly updatePayAppFormTemplateSet: Company
  /** Updates the pay app requirements on a project */
  readonly updatePayAppRequirementGroups: Contract
  /** Updates a project */
  readonly updateProject: Project
  /** Updates whether retention is rounded on the contract. */
  readonly updateRoundRetention: Contract
  /**
   * Saves Sage Intacct Peyote Web Services credentials (company id / user id /
   * password) for the XML Gateway. The partner sender id/password are supplied by
   * Siteline and live in config, not per-company storage.
   */
  readonly updateSageIntacctPeyoteCredentials: Scalars['Boolean']['output']
  /** Updates an SOV line item group */
  readonly updateSovLineItemGroup: SovLineItemGroup
  /**
   * Saves the chosen Spectrum company code on top of existing DB credentials. Phase 2
   * of the Spectrum Peyote setup flow.
   */
  readonly updateSpectrumPeyoteCompany: Scalars['Boolean']['output']
  /**
   * Saves Spectrum Peyote DB credentials (host/port/database/user/password). Setup is
   * two-phase: this writes the connection details so the next step can list the
   * available company codes via `linkCompanies`.
   */
  readonly updateSpectrumPeyoteCredentials: Scalars['Boolean']['output']
  /** Updates the lien rights requirements for a state */
  readonly updateStateLienRequirementsSummary: StateLienRequirementsSummary
  /** Updates new template variant */
  readonly updateTemplateVariant: FormTemplateVariant
  /** Edits a new user education campaign */
  readonly updateUserEducationCampaign: UserEducationCampaign
  /** Saves Vista Peyote DB credentials (host/port/database/user/password) */
  readonly updateVistaPeyoteCredentials: Scalars['Boolean']['output']
}

export type MutationAddCompanyIntegrationArgs = {
  input: AddCompanyIntegrationInput
}

export type MutationAddFormTemplateCommentArgs = {
  input: AddFormTemplateCommentInput
}

export type MutationApplyAnnotationOverrideArgs = {
  input: ApplyAnnotationOverrideInput
}

export type MutationArchiveCompanyIntegrationArgs = {
  id: Scalars['ID']['input']
}

export type MutationClearCompanyContactsArgs = {
  id: Scalars['ID']['input']
}

export type MutationClearPayAppEventsArgs = {
  payAppId: Scalars['ID']['input']
}

export type MutationCloneFormTemplateArgs = {
  input: CloneFormTemplateInput
}

export type MutationCloneFormTemplateVersionArgs = {
  formTemplateVersionId: Scalars['ID']['input']
}

export type MutationConvertRetentionTrackingLevelArgs = {
  input: ConvertRetentionTrackingLevelInput
}

export type MutationCreateAdminUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationCreateCompanyArgs = {
  company: CompanyInput
}

export type MutationCreateCompanyContactArgs = {
  input: CreateCompanyContactInput
}

export type MutationCreateCompanyFormTemplateCollectionArgs = {
  input: CreateCompanyFormTemplateCollectionInput
}

export type MutationCreateFeatureFlagArgs = {
  input: CreateFeatureFlagInput
}

export type MutationCreateFormTemplateArgs = {
  input: CreateFormTemplateInput
}

export type MutationCreateFormTemplateAnnotationArgs = {
  input: CreateFormAnnotationInput
}

export type MutationCreateFormTemplateAnnotationsArgs = {
  input: CreateFormAnnotationsInput
}

export type MutationCreateFormTemplateVersionArgs = {
  input: CreateFormTemplateVersionInput
}

export type MutationCreateLienWaiverFormTemplateSetArgs = {
  input: CreateLienWaiverFormTemplateSetInput
}

export type MutationCreateLocationArgs = {
  input: CreateLocationInput
}

export type MutationCreatePayAppFormTemplateSetArgs = {
  input: CreatePayAppFormTemplateSetInput
}

export type MutationCreateSovLineItemGroupArgs = {
  input: CreateSovLineItemGroupInput
}

export type MutationCreateTemplateVariantArgs = {
  input: CreateTemplateVariantInput
}

export type MutationCreateTestTemplateArgs = {
  input: CreateTestTemplateInput
}

export type MutationCreateUserEducationCampaignArgs = {
  input: CreateUserEducationCampaignInput
}

export type MutationDeleteAllContractsForCompanyArgs = {
  companyId: Scalars['ID']['input']
  confirmation: Scalars['String']['input']
}

export type MutationDeleteAnnotationsFromAiSuggestionArgs = {
  input: DeleteAnnotationsFromAiSuggestionInput
}

export type MutationDeleteCacheKeysArgs = {
  input: DeleteCacheKeysInput
}

export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCompanyFormTemplateCollectionArgs = {
  input: DeleteCompanyFormTemplateCollectionInput
}

export type MutationDeleteFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFormTemplateAnnotationsArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>
}

export type MutationDeleteFormTemplateCommentArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFormTemplateVersionArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteLienWaiverFormTemplateSetArgs = {
  input: DeleteLienWaiverFormTemplateSetInput
}

export type MutationDeleteLienWaiverRequestsForMonthArgs = {
  input: DeleteLienWaiverRequestsForMonthInput
}

export type MutationDeletePayAppArgs = {
  payAppId: Scalars['ID']['input']
}

export type MutationDeletePayAppFormTemplateSetArgs = {
  input: DeletePayAppFormTemplateSetInput
}

export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSovLineItemArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSovLineItemGroupArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteTemplateVariantArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteVendorArgs = {
  id: Scalars['ID']['input']
}

export type MutationDisableLowerTierLienWaiversArgs = {
  contractId: Scalars['ID']['input']
}

export type MutationDisablePrimaryLienWaiversArgs = {
  contractId: Scalars['ID']['input']
}

export type MutationDisableSubTierLienWaiversArgs = {
  contractId: Scalars['ID']['input']
}

export type MutationDisableUserArgs = {
  input: DisableUserInput
}

export type MutationEnableIntegrationCredentialAutoRotationArgs = {
  input: EnableIntegrationCredentialAutoRotationInput
}

export type MutationEnableLowerTierLienWaiversArgs = {
  input: EnableLienWaiverInput
}

export type MutationEnablePrimaryLienWaiversArgs = {
  input: EnableLienWaiverInput
}

export type MutationEnableSubTierLienWaiversArgs = {
  input: EnableLienWaiverInput
}

export type MutationEnableUserArgs = {
  input: EnableUserInput
}

export type MutationExportIntegrationCredentialsToPostmanArgs = {
  input: ExportIntegrationCredentialsToPostmanInput
}

export type MutationFinishedOnboardingFormsArgs = {
  id: Scalars['ID']['input']
}

export type MutationGenerateSage100PeyotePairingCodeArgs = {
  companyIntegrationId: Scalars['ID']['input']
}

export type MutationIgnoreFormTemplateProvidedTypeArgs = {
  input: IgnoreFormTemplateProvidedTypeInput
}

export type MutationImportSovFromIntegrationArgs = {
  input: ImportSovFromIntegrationInput
}

export type MutationInviteCompanyUserArgs = {
  input: InviteCompanyUserInput
}

export type MutationMarkCompanyAsChurnedArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationMarkFormTemplateAsDuplicateArgs = {
  input: MarkFormTemplateAsDuplicateInput
}

export type MutationMarkLienWaiverRequestsAsSubmittedForMonthArgs = {
  input: MarkLienWaiverRequestsAsSubmittedForMonthInput
}

export type MutationMarkOldSubmittedPayAppsAsPaidArgs = {
  input: MarkOldSubmittedPayAppsAsPaidInput
}

export type MutationMarkWriteSyncAsFailedArgs = {
  input: MarkWriteSyncAsFailedInput
}

export type MutationMergeGeneralContractorsArgs = {
  input: MergeGeneralContractorsInput
}

export type MutationMigrateIntegrationContractsArgs = {
  input: MigrateIntegrationContractsInput
}

export type MutationMigrateIntegrationVendorsArgs = {
  input: MigrateIntegrationVendorsInput
}

export type MutationModifyEmailPreferencesArgs = {
  input: ModifyEmailPreferencesInput
}

export type MutationModifyNotificationPreferencesArgs = {
  input: ModifyNotificationPreferencesInput
}

export type MutationPeyoteCheckDatabasePermissionsArgs = {
  input: PeyoteCheckDatabasePermissionsInput
}

export type MutationPeyoteCheckNetworkConnectionArgs = {
  input: PeyoteCheckNetworkConnectionInput
}

export type MutationPeyoteCheckUsernamePasswordArgs = {
  input: PeyoteCheckUsernamePasswordInput
}

export type MutationRefreshIntegrationMappingsArgs = {
  input: RefreshIntegrationMappingsInput
}

export type MutationReplaceFormTemplateAnnotationsArgs = {
  input: ReplaceFormTemplateAnnotationsInput
}

export type MutationRequeueWriteSyncArgs = {
  input: RequeueWriteSyncInput
}

export type MutationResendUserInviteArgs = {
  id: Scalars['ID']['input']
}

export type MutationResetPayAppArgs = {
  payAppId: Scalars['ID']['input']
}

export type MutationResetUserMfaArgs = {
  userId: Scalars['ID']['input']
}

export type MutationRetractPayAppArgs = {
  payAppId: Scalars['ID']['input']
}

export type MutationRotateExternalApiTokenArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationRotateIntegrationCredentialArgs = {
  input: RotateIntegrationCredentialInput
}

export type MutationRunFormTemplateSuggestionsArgs = {
  input: RunFormTemplateSuggestionsInput
}

export type MutationSendCompanyMonthlyReportTestEmailArgs = {
  input: SendCompanyMonthlyReportTestEmailInput
}

export type MutationSetCompanyInternalSitelineNotesArgs = {
  input: SetCompanyInternalSitelineNotesInput
}

export type MutationSetFormTemplateTagsArgs = {
  input: SetFormTemplateTagsInput
}

export type MutationSetLegalDocumentSyncedArgs = {
  id: Scalars['ID']['input']
}

export type MutationSetLineItemsInGroupArgs = {
  input: SetLineItemsInGroupInput
}

export type MutationSetPayAppProposedArgs = {
  input: SetPayAppProposedInput
}

export type MutationSetPayAppSyncedArgs = {
  input: SetPayAppSyncedInput
}

export type MutationSkipFormTemplateValidationArgs = {
  input: SkipFormTemplateValidationInput
}

export type MutationTestSage100PeyoteConnectorConnectionArgs = {
  companyIntegrationId: Scalars['ID']['input']
}

export type MutationUnarchiveCompanyIntegrationArgs = {
  id: Scalars['ID']['input']
}

export type MutationUpdateAcumaticaPeyoteCredentialsArgs = {
  input: UpdateAcumaticaPeyoteCredentialsInput
}

export type MutationUpdateAgaveIntegrationCredentialArgs = {
  input: UpdateAgaveIntegrationCredentialInput
}

export type MutationUpdateChangeOrderLogFormArgs = {
  input: UpdateChangeOrderLogFormInput
}

export type MutationUpdateChangeOrderRequestFormArgs = {
  input: UpdateChangeOrderRequestFormInput
}

export type MutationUpdateCmicPeyoteBasicCredentialsArgs = {
  input: UpdateCmicPeyoteBasicCredentialsInput
}

export type MutationUpdateCmicPeyoteOauthCredentialsArgs = {
  input: UpdateCmicPeyoteOauthCredentialsInput
}

export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput
}

export type MutationUpdateCompanyContactArgs = {
  input: UpdateCompanyContactInput
}

export type MutationUpdateCompanyFormTemplateCollectionArgs = {
  input: UpdateCompanyFormTemplateCollectionInput
}

export type MutationUpdateCompanyIntegrationArgs = {
  input: UpdateCompanyIntegrationInput
}

export type MutationUpdateContractArgs = {
  input: UpdateContractInput
}

export type MutationUpdateContractUsersArgs = {
  input: UpdateContractUsersInput
}

export type MutationUpdateDefaultChangeOrderLogFormArgs = {
  input: UpdateDefaultChangeOrderLogFormInput
}

export type MutationUpdateDefaultChangeOrderRequestFormArgs = {
  input: UpdateDefaultChangeOrderRequestFormInput
}

export type MutationUpdateDefaultPayAppFormsArgs = {
  input: UpdateDefaultPayAppFormsInput
}

export type MutationUpdateDefaultPrimaryLienWaiverFormsArgs = {
  input: UpdateDefaultLienWaiverFormsInput
}

export type MutationUpdateDefaultVendorLienWaiverFormsArgs = {
  input: UpdateDefaultLienWaiverFormsInput
}

export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInput
}

export type MutationUpdateFormTemplateArgs = {
  input: UpdateFormTemplateInput
}

export type MutationUpdateFormTemplateAnnotationsArgs = {
  input: UpdateFormAnnotationsInput
}

export type MutationUpdateFormTemplateAssociatedCompanyArgs = {
  input: UpdateFormTemplateAssociatedCompanyInput
}

export type MutationUpdateFormTemplateAssociatedContractsArgs = {
  input: UpdateFormTemplateAssociatedContractsInput
}

export type MutationUpdateFormTemplateBuilderArgs = {
  input: UpdateFormTemplateUserInput
}

export type MutationUpdateFormTemplateDueDateArgs = {
  input: UpdateFormTemplateDueDateInput
}

export type MutationUpdateFormTemplateOriginalFileArgs = {
  input: UpdateFormTemplateOriginalFileInput
}

export type MutationUpdateFormTemplateOwnerArgs = {
  input: UpdateFormTemplateUserInput
}

export type MutationUpdateFormTemplateRequestingCompanyArgs = {
  input: UpdateFormTemplateRequestingCompanyInput
}

export type MutationUpdateFormTemplateStatusArgs = {
  input: UpdateFormTemplateStatusInput
}

export type MutationUpdateFormTemplateValidatorArgs = {
  input: UpdateFormTemplateUserInput
}

export type MutationUpdateFormTemplateVersionArgs = {
  input: UpdateFormTemplateVersionInput
}

export type MutationUpdateFoundationPeyoteCredentialsArgs = {
  input: UpdateFoundationPeyoteCredentialsInput
}

export type MutationUpdateIntegrationCredentialArgs = {
  input: UpdateIntegrationCredentialInput
}

export type MutationUpdateIntegrationMappingsArgs = {
  input: UpdateIntegrationMappingsInput
}

export type MutationUpdateLegalRequirementsArgs = {
  input: UpdateLegalRequirementsInput
}

export type MutationUpdateLienWaiverFormTemplateSetArgs = {
  input: UpdateLienWaiverFormTemplateSetInput
}

export type MutationUpdateLinkCompanyArgs = {
  companyIntegrationId: Scalars['ID']['input']
  sourceCompanyId: Scalars['String']['input']
}

export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput
}

export type MutationUpdateOnboardedProjectContractStatusArgs = {
  input: UpdateOnboardedProjectContractStatusInput
}

export type MutationUpdatePayAppArgs = {
  input: UpdatePayAppInput
}

export type MutationUpdatePayAppFormTemplateSetArgs = {
  input: UpdatePayAppFormTemplateSetInput
}

export type MutationUpdatePayAppRequirementGroupsArgs = {
  input: UpdatePayAppRequirementGroupsInput
}

export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput
}

export type MutationUpdateRoundRetentionArgs = {
  input: UpdateRoundRetentionInput
}

export type MutationUpdateSageIntacctPeyoteCredentialsArgs = {
  input: UpdateSageIntacctPeyoteCredentialsInput
}

export type MutationUpdateSovLineItemGroupArgs = {
  input: UpdateSovLineItemGroupInput
}

export type MutationUpdateSpectrumPeyoteCompanyArgs = {
  input: UpdateSpectrumPeyoteCompanyInput
}

export type MutationUpdateSpectrumPeyoteCredentialsArgs = {
  input: UpdateSpectrumPeyoteCredentialsInput
}

export type MutationUpdateStateLienRequirementsSummaryArgs = {
  input: UpdateStateLienRequirementsSummaryInput
}

export type MutationUpdateTemplateVariantArgs = {
  input: UpdateTemplateVariantInput
}

export type MutationUpdateUserEducationCampaignArgs = {
  input: UpdateUserEducationCampaignInput
}

export type MutationUpdateVistaPeyoteCredentialsArgs = {
  input: UpdateVistaPeyoteCredentialsInput
}

export { NotaryTag }

export type Notification = {
  readonly __typename: 'Notification'
  /** Contract for which this notification is. */
  readonly contract: Maybe<Contract>
  /** Used to show time of notification. */
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * Initials of the creator of the notification. Empty if created by the system. We only store
   * the initals of the creator, rather than a user ID, because of cases where an unauthenticated
   * user creates a notification (i.e. LTLW Signed). These initials are used to show an avatar
   * for that user on the notification.
   */
  readonly createdByUserInitials: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  /** Link to redirect to if the notification is clicked. */
  readonly link: Scalars['String']['output']
  /** Actual text of notification. */
  readonly message: Scalars['String']['output']
  /** Whether the notification has been read yet by the user. */
  readonly read: Scalars['Boolean']['output']
  /** Indicates which notification this is. */
  readonly type: NotificationType
  readonly updatedAt: Scalars['DateTime']['output']
  /** User for whom this notification is. */
  readonly user: User
}

/**
 * Feed of notifications returned in paginated lists. Cursor is the latest notification created time
 * and hasNext indicates if there are more notifications to be returned.
 */
export type NotificationFeed = {
  readonly __typename: 'NotificationFeed'
  readonly cursor: Scalars['DateTime']['output']
  readonly hasNext: Scalars['Boolean']['output']
  readonly notifications: ReadonlyArray<Notification>
}

export { NotificationType }

export { OfficeTeamUpdateType }

/** Tracks the status of onboarding legal requirements for a project from the Compliance module */
export type OnboardedProjectComplianceStatus = {
  readonly __typename: 'OnboardedProjectComplianceStatus'
  /** The user finished adding general contractor compliance recipients */
  readonly addedGcRecipients: Scalars['Boolean']['output']
  /** The user completed the step to set up legal requirements */
  readonly addedLegalRequirements: Scalars['Boolean']['output']
  /**
   * The user has completed onboarding. This step determines if on subsequent visits, we direct the
   * user to the onboarding page or we direct the user to the compliance overview page.
   */
  readonly completedOnboarding: Scalars['Boolean']['output']
}

/** Represents the status of each of the onboarding steps for a new project contract. */
export type OnboardedProjectContractStatus = {
  readonly __typename: 'OnboardedProjectContractStatus'
  /** Whether the subcontractor has already added GC contact emails. */
  readonly addedGcContacts: Scalars['Boolean']['output']
  /** Whether the subcontractor has already added their SOV. */
  readonly addedSov: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their teammates. */
  readonly addedTeammates: Scalars['Boolean']['output']
  /** Computed fields to simplify frontend loads */
  readonly isComplete: Scalars['Boolean']['output']
  readonly isReadyForPayAppSubmit: Scalars['Boolean']['output']
  /**
   * Whether the admin has notified the subcontractor that the forms are onboarded, or no notification is
   * required because no forms were processed for the project
   */
  readonly notifiedOnboardedForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the change order log forms. */
  readonly onboardedChangeOrderLogForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the change order request forms. */
  readonly onboardedChangeOrderRequestForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the pay app forms. */
  readonly onboardedPayAppForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the primary lien waiver forms. */
  readonly onboardedPrimaryLienWaiverForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the sub-tier lien waiver forms. */
  readonly onboardedSubTierLienWaiverForms: Scalars['Boolean']['output']
  /** If false, an admin user is currently processing the vendor lien waiver forms. */
  readonly onboardedVendorLienWaiverForms: Scalars['Boolean']['output']
  /** Whether the subcontractor has uploaded change order log forms/sent them to admin */
  readonly selectedChangeOrderLogForms: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their change order request forms/sent them to admin. */
  readonly selectedChangeOrderRequestForms: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their pay app forms/sent them to admin. */
  readonly selectedPayAppForms: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their primary lien waivers/sent them to admin. */
  readonly selectedPrimaryLienWaivers: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected a rate table. */
  readonly selectedRateTable: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their sub-tier lien waivers/sent them to admin. */
  readonly selectedSubTierLienWaivers: Scalars['Boolean']['output']
  /** Whether the subcontractor has already selected their vendor lien waivers/sent them to admin. */
  readonly selectedVendorLienWaivers: Scalars['Boolean']['output']
  /** Whether the subcontractor has created the project's first pay app. */
  readonly startedBilling: Scalars['Boolean']['output']
}

/** Tracks the status of onboarding vendors/lien waivers for a project from the Vendor module */
export type OnboardedProjectVendorsStatus = {
  readonly __typename: 'OnboardedProjectVendorsStatus'
  /** The user finished adding general contractor lien waiver recipients */
  readonly addedGcRecipients: Scalars['Boolean']['output']
  /** The user completed the vendor documents step of onboarding */
  readonly addedLegalRequirements: Scalars['Boolean']['output']
  readonly addedSubTierLienWaivers: Scalars['Boolean']['output']
  /**
   * The first onboarding step is to select lien waiver templates. If this was done during project onboarding,
   * this key will be set to true. If during project onboarding, the user did not select vendor lien waivers,
   * this step will be outstanding (set to false), and only flipped to true when the user either selects
   * lien waivers and confirms their selections.
   */
  readonly addedVendorLienWaivers: Scalars['Boolean']['output']
  /** The user finished adding vendors */
  readonly addedVendors: Scalars['Boolean']['output']
  /**
   * The user has completed onboarding. This step determines if on subsequent visits, we direct the user
   * to the onboarding page or we direct the user to the project details section.
   */
  readonly completedOnboarding: Scalars['Boolean']['output']
}

/** Number of vendor lien waivers outstanding across all projects in a single month */
export type OutstandingLienWaiversByMonth = {
  readonly __typename: 'OutstandingLienWaiversByMonth'
  readonly month: Scalars['DateTime']['output']
  readonly numOutstandingLienWaiversThisMonth: Scalars['SafeInt']['output']
}

/** A row in the outstanding pay apps list — one open pay app, referencing its source entity */
export type OutstandingPayApp = {
  readonly __typename: 'OutstandingPayApp'
  readonly contract: Contract
  readonly payApp: Maybe<PayApp>
  readonly preSitelinePayApp: Maybe<PreSitelinePayApp>
}

export type OutstandingPayApps = {
  readonly __typename: 'OutstandingPayApps'
  /** Opaque keyset token for the last pay app on this page, to pass as the next page's cursor */
  readonly cursor: Maybe<Scalars['ID']['output']>
  /** Whether there are more pay apps after the current page */
  readonly hasNext: Scalars['Boolean']['output']
  readonly payApps: ReadonlyArray<OutstandingPayApp>
  /** Total number of outstanding pay apps across the full filtered set */
  readonly totalCount: Scalars['Int']['output']
}

export { OutstandingPayAppsContractStatus }

export { OutstandingPayAppsSortCriteria }

/** Aggregate stats over the full outstanding-pay-apps set matching the active filters. */
export type OutstandingPayAppsSummary = {
  readonly __typename: 'OutstandingPayAppsSummary'
  /** Average days aged across the matching pay apps */
  readonly averageDaysAged: Scalars['Float']['output']
  /** Count of outstanding invoices (pay apps) across the matching set */
  readonly numInvoices: Scalars['SafeInt']['output']
  /** Count of overdue (past-due) pay apps */
  readonly numPastDue: Scalars['SafeInt']['output']
  /** Distinct projects across the matching pay apps */
  readonly numProjects: Scalars['SafeInt']['output']
  /** Summed post-tax outstanding for the active filters, in cents */
  readonly totalOutstanding: Scalars['SafeInt']['output']
}

export type OverviewDashboard = {
  readonly __typename: 'OverviewDashboard'
  readonly billingSummary: BillingDashboardSummary
  readonly payAppAgingSummary: PayAppAgingDashboardSummary
  readonly projectSnapshotScoreBreakdown: ProjectSnapshotScoreBreakdown
  readonly vendorSummary: VendorLienWaiverDashboardSummary
}

export type Owner = {
  readonly __typename: 'Owner'
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly locations: ReadonlyArray<Location>
  readonly name: Scalars['String']['output']
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

export type PaginatedAgingDashboard = {
  readonly __typename: 'PaginatedAgingDashboard'
  readonly contracts: ReadonlyArray<PayAppAgingDashboardContract>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  /** Summary across the full filtered set, not just the current page. */
  readonly payAppAgingSummary: PayAppAgingDashboardSummary
  readonly totalCount: Scalars['Int']['output']
}

export type PaginatedBillingDashboard = {
  readonly __typename: 'PaginatedBillingDashboard'
  /** Summary across the full filtered set, not just the current page. */
  readonly billingSummary: BillingDashboardSummary
  readonly contracts: ReadonlyArray<BillingDashboardContract>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/**
 * A list of contracts that can be paginated through, each including a list of predicted payment date periods.
 * The cursor is the ID of the last contract in the list.
 */
export type PaginatedCashForecastContractList = {
  readonly __typename: 'PaginatedCashForecastContractList'
  readonly contracts: ReadonlyArray<CashForecastContract>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/** A list of companies that can be paginated through. The cursor is the ID of the last company in the list. */
export type PaginatedCompanyList = {
  readonly __typename: 'PaginatedCompanyList'
  readonly companies: ReadonlyArray<Company>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/** A list of contracts that can be paginated through. The cursor is the ID of the last contract in the list. */
export type PaginatedContractList = {
  readonly __typename: 'PaginatedContractList'
  readonly contracts: ReadonlyArray<Contract>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/**
 * A list of contract mismatch report operation groups that can be paginated through.
 * The cursor is the group ID of the last group in the list.
 */
export type PaginatedContractMismatchReportOperationGroups = {
  readonly __typename: 'PaginatedContractMismatchReportOperationGroups'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly groups: ReadonlyArray<ContractMismatchReportOperationGroup>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/**
 * A list of a general contractor's contacts that can be paginated through. The cursor is the ID of
 * the last contact in the list.
 */
export type PaginatedGeneralContractorContactList = {
  readonly __typename: 'PaginatedGeneralContractorContactList'
  readonly contacts: ReadonlyArray<GeneralContractorContact>
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/**
 * A list of general contractors that can be paginated through. The cursor is the ID of the last
 * general contractor in the list.
 */
export type PaginatedGeneralContractorList = {
  readonly __typename: 'PaginatedGeneralContractorList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly generalContractors: ReadonlyArray<GeneralContractor>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
}

/** A list of integration requests that can be paginated through. The cursor is the ID of the last request in the list. */
export type PaginatedIntegrationRequestList = {
  readonly __typename: 'PaginatedIntegrationRequestList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly integrationRequests: ReadonlyArray<IntegrationRequest>
  readonly totalCount: Scalars['Int']['output']
}

export { PaginatedListSortOrder }

/** A list of pay apps that can be paginated through. The cursor is the ID of the last pay app in the list. */
export type PaginatedPayAppList = {
  readonly __typename: 'PaginatedPayAppList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly payApps: ReadonlyArray<PayApp>
  readonly totalCount: Scalars['Int']['output']
}

export type PaginatedReportList = {
  readonly __typename: 'PaginatedReportList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly reports: ReadonlyArray<Report>
  readonly totalCount: Scalars['Int']['output']
}

/** A list of templates that can be paginated through. The cursor is the ID of the last template in the list. */
export type PaginatedTemplateList = {
  readonly __typename: 'PaginatedTemplateList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly templates: ReadonlyArray<FormTemplate>
  readonly totalCount: Scalars['Int']['output']
}

/** A list of template variants that can be paginated through. The cursor is the ID of the last variant in the list. */
export type PaginatedTemplateVariantList = {
  readonly __typename: 'PaginatedTemplateVariantList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
  readonly variants: ReadonlyArray<FormTemplateVariant>
}

/**
 * A list of vendor contracts that can be paginated through.
 * The cursor is the ID of the last vendor contract in the list.
 */
export type PaginatedVendorContractsList = {
  readonly __typename: 'PaginatedVendorContractsList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
  readonly vendorContracts: ReadonlyArray<VendorContract>
}

/**
 * A list of vendors that can be paginated through.
 * The cursor is the ID of the last vendor in the list.
 */
export type PaginatedVendorsList = {
  readonly __typename: 'PaginatedVendorsList'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly totalCount: Scalars['Int']['output']
  readonly vendors: ReadonlyArray<Vendor>
}

/** A list of write sync operations that can be paginated through. The cursor is the ID of the last operation in the list. */
export type PaginatedWriteSyncOperations = {
  readonly __typename: 'PaginatedWriteSyncOperations'
  readonly cursor: Maybe<Scalars['ID']['output']>
  readonly hasNext: Scalars['Boolean']['output']
  readonly operations: ReadonlyArray<WriteSyncOperation>
  readonly totalCount: Scalars['Int']['output']
}

/** Represents a single (monthly) pay app for a single company on a single project. */
export type PayApp = {
  readonly __typename: 'PayApp'
  /** Date this pay app started aging, or null if it isn't aging. Wraps getPayAppAgingSince. */
  readonly agingSince: Maybe<Scalars['DateTime']['output']>
  /** Amount due, post tax. This is amountDuePreTax + amountDueTaxAmount */
  readonly amountDuePostTax: Scalars['SafeInt']['output']
  /** Current billed - retention held + retention released. This is pre-tax. */
  readonly amountDuePreTax: Scalars['SafeInt']['output']
  /** Tax amount on the amount due. This is the sum of all tax amounts on the progresses/amount items. */
  readonly amountDueTaxAmount: Scalars['SafeInt']['output']
  /**
   * A list of amount line items for the pay app.
   * Only used for QUICK pay apps.
   * This array is empty for all other types of pay apps.
   */
  readonly amountLineItems: ReadonlyArray<AmountLineItem>
  /**
   * The amount that was paid on this pay app. This may or may not be the payAppNet amount, depending
   * on what the end user recorded. If the pay app has not been paid, then this returns null/undefined.
   * This amount is post-tax.
   */
  readonly amountPaid: Maybe<Scalars['SafeInt']['output']>
  /** List of attachments to include as backup in the pay app */
  readonly attachments: ReadonlyArray<PayAppAttachment>
  /**
   * Indicates whether the latest updates to the progress values was done by an automatic read sync
   * from an integration. For example, if the GC modifies a sub's billing directly on Textura, this
   * bit will be set to true once we have pulled the billing data back into Siteline.
   */
  readonly automaticallyReadBilling: Scalars['Boolean']['output']
  /** Total balance left to finish after this pay app. */
  readonly balanceToFinish: Scalars['SafeInt']['output']
  /**
   * End date of the billing period for this pay app. Usually end of the month.
   * Note that it's a point in time and that you'll need the project timezone to determine the month.
   * We use this field to determine the "month" of the pay app.
   */
  readonly billingEnd: Scalars['DateTime']['output']
  /**
   * Start date of the billing period for this pay app. Usually start of the month.
   * Note that it's a point in time and that you'll need the project timezone to determine the month.
   */
  readonly billingStart: Scalars['DateTime']['output']
  /**
   * Billing type extracted from the contract billing type when pay app is created.
   * - For LUMP_SUM/UNIT_PRICE billing, only `progress` items are provided
   * - For QUICK billing, only `amountLineItems` are provided, and they all have `type = ADDITIONAL`
   */
  readonly billingType: BillingType
  /** Whether the forms for this pay app can be generated, i.e. they've been selected or provided and fully processed */
  readonly canGenerateForms: Scalars['Boolean']['output']
  /** List of CompanyContact references that were CC'd on the email version of this PayApp. */
  readonly ccContacts: ReadonlyArray<CompanyContact>
  /** List of scheduled collections notifications to be sent to the GC */
  readonly collectionsNotifications: ReadonlyArray<PayAppCollectionsNotification>
  /** Collections tasks on the pay app, as entered by the user */
  readonly collectionsTasks: ReadonlyArray<CollectionsTask>
  /** A list of comments on the pay app. */
  readonly comments: ReadonlyArray<PayAppComment>
  /** Contract that this pay app belongs to */
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * This is the gross amount billed for this PayApp.
   * For LUM_SUM/UNIT_PRICE, this is the sum of progress billed + stored materials billed.
   * For T&M, this is the sum of all line items' post-fee pre-tax amount.
   * For QUICK, this is the sum of all amount line items' due pre-tax.
   * Denormalized: maintained by recomputePayAppCurrentBilled on every billing mutation.
   */
  readonly currentBilled: Scalars['SafeInt']['output']
  /** The total amount of progress and retention billed. Does not subtract retention held. */
  readonly currentProgressAndRetentionBilled: Scalars['SafeInt']['output']
  /**
   * This is the time at which a pay app draft was submitted. It is cleared when a pay app is edited
   * and won't ever be set if the pay app was never submitted while it was a draft.
   */
  readonly draftSubmittedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * Array of CompanyContact references that were emailed a PDF version of this PayApp. This is only
   * used when the general contractor is not using Siteline to administer PayApps.
   */
  readonly emailedContacts: ReadonlyArray<CompanyContact>
  /** A list of events related to this pay app, like `PAY_APP_SUBMITTED`. */
  readonly events: ReadonlyArray<PayAppEvent>
  /**
   * Generated when the pay app is signed so any future submissions and downloads include the exact
   * invoice that was signed. This file includes only the "invoice" forms, i.e. pay app requirements
   * and primary lien waiver. Other attachments will still be re-generated.
   */
  readonly finalInvoice: Maybe<StoredFile>
  readonly formTemplates: ReadonlyArray<PinnedPayAppTemplate>
  /** A list of all user-entered values for the forms in this pay app. */
  readonly formValues: ReadonlyArray<FormTemplateAnnotationValue>
  /** Gets a base set of G702 values to preview for a pay app */
  readonly g702Values: G702Values
  /** Whether the contract rate table was swapped or updated since the pay app was created */
  readonly hasContractRateTableChanged: Scalars['Boolean']['output']
  /**
   * Templates that are pinned to this pay-app. Since @oneToMany cannot be nullable, formTemplates can
   * only be an array with 0 or more elements. This is why we use a flag to determine whether to get
   * templates from the array, or from the contract that this pay-app belongs to.
   */
  readonly hasPinnedTemplates: Scalars['Boolean']['output']
  /** Whether fees have changed on the contract since the pay app was created */
  readonly haveContractFeesChanged: Scalars['Boolean']['output']
  /** Whether the taxes have changed on the contract since the pay app was created */
  readonly haveContractTaxesChanged: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /**
   * Iff a pay app has an event of type PAY_APP_PAID_IN_INTEGRATION, returns the date it was marked as
   * paid based on the date in the PayAppEvent logs. Otherwise returns null.
   */
  readonly integrationPaidAt: Maybe<Scalars['DateTime']['output']>
  /**
   * Date before which invoice must be submitted by the sub project manager to the sub accountant
   * (internal deadline).
   */
  readonly internalDueDate: Scalars['DateTime']['output']
  /** Optional invoice number for this pay app, to be used with template variables, if it exists. */
  readonly invoiceNumber: Maybe<Scalars['String']['output']>
  /** A single bit to describe if an invoice has been marked as completed by a sub project manager. */
  readonly invoiceReady: Scalars['Boolean']['output']
  /**
   * If the amount paid on the pay app doesn't match the amount due, we allow the customer to manually
   * mark the pay app balance as closed so the remaining amount isn't considered due and doesn't appear
   * in aging reports.
   */
  readonly isBalanceManuallyClosed: Scalars['Boolean']['output']
  /**
   * This is only meant to be used for reference in the lien rights tracker, where we need to know
   * whether a T&M project is fully billed (excluding retention). This will be used to determine
   * whether we should signal to the user "missing key date", prompting them to provide a date of
   * last furnishing. Note that this field is OPTIONAL and only for T&M - it should not be used
   * outside of this context.
   */
  readonly isFinalPayApp: Maybe<Scalars['Boolean']['output']>
  /**
   * The last ERP syncs for this entity, successful or not.
   * For most contracts, this will have a length of 0 or 1. However because we support multiple ERP contracts
   * per Siteline contract, this can have as many syncs as there are ERP contracts.
   * These must be stored in the database because they need to reset when editing the invoice.
   */
  readonly lastErpSyncs: ReadonlyArray<WriteSyncOperation>
  /** If a past pay app had a retention override at the pay app level, it's returned here */
  readonly lastPayAppWithRetentionHeldOverride: Maybe<PayApp>
  /** The last write sync for this entity, completed or not */
  readonly lastSync: Maybe<WriteSyncOperation>
  /** The last write sync for this entity. Null if not successful */
  readonly lastSyncIfSuccessful: Maybe<WriteSyncOperation>
  /** List of legal documents to include as backup in the pay app */
  readonly legalDocuments: ReadonlyArray<LegalDocument>
  /** List of LienWaivers for the top-tier sub and all lower-tier subs */
  readonly lienWaivers: ReadonlyArray<LienWaiver>
  /**
   * Iff a pay app has an event of type PAY_APP_PAID_IN_INTEGRATION, returns the type of integration
   * that was used to mark it paid. Otherwise returns null.
   */
  readonly markedAsPaidIntegration: Maybe<Integration>
  /** Retention held percent on the stored materials billing */
  readonly materialsRetentionHeldPercent: Maybe<Scalars['Float']['output']>
  /**
   * If there are fields missing on the contract or project that are required to generate this
   * pay app's forms, they're returned here
   */
  readonly missingRequiredFields: ReadonlyArray<RequiredFieldForForms>
  /**
   * If there are fields missing on the contract or project that are required to generate this pay
   * app's unconditional lien waiver, they're returned here
   */
  readonly missingRequiredUnconditionalLienWaiverFields: ReadonlyArray<RequiredFieldForForms>
  /** Payment date, denormalized from statusChangedAt when status is PAID */
  readonly paidAt: Maybe<Scalars['DateTime']['output']>
  /** Date before which the entire PayApp must be submitted to the GC (external deadline). */
  readonly payAppDueDate: Scalars['DateTime']['output']
  /** The pay app's number within its contract. Denormalized: maintained on create/delete/billing-date/pastPayAppCount changes. */
  readonly payAppNumber: Scalars['SafeInt']['output']
  /** Estimated payment due date from aging anchor + contract payment terms. Wraps getPaymentDueDateForPayApp. */
  readonly paymentDueDate: Scalars['DateTime']['output']
  /** Includes information about the physical signatures required on this pay app. */
  readonly physicalSignatureRequired: PhysicalSignatureRequired
  readonly pinnedChangeOrderLogFormTemplateVersion: Maybe<FormTemplateVersion>
  /**
   * The date payment is expected or predicted, to be used for cash forecasting. This date is entered
   * by the customer, but may be suggested to them based on past payment history.
   */
  readonly predictedPaymentDate: Maybe<Scalars['DateTime']['output']>
  /**
   * A list of progress values for their respective SOV line items.
   * Not used for QUICK pay apps.
   * This array is empty for all other types of pay apps.
   */
  readonly progress: ReadonlyArray<SovLineItemProgress>
  /** Retention held percent on the progress billing */
  readonly progressRetentionHeldPercent: Maybe<Scalars['Float']['output']>
  /**
   * Link back to rate table that was used to create a T&M pay app.
   * It will always exist for T&M pay apps, although it might be archived.
   * Always null for pay apps that are not T&M.
   */
  readonly rateTable: Maybe<RateTable>
  /**
   * Only for T&M.
   * Warning: this includes *all* fees, including group fees.
   */
  readonly rateTableFees: ReadonlyArray<PayAppRateTableFee>
  /** Only for T&M */
  readonly rateTableGroups: ReadonlyArray<PayAppRateTableGroup>
  /** Only for T&M */
  readonly rateTableItems: ReadonlyArray<PayAppRateTableItem>
  /** Retention held in this pay app only (this period). */
  readonly retentionHeldCurrent: Scalars['SafeInt']['output']
  /** Retention held in this pay app, on stored materials billing only (this period). */
  readonly retentionHeldCurrentMaterials: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldCurrentMaterials. */
  readonly retentionHeldCurrentMaterialsPercent: Scalars['Float']['output']
  /** Tax on retentionHeldCurrentMaterials. */
  readonly retentionHeldCurrentMaterialsTax: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldCurrent (blended/configured per strategy). */
  readonly retentionHeldCurrentPercent: Scalars['Float']['output']
  /** Retention held in this pay app, on progress billing only (this period). */
  readonly retentionHeldCurrentProgress: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldCurrentProgress. */
  readonly retentionHeldCurrentProgressPercent: Scalars['Float']['output']
  /** Tax on retentionHeldCurrentProgress. */
  readonly retentionHeldCurrentProgressTax: Scalars['SafeInt']['output']
  /**
   * Tax on retentionHeldCurrent. Zero unless contract.appliesTaxToRetention = true,
   * which only applies under STANDARD retention tracking.
   */
  readonly retentionHeldCurrentTax: Scalars['SafeInt']['output']
  /**
   * Retention override amount on the pay app on both progress and material billing. Takes precedence
   * over the progress and materials percents if set on the pay app. If set, also takes precedence over
   * retention values tracked on the individual progresses.
   */
  readonly retentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  /** Retention held in all previous pay apps (excluding this period), minus retention released to date. */
  readonly retentionHeldPrevious: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldPrevious. */
  readonly retentionHeldPreviousPercent: Scalars['Float']['output']
  /** Tax on retentionHeldPrevious. */
  readonly retentionHeldPreviousTax: Scalars['SafeInt']['output']
  /** Total retention held cumulatively through this pay app, including this period. */
  readonly retentionHeldToDate: Scalars['SafeInt']['output']
  /** Retention held cumulatively through this pay app, on stored materials billing only. */
  readonly retentionHeldToDateMaterialsInStorage: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldToDateMaterialsInStorage. */
  readonly retentionHeldToDateMaterialsInStoragePercent: Scalars['Float']['output']
  /** Tax on retentionHeldToDateMaterialsInStorage. */
  readonly retentionHeldToDateMaterialsInStorageTax: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldToDate. */
  readonly retentionHeldToDatePercent: Scalars['Float']['output']
  /** Tax on retentionHeldToDate. See retentionHeldCurrentTax for when this is non-zero. */
  readonly retentionHeldToDateTax: Scalars['SafeInt']['output']
  /** Retention held cumulatively through this pay app, on progress billing only. */
  readonly retentionHeldToDateWorkCompleted: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldToDateWorkCompleted. */
  readonly retentionHeldToDateWorkCompletedPercent: Scalars['Float']['output']
  /** Tax on retentionHeldToDateWorkCompleted. */
  readonly retentionHeldToDateWorkCompletedTax: Scalars['SafeInt']['output']
  /**
   * Optional invoice number for retention release invoices synced to ERPs,
   * when retention release is separate from the normal invoice.
   */
  readonly retentionInvoiceNumber: Maybe<Scalars['String']['output']>
  /** Used to determine whether the type of pay app is 'normal' or 'retention-only'. */
  readonly retentionOnly: Scalars['Boolean']['output']
  /**
   * Retention released override amount on the pay app on both progress and material billing.
   * For STANDARD/LINE_ITEM strategies, this is an override.
   * For PAY_APP/PROJECT strategies, this is the only source of truth for retention released.
   * For display purposes, use `retentionReleasedCurrent` over this field because it can be null.
   */
  readonly retentionReleased: Maybe<Scalars['SafeInt']['output']>
  /** Retention released in this pay app only (this period). */
  readonly retentionReleasedCurrent: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedCurrent. */
  readonly retentionReleasedCurrentTax: Scalars['SafeInt']['output']
  /** Retention released in all previous pay apps (excluding this period). */
  readonly retentionReleasedPrevious: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedPrevious. */
  readonly retentionReleasedPreviousTax: Scalars['SafeInt']['output']
  /** Total retention released cumulatively through this pay app, including this period. */
  readonly retentionReleasedToDate: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedToDate. */
  readonly retentionReleasedToDateTax: Scalars['SafeInt']['output']
  /** Event logs from each time the pay app was reverted to draft */
  readonly revertToDraftEvents: ReadonlyArray<PayAppEvent>
  /** This is the time at which a pay app was first sent to signer for review/signature. */
  readonly sentToSignerAt: Maybe<Scalars['DateTime']['output']>
  readonly signature: Maybe<Signature>
  /**
   * Status of the pay app. Use this as the source of truth for statuses instead of status logs.
   * We denormalized statuses for performance reasons.
   */
  readonly status: PayAppStatus
  /** Last time the status was updated */
  readonly statusChangedAt: Scalars['DateTime']['output']
  /** List of all status state transitions for the pay app. */
  readonly statusLogs: ReadonlyArray<PayAppStatusLog>
  /** Submission date, denormalized from statusUpdatedAt when status transitions to PROPOSED or SYNCED */
  readonly submittedAt: Maybe<Scalars['DateTime']['output']>
  /** User who submitted, denormalized when status transitions to PROPOSED or SYNCED */
  readonly submittedBy: Maybe<User>
  /** Vendors to include on sworn statement forms, with their corresponding metrics */
  readonly swornStatementVendors: Maybe<ReadonlyArray<PayAppSwornStatementVendor>>
  /** If an invoice was rejected by the GC in Textura, this is the date it was rejected */
  readonly texturaRejectedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * If an invoice was rejected by the GC in Textura, this is the reason it was rejected for.
   * Note that this might not always be provided in the textura message that we parse, so it can be null
   * while texturaRejectedAt is set. Do not rely on this field to determine whether an invoice was rejected.
   */
  readonly texturaRejectionReason: Maybe<Scalars['String']['output']>
  readonly timeZone: Scalars['String']['output']
  /** The SOV total value as of this pay app */
  readonly totalValue: Scalars['SafeInt']['output']
  /** Open balance post-tax, partial payments subtracted. Wraps getUnpaidAmountPostTaxForPayApp. */
  readonly unpaidAmountPostTax: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  /** If provided, we'll use this file instead of generating it on the fly */
  readonly uploadedFile: Maybe<StoredFile>
  readonly worksheetProgress: ReadonlyArray<WorksheetLineItemProgress>
}

export { PayAppAgingBucket }

export type PayAppAgingDashboard = {
  readonly __typename: 'PayAppAgingDashboard'
  readonly contracts: ReadonlyArray<PayAppAgingDashboardContract>
  readonly payAppAgingSummary: PayAppAgingDashboardSummary
}

export type PayAppAgingDashboardContract = {
  readonly __typename: 'PayAppAgingDashboardContract'
  readonly agingBreakdown: AgingBreakdown
  readonly billingStatus: DashboardBillingStatus
  readonly contract: Contract
  /**
   * If aging is calculated from submission date and there are unpaid pre-Siteline pay apps with no
   * submitted date, this will be true so the user knows that pay apps are missing from the data
   */
  readonly hasMissingPreSitelinePayApps: Scalars['Boolean']['output']
  readonly numComments: Scalars['SafeInt']['output']
}

export type PayAppAgingDashboardSummary = {
  readonly __typename: 'PayAppAgingDashboardSummary'
  /** Total amount across all unpaid pay apps over 30 days aged */
  readonly amountAged30Days: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no amount aged over 30 days */
  readonly amountAged30DaysMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Total amount across all unpaid pay apps over 60 days aged */
  readonly amountAged60Days: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no amount aged over 60 days */
  readonly amountAged60DaysMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Total amount across all unpaid pay apps over 90 days aged */
  readonly amountAged90Days: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no amount aged over 90 days */
  readonly amountAged90DaysMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Total amount across all unpaid pay apps over 120 days aged */
  readonly amountAged120Days: Scalars['SafeInt']['output']
  /** If undefined, the previous month had no amount aged over 120 days */
  readonly amountAged120DaysMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** If undefined, the previous month had no amount outstanding */
  readonly amountOutstandingMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  /** Amount due across all unpaid pay apps in a month */
  readonly amountOutstandingThisMonth: Scalars['SafeInt']['output']
  /** Average days to paid across all pay apps */
  readonly averageDaysToPaid: Scalars['Float']['output']
  /** If undefined, the previous month had no paid pay apps */
  readonly averageDaysToPaidMonthOverMonthPercent: Maybe<Scalars['Float']['output']>
  readonly payAppAgingBreakdown: AgingBreakdown
}

/** Represents an attachment, image, or binary file that can be accessed via a URL. */
export type PayAppAttachment = {
  readonly __typename: 'PayAppAttachment'
  /** If this attachment was created from a recurring contract attachment, link to that attachment */
  readonly contractPayAppAttachment: Maybe<ContractPayAppAttachment>
  readonly createdAt: Scalars['DateTime']['output']
  /** Optional description of the attachment */
  readonly description: Maybe<Scalars['String']['output']>
  readonly file: StoredFile
  readonly id: Scalars['ID']['output']
  /** The attachment is not included in the pay app PDF package, but is attached to submission emails */
  readonly isEmailAttachment: Scalars['Boolean']['output']
  /** Internal-only attachments will never get included in the generated PDF package for the pay app */
  readonly isInternalOnly: Scalars['Boolean']['output']
  readonly name: Scalars['String']['output']
  readonly payApp: PayApp
  /** Rate table items that are associated with this attachment */
  readonly rateTableItems: ReadonlyArray<PayAppRateTableItem>
  /** Optional reference to a SOV Line Item Progress that the attachment is associated with */
  readonly sovLineItemProgress: Maybe<SovLineItemProgress>
  readonly updatedAt: Scalars['DateTime']['output']
  /**
   * Unique upload identifier provided by clients when adding an attachment.
   * This allows clients to optimistically render attachments while uploading, then re-render them
   * when uploads complete.
   */
  readonly uploadId: Scalars['ID']['output']
}

/**
 * A notification scheduled to be sent to a general contractor for collection of payments.
 * This is the actual scheduled notification at the pay app level. It stays linked to the setting it
 * was scheduled from; if that setting is deleted, disabled, or shadowed by a nearer-level setting,
 * the notification resolves to NOT_NEEDED.
 */
export type PayAppCollectionsNotification = {
  readonly __typename: 'PayAppCollectionsNotification'
  /** If the notification was canceled by the user, this is the time it was canceled */
  readonly canceledAt: Maybe<Scalars['DateTime']['output']>
  /** Recipients of the notification, from the contract's recipient list for the setting's type */
  readonly gcContacts: ReadonlyArray<CompanyContact>
  readonly id: Scalars['ID']['output']
  /** The last time the notification was sent */
  readonly lastSentOn: Maybe<Scalars['DateTime']['output']>
  /** If provided, ignore the setting's schedule and use this send time instead */
  readonly overrideSendTime: Maybe<Scalars['DateTime']['output']>
  readonly payApp: PayApp
  /** List of send logs for this notification */
  readonly sendLogs: ReadonlyArray<CollectionsNotificationSendLog>
  /** Scheduled send time. Inferred from the linked setting, or overrideSendTime if provided. */
  readonly sendTime: Scalars['DateTime']['output']
  /** The collections notification setting this notification was scheduled from, at any level */
  readonly setting: CollectionsNotificationSetting
  /** Current status of the notification (not sent, sent, canceled, or not needed) */
  readonly status: PayAppCollectionsNotificationStatus
  /** Type of notification to send, from the linked setting */
  readonly type: CollectionsNotificationType
}

export { PayAppCollectionsNotificationStatus }

/** Represents a comment from a user on a pay app. */
export type PayAppComment = {
  readonly __typename: 'PayAppComment'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly message: Scalars['String']['output']
  readonly payApp: PayApp
  readonly type: PayAppCommentType
  readonly user: User
}

export { PayAppCommentType }

/** Represents a single event that occurred on a pay app object. */
export type PayAppEvent = {
  readonly __typename: 'PayAppEvent'
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly id: Scalars['ID']['output']
  /** Whether the event was inserted via the admin API */
  readonly isAdmin: Scalars['Boolean']['output']
  /** Values in this dictionary depend on the event type */
  readonly metadata: Scalars['JSONObject']['output']
  readonly payApp: PayApp
  readonly type: PayAppEventType
}

export { PayAppEventType }

export { PayAppListSortCriteria }

/** A pay-app level or group-level fee on a T&M pay app. */
export type PayAppRateTableFee = {
  readonly __typename: 'PayAppRateTableFee'
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  /** If provided, this fee applies to a specific group */
  readonly group: Maybe<PayAppRateTableGroup>
  readonly id: Scalars['ID']['output']
  /** If provided, this fee overrides another fee at the pay app (global) level. It must be a group fee in this case. */
  readonly overridesFee: Maybe<PayAppRateTableFee>
  readonly payApp: PayApp
  readonly percent: Scalars['Float']['output']
  /** Link back to the contract rate table fee that was used to create this fee, if it still exists. */
  readonly rateTableFee: Maybe<ContractRateTableFee>
  readonly updatedAt: Scalars['DateTime']['output']
}

/** A line item group on a T&M pay app. */
export type PayAppRateTableGroup = {
  readonly __typename: 'PayAppRateTableGroup'
  /** Total amount after all fees and taxes */
  readonly amountPostFeesPostTax: Scalars['SafeInt']['output']
  /** Amount after fees, but before tax applies */
  readonly amountPostFeesPreTax: Scalars['SafeInt']['output']
  /** Amount before any fee or tax applies */
  readonly amountPreFeesPreTax: Scalars['SafeInt']['output']
  readonly createdAt: Scalars['DateTime']['output']
  readonly fees: ReadonlyArray<PayAppRateTableFee>
  readonly id: Scalars['ID']['output']
  readonly items: ReadonlyArray<PayAppRateTableItem>
  readonly name: Scalars['String']['output']
  readonly payApp: PayApp
  /** Link back to the rate table group that was used to create the pay app item, if it still exists. */
  readonly rateTableGroup: Maybe<RateTableGroup>
  /** This is the pinned tax for this group, which is either the default tax group or the category override. */
  readonly taxGroup: Maybe<TaxGroup>
  readonly type: LineItemType
  readonly updatedAt: Scalars['DateTime']['output']
}

/** A line item on a T&M pay app. */
export type PayAppRateTableItem = {
  readonly __typename: 'PayAppRateTableItem'
  /** Attachments that are associated with this item */
  readonly attachments: ReadonlyArray<PayAppAttachment>
  readonly code: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly currentBilled: Scalars['SafeInt']['output']
  readonly currentUnitsBilled: Scalars['Float']['output']
  readonly description: Scalars['String']['output']
  /** Group that the line item belongs to */
  readonly group: PayAppRateTableGroup
  readonly id: Scalars['ID']['output']
  /** Whether this item was manually added to the pay app and doesn't have a matching rate table item */
  readonly isOneOffItem: Scalars['Boolean']['output']
  readonly payApp: PayApp
  /** Link back to the rate table item that was used to create the pay app item, if it still exists. */
  readonly rateTableItem: Maybe<RateTableItem>
  readonly sortOrder: Scalars['SafeInt']['output']
  readonly unitName: Maybe<Scalars['String']['output']>
  readonly unitRate: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Represents a single requirement for a document that goes into a PayApp. */
export type PayAppRequirement = {
  readonly __typename: 'PayAppRequirement'
  /**
   * Conditions that must be fulfilled for this requirement to appear in a PDF package.
   * If no condition is provided (empty array), the requirement always appears.
   * If there are one or more conditions, the requirement only appears if all conditions are fulfilled.
   */
  readonly conditions: ReadonlyArray<PayAppRequirementCondition>
  readonly createdAt: Scalars['DateTime']['output']
  /** Order of the requirement in its own group. */
  readonly groupOrder: Scalars['Int']['output']
  readonly id: Scalars['ID']['output']
  readonly payAppRequirementGroup: PayAppRequirementGroup
  /**
   * When null, this pay app requirement shows no template.
   * This is used to skip a template altogether for a specific condition (eg: for retention pay apps)
   */
  readonly templateVariant: Maybe<FormTemplateVariant>
  readonly updatedAt: Scalars['DateTime']['output']
}

export { PayAppRequirementCondition }

/**
 * Pay-apps determine which requirements to show by iterating over each requirement group and picking
 * one requirement from the group. Requirements are selected by picking the first one in their group
 * which meets all its conditions. It is possible that a requirement group has no eligible requirement
 * to show, in which case the group is ignored altogether.
 * Group order is determined by `PayAppRequirementGroup.order`.
 * Example:
 * - Group (order = 1)
 *   - Requirement (groupOrder = 1)
 *   - Requirement (groupOrder = 2)
 * - Group (order = 2)
 *   - Requirement (groupOrder = 1)
 *   - Requirement (groupOrder = 2)
 *   - Requirement (groupOrder = 3)
 */
export type PayAppRequirementGroup = {
  readonly __typename: 'PayAppRequirementGroup'
  readonly contract: Maybe<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** The order of the group as displayed in the pay-app */
  readonly order: Scalars['Int']['output']
  readonly payAppRequirements: ReadonlyArray<PayAppRequirement>
  readonly updatedAt: Scalars['DateTime']['output']
}

export { PayAppStatus }

/** Breakdown of statuses for all pay apps in a month */
export type PayAppStatusBreakdown = {
  readonly __typename: 'PayAppStatusBreakdown'
  readonly draftOnTime: Scalars['SafeInt']['output']
  readonly notBillingThisMonth: Scalars['SafeInt']['output']
  readonly pastDue: Scalars['SafeInt']['output']
  readonly submitted: Scalars['SafeInt']['output']
}

export { PayAppStatusFilter }

/** Represents a log of all statuses for a pay app and when the transition occurred. */
export type PayAppStatusLog = {
  readonly __typename: 'PayAppStatusLog'
  /** Time when the log was created. This should be used to determine the latest status on a pay app. */
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly ipAddress: Maybe<Scalars['String']['output']>
  readonly payApp: PayApp
  readonly status: PayAppStatus
  /**
   * This is a user-visible time for when the status was changed. For example, the pay app may be
   * marked as paid on the UI at one point (which would be the createdAt) but the user may enter a
   * different time for when the money actually came in (which would be the statusUpdatedAt).
   */
  readonly statusUpdatedAt: Scalars['DateTime']['output']
  /** This is a required field for all new log entries, but its optional for backwards compatibility. */
  readonly user: Maybe<User>
}

/**
 * The vendor metrics that may be shown on a pay app's sworn statement, based on current commitments on
 * the contract. If this object exists for a VendorContract and PayApp, then that vendor will appear on
 * the pay app's sworn statement form.
 */
export type PayAppSwornStatementVendor = {
  readonly __typename: 'PayAppSwornStatementVendor'
  /**
   * The total amount outstanding in open invoices on this vendor's commitments, to date. This may be
   * calculated from ERP invoices, or manually entered or edited by the user. Note that this is not the
   * same as the total commitment amount minus the amount paid, since this includes only what has been
   * billed.
   */
  readonly amountOutstandingToDate: Maybe<Scalars['SafeInt']['output']>
  /**
   * The total amount paid on this vendor's commitments, to date. This may be calculated from ERP
   * invoices, or manually entered or edited by the user.
   */
  readonly amountPaidToDate: Maybe<Scalars['SafeInt']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /**
   * When the amounts are updated, either manually or via integration, this field is updated to reflect
   * the details of that update. When this entity is first created, this field should be null.
   */
  readonly lastUpdate: Maybe<PayAppSwornStatementVendorUpdate>
  readonly payApp: PayApp
  /** The sum total of all open commitments whose date is on or before the pay app's billing end date */
  readonly totalCommitmentAmount: Scalars['SafeInt']['output']
  /** The last time the sworn statement metrics were updated */
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContract: VendorContract
}

export type PayAppSwornStatementVendorUpdate = {
  readonly __typename: 'PayAppSwornStatementVendorUpdate'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** If updated via integration, this is the through date used for fetching vendor invoices */
  readonly integrationInvoicesThroughDate: Maybe<Scalars['DateTime']['output']>
  /**
   * The user who last manually edited the amounts. If the last edit was from an update via
   * integration, or the amounts have not yet been edited, this should be null.
   */
  readonly manuallyUpdatedBy: Maybe<User>
  readonly swornStatementVendor: PayAppSwornStatementVendor
  readonly updatedAt: Scalars['DateTime']['output']
  /**
   * The integration from which the amounts were last updated. If the last edit was manual, or the
   * amounts have not yet been edited, this should be null.
   */
  readonly updatedFromIntegrationType: Maybe<IntegrationType>
}

export type PayAppsSubmittedData = {
  readonly __typename: 'PayAppsSubmittedData'
  readonly companyCreatedAt: Scalars['DateTime']['output']
  readonly companyId: Scalars['ID']['output']
  readonly companyName: Scalars['String']['output']
  readonly payAppsSubmittedThisMonth: Scalars['SafeInt']['output']
  readonly sitelinePointOfContactId: Maybe<Scalars['ID']['output']>
  readonly sitelinePointOfContactName: Maybe<Scalars['String']['output']>
}

export type PayAppsSubmittedMonthInput = {
  /** This is in YYYY-MM format */
  readonly month: Scalars['String']['input']
}

export { PaymentDateEstimationType }

/**
 * Saved payment method for a company user. Used for charging mail orders and other one-off payments.
 * Cards are stored in Stripe and referenced here by stripePaymentMethodId.
 */
export type PaymentMethod = {
  readonly __typename: 'PaymentMethod'
  readonly brand: CardBrand
  readonly companyUser: CompanyUser
  readonly createdAt: Scalars['DateTime']['output']
  readonly deletedAt: Maybe<Scalars['DateTime']['output']>
  readonly expMonth: Scalars['Int']['output']
  readonly expYear: Scalars['Int']['output']
  readonly id: Scalars['ID']['output']
  readonly isDefault: Scalars['Boolean']['output']
  readonly last4: Scalars['String']['output']
  /** Unique fingerprint from Stripe used for duplicate detection */
  readonly stripeFingerprint: Scalars['String']['output']
  readonly stripePaymentMethodId: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type PaymentPeriodDateRange = {
  readonly __typename: 'PaymentPeriodDateRange'
  readonly endDate: Scalars['String']['output']
  readonly startDate: Scalars['String']['output']
}

export type PendingChangeOrderReport = {
  readonly __typename: 'PendingChangeOrderReport'
  readonly changeOrderRequests: ReadonlyArray<ChangeOrderRequest>
  readonly totalAmountApproved: Scalars['SafeInt']['output']
  readonly totalAmountAuthorizedToProceed: Scalars['SafeInt']['output']
  readonly totalAmountInDraft: Scalars['SafeInt']['output']
  readonly totalAmountProceedingWithWork: Scalars['SafeInt']['output']
  readonly totalAmountRequested: Scalars['SafeInt']['output']
  readonly totalOriginalContractAmount: Scalars['SafeInt']['output']
  readonly totalRevisedContractAmount: Scalars['SafeInt']['output']
}

export { Permission }

export type PeyoteCheckDatabasePermissionsInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly database: Scalars['String']['input']
  readonly host: Scalars['String']['input']
  readonly password: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
  readonly user: Scalars['String']['input']
}

export type PeyoteCheckNetworkConnectionInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly host: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
}

export type PeyoteCheckUsernamePasswordInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly database?: InputMaybe<Scalars['String']['input']>
  readonly host: Scalars['String']['input']
  readonly password: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
  readonly user: Scalars['String']['input']
}

export type PeyoteConnectorStatus = {
  readonly __typename: 'PeyoteConnectorStatus'
  readonly connectorVersion: Maybe<Scalars['String']['output']>
  readonly errorMessage: Maybe<Scalars['String']['output']>
  readonly isConnectorOnline: Scalars['Boolean']['output']
}

/** Generic response from each Peyote SQL debugger step (network / login / permissions). */
export type PeyoteSqlDebuggerResult = {
  readonly __typename: 'PeyoteSqlDebuggerResult'
  /** Step-specific payload (DB metadata for step 2, roles/permissions for step 3). */
  readonly context: Scalars['JSONObject']['output']
  readonly message: Scalars['String']['output']
  readonly status: PeyoteSqlDebuggerStatus
}

export { PeyoteSqlDebuggerStatus }

export { PhysicalSignatureRequired }

/** A template version pinned on a pay-app. Templates are pinned at signing time. */
export type PinnedPayAppTemplate = {
  readonly __typename: 'PinnedPayAppTemplate'
  readonly formTemplateVariant: FormTemplateVariant
  readonly formTemplateVersion: FormTemplateVersion
  readonly order: Scalars['Int']['output']
  readonly payApp: PayApp
}

/**
 * A pay app that was created before the contract was onboarded onto Siteline.
 * It is used purely for aging reports & unconditional lien waivers.
 * It does not act as the source of truth for pre-siteline billing (that's on the contract itself).
 */
export type PreSitelinePayApp = {
  readonly __typename: 'PreSitelinePayApp'
  /** Date this pre-Siteline pay app started aging, or null if it isn't aging. Wraps getPreSitelinePayAppAgingSince. */
  readonly agingSince: Maybe<Scalars['DateTime']['output']>
  readonly amountPaid: Maybe<Scalars['SafeInt']['output']>
  readonly billingEnd: Maybe<Scalars['DateTime']['output']>
  readonly billingStart: Maybe<Scalars['DateTime']['output']>
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /** Open balance with partial payments subtracted. Wraps currentPreSitelinePayAppAmountDue. */
  readonly currentAmountDue: Scalars['SafeInt']['output']
  /** Progress/materials billed */
  readonly currentBilled: Maybe<Scalars['SafeInt']['output']>
  readonly id: Scalars['ID']['output']
  /**
   * If the amount paid on the pay app doesn't match the amount due, we allow the customer to manually
   * mark the pay app balance as closed so the remaining amount isn't considered due and doesn't appear
   * in aging reports.
   */
  readonly isBalanceManuallyClosed: Scalars['Boolean']['output']
  readonly isFinal: Scalars['Boolean']['output']
  readonly isNotarizingUnconditional: Scalars['Boolean']['output']
  readonly paidAt: Maybe<Scalars['DateTime']['output']>
  readonly payAppFile: Maybe<StoredFile>
  readonly payAppNumber: Scalars['Int']['output']
  /**
   * Amount due on the pay app.
   * paymentDue = currentBilled - retentionHeld + retentionReleased
   */
  readonly paymentDue: Maybe<Scalars['SafeInt']['output']>
  /** Estimated payment due date from aging anchor + contract payment terms. Wraps getPaymentDueDateForPreSitelinePayApp. */
  readonly paymentDueDate: Scalars['DateTime']['output']
  readonly percentComplete: Scalars['Float']['output']
  /** Current retention held on the pay app. Must be 0 for retention-only pay apps. */
  readonly retentionHeld: Maybe<Scalars['SafeInt']['output']>
  readonly retentionOnly: Scalars['Boolean']['output']
  /** Current retention released on the pay app */
  readonly retentionReleased: Maybe<Scalars['SafeInt']['output']>
  readonly status: Maybe<PreSitelinePayAppStatus>
  readonly submittedAt: Maybe<Scalars['DateTime']['output']>
  readonly submittedUnconditionalOutsideOfSiteline: Scalars['Boolean']['output']
  readonly timeZone: Scalars['String']['output']
  readonly unconditionalLienWaiver: Maybe<LienWaiver>
}

export { PreSitelinePayAppStatus }

export type ProcessSalesLeadsInput = {
  readonly companyNames: ReadonlyArray<Scalars['String']['input']>
  readonly leadSourceDetail: Scalars['String']['input']
}

/** Represents a single project that produces payment applications on a regular schedule. */
export type Project = {
  readonly __typename: 'Project'
  readonly architect: Maybe<CompanyProjectMetadata>
  readonly bondNumber: Maybe<Scalars['String']['output']>
  readonly bondProvider: Maybe<CompanyProjectMetadata>
  readonly contracts: ReadonlyArray<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  /** The general contractor for the project */
  readonly gc: Maybe<GeneralContractor>
  readonly gcAddress: Maybe<Location>
  /**
   * Override for the GC name just for this project.
   * Equivalent to CompanyProjectMetadata.companyName for GCs.
   * This is only set on old projects that used to have this override. We no longer allow this override to be set on new projects.
   */
  readonly gcName: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly location: Location
  readonly metadata: ProjectMetadata
  readonly name: Scalars['String']['output']
  readonly ownerAddress: Maybe<Location>
  /** The owner for the project */
  readonly ownerEntity: Maybe<Owner>
  /** Project number as defined by the General Contractor. Subcontractors use Contract.internalProjectNumber instead. */
  readonly projectNumber: Scalars['String']['output']
  readonly timeZone: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type ProjectCompanies = {
  readonly __typename: 'ProjectCompanies'
  readonly architects: ReadonlyArray<Company>
  readonly bondProviders: ReadonlyArray<Company>
  readonly gcs: ReadonlyArray<GeneralContractor>
  readonly ownerEntities: ReadonlyArray<Owner>
}

/** A single project to be asynchronously imported from an integration */
export type ProjectImportOperation = {
  readonly __typename: 'ProjectImportOperation'
  readonly company: Company
  /** If null, the project import was triggered from a manual import (i.e. from Excel or CSV) */
  readonly companyIntegration: Maybe<CompanyIntegration>
  /** Set if the import was successful */
  readonly contract: Maybe<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly error: Maybe<Scalars['String']['output']>
  readonly group: ProjectImportOperationGroup
  readonly groupId: Scalars['ID']['output']
  readonly id: Scalars['ID']['output']
  readonly integrationProjectName: Maybe<Scalars['String']['output']>
  readonly integrationProjectNumber: Maybe<Scalars['String']['output']>
  readonly metadata: Scalars['JSONObject']['output']
  readonly status: ImportOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Contains some stats about a particular import group. Computed for each ProjectImportOperation. */
export type ProjectImportOperationGroup = {
  readonly __typename: 'ProjectImportOperationGroup'
  readonly numFailed: Scalars['SafeInt']['output']
  readonly numSuccessful: Scalars['SafeInt']['output']
  readonly status: ImportOperationStatus
  readonly totalOperations: Scalars['SafeInt']['output']
}

/** DEPRECATED */
export type ProjectLienWaiversByMonth = {
  readonly __typename: 'ProjectLienWaiversByMonth'
  readonly lienWaiversByMonth: ReadonlyArray<LienWaiversByMonth>
  readonly project: Project
  readonly requiresLowerTierLienWaivers: Scalars['Boolean']['output']
}

/** Represents metadata around a project. */
export type ProjectMetadata = {
  readonly __typename: 'ProjectMetadata'
  readonly fieldProgressDueOnDayOfMonth: Scalars['Int']['output']
  readonly payAppDueOnDayOfMonth: Scalars['Int']['output']
}

export type ProjectMetadataInput = {
  readonly payAppDueOnDayOfMonth: Scalars['Int']['input']
}

/**
 * Every field should be provided for lump sum and unit price projects but only amountBilledAndDraftThisMonth
 * will be provided for quick bills (which is why its the only required field)
 */
export type ProjectMetrics = {
  readonly __typename: 'ProjectMetrics'
  /** Gross billed, including drafts */
  readonly amountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  /**
   * Gross billed, drafts only.
   * WARNING: This ignores the payAppStatus filter.
   */
  readonly amountInDraftThisMonth: Maybe<Scalars['SafeInt']['output']>
  /**
   * Gross billed, drafts only.
   * This complies with the payAppStatus filter, which means it is 0 if the filter excludes drafts.
   */
  readonly amountInDraftThisMonthFiltered: Maybe<Scalars['SafeInt']['output']>
  readonly balanceToFinish: Maybe<Scalars['SafeInt']['output']>
  readonly billedAndDraftRetentionHeldThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** Gross amount billed to date */
  readonly completedThruMonth: Maybe<Scalars['SafeInt']['output']>
  /** Net billed (deducting retention held), including drafts */
  readonly netAmountBilledAndDraftThisMonth: Scalars['SafeInt']['output']
  /**
   * Net billed (deducting retention held), drafts only.
   * WARNING: This ignores the payAppStatus filter.
   */
  readonly netAmountInDraftThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** Net amount billed to date (deducting retention held) */
  readonly netCompletedThruMonth: Maybe<Scalars['SafeInt']['output']>
  readonly percentCompletedThruMonth: Maybe<Scalars['Float']['output']>
  /** Progress billed this month minus retention held. Retention billed is not included. */
  readonly progressBilledAndDraftMinusRetentionHeldThisMonth: Maybe<Scalars['SafeInt']['output']>
  /**
   * Progress billed this month, not deducting retention held.
   * Retention billed is not included.
   * This is the same as amountBilledAndDraftThisMonth.
   */
  readonly progressBilledAndDraftThisMonth: Maybe<Scalars['SafeInt']['output']>
  /**
   * Progress in draft this month minus retention held
   * Retention billed is not included.
   * This complies with the payAppStatus filter, which means it is 0 if the filter excludes drafts.
   */
  readonly progressInDraftMinusRetentionHeldThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** Retention billed this month */
  readonly retentionBilledAndDraftThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** Retention billed to date including draft pay apps (when applicable) */
  readonly retentionBilledAndDraftThruMonth: Maybe<Scalars['SafeInt']['output']>
  /**
   * Retention in draft this month.
   * This complies with the payAppStatus filter, which means it is 0 if the filter excludes drafts.
   */
  readonly retentionBilledInDraftThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** Retention billed to date on submitted pay apps */
  readonly retentionBilledThruMonth: Maybe<Scalars['SafeInt']['output']>
  /** Retention held on only submitted pay apps */
  readonly retentionHeldThisMonth: Maybe<Scalars['SafeInt']['output']>
  /** All retention held to date, including draft and submitted pay apps */
  readonly retentionHeldThruMonth: Maybe<Scalars['SafeInt']['output']>
  readonly totalValue: Maybe<Scalars['SafeInt']['output']>
}

export { ProjectOnboardingFormType }

export { ProjectSnapshotDashboardSnapshotScoreFilter }

export type ProjectSnapshotScoreBreakdown = {
  readonly __typename: 'ProjectSnapshotScoreBreakdown'
  readonly numScoredHigh: Scalars['SafeInt']['output']
  readonly numScoredLow: Scalars['SafeInt']['output']
  readonly numScoredMedium: Scalars['SafeInt']['output']
}

export type ProjectSnapshotSummary = {
  readonly __typename: 'ProjectSnapshotSummary'
  /** Whether any of the contracts included in the summary have draft pay app billing */
  readonly hasDraftPayAppBilling: Scalars['Boolean']['output']
  /**
   * The number of contracts used to calculate the total over/underbilling and
   * cash position, i.e. the number of contracts that have cost data
   */
  readonly numContractsWithCost: Scalars['SafeInt']['output']
  /** The number of projects with unapproved change order requests */
  readonly numContractsWithUnapprovedChangeOrderRequests: Scalars['SafeInt']['output']
  readonly scoreBreakdown: ProjectSnapshotScoreBreakdown
  readonly totalBillingsInExcessOfCost: Maybe<Scalars['SafeInt']['output']>
  /** Sum of cash position across all active contracts */
  readonly totalCollectedInExcessOfCost: Scalars['SafeInt']['output']
  readonly totalCollectedToDate: Maybe<Scalars['SafeInt']['output']>
  /** Sum of contract values (SOV total) across all active contracts with cost data */
  readonly totalContractValue: Maybe<Scalars['SafeInt']['output']>
  readonly totalCostToDate: Maybe<Scalars['SafeInt']['output']>
  readonly totalCurrentBudget: Maybe<Scalars['SafeInt']['output']>
  /** Sum of current gross profit (gross billed to date - cost to date) across all active contracts with cost data */
  readonly totalCurrentGrossProfit: Maybe<Scalars['SafeInt']['output']>
  /** Sum of earned revenue across all active contracts with cost data */
  readonly totalEarnedRevenue: Maybe<Scalars['SafeInt']['output']>
  /** Sum of gross billed to date across all active contracts with cost data */
  readonly totalGrossBilledToDate: Maybe<Scalars['SafeInt']['output']>
  /** Sum of projected gross profit (contract value - estimated job cost) across all active contracts with cost data */
  readonly totalProjectedGrossProfit: Maybe<Scalars['SafeInt']['output']>
  /** Sum of COR amounts for submitted but unapproved CORs. Null if no contracts have any CORs. */
  readonly totalUnapprovedChangeOrderRequestAmount: Maybe<Scalars['SafeInt']['output']>
}

export type Query = {
  readonly __typename: 'Query'
  /** Finds count and ID of abandoned pay apps for a given company */
  readonly abandonedPayApps: ReadonlyArray<AbandonedPayAppsData>
  /** Returns a status summary of active company integrations on Agave Connector integrations */
  readonly agaveConnectorCompanyIntegrationsStatus: ReadonlyArray<AgaveConnectorCompanyIntegrationStatus>
  /** Gets credentials for a company integration formatted for dev.env */
  readonly agaveCredentialsForDevEnv: Scalars['String']['output']
  /** Get Agave debugger session url */
  readonly agaveDebuggerSessionUrl: Maybe<Scalars['String']['output']>
  /** Matrix of Agave endpoints × integration types with source_data paths */
  readonly agaveEndpointMatrix: AgaveEndpointMatrix
  /** Gets an Agave link token. */
  readonly agaveLinkToken: Scalars['String']['output']
  /** Gets a list of users at a company who have access to every company project */
  readonly allProjectUsersByCompany: ReadonlyArray<CompanyUser>
  /** Finds the number of pay apps submitted by each company in each month */
  readonly billingTotals: ReadonlyArray<BillingTotalsData>
  /** Returns a list of all keys on the generic or files cache, by key pattern. */
  readonly cacheKeys: ReadonlyArray<Scalars['String']['output']>
  /** Finds percent of projects per company with change order requests */
  readonly changeOrderLogUse: ReadonlyArray<ChangeOrderLogUseData>
  /** Returns the live Sitelord chat tool catalog and any per-MCP load errors. */
  readonly chatTools: ChatToolsResponse
  /** Returns logs from Cloud Logging */
  readonly cloudLoggingLogs: CloudLoggingLogsResponse
  /** Returns all companies */
  readonly companies: ReadonlyArray<Company>
  /** Returns a list of company IDs given a rollout percentage */
  readonly companiesByRolloutPercentage: ReadonlyArray<Scalars['ID']['output']>
  /** Returns a specific company */
  readonly company: Company
  /** Returns a single company integration by ID */
  readonly companyIntegration: CompanyIntegration
  /** Get internal siteline notes for a company */
  readonly companyInternalSitelineNotes: Maybe<Scalars['String']['output']>
  /** Finds percent of projects per company with legal requirements */
  readonly complianceUse: ReadonlyArray<ComplianceUseData>
  /** Returns a contract by ID */
  readonly contract: Contract
  /** Gets a list of form templates associated with a contract. */
  readonly contractFormTemplates: ReadonlyArray<FormTemplate>
  /** Returns a list of contracts by ID */
  readonly contractsById: ReadonlyArray<Contract>
  /** Returns the companies used for customer demos */
  readonly demoCompanies: ReadonlyArray<Company>
  /** Returns all feature flags */
  readonly featureFlags: ReadonlyArray<FeatureFlag>
  /** Gets a form template by ID */
  readonly formTemplate: FormTemplate
  /** Gets a form template variant by ID */
  readonly formTemplateVariant: FormTemplateVariant
  /** Gets a form template version by ID */
  readonly formTemplateVersion: FormTemplateVersion
  /** Finds the number of forms a company has requeseted, how many have been completed, and the ratio */
  readonly formTracker: ReadonlyArray<FormTrackerData>
  /** Finds how long it takes to complete form templates given a variety of filters */
  readonly formTurnaroundData: FormTurnaroundData
  /** Contracts that have been fully billed in Siteline */
  readonly fullyBilledContracts: ReadonlyArray<Contract>
  /** Finds all general contractor companies for deduping */
  readonly generalContractorsForDedupe: ReadonlyArray<GeneralContractorForDedupe>
  /** Returns the decrypted credentials blob for a company integration */
  readonly integrationCredential: Scalars['JSONObject']['output']
  /** Returns invoice type info for Sage Intacct from the integration service */
  readonly integrationInvoiceTypes: ReadonlyArray<IntegrationInvoiceType>
  /** Gets the OAuth authorize URL for an integration that uses OAuth (e.g. Procore Peyote). */
  readonly integrationOauthAuthorizeUrl: Scalars['String']['output']
  /** Returns a list of 1Password items in the Siteline Customer Login vault, with their title only */
  readonly integrationOnePasswordItems: ReadonlyArray<IntegrationOnePasswordItem>
  /** Fetches a single integration request by its MongoDB document ID */
  readonly integrationRequest: IntegrationRequest
  /** Gets a legal requirement by ID */
  readonly legalRequirement: LegalRequirement
  /** Number of lien waivers requested per company in the last 30 days */
  readonly lienWaiversRequested: ReadonlyArray<LienWaiverRequestData>
  /**
   * Returns the source-system "companies" (Vista HQCos, Sage 300 company codes, …)
   * visible to an integration's saved credentials. Naming mirrors Agave's
   * `/link/companies`. Used by the admin-dashboard setup flow so the user can pick
   * which one to scope the integration to.
   */
  readonly linkCompanies: ReadonlyArray<LinkCompany>
  /** List of paginated companies according to specific filters */
  readonly paginatedCompanies: PaginatedCompanyList
  /** Returns a list of paginated contract mismatch report operation groups */
  readonly paginatedContractMismatchReportOperationGroups: PaginatedContractMismatchReportOperationGroups
  /** List of paginated contracts according to specific filters */
  readonly paginatedContracts: PaginatedContractList
  /** List of paginated integration requests */
  readonly paginatedIntegrationRequests: PaginatedIntegrationRequestList
  /** List of paginated contracts according to specific filters */
  readonly paginatedTemplates: PaginatedTemplateList
  /** Returns a list of paginated write sync operations */
  readonly paginatedWriteSyncOperations: PaginatedWriteSyncOperations
  /** Returns a specific pay-app */
  readonly payApp: PayApp
  /** Finds number of pay apps submitted in a given month per company */
  readonly payAppsSubmittedMonth: ReadonlyArray<PayAppsSubmittedData>
  /** All GraphQL servers need a root query type. This one is empty. */
  readonly placeholder: Scalars['Boolean']['output']
  /** Returns a project by ID */
  readonly project: Project
  /** Returns all projects */
  readonly projects: ReadonlyArray<Project>
  /** Gets a list of projects that a company is part of as an owner, GC or sub. */
  readonly projectsByCompany: ReadonlyArray<Project>
  /** Gets a list of projects that a user is part of. */
  readonly projectsByUser: ReadonlyArray<Project>
  /**
   * Whether the Sage Intacct Peyote integration currently has customer-supplied Web
   * Services sender credentials stored. Used by the admin setup modal to warn before
   * a re-save that omits them would drop them and fall back to Siteline's shared
   * sender. Never returns the secret values themselves.
   */
  readonly sageIntacctPeyoteHasSenderCredentials: Scalars['Boolean']['output']
  /** Search projects, companies, etc */
  readonly search: ReadonlyArray<SearchResult>
  /** Find templates similar to a given file */
  readonly similarTemplates: ReadonlyArray<SimilarTemplate>
  /** Returns all the Siteline team members */
  readonly sitelineTeamMembers: ReadonlyArray<User>
  /** Gets a list of all SOV Line Item Groups for a provided company and project. */
  readonly sovLineItemGroups: ReadonlyArray<SovLineItemGroup>
  /** Returns a list of all lien rights requirements by state */
  readonly stateLienRequirementsSummaries: ReadonlyArray<StateLienRequirementsSummary>
  /** Returns a single state's lien rights requirements summary */
  readonly stateLienRequirementsSummary: Maybe<StateLienRequirementsSummary>
  /** Template build statistics */
  readonly templateBuildStats: TemplateBuildStats
  /** Finds time to value for newly onboarded companies */
  readonly timeToValue: ReadonlyArray<TimeToValueData>
  /** Returns a user by ID */
  readonly user: User
  /** Returns details for a single user education campaign */
  readonly userEducationCampaign: UserEducationCampaign
  /** Returns all user education campaigns */
  readonly userEducationCampaigns: ReadonlyArray<UserEducationCampaign>
}

export type QueryAgaveCredentialsForDevEnvArgs = {
  input: AgaveCredentialsForDevEnvInput
}

export type QueryAgaveDebuggerSessionUrlArgs = {
  input: AgaveDebuggerSessionUrlInput
}

export type QueryAgaveLinkTokenArgs = {
  companyIntegrationId: Scalars['ID']['input']
}

export type QueryAllProjectUsersByCompanyArgs = {
  id: Scalars['ID']['input']
}

export type QueryBillingTotalsArgs = {
  input: BillingTotalsInput
}

export type QueryCacheKeysArgs = {
  input: GetCacheKeysInput
}

export type QueryCloudLoggingLogsArgs = {
  input: CloudLoggingLogsInput
}

export type QueryCompaniesByRolloutPercentageArgs = {
  input: CompaniesByRolloutPercentageInput
}

export type QueryCompanyArgs = {
  id: Scalars['ID']['input']
}

export type QueryCompanyIntegrationArgs = {
  id: Scalars['ID']['input']
}

export type QueryCompanyInternalSitelineNotesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryContractArgs = {
  id: Scalars['ID']['input']
}

export type QueryContractFormTemplatesArgs = {
  contractId: Scalars['ID']['input']
}

export type QueryContractsByIdArgs = {
  input: ContractsByIdInput
}

export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export type QueryFormTemplateVariantArgs = {
  id: Scalars['ID']['input']
}

export type QueryFormTemplateVersionArgs = {
  id: Scalars['ID']['input']
}

export type QueryFormTrackerArgs = {
  input: FormTrackerInput
}

export type QueryFormTurnaroundDataArgs = {
  input: FormTurnaroundDataInput
}

export type QueryGeneralContractorsForDedupeArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryIntegrationCredentialArgs = {
  input: IntegrationCredentialInput
}

export type QueryIntegrationInvoiceTypesArgs = {
  input: IntegrationInvoiceTypesInput
}

export type QueryIntegrationOauthAuthorizeUrlArgs = {
  input: IntegrationOauthAuthorizeUrlInput
}

export type QueryIntegrationRequestArgs = {
  id: Scalars['String']['input']
}

export type QueryLegalRequirementArgs = {
  id: Scalars['ID']['input']
}

export type QueryLinkCompaniesArgs = {
  companyIntegrationId: Scalars['ID']['input']
}

export type QueryPaginatedCompaniesArgs = {
  input: GetPaginatedCompaniesInput
}

export type QueryPaginatedContractMismatchReportOperationGroupsArgs = {
  input: GetPaginatedContractMismatchReportOperationGroupsInput
}

export type QueryPaginatedContractsArgs = {
  input: GetPaginatedContractsInput
}

export type QueryPaginatedIntegrationRequestsArgs = {
  input: GetPaginatedIntegrationRequestsInput
}

export type QueryPaginatedTemplatesArgs = {
  input: GetPaginatedTemplatesInput
}

export type QueryPaginatedWriteSyncOperationsArgs = {
  input: GetPaginatedWriteSyncOperationsInput
}

export type QueryPayAppArgs = {
  id: Scalars['ID']['input']
}

export type QueryPayAppsSubmittedMonthArgs = {
  input: PayAppsSubmittedMonthInput
}

export type QueryProjectArgs = {
  id: Scalars['ID']['input']
}

export type QueryProjectsByCompanyArgs = {
  id: Scalars['ID']['input']
}

export type QueryProjectsByUserArgs = {
  id: Scalars['ID']['input']
}

export type QuerySageIntacctPeyoteHasSenderCredentialsArgs = {
  companyIntegrationId: Scalars['ID']['input']
}

export type QuerySearchArgs = {
  query: Scalars['String']['input']
  type?: InputMaybe<SearchResultType>
}

export type QuerySimilarTemplatesArgs = {
  upload: Scalars['Upload']['input']
}

export type QuerySovLineItemGroupsArgs = {
  contractId: Scalars['ID']['input']
}

export type QueryStateLienRequirementsSummaryArgs = {
  input: StateLienRequirementsSummaryInput
}

export type QueryUserArgs = {
  id: Scalars['ID']['input']
}

export type QueryUserEducationCampaignArgs = {
  id: Scalars['ID']['input']
}

export type QuickbooksOnlineIntegrationItem = {
  readonly __typename: 'QuickbooksOnlineIntegrationItem'
  readonly integrationItemId: Scalars['String']['output']
  readonly name: Scalars['String']['output']
  readonly sourceId: Scalars['String']['output']
}

export { QuickbooksOnlineSyncType }

export type RateTable = {
  readonly __typename: 'RateTable'
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * Returns all contracts associated with the rate table. This includes contracts that are currently
   * linked to the rate table, as well as contracts with a pay app linked to the rate table or a
   * change order request linked to the rate table. This may not be the current rate table associated
   * with all associated contracts, as a newer rate table may have been linked since the pay app or
   * COR was billed or priced.
   */
  readonly associatedContracts: ReadonlyArray<Contract>
  readonly company: Company
  /** List of contracts that are currently linked to this rate table */
  readonly contracts: ReadonlyArray<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  /** If the rate table becomes effective as of a certain date, that date may be set here */
  readonly effectiveAt: Maybe<Scalars['DateTime']['output']>
  /** If the rate table expires as of a certain date, that date may be set here */
  readonly expiresAt: Maybe<Scalars['DateTime']['output']>
  readonly groups: ReadonlyArray<RateTableGroup>
  readonly id: Scalars['ID']['output']
  /** Mappings of Siteline entity to Integration entity. Fields depend on the integration type. */
  readonly integrationMappings: Scalars['JSONObject']['output']
  readonly items: ReadonlyArray<RateTableItem>
  readonly lastEditedAt: Scalars['DateTime']['output']
  readonly lastEditedBy: User
  readonly name: Scalars['String']['output']
  readonly status: RateTableStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

export type RateTableGroup = {
  readonly __typename: 'RateTableGroup'
  readonly contractRateTableFees: ReadonlyArray<ContractRateTableFee>
  readonly contractRateTableTaxGroups: ReadonlyArray<ContractRateTableTaxGroup>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly items: ReadonlyArray<RateTableItem>
  readonly name: Scalars['String']['output']
  readonly rateTable: RateTable
  readonly type: LineItemType
  readonly updatedAt: Scalars['DateTime']['output']
}

export type RateTableItem = {
  readonly __typename: 'RateTableItem'
  readonly code: Maybe<Scalars['String']['output']>
  readonly costType: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly description: Scalars['String']['output']
  readonly group: RateTableGroup
  readonly id: Scalars['ID']['output']
  readonly rateTable: RateTable
  /** Order in which to display the rate table line items. First line item starts at 1. */
  readonly sortOrder: Scalars['SafeInt']['output']
  readonly unitName: Maybe<Scalars['String']['output']>
  readonly unitRate: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export { RateTableStatus }

export type RefreshIntegrationMappingsInput = {
  readonly integrationId: Scalars['ID']['input']
  readonly refreshLegalRequirements: Scalars['Boolean']['input']
  readonly refreshProjectAndContract: Scalars['Boolean']['input']
  readonly refreshVendors: Scalars['Boolean']['input']
}

export type ReplaceFormTemplateAnnotationsInput = {
  readonly annotations: ReadonlyArray<FormAnnotationInput>
  readonly formTemplateVersionId: Scalars['ID']['input']
}

/**
 * Report Builder: A saved custom report configuration. Users select project-level data fields
 * from multiple sections to create reusable Excel exports. Only the creator can edit/delete,
 * but all company members can view and run saved reports.
 */
export type Report = {
  readonly __typename: 'Report'
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly deletedAt: Maybe<Scalars['DateTime']['output']>
  readonly fields: ReadonlyArray<Scalars['JSONObject']['output']>
  /** Optional field whose value groups rows into sections (with subtotals) in the exported report */
  readonly groupByField: Maybe<ReportGroupByField>
  readonly id: Scalars['ID']['output']
  /** True for one-off reports that are run without being saved */
  readonly isAdHoc: Scalars['Boolean']['output']
  readonly name: Scalars['String']['output']
  readonly projectFilters: Maybe<Scalars['JSONObject']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

export { ReportDataField }

export type ReportDataFieldInfo = {
  readonly __typename: 'ReportDataFieldInfo'
  readonly field: ReportDataField
  /** If true, this field reflects current state regardless of the selected date range */
  readonly isPointInTime: Scalars['Boolean']['output']
  /** Per-section display names for the builder UI */
  readonly sections: ReadonlyArray<ReportDataFieldSectionInfo>
}

export type ReportDataFieldSectionInfo = {
  readonly __typename: 'ReportDataFieldSectionInfo'
  readonly displayName: Scalars['String']['output']
  readonly section: ReportSection
}

export { ReportGroupByField }

/**
 * Report Builder: Tracks async report generation status. The Excel file is emailed to the user when
 * complete (not stored). The snapshot captures the fields, filters, grouping, etc that what was exported
 * and which contracts were filtered at run time, independent of the saved report's current state.
 */
export type ReportRunOperation = {
  readonly __typename: 'ReportRunOperation'
  readonly company: Company
  readonly completedAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly endDate: Scalars['String']['output']
  /** Error strings (per contract) if an error occurred; status will be FAILED */
  readonly errors: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly fields: ReadonlyArray<Scalars['JSONObject']['output']>
  readonly groupByField: Maybe<ReportGroupByField>
  readonly id: Scalars['ID']['output']
  readonly projectFilters: Maybe<Scalars['JSONObject']['output']>
  readonly report: Report
  readonly requestedBy: User
  readonly startDate: Scalars['String']['output']
  readonly status: ReportRunOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

export { ReportRunOperationStatus }

export { ReportSection }

export type RequeueWriteSyncInput = {
  readonly writeSyncOperationId: Scalars['ID']['input']
}

export { RequiredFieldForForms }

export type RetentionBillingResult = {
  readonly __typename: 'RetentionBillingResult'
  readonly retentionHeldCurrent: Scalars['Float']['output']
  readonly retentionHeldToDate: Scalars['Float']['output']
  readonly retentionReleased: Scalars['Float']['output']
}

export type RetentionChangelog = {
  readonly __typename: 'RetentionChangelog'
  /** Whether payAppChangedIn is retentionOnly, used for sorting the changelog. */
  readonly changedInRetentionOnlyPayApp: Scalars['Boolean']['output']
  /** Contract this retention changelog is for. */
  readonly contract: Contract
  readonly id: Scalars['ID']['output']
  /**
   * The line item for which this retention percent applies. If not specified, it impacts the entire
   * pay app.
   */
  readonly lineItemRetentionAdjustedOn: Maybe<SovLineItem>
  /** The billingEnd of the payAppChangedIn, used for sorting the changelog. */
  readonly monthChangedIn: Maybe<Scalars['DateTime']['output']>
  /** The pay app in which the user set the percent for the past pay app. */
  readonly payAppChangedIn: Maybe<PayApp>
  /**
   * The past pay app for which this retention percent applies. If not specified, it represents
   * retention from before onboarding to Siteline.
   */
  readonly payAppRetentionAdjustedOn: Maybe<PayApp>
  /** Whether this retention is from before the project was added to Siteline. */
  readonly preSiteline: Scalars['Boolean']['output']
  /** The progress retention on this progress or pay app not including the delta. */
  readonly progressRetentionAmount: Scalars['SafeInt']['output']
  /** The progress retention percent as a decimal (0-1). */
  readonly progressRetentionPercent: Scalars['Float']['output']
  /**
   * Amount of retention for this line item or pay app being billed for in the payAppChangedIn. Note:
   * this value is always 0 if the payAppChangedIn is the current pay app because you can't bill for
   * retention in the current month since it hasn't been held yet.
   */
  readonly retentionBilled: Scalars['SafeInt']['output']
  /** Fudge amount of retention on this progress or pay app. */
  readonly retentionDelta: Scalars['SafeInt']['output']
  /** The stored materials retention on this progress or pay app not including the delta. */
  readonly storedMaterialsRetentionAmount: Scalars['SafeInt']['output']
  /** The stored materials retention percent as a decimal (0-1). */
  readonly storedMaterialsRetentionPercent: Scalars['Float']['output']
}

export { RetentionTrackingLevel }

export type RotateIntegrationCredentialInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
}

export type RunFormTemplateSuggestionsInput = {
  /** The form template version to extract + classify. */
  readonly formTemplateVersionId: Scalars['ID']['input']
}

export { Sage100InvoiceTaxType }

export type SearchResult = {
  readonly __typename: 'SearchResult'
  readonly description: Scalars['String']['output']
  readonly id: Scalars['String']['output']
  readonly score: Scalars['Float']['output']
  readonly type: SearchResultType
}

export { SearchResultType }

export type SendCompanyMonthlyReportTestEmailInput = {
  readonly companyId: Scalars['ID']['input']
  readonly month: Scalars['Int']['input']
  readonly userId?: InputMaybe<Scalars['ID']['input']>
  readonly year: Scalars['Int']['input']
}

export type SetCompanyInternalSitelineNotesInput = {
  readonly companyId: Scalars['ID']['input']
  readonly internalSitelineNotes?: InputMaybe<Scalars['String']['input']>
}

export type SetFormTemplateTagsInput = {
  readonly id: Scalars['ID']['input']
  readonly tags: ReadonlyArray<FormTemplateTag>
}

export type SetLineItemsInGroupInput = {
  readonly groupId: Scalars['ID']['input']
  readonly sovLineItemIds: ReadonlyArray<Scalars['ID']['input']>
}

export type SetPayAppProposedInput = {
  readonly id: Scalars['ID']['input']
  readonly proposedAt: Scalars['DateTime']['input']
}

export type SetPayAppSyncedInput = {
  readonly id: Scalars['ID']['input']
  readonly syncedAt: Scalars['DateTime']['input']
}

/**
 * Response from creating a Stripe Setup Intent for card verification.
 * Not stored in database - returned directly from Stripe API.
 */
export type SetupIntentResponse = {
  readonly __typename: 'SetupIntentResponse'
  /** Stripe client secret for confirming the setup intent on the frontend */
  readonly stripeClientSecret: Scalars['String']['output']
}

/**
 * When a user signs a document, they either use their name + font or they upload a file. Depending on
 * which is chosen, either the name + font are populated or the file name + url + type are populated.
 * There are 2 checks:
 * 1. Confirms that either the user or vendor is specified but not both.
 * 2. Confirms that either a manual signature is specified or a uploaded signature but not both.
 */
export type Signature = {
  readonly __typename: 'Signature'
  readonly createdAt: Scalars['DateTime']['output']
  readonly file: Maybe<StoredFile>
  readonly id: Scalars['ID']['output']
  readonly ipAddress: Maybe<Scalars['String']['output']>
  readonly signatureFont: Maybe<SignatureFont>
  readonly signatureName: Maybe<Scalars['String']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly user: Maybe<User>
  readonly vendorContact: Maybe<VendorContact>
}

export { SignatureAnnotationType }

export { SignatureFont }

export type SimilarTemplate = {
  readonly __typename: 'SimilarTemplate'
  /** Similarity score between the input file and returned template. Range: 0-1, higher is better. Score >= 0.8 is a strong match. */
  readonly score: Scalars['Float']['output']
  readonly template: FormTemplate
  readonly version: FormTemplateVersion
}

export { SitelineTeamMemberRole }

export type SkipFormTemplateValidationInput = {
  readonly formTemplateId: Scalars['ID']['input']
  readonly message: Scalars['String']['input']
}

/** Represents a full schedule of values for a given project and company. */
export type Sov = {
  readonly __typename: 'Sov'
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** Integration mappings for this SOV. Contains mappings between Siteline and Integration line items. */
  readonly integrationMappings: Scalars['JSONObject']['output']
  readonly lineItemGroups: ReadonlyArray<SovLineItemGroup>
  readonly lineItems: ReadonlyArray<SovLineItem>
  /** Sum of totalValue from every SovLineItem, excluding change orders. */
  readonly originalTotalValue: Scalars['SafeInt']['output']
  /**
   * This includes both retention and stored materials. Stored materials are only ever billed for once,
   * and then they're considered a part of totalBilled. It makes sense to split it out in
   * SovLineItemProgress as we need to capture that in the specific month.
   */
  readonly totalBilled: Scalars['SafeInt']['output']
  /** This is the total amount of retention that has been accumulated on the entire SOV to date. */
  readonly totalRetention: Scalars['SafeInt']['output']
  /** Sum of totalValue from every SovLineItem. Updated any time the SOV is modified. */
  readonly totalValue: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type SovChangeSet = {
  readonly __typename: 'SovChangeSet'
  readonly additions: ReadonlyArray<LineItemAddition>
  readonly deletions: ReadonlyArray<LineItemDeletion>
  readonly groupAdditions: ReadonlyArray<LineItemGroupAddition>
  readonly groupDeletions: ReadonlyArray<LineItemGroupDeletion>
  readonly groupUpdates: ReadonlyArray<LineItemGroupUpdate>
  readonly updates: ReadonlyArray<LineItemUpdate>
}

export type SovChangeSetCreateLineItem = {
  readonly __typename: 'SovChangeSetCreateLineItem'
  readonly changeOrderApprovedDate: Maybe<Scalars['DateTime']['output']>
  readonly changeOrderEffectiveDate: Maybe<Scalars['DateTime']['output']>
  readonly code: Scalars['String']['output']
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly defaultRetentionPercent: Maybe<Scalars['Float']['output']>
  readonly erpIntegrationId: Maybe<Scalars['ID']['output']>
  readonly isChangeOrder: Scalars['Boolean']['output']
  readonly latestTotalValue: Scalars['SafeInt']['output']
  readonly name: Scalars['String']['output']
  readonly originalTotalValue: Scalars['SafeInt']['output']
  readonly preSitelineRetentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  readonly previousBilled: Scalars['SafeInt']['output']
  readonly previousMaterialsInStorage: Maybe<Scalars['SafeInt']['output']>
  readonly previousStoredMaterials: Maybe<Scalars['SafeInt']['output']>
  readonly sortOrder: Maybe<Scalars['SafeInt']['output']>
  readonly sovLineItemGroupId: Maybe<Scalars['String']['output']>
  readonly taxGroupId: Maybe<Scalars['ID']['output']>
  readonly unitName: Maybe<Scalars['String']['output']>
  readonly unitPrice: Maybe<Scalars['Decimal']['output']>
}

export type SovChangeSetCreateLineItemGroup = {
  readonly __typename: 'SovChangeSetCreateLineItemGroup'
  readonly code: Maybe<Scalars['String']['output']>
  readonly name: Scalars['String']['output']
}

export type SovChangeSetUpdateLineItem = {
  readonly __typename: 'SovChangeSetUpdateLineItem'
  /** Undefined to ignore, null to remove */
  readonly changeOrderApprovedDate: Maybe<Scalars['DateTime']['output']>
  readonly changeOrderEffectiveDate: Maybe<Scalars['DateTime']['output']>
  readonly code: Maybe<Scalars['String']['output']>
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly defaultRetentionPercent: Maybe<Scalars['Float']['output']>
  readonly erpIntegrationId: Maybe<Scalars['ID']['output']>
  readonly isChangeOrder: Maybe<Scalars['Boolean']['output']>
  readonly latestTotalValue: Maybe<Scalars['SafeInt']['output']>
  readonly name: Maybe<Scalars['String']['output']>
  readonly originalTotalValue: Maybe<Scalars['SafeInt']['output']>
  readonly preSitelineRetentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  readonly previousBilled: Maybe<Scalars['SafeInt']['output']>
  readonly previousMaterialsInStorage: Maybe<Scalars['SafeInt']['output']>
  readonly previousStoredMaterials: Maybe<Scalars['SafeInt']['output']>
  readonly sortOrder: Maybe<Scalars['SafeInt']['output']>
  readonly sovLineItemGroupId: Maybe<Scalars['String']['output']>
  readonly taxGroupId: Maybe<Scalars['ID']['output']>
  readonly unitName: Maybe<Scalars['String']['output']>
  readonly unitPrice: Maybe<Scalars['Decimal']['output']>
}

export type SovChangeSetUpdateLineItemGroup = {
  readonly __typename: 'SovChangeSetUpdateLineItemGroup'
  readonly code: Maybe<Scalars['String']['output']>
  readonly name: Maybe<Scalars['String']['output']>
}

/**
 * Represents a single line item from a single SOV.
 * Constraints:
 * - Ensure that a change order always has an approval date, and that a regular line item does not
 *   have an change-order approval date
 */
export type SovLineItem = {
  readonly __typename: 'SovLineItem'
  /**
   * Equivalent to `totalBilled`, except includes progress billed on draft and signed pay apps as well as
   * proposed and paid.
   */
  readonly billedToDate: Scalars['SafeInt']['output']
  /** If this is a change order, this is the date that this SovLineItem was approved. */
  readonly changeOrderApprovedDate: Maybe<Scalars['DateTime']['output']>
  /**
   * If this is a change order and it should start appearing on pay apps in a month other than the
   * month it was approved, this month will be used instead of the approval date. By default, the
   * change order is considered effective in the month it was approved.
   */
  readonly changeOrderEffectiveDate: Maybe<Scalars['DateTime']['output']>
  /**
   * Change order requests that are associated with this line item. All change order requests in
   * this list should be linked to each other as well.
   */
  readonly changeOrderRequests: ReadonlyArray<ChangeOrderRequest>
  readonly code: Scalars['String']['output']
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  /** Tracks what initial retention % to initialize progress at for the first pay app. Range 0-1. */
  readonly defaultRetentionPercent: Maybe<Scalars['Float']['output']>
  /** If Siteline contract has multiple ERP contracts, this is the target integration for this line item */
  readonly erpIntegration: Maybe<Integration>
  readonly id: Scalars['ID']['output']
  /** This is set to true if this line item is a part of a change order, false otherwise. */
  readonly isChangeOrder: Scalars['Boolean']['output']
  /** The latest total value for the line item. Denormalized: maintained on every SOV change. */
  readonly latestTotalValue: Scalars['SafeInt']['output']
  readonly name: Scalars['String']['output']
  /** The original total value of the line item when it was added. Denormalized: maintained on every SOV change. */
  readonly originalTotalValue: Scalars['SafeInt']['output']
  /**
   * Pre-siteline retention override amount in cents.
   * This is required for pay-app/project tracking.
   */
  readonly preSitelineRetentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  /**
   * Tax rate to apply to pre-siteline billing.
   * This is automatically set when enabling taxes at the beginning of a contract, or directly
   * when importing/creating a contract.
   */
  readonly preSitelineTaxPercent: Scalars['Float']['output']
  /**
   * This is the total amount previously billed for this line item if the project is being added to
   * Siteline part of the way through. For new projects this number is set to 0.
   */
  readonly previousBilled: Scalars['SafeInt']['output']
  /**
   * This is the total amount of materials that were held in storage at the time that the project was
   * added to Siteline. This number is only relevant to manual stored materials carryover type, where
   * materials in storage is tracked separately from materials billed.
   */
  readonly previousMaterialsInStorage: Scalars['SafeInt']['output']
  /**
   * This is the total amount of previously billed stored materials for this line item if the project
   * is being added to Siteline part of the way through. This number is independent from previousBilled
   * and previousBilled includes both progress and stored materials. For new projects this number is
   * set to 0.
   */
  readonly previousStoredMaterials: Scalars['SafeInt']['output']
  readonly progress: ReadonlyArray<SovLineItemProgress>
  /**
   * A simple helper to share this logic. Runs the formula: (totalBilled / totalValue) to at most 2
   * decimal places.
   */
  readonly progressComplete: Scalars['Float']['output']
  /** Denormalized retention held pre-siteline for this line item. */
  readonly retentionHeldPreSiteline: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldPreSiteline. */
  readonly retentionHeldPreSitelinePercent: Scalars['Float']['output']
  /** Tax on retentionHeldPreSiteline. */
  readonly retentionHeldPreSitelineTax: Scalars['SafeInt']['output']
  /** Denormalized total retention held on this line item to date (latest pay app, or pre-siteline). */
  readonly retentionHeldTotal: Scalars['SafeInt']['output']
  /**
   * If defined, it will be assumed that all SovLineItem objects have the sortOrder defined and this
   * will be used to sort in order instead of the `code` field, which is the default sorting method.
   */
  readonly sortOrder: Scalars['SafeInt']['output']
  readonly sov: Sov
  /** Optional group for this line item */
  readonly sovLineItemGroup: Maybe<SovLineItemGroup>
  /** Optional tax rate to apply to the line item. It must be a tax group from the subcontractor company. */
  readonly taxGroup: Maybe<TaxGroup>
  /**
   * This includes both retention and stored materials. Stored materials are only ever billed for once,
   * and then they're considered a part of totalBilled. It makes sense to split it out in
   * SovLineItemProgress as we need to capture that in the specific month. Includes only proposed/paid pay apps.
   */
  readonly totalBilled: Scalars['SafeInt']['output']
  /** List of all total values for the line item */
  readonly totalValues: ReadonlyArray<SovLineItemTotalValue>
  /** The human-readable unit of measurement for each unit, e.g. LF, EA, HR for UNIT_PRICE contract. */
  readonly unitName: Maybe<Scalars['String']['output']>
  /** A price per unit, in cents. This is used for UNIT_PRICE contracts. */
  readonly unitPrice: Maybe<Scalars['Decimal']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly worksheetLineItems: ReadonlyArray<WorksheetLineItem>
}

/** Represents a group of SovLineItems, denoted primarily by a name. */
export type SovLineItemGroup = {
  readonly __typename: 'SovLineItemGroup'
  readonly code: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lineItems: ReadonlyArray<SovLineItem>
  readonly name: Scalars['String']['output']
  readonly sov: Sov
  readonly updatedAt: Scalars['DateTime']['output']
}

export type SovLineItemInput = {
  readonly changeOrderApprovedDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly code: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['String']['input']>
  readonly isChangeOrder: Scalars['Boolean']['input']
  readonly name: Scalars['String']['input']
  readonly previousBilled: Scalars['SafeInt']['input']
  readonly previousStoredMaterials?: InputMaybe<Scalars['SafeInt']['input']>
  readonly progressRetentionPercent?: InputMaybe<Scalars['Float']['input']>
  readonly sortOrder: Scalars['SafeInt']['input']
  readonly sovLineItemGroupId?: InputMaybe<Scalars['ID']['input']>
  readonly totalValue: Scalars['SafeInt']['input']
}

/**
 * Represents the progress for a single SOV line item, to be used in monthly pay apps.
 * Constraints:
 * - Ensure that there is only one progress per line-item/pay-app tuple.
 */
export type SovLineItemProgress = {
  readonly __typename: 'SovLineItemProgress'
  /** Amount due, post tax. This is amountDuePreTax + amountDueTaxAmount */
  readonly amountDuePostTax: Scalars['SafeInt']['output']
  /** Current billed - retention held + retention released. This is pre-tax. */
  readonly amountDuePreTax: Scalars['SafeInt']['output']
  /** Tax amount on the amount due. Tax rate is available on sovLineItem.taxGroup */
  readonly amountDueTaxAmount: Scalars['SafeInt']['output']
  /** Optional description of the PayAppAttachments associated with the SovLineItemProgress */
  readonly attachmentsDescription: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  /** Sum of progressBilled + storedMaterialBilled. This does not deduct retention. */
  readonly currentBilled: Scalars['SafeInt']['output']
  /**
   * A list of events related to this progress, like `SET_PROGRESS_BILLED`.
   * Pay-app events, like submissions, are not reflected here. They are reflected on the pay app itself
   */
  readonly events: ReadonlyArray<SovLineItemProgressEvent>
  /** This is the total amount billed in all progress for this line item after this pay app. */
  readonly futureBilled: Scalars['SafeInt']['output']
  readonly id: Scalars['ID']['output']
  /** If a past progress had a retention override on this line item, it's returned here */
  readonly lastProgressWithRetentionHeldOverride: Maybe<SovLineItemProgress>
  /**
   * Materials left in storage after applying changes from this pay app
   * materialsInStorageThroughPreviousPayApp + materialsAddedToStorageInCurrentPayApp - materialsInstalledInCurrentPayApp
   */
  readonly materialsInStorageThroughCurrentPayApp: Scalars['SafeInt']['output']
  /** Sum of all previous storedMaterialBilled - previous materialsInstalledInCurrentPayApp */
  readonly materialsInStorageThroughPreviousPayApp: Scalars['SafeInt']['output']
  /**
   * Materials installed in the current pay app
   * Bounds: 0 to materialsInStorageThroughPreviousPayApp + materialsAddedToStorageInCurrentPayApp
   * In automatic mode, this is always equal to materialsAddedToStorageInCurrentPayApp (or storedMaterialBilled)
   */
  readonly materialsInstalledInCurrentPayApp: Scalars['SafeInt']['output']
  /** Retention held percent on the stored materials billing */
  readonly materialsRetentionHeldPercent: Maybe<Scalars['Float']['output']>
  readonly payApp: PayApp
  /** This is the total amount billed in all progress for this line item prior to this pay app. */
  readonly previousBilled: Scalars['SafeInt']['output']
  /** This is the total amount of retention in all progress for this line item prior to this pay app. */
  readonly previousRetention: Scalars['SafeInt']['output']
  /** Sum of all previous progress billed and materials installed. */
  readonly previousWorkCompleted: Scalars['SafeInt']['output']
  /** Progress billed this period, pre-tax. */
  readonly progressBilled: Scalars['SafeInt']['output']
  /** Retention held percent on the progress billing */
  readonly progressRetentionHeldPercent: Maybe<Scalars['Float']['output']>
  /**
   * Combined (progress + materials) retention held in this pay app. Stored so consumers don't have
   * to sum `retentionHeldCurrentProgress + retentionHeldCurrentMaterials` themselves.
   */
  readonly retentionHeldCurrent: Scalars['SafeInt']['output']
  /** Retention held in this pay app, on stored materials billing only (this period). */
  readonly retentionHeldCurrentMaterials: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldCurrentMaterials. */
  readonly retentionHeldCurrentMaterialsPercent: Scalars['Float']['output']
  /** Tax on retentionHeldCurrentMaterials. */
  readonly retentionHeldCurrentMaterialsTax: Scalars['SafeInt']['output']
  /**
   * Effective retention percent for the combined (progress + materials) retention held in this pay
   * app. Captures the engine's blended/configured rate (mirrors the safeDivide / equal-rate logic
   * in line-item.ts:113-114) so reads avoid SQL blending.
   */
  readonly retentionHeldCurrentPercent: Scalars['Float']['output']
  /** Retention held in this pay app, on progress billing only (this period). */
  readonly retentionHeldCurrentProgress: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldCurrentProgress. */
  readonly retentionHeldCurrentProgressPercent: Scalars['Float']['output']
  /** Tax on retentionHeldCurrentProgress. */
  readonly retentionHeldCurrentProgressTax: Scalars['SafeInt']['output']
  /**
   * Tax on retentionHeldCurrent. Zero unless contract.appliesTaxToRetention = true, which only applies
   * under STANDARD retention tracking. Stored so consumers don't have to sum
   * `retentionHeldCurrentProgressTax + retentionHeldCurrentMaterialsTax` themselves.
   */
  readonly retentionHeldCurrentTax: Scalars['SafeInt']['output']
  /**
   * Retention override amount on the sov line item progress on both progress and material billing.
   * Takes precedence over the progress and materials percents if set.
   */
  readonly retentionHeldOverride: Maybe<Scalars['SafeInt']['output']>
  /** Retention held in all previous pay apps for this line item (excluding this period), minus retention released to date. */
  readonly retentionHeldPrevious: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldPrevious. */
  readonly retentionHeldPreviousPercent: Scalars['Float']['output']
  /** Tax on retentionHeldPrevious. */
  readonly retentionHeldPreviousTax: Scalars['SafeInt']['output']
  /**
   * Combined (progress + materials) retention held cumulatively through this pay app. Stored so
   * consumers don't have to sum `retentionHeldToDateWorkCompleted + retentionHeldToDateMaterialsInStorage`
   * themselves.
   */
  readonly retentionHeldToDate: Scalars['SafeInt']['output']
  /** Retention held cumulatively through this pay app, on stored materials billing only. */
  readonly retentionHeldToDateMaterialsInStorage: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldToDateMaterialsInStorage. */
  readonly retentionHeldToDateMaterialsInStoragePercent: Scalars['Float']['output']
  /** Tax on retentionHeldToDateMaterialsInStorage. */
  readonly retentionHeldToDateMaterialsInStorageTax: Scalars['SafeInt']['output']
  /**
   * Effective retention percent for the combined (progress + materials) retention held to date.
   * Used directly as the percent for `retentionHeld({ type: 'previous' })` reads when there's a
   * prior pay app (the engine carries forward asOf's own toDate percent).
   */
  readonly retentionHeldToDatePercent: Scalars['Float']['output']
  /** Retention held cumulatively through this pay app, on progress billing only. */
  readonly retentionHeldToDateWorkCompleted: Scalars['SafeInt']['output']
  /** Effective retention percent for retentionHeldToDateWorkCompleted. */
  readonly retentionHeldToDateWorkCompletedPercent: Scalars['Float']['output']
  /** Tax on retentionHeldToDateWorkCompleted. */
  readonly retentionHeldToDateWorkCompletedTax: Scalars['SafeInt']['output']
  /** Total retention being released for this line item on this progress in cents */
  readonly retentionReleased: Maybe<Scalars['SafeInt']['output']>
  /** Retention released in this pay app only (this period). */
  readonly retentionReleasedCurrent: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedCurrent. */
  readonly retentionReleasedCurrentTax: Scalars['SafeInt']['output']
  /** Retention released in all previous pay apps for this line item (excluding this period). */
  readonly retentionReleasedPrevious: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedPrevious. */
  readonly retentionReleasedPreviousTax: Scalars['SafeInt']['output']
  /** Retention released cumulatively through this pay app, including this period. */
  readonly retentionReleasedToDate: Scalars['SafeInt']['output']
  /** Tax on retentionReleasedToDate. */
  readonly retentionReleasedToDateTax: Scalars['SafeInt']['output']
  readonly sovLineItem: SovLineItem
  /**
   * Pre-tax amount of materials bought (but not necessary installed) in this pay app,
   * to be immediately billed to the GC.
   */
  readonly storedMaterialBilled: Scalars['SafeInt']['output']
  /**
   * Tax rate applied to this progress, determined at the time of the pay app creation.
   * Value is between 0 and 1.
   */
  readonly taxPercent: Scalars['Float']['output']
  /** The line item's total value as of this progress */
  readonly totalValue: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  /**
   * This is the subcontractor user that last modified this progress. Could be empty if this was last
   * modified by a backend system.
   */
  readonly updatedBy: Maybe<User>
  /** Progress for all worksheet line items associated with this progress's SOV line item */
  readonly worksheetLineItemProgress: ReadonlyArray<WorksheetLineItemProgress>
}

/** An event tied to a line-item progress. */
export type SovLineItemProgressEvent = {
  readonly __typename: 'SovLineItemProgressEvent'
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly id: Scalars['ID']['output']
  readonly isAdmin: Scalars['Boolean']['output']
  /** Values in this dictionary depend on the event type */
  readonly metadata: Scalars['JSONObject']['output']
  readonly sovLineItemProgress: SovLineItemProgress
  readonly type: SovLineItemProgressEventType
}

export { SovLineItemProgressEventType }

/** A log of the total value of an SOV Line Item at different dates in time */
export type SovLineItemTotalValue = {
  readonly __typename: 'SovLineItemTotalValue'
  /**
   * If set, the total value only applies starting the given approved date. If the
   *  total value changes in a pay app, use the pay app start as the approved date.
   * If it is not set, it is the total value from pre-siteline onboarding.
   */
  readonly approvedDate: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly lineItem: SovLineItem
  readonly totalValue: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type StateLienRequirementsSummary = {
  readonly __typename: 'StateLienRequirementsSummary'
  /** Optional links for reference to a source for state requirements */
  readonly citations: ReadonlyArray<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** Additional details about the state's lien requirements */
  readonly lienAdditionalNotes: Maybe<Scalars['String']['output']>
  readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
  readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
  /** The deadline for filing a lien */
  readonly lienDeadlineInterval: Scalars['SafeInt']['output']
  readonly lienDeadlineModifier: LienRightsDeadlineModifier
  /** Certain documents may be filed by the owner that will shorten lien deadlines */
  readonly lienDeadlineNoticeRequirements: ReadonlyArray<LienDeadlineNoticeRequirement>
  readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
  readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
  /** The amount of time after a lien is filed that it can be enforced */
  readonly lienEnforcementInterval: Scalars['SafeInt']['output']
  readonly preLienAnchor: Maybe<LienRightsDeadlineAnchor>
  readonly preLienInterval: Maybe<Scalars['SafeInt']['output']>
  readonly preLienIntervalGranularity: Maybe<LienRightsDeadlineGranularity>
  readonly preLienModifier: Maybe<LienRightsDeadlineModifier>
  /**
   * A pre-lien document may be required to be filed before a lien is filed. If type is null,
   * no such document is required before the lien is filed. If non-null, the interval is required.
   */
  readonly preLienName: Maybe<Scalars['String']['output']>
  /** Additional details about the state's preliminary notice requirements */
  readonly preliminaryNoticeAdditionalNotes: Maybe<Scalars['String']['output']>
  /**
   * For some states, a preliminary notice is required if and only if the owner files a certain notice. If that's the
   * case, this is the name of the notice and we will treat the prelim as required only if this document is filed.
   */
  readonly preliminaryNoticeContingentOn: Maybe<Scalars['String']['output']>
  readonly preliminaryNoticeDeadlineAnchor: Maybe<LienRightsDeadlineAnchor>
  readonly preliminaryNoticeDeadlineGranularity: Maybe<LienRightsDeadlineGranularity>
  readonly preliminaryNoticeDeadlineInterval: Maybe<Scalars['SafeInt']['output']>
  readonly preliminaryNoticeDeadlineModifier: Maybe<LienRightsDeadlineModifier>
  readonly preliminaryNoticeLateFilingGranularity: Maybe<LienRightsDeadlineGranularity>
  /**
   * If a preliminary notice is filed after the deadline, the amount of time relative to filing that
   * the filer is protected. If null, late filing is not allowed.
   */
  readonly preliminaryNoticeLateFilingInterval: Maybe<Scalars['SafeInt']['output']>
  readonly preliminaryNoticeLateFilingModifier: Maybe<LienRightsDeadlineModifier>
  /**
   * A preliminary notice is normally filed early in the project to establish lien rights. If type is null,
   * it's assumed that no preliminary notice exists in the state. If non-null, it may or may not be required, but
   * the customer will be able to mark it as completed in the UI.
   */
  readonly preliminaryNoticeName: Maybe<Scalars['String']['output']>
  readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
  /** State code, usually two characters */
  readonly state: Scalars['String']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type StateLienRequirementsSummaryInput = {
  /** State code, usually two characters */
  readonly state: Scalars['String']['input']
}

/** Represents a file stored in Cloud Storage */
export type StoredFile = {
  readonly __typename: 'StoredFile'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly ipAddress: Maybe<Scalars['String']['output']>
  readonly name: Scalars['String']['output']
  readonly size: Scalars['SafeInt']['output']
  readonly type: StoredFileType
  readonly updatedAt: Scalars['DateTime']['output']
  readonly uploadedBy: Maybe<User>
  readonly url: Scalars['URL']['output']
}

export type StoredFileInput = {
  readonly file: Scalars['Upload']['input']
  readonly name: Scalars['String']['input']
}

export { StoredFileType }

export { StoredMaterialsCarryoverType }

/** A set of lien-waiver templates to use for a subcontractor */
export type SubcontractorLienWaiverTemplateSet = {
  readonly __typename: 'SubcontractorLienWaiverTemplateSet'
  readonly conditionalFinalVariant: Maybe<FormTemplateVariant>
  readonly conditionalProgressVariant: Maybe<FormTemplateVariant>
  readonly id: Scalars['ID']['output']
  readonly unconditionalFinalVariant: Maybe<FormTemplateVariant>
  readonly unconditionalProgressVariant: Maybe<FormTemplateVariant>
}

export type SubcontractorLienWaiverTemplateSetInput = {
  readonly conditionalFinalVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly conditionalProgressVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly unconditionalFinalVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly unconditionalProgressVariantId?: InputMaybe<Scalars['ID']['input']>
}

export type Subscription = {
  readonly __typename: 'Subscription'
  /** Pushes the FormTemplateSuggestionsRun to the client every time its phase advances */
  readonly formTemplateSuggestionsRunUpdated: FormTemplateSuggestionsRun
  /** Any time the given form template is updated, the data is pushed to the client. */
  readonly updatedFormTemplate: FormTemplate
}

export type SubscriptionFormTemplateSuggestionsRunUpdatedArgs = {
  id: Scalars['ID']['input']
}

export type SubscriptionUpdatedFormTemplateArgs = {
  id: Scalars['ID']['input']
}

export { TaxCalculationType }

/** A single tax rate belonging to a company. */
export type TaxGroup = {
  readonly __typename: 'TaxGroup'
  /** We archive tax groups instead of deleting them so we preserve any existing references */
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** List of mappings to integration tax groups */
  readonly integrationMappings: Scalars['JSONObject']['output']
  readonly name: Scalars['String']['output']
  /** Tax percentage for this group, between 0 and 1 */
  readonly taxPercent: Scalars['Float']['output']
  readonly updatedAt: Scalars['DateTime']['output']
}

export type TaxGroupReport = {
  readonly __typename: 'TaxGroupReport'
  readonly billedPerTaxGroup: ReadonlyArray<BilledPerTaxGroup>
  readonly contractBilledPerTaxGroup: ReadonlyArray<ContractBilledPerTaxGroup>
  readonly summary: TaxGroupReportSummary
  readonly taxesByState: ReadonlyArray<TaxesByState>
}

export type TaxGroupReportSummary = {
  readonly __typename: 'TaxGroupReportSummary'
  readonly numProjects: Scalars['SafeInt']['output']
  readonly totalTaxAmountThisPeriod: Scalars['SafeInt']['output']
}

export type TaxesByState = {
  readonly __typename: 'TaxesByState'
  readonly state: Scalars['String']['output']
  readonly totalScheduledValue: Scalars['SafeInt']['output']
  readonly totalTaxAmountThisPeriod: Scalars['SafeInt']['output']
}

export type TemplateBuildStats = {
  readonly __typename: 'TemplateBuildStats'
  readonly builders: ReadonlyArray<TemplateBuildStatsBuilder>
}

export type TemplateBuildStatsBuilder = {
  readonly __typename: 'TemplateBuildStatsBuilder'
  readonly user: User
  /** Number of templates that are waiting for this user */
  readonly waitingOnCount: Scalars['Int']['output']
}

export { TemplateListSortCriteria }

export { TemplateListStatusFilter }

export { TemplateVariantListSortCriteria }

export { TextAlignment }

export { TimeToPaymentBreakdownSortCriteria }

export type TimeToPaymentDashboard = {
  readonly __typename: 'TimeToPaymentDashboard'
  readonly breakdown: ReadonlyArray<TimeToPaymentEntity>
  /** Top 3 fastest-paying entities */
  readonly fastestEntities: ReadonlyArray<TimeToPaymentEntity>
  /** Top 3 slowest-paying entities */
  readonly slowestEntities: ReadonlyArray<TimeToPaymentEntity>
  readonly timeline: TimeToPaymentTimeline
}

export type TimeToPaymentEntity = {
  readonly __typename: 'TimeToPaymentEntity'
  readonly averageDaysToPaid: Scalars['Float']['output']
  readonly contractIds: ReadonlyArray<Scalars['ID']['output']>
  /** GC ID, User ID, Location ID, or Owner ID depending on viewBy */
  readonly id: Scalars['ID']['output']
  readonly name: Scalars['String']['output']
  readonly numPayApps: Scalars['SafeInt']['output']
  readonly numProjects: Scalars['SafeInt']['output']
  readonly totalContractValue: Scalars['SafeInt']['output']
  /** The type of entity: matches the viewBy input */
  readonly type: TimeToPaymentViewBy
}

export type TimeToPaymentTimeline = {
  readonly __typename: 'TimeToPaymentTimeline'
  readonly fastestMonth: Maybe<TimeToPaymentTimelineMonth>
  readonly months: ReadonlyArray<TimeToPaymentTimelineMonth>
  readonly periodAverageDays: Scalars['Float']['output']
  readonly slowestMonth: Maybe<TimeToPaymentTimelineMonth>
}

export type TimeToPaymentTimelineMonth = {
  readonly __typename: 'TimeToPaymentTimelineMonth'
  readonly averageDaysToPaid: Scalars['Float']['output']
  /** Month in YYYY-MM format */
  readonly month: Scalars['String']['output']
}

export { TimeToPaymentViewBy }

export type TimeToValueData = {
  readonly __typename: 'TimeToValueData'
  readonly billingByMonth: ReadonlyArray<TimeToValueMonth>
  readonly company: Company
}

export type TimeToValueMonth = {
  readonly __typename: 'TimeToValueMonth'
  readonly cumulativeContractsBilled: Scalars['SafeInt']['output']
  /** Format is YYYY-MM */
  readonly month: Scalars['String']['output']
}

export { TransactionRelatedEntityType }

export { TransactionStatus }

export { TransactionType }

/** MFA rusted device */
export type TrustedDevice = {
  readonly __typename: 'TrustedDevice'
  readonly createdAt: Scalars['DateTime']['output']
  readonly deviceToken: Scalars['String']['output']
  readonly expiresAt: Scalars['DateTime']['output']
  readonly factorId: Scalars['ID']['output']
  readonly userId: Scalars['ID']['output']
}

/** Sign-in token verifying an MFA trusted device */
export type TrustedDeviceResult = {
  readonly __typename: 'TrustedDeviceResult'
  readonly signInToken: Scalars['String']['output']
}

export { Tutorial }

export type UpdateAcumaticaPeyoteCredentialsInput = {
  readonly clientId: Scalars['String']['input']
  readonly clientSecret: Scalars['String']['input']
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly instanceName?: InputMaybe<Scalars['String']['input']>
  readonly instanceUrl: Scalars['String']['input']
}

export type UpdateAgaveIntegrationCredentialInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly publicToken: Scalars['String']['input']
}

export type UpdateChangeOrderLogFormInput = {
  readonly changeOrderLogFormTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly contractId: Scalars['ID']['input']
}

export type UpdateChangeOrderRequestFormInput = {
  readonly changeOrderRequestFormTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly contractId: Scalars['ID']['input']
}

export type UpdateCmicPeyoteBasicCredentialsInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  /** Environment path segment mounted under the server URL, e.g. `cmicprod`. */
  readonly environment: Scalars['String']['input']
  /** Basic Auth password. */
  readonly password: Scalars['String']['input']
  /** Server URL up to `.com`, e.g. `https://atlas-api.cmiccloud.com` (cloud) or the customer's own host (on-prem). */
  readonly serverUrl: Scalars['String']['input']
  /** Basic Auth username (CMiC's `CLIENT_ID||USER_ID`). */
  readonly username: Scalars['String']['input']
}

export type UpdateCmicPeyoteOauthCredentialsInput = {
  /** Client id registered with the identity provider. */
  readonly clientId: Scalars['String']['input']
  /** Client secret registered with the identity provider. */
  readonly clientSecret: Scalars['String']['input']
  readonly companyIntegrationId: Scalars['ID']['input']
  /** Environment path segment mounted under the server URL, e.g. `cmicprod`. */
  readonly environment: Scalars['String']['input']
  /** The identity provider the instance federates login to. */
  readonly idpProvider: CmicIdpProvider
  /** Server URL up to `.com`, e.g. `https://atlas-api.cmiccloud.com`. CMiC serves OAuth from a different host than Basic Auth. */
  readonly serverUrl: Scalars['String']['input']
}

export type UpdateCompanyContactInput = {
  readonly companyName?: InputMaybe<Scalars['String']['input']>
  readonly email?: InputMaybe<Scalars['EmailAddress']['input']>
  readonly fullName?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>
  readonly phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>
}

export type UpdateCompanyFormTemplateCollectionInput = {
  readonly billingType?: InputMaybe<BillingType>
  readonly changeOrderLogVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly changeOrderRequestVariantId?: InputMaybe<Scalars['ID']['input']>
  readonly collectionId: Scalars['ID']['input']
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly payAppTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly primaryLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly subTierLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
  readonly vendorLienWaiverTemplateSetId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateCompanyInput = {
  readonly allowLumpSumOverbilling?: InputMaybe<Scalars['Boolean']['input']>
  readonly allowsLienRightsTracking?: InputMaybe<Scalars['Boolean']['input']>
  readonly applyLienRightsTrackingToExistingProjects?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultLienRightsTracking?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultQuickBillingTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly defaultShowAuditItemOnSignedPackages?: InputMaybe<Scalars['Boolean']['input']>
  readonly enableDailyContractMismatchReport?: InputMaybe<Scalars['Boolean']['input']>
  readonly expectedNumberOfProjects?: InputMaybe<Scalars['SafeInt']['input']>
  readonly id: Scalars['ID']['input']
  readonly isDemoCompany?: InputMaybe<Scalars['Boolean']['input']>
  readonly metadata?: InputMaybe<CompanyMetadataInput>
  readonly mfaRequirement?: InputMaybe<CompanyMfaRequirement>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly nickname?: InputMaybe<Scalars['String']['input']>
  readonly notaryExpiresAt?: InputMaybe<Scalars['DateTime']['input']>
  readonly notarySignature?: InputMaybe<StoredFileInput>
  readonly notaryStamp?: InputMaybe<StoredFileInput>
  readonly notaryTags?: InputMaybe<ReadonlyArray<NotaryTag>>
  readonly phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>
  readonly picture?: InputMaybe<StoredFileInput>
  readonly secondarySignature?: InputMaybe<StoredFileInput>
  readonly sitelinePointOfContactId?: InputMaybe<Scalars['ID']['input']>
  readonly type?: InputMaybe<CompanyType>
  readonly userSessionTimeout?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateCompanyIntegrationInput = {
  readonly id: Scalars['ID']['input']
  readonly importChangeOrdersMethod?: InputMaybe<ImportIntegrationChangeOrdersMethod>
  readonly importComboJobMethod?: InputMaybe<ImportIntegrationComboJobMethod>
  readonly importProjectNameSource?: InputMaybe<ImportIntegrationProjectNameSource>
  /** Pass null to remove label */
  readonly label?: InputMaybe<Scalars['String']['input']>
  /** Pass null to remove location */
  readonly locationId?: InputMaybe<Scalars['ID']['input']>
  readonly metadata?: InputMaybe<Scalars['JSONObject']['input']>
  readonly revertPayAppsToDraftWhenTexturaInvoiceRejected?: InputMaybe<Scalars['Boolean']['input']>
  /** Every field below is optional so a caller can patch just the fields it owns (e.g. the Sage Intacct setup flow updating only metadata) without echoing the rest back. Omitted fields are left untouched. */
  readonly shouldImportNewProjectSov?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateContractInput = {
  readonly category?: InputMaybe<ContractCategory>
  readonly contractDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly contractNumber?: InputMaybe<Scalars['String']['input']>
  readonly contractTemplateVariables?: InputMaybe<Scalars['JSONObject']['input']>
  readonly daysBeforePayAppDue?: InputMaybe<Scalars['Int']['input']>
  readonly defaultRetentionPercent?: InputMaybe<Scalars['Float']['input']>
  readonly id: Scalars['ID']['input']
  readonly internalProjectNumber?: InputMaybe<Scalars['String']['input']>
  readonly pastPayAppCount?: InputMaybe<Scalars['Int']['input']>
  readonly retentionTrackingLevel?: InputMaybe<RetentionTrackingLevel>
  readonly selectedAddress?: InputMaybe<Scalars['ID']['input']>
  readonly status?: InputMaybe<ContractStatus>
  readonly vendorNumber?: InputMaybe<Scalars['String']['input']>
}

export type UpdateContractUsersInput = {
  readonly addUserIds: ReadonlyArray<Scalars['ID']['input']>
  readonly id: Scalars['ID']['input']
  readonly removeUserIds: ReadonlyArray<Scalars['ID']['input']>
}

export type UpdateDefaultChangeOrderLogFormInput = {
  readonly changeOrderLogFormTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly companyId: Scalars['ID']['input']
  readonly updateContractTemplates: Scalars['Boolean']['input']
}

export type UpdateDefaultChangeOrderRequestFormInput = {
  readonly changeOrderRequestFormTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly companyId: Scalars['ID']['input']
  readonly updateContractTemplates: Scalars['Boolean']['input']
}

export type UpdateDefaultLienWaiverFormsInput = {
  readonly companyId: Scalars['ID']['input']
  readonly lienWaivers: SubcontractorLienWaiverTemplateSetInput
}

export type UpdateDefaultPayAppFormsInput = {
  readonly billingType: BillingType
  readonly companyId: Scalars['ID']['input']
  readonly payAppRequirementGroups: ReadonlyArray<UpdatePayAppRequirementGroupInput>
}

export type UpdateFeatureFlagInput = {
  /** Specific company IDs that have this feature flag enabled. */
  readonly companyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly description?: InputMaybe<Scalars['String']['input']>
  /** No change if not set */
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>
  readonly name: FeatureFlagName
  readonly sitelineTeamMembersOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateFormAnnotationInput = {
  readonly copyDefaultValueFromPreviousAnnotationValue?: InputMaybe<Scalars['Boolean']['input']>
  readonly defaultValueKey?: InputMaybe<Scalars['String']['input']>
  readonly doNotRetainOnReset?: InputMaybe<Scalars['Boolean']['input']>
  readonly dynamicFieldTag?: InputMaybe<Scalars['String']['input']>
  readonly fieldType?: InputMaybe<FormTemplateAnnotationMetadataFieldType>
  readonly fontColor?: InputMaybe<Scalars['String']['input']>
  readonly fontFamily?: InputMaybe<FormTemplateFont>
  readonly height?: InputMaybe<Scalars['Float']['input']>
  readonly id: Scalars['ID']['input']
  readonly imageType?: InputMaybe<FormTemplateAnnotationImageType>
  readonly isOptional?: InputMaybe<Scalars['Boolean']['input']>
  /** If the form has more than one page, this is the 1-indexed page the annotation is on */
  readonly pageNumber?: InputMaybe<Scalars['Int']['input']>
  readonly permanentId?: InputMaybe<Scalars['ID']['input']>
  readonly prefix?: InputMaybe<Scalars['String']['input']>
  readonly selectedKey?: InputMaybe<Scalars['String']['input']>
  readonly signatureType?: InputMaybe<SignatureAnnotationType>
  readonly suffix?: InputMaybe<Scalars['String']['input']>
  readonly syncTag?: InputMaybe<Scalars['String']['input']>
  readonly textAlignment?: InputMaybe<TextAlignment>
  readonly type?: InputMaybe<FormTemplateAnnotationType>
  readonly userVisibleName?: InputMaybe<Scalars['String']['input']>
  readonly width?: InputMaybe<Scalars['Float']['input']>
  readonly wrapText?: InputMaybe<Scalars['Boolean']['input']>
  readonly xStart?: InputMaybe<Scalars['Float']['input']>
  readonly yStart?: InputMaybe<Scalars['Float']['input']>
}

export type UpdateFormAnnotationsInput = {
  readonly inputs: ReadonlyArray<UpdateFormAnnotationInput>
}

export type UpdateFormTemplateAssociatedCompanyInput = {
  readonly associatedCompanyId: Scalars['ID']['input']
  readonly id: Scalars['ID']['input']
}

export type UpdateFormTemplateAssociatedContractsInput = {
  readonly contractIds: ReadonlyArray<Scalars['ID']['input']>
  readonly id: Scalars['ID']['input']
}

export type UpdateFormTemplateDueDateInput = {
  /** If null, will clear the due date for this form template */
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly id: Scalars['ID']['input']
}

export type UpdateFormTemplateInput = {
  readonly id: Scalars['ID']['input']
  readonly type?: InputMaybe<FormTemplateType>
  readonly userVisibleName?: InputMaybe<Scalars['String']['input']>
}

export type UpdateFormTemplateOriginalFileInput = {
  readonly file: Scalars['Upload']['input']
  readonly id: Scalars['ID']['input']
}

export type UpdateFormTemplateRequestingCompanyInput = {
  readonly id: Scalars['ID']['input']
  readonly requestingCompanyId: Scalars['ID']['input']
}

export type UpdateFormTemplateStatusInput = {
  readonly id: Scalars['ID']['input']
  readonly status: FormTemplateStatus
}

export type UpdateFormTemplateUserInput = {
  readonly id: Scalars['ID']['input']
  readonly userId: Scalars['ID']['input']
}

export type UpdateFormTemplateVersionInput = {
  readonly file?: InputMaybe<Scalars['Upload']['input']>
  readonly id: Scalars['ID']['input']
  readonly isReadyForManualStoredMaterials?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateFoundationPeyoteCredentialsInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly database: Scalars['String']['input']
  readonly host: Scalars['String']['input']
  readonly password: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
  readonly user: Scalars['String']['input']
}

export type UpdateIntegrationCredentialInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly hh2Username?: InputMaybe<Scalars['String']['input']>
  readonly password: Scalars['String']['input']
  readonly username: Scalars['String']['input']
}

export type UpdateIntegrationMappingsInput = {
  readonly integrationId: Scalars['ID']['input']
  readonly mappings: Scalars['JSONObject']['input']
}

/** An operation to import and update the job cost for a contract */
export type UpdateJobCostOperation = {
  readonly __typename: 'UpdateJobCostOperation'
  readonly company: Company
  readonly companyIntegration: Maybe<CompanyIntegration>
  /** Set if the import was successful */
  readonly contractCost: Maybe<ContractCost>
  readonly createdAt: Scalars['DateTime']['output']
  /** The user who started this import. Null if queued by scheduled job. */
  readonly createdBy: Maybe<User>
  readonly error: Maybe<Scalars['String']['output']>
  readonly group: UpdateJobCostOperationGroup
  readonly groupId: Scalars['ID']['output']
  readonly id: Scalars['ID']['output']
  readonly payload: Scalars['JSONObject']['output']
  readonly status: ImportOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

/** Contains some stats about a particular import group. Computed for each UpdateJobCostOperation. */
export type UpdateJobCostOperationGroup = {
  readonly __typename: 'UpdateJobCostOperationGroup'
  readonly companyIntegration: Maybe<CompanyIntegration>
  /** When all operations in the group have finished. Null while import is in progress. */
  readonly completedAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly numFailed: Scalars['SafeInt']['output']
  readonly numSuccessful: Scalars['SafeInt']['output']
  readonly status: ImportOperationStatus
  readonly totalOperations: Scalars['SafeInt']['output']
}

export type UpdateLegalRequirementInput = {
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>
  readonly expirationFrequency: DocumentExpirationFrequency
  readonly formTemplateId?: InputMaybe<Scalars['ID']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly name: Scalars['String']['input']
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateLegalRequirementsInput = {
  readonly contractId: Scalars['ID']['input']
  readonly requirements: ReadonlyArray<UpdateLegalRequirementInput>
}

export type UpdateLienWaiverFormTemplateSetInput = {
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly lienWaivers: SubcontractorLienWaiverTemplateSetInput
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly templateSetId: Scalars['ID']['input']
}

export type UpdateLocationInput = {
  readonly id: Scalars['ID']['input']
  readonly location: LocationInput
}

export type UpdateOnboardedProjectContractStatusInput = {
  readonly addedGcContacts?: InputMaybe<Scalars['Boolean']['input']>
  readonly addedSov?: InputMaybe<Scalars['Boolean']['input']>
  readonly addedTeammates?: InputMaybe<Scalars['Boolean']['input']>
  readonly contractId: Scalars['ID']['input']
  readonly notifiedOnboardedForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly onboardedChangeOrderLogForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly onboardedChangeOrderRequestForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly onboardedPayAppForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly onboardedPrimaryLienWaiverForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly onboardedVendorLienWaiverForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedChangeOrderLogForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedChangeOrderRequestForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedPayAppForms?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedPrimaryLienWaivers?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedRateTable?: InputMaybe<Scalars['Boolean']['input']>
  readonly selectedVendorLienWaivers?: InputMaybe<Scalars['Boolean']['input']>
  readonly startedBilling?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdatePayAppFormTemplateSetInput = {
  readonly billingType?: InputMaybe<BillingType>
  readonly gcId?: InputMaybe<Scalars['ID']['input']>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly requirementGroups: ReadonlyArray<UpdatePayAppRequirementGroupInput>
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly templateSetId: Scalars['ID']['input']
}

export type UpdatePayAppInput = {
  readonly id: Scalars['ID']['input']
  readonly retentionOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdatePayAppRequirementGroupInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly order: Scalars['Int']['input']
  readonly requirements: ReadonlyArray<UpdatePayAppRequirementInput>
}

export type UpdatePayAppRequirementGroupsInput = {
  readonly contractId: Scalars['ID']['input']
  readonly requirementGroups: ReadonlyArray<UpdatePayAppRequirementGroupInput>
}

export type UpdatePayAppRequirementInput = {
  readonly conditions: ReadonlyArray<PayAppRequirementCondition>
  readonly groupOrder: Scalars['Int']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly templateVariantId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateProjectInput = {
  readonly architect?: InputMaybe<CompanyProjectMetadataInput>
  readonly id: Scalars['ID']['input']
  readonly location?: InputMaybe<LocationInput>
  readonly metadata?: InputMaybe<ProjectMetadataInput>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly projectNumber?: InputMaybe<Scalars['String']['input']>
  readonly removeArchitect?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateRoundRetentionInput = {
  readonly contractId: Scalars['ID']['input']
  readonly roundRetention: Scalars['Boolean']['input']
}

export type UpdateSageIntacctPeyoteCredentialsInput = {
  readonly companyId: Scalars['String']['input']
  readonly companyIntegrationId: Scalars['ID']['input']
  /** Optional customer-supplied Web Services sender id; falls back to Siteline's shared sender id when omitted. Set together with senderPassword. */
  readonly senderId?: InputMaybe<Scalars['String']['input']>
  /** Optional customer-supplied Web Services sender password; falls back to Siteline's shared sender password when omitted. Set together with senderId. */
  readonly senderPassword?: InputMaybe<Scalars['String']['input']>
  readonly userId: Scalars['String']['input']
  readonly userPassword: Scalars['String']['input']
}

export type UpdateSovLineItemGroupInput = {
  readonly groupCode?: InputMaybe<Scalars['String']['input']>
  readonly groupName?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['String']['input']
}

export type UpdateSpectrumPeyoteCompanyInput = {
  readonly companyCode: Scalars['String']['input']
  readonly companyIntegrationId: Scalars['ID']['input']
}

export type UpdateSpectrumPeyoteCredentialsInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly database: Scalars['String']['input']
  readonly host: Scalars['String']['input']
  readonly password: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
  readonly user: Scalars['String']['input']
}

export type UpdateStateLienRequirementsSummaryInput = {
  readonly citations: ReadonlyArray<Scalars['String']['input']>
  readonly lienAdditionalNotes?: InputMaybe<Scalars['String']['input']>
  readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
  readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
  readonly lienDeadlineInterval: Scalars['SafeInt']['input']
  readonly lienDeadlineModifier: LienRightsDeadlineModifier
  readonly lienDeadlineNoticeRequirements: ReadonlyArray<LienDeadlineNoticeRequirementInput>
  readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
  readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
  readonly lienEnforcementInterval: Scalars['SafeInt']['input']
  readonly preLienAnchor?: InputMaybe<LienRightsDeadlineAnchor>
  readonly preLienInterval?: InputMaybe<Scalars['SafeInt']['input']>
  readonly preLienIntervalGranularity?: InputMaybe<LienRightsDeadlineGranularity>
  readonly preLienModifier?: InputMaybe<LienRightsDeadlineModifier>
  readonly preLienName?: InputMaybe<Scalars['String']['input']>
  readonly preliminaryNoticeAdditionalNotes?: InputMaybe<Scalars['String']['input']>
  readonly preliminaryNoticeContingentOn?: InputMaybe<Scalars['String']['input']>
  readonly preliminaryNoticeDeadlineAnchor?: InputMaybe<LienRightsDeadlineAnchor>
  readonly preliminaryNoticeDeadlineGranularity?: InputMaybe<LienRightsDeadlineGranularity>
  readonly preliminaryNoticeDeadlineInterval?: InputMaybe<Scalars['SafeInt']['input']>
  readonly preliminaryNoticeDeadlineModifier?: InputMaybe<LienRightsDeadlineModifier>
  readonly preliminaryNoticeLateFilingGranularity?: InputMaybe<LienRightsDeadlineGranularity>
  readonly preliminaryNoticeLateFilingInterval?: InputMaybe<Scalars['SafeInt']['input']>
  readonly preliminaryNoticeLateFilingModifier?: InputMaybe<LienRightsDeadlineModifier>
  readonly preliminaryNoticeName?: InputMaybe<Scalars['String']['input']>
  readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
  /** State code, usually two characters */
  readonly state: Scalars['String']['input']
}

export type UpdateTemplateVariantInput = {
  readonly hidesZeroDollarAmounts?: InputMaybe<Scalars['Boolean']['input']>
  readonly id: Scalars['ID']['input']
  readonly internalName?: InputMaybe<Scalars['String']['input']>
  readonly roundPercentages?: InputMaybe<Scalars['Boolean']['input']>
  readonly useCompanyNotarySignatureIfAvailable?: InputMaybe<Scalars['Boolean']['input']>
  readonly userVisibleName?: InputMaybe<Scalars['String']['input']>
}

export type UpdateUserEducationCampaignInput = {
  readonly id: Scalars['ID']['input']
  readonly info: CreateUserEducationCampaignInput
}

export type UpdateVistaPeyoteCredentialsInput = {
  readonly companyIntegrationId: Scalars['ID']['input']
  readonly database: Scalars['String']['input']
  readonly host: Scalars['String']['input']
  readonly password: Scalars['String']['input']
  readonly port: Scalars['Int']['input']
  readonly user: Scalars['String']['input']
}

/** Represents a single person that works at a single company. */
export type User = {
  readonly __typename: 'User'
  /** A list of email notifications the user has unsubscribed from. */
  readonly blockedEmails: ReadonlyArray<EmailType>
  /** A list of notifications the user has unsubscribed from. */
  readonly blockedNotifications: ReadonlyArray<NotificationType>
  /**
   * User education campaigns are shown once per user and should be added to this array once shown so
   * they aren't triggered again. Unlike `tutorialsShown`, campaigns are dynamically created in admin and
   * are referenced by ID.
   */
  readonly campaignsShown: ReadonlyArray<UserEducationCampaign>
  readonly companies: ReadonlyArray<Company>
  readonly companyUsers: ReadonlyArray<CompanyUser>
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * When the first signature is used/uploaded, the default signature will be set to that, and then
   * every time a new signature is used or uploaded, it'll override the default.
   * Therefore, this field is essentially just the last used signature.
   */
  readonly defaultSignature: Maybe<Signature>
  readonly email: Scalars['EmailAddress']['output']
  /** Feature flags enabled for all companies the user belongs to */
  readonly featureFlags: ReadonlyArray<FeatureFlagName>
  readonly firstName: Scalars['String']['output']
  readonly fullName: Scalars['String']['output']
  /** Whether in-app push notifications are enabled. */
  readonly hasPushNotificationsEnabled: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  /** Generated from the user's ID + email, used to securely identify the user in Intercom. */
  readonly intercomUserJwt: Scalars['String']['output']
  readonly jobTitle: Maybe<Scalars['String']['output']>
  readonly lastName: Scalars['String']['output']
  /** Whether the user has TOTP MFA enabled, checked via Firebase */
  readonly mfaEnrolled: Scalars['Boolean']['output']
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly policiesAcceptedAt: Maybe<Scalars['DateTime']['output']>
  /** If the user is a Siteline team member, gives their role. Null otherwise */
  readonly sitelineTeamMemberRole: Maybe<SitelineTeamMemberRole>
  readonly starredProjects: ReadonlyArray<Project>
  /**
   * Educational tooltips and tutorials that are shown only once per user should be added
   * to this array once seen or dismissed to track that they shouldn't be shown again
   */
  readonly tutorialsShown: ReadonlyArray<Tutorial>
  readonly updatedAt: Scalars['DateTime']['output']
}

/** A user education campaign represents a one-time popup in the app announcing a change to the user */
export type UserEducationCampaign = {
  readonly __typename: 'UserEducationCampaign'
  /** Optional CSS selector to anchor the popup to a specific element */
  readonly anchorSelector: Maybe<Scalars['String']['output']>
  /** If undefined, will not show any button on the popup */
  readonly buttonLabel: Maybe<Scalars['String']['output']>
  /** If `buttonLabel` is defined but not `buttonLink`, the button will dismiss the popup */
  readonly buttonLink: Maybe<Scalars['String']['output']>
  /** The Siteline user that created this campaign */
  readonly createdBy: User
  /** The campaign will run only up to the end date */
  readonly endDate: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly message: Scalars['String']['output']
  /** An internal name for the campaign for tracking, not to be exposed to the user */
  readonly name: Scalars['String']['output']
  /** If true, a 'NEW' tag is shown at the top of the popup */
  readonly showNewTag: Scalars['Boolean']['output']
  /** The campaign will only be shown to users after the start date */
  readonly startDate: Scalars['DateTime']['output']
  /** If defined, the campaign will only be shown to a user with all given permissions */
  readonly targetPermissions: ReadonlyArray<Permission>
  readonly title: Scalars['String']['output']
}

export type UserInput = {
  readonly email: Scalars['String']['input']
  readonly firstName: Scalars['String']['input']
  readonly lastName: Scalars['String']['input']
}

export { UserStatus }

export type Vendor = {
  readonly __typename: 'Vendor'
  readonly address: Maybe<Location>
  readonly company: Company
  /** The company integrations this vendor is linked to */
  readonly companyIntegrations: ReadonlyArray<CompanyIntegration>
  /** The sum of amounts on all conditional lien waivers requested for this vendor */
  readonly conditionalAmountWaived: Scalars['SafeInt']['output']
  readonly contacts: ReadonlyArray<VendorContact>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  /** Mappings of Siteline entities to Integration entities. Fields depend on the integration type. */
  readonly integrationMappings: Scalars['JSONObject']['output']
  /** Internal notes and reminders about the vendor, added by users internally */
  readonly internalNotes: Maybe<Scalars['String']['output']>
  readonly name: Scalars['String']['output']
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  /** The sum of amounts on all unconditional lien waivers requested for this vendor */
  readonly unconditionalAmountWaived: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContracts: ReadonlyArray<VendorContract>
}

export { VendorComplianceStatus }

/** Represents a contact at a vendor or lower-tier contractor who receives lien waiver or document requests */
export type VendorContact = {
  readonly __typename: 'VendorContact'
  /** An archived vendor contact should not be surfaced to the user, except relating to past document requests */
  readonly archivedAt: Maybe<Scalars['DateTime']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  /**
   * When the first signature is used/uploaded, the default signature will be set to that, and then
   * every time a new signature is used or uploaded, it'll override the default.
   * Therefore, this field is essentially just the last used signature.
   */
  readonly defaultSignature: Maybe<Signature>
  readonly email: Scalars['EmailAddress']['output']
  readonly fullName: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly jobTitle: Maybe<Scalars['String']['output']>
  /** When a contact is used on a sub-tier lien waiver, it shouldn't overwrite primary vendor contacts */
  readonly lowerTierTo: Maybe<Vendor>
  /**
   * Whether this vendor contact has opted out of digital signatures.
   * If yes, lien waiver requests must be sent manually, and subcontractors will upload lien waivers directly.
   */
  readonly optedOutOfDigitalSignaturesAt: Maybe<Scalars['DateTime']['output']>
  readonly phoneNumber: Maybe<Scalars['PhoneNumber']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendor: Vendor
}

/** Contract that tracks all the legal requirements that a vendor needs to provide. */
export type VendorContract = {
  readonly __typename: 'VendorContract'
  readonly commitments: ReadonlyArray<VendorContractCommitment>
  /** The sum of amounts on all conditional lien waivers requested for this vendor and contract */
  readonly conditionalAmountWaived: Scalars['SafeInt']['output']
  readonly contract: Contract
  readonly createdAt: Scalars['DateTime']['output']
  /** If provided, this will be the default amount text for all new lien waivers on this vendor contract */
  readonly defaultLienWaiverAmountText: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  /**
   * If true, we will automatically create a `PayAppSwornStatementVendor` for every new pay app on this
   * contract. Flipping to true will also create a `PayAppSwornStatementVendor` for every draft pay app
   * on this contract. Flipping to false will remove the corresponding `PayAppSwornStatementVendor`
   * from every draft pay app on this contract. Defaults to false.
   */
  readonly includeInSwornStatements: Scalars['Boolean']['output']
  readonly legalDocumentRequests: ReadonlyArray<LegalDocumentRequest>
  readonly lienWaivers: ReadonlyArray<LienWaiver>
  /**
   * If this is a lower-lower-tier vendor, set to the `VendorContract` for the vendor who contracted them.
   * This `VendorContract` must be for another vendor on this project.
   */
  readonly lowerTierTo: Maybe<VendorContract>
  readonly payAppSwornStatements: ReadonlyArray<PayAppSwornStatementVendor>
  readonly preliminaryNotices: ReadonlyArray<VendorPreliminaryNotice>
  /** The sum of amounts on all unconditional lien waivers requested for this vendor and contract */
  readonly unconditionalAmountWaived: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendor: Vendor
  readonly vendorLegalRequirements: ReadonlyArray<VendorLegalRequirement>
}

export type VendorContractCommitment = {
  readonly __typename: 'VendorContractCommitment'
  readonly amount: Scalars['SafeInt']['output']
  readonly closedAt: Maybe<Scalars['DateTime']['output']>
  readonly commitmentType: VendorContractCommitmentType
  readonly createdAt: Scalars['DateTime']['output']
  readonly date: Maybe<Scalars['DateTime']['output']>
  readonly file: Maybe<StoredFile>
  readonly id: Scalars['ID']['output']
  readonly integrationMappings: Maybe<Scalars['JSONObject']['output']>
  readonly number: Scalars['String']['output']
  readonly payWhenPaid: Scalars['Boolean']['output']
  readonly paymentTerms: Maybe<Scalars['SafeInt']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContract: VendorContract
}

export { VendorContractCommitmentType }

/** A single vendor to be asynchronously imported from an integration */
export type VendorImportOperation = {
  readonly __typename: 'VendorImportOperation'
  readonly company: Company
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  readonly error: Maybe<Scalars['String']['output']>
  readonly group: VendorImportOperationGroup
  readonly groupId: Scalars['ID']['output']
  readonly id: Scalars['ID']['output']
  /** If provided, this mapping will be removed if the import is successful */
  readonly migratingFromCompanyIntegration: Maybe<CompanyIntegration>
  readonly payload: Scalars['JSONObject']['output']
  readonly status: ImportOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
  /** Set if the import was successful */
  readonly vendor: Maybe<Vendor>
}

/** Contains some stats about a particular import group. Computed for each VendorImportOperation. */
export type VendorImportOperationGroup = {
  readonly __typename: 'VendorImportOperationGroup'
  readonly numFailed: Scalars['SafeInt']['output']
  readonly numSuccessful: Scalars['SafeInt']['output']
  readonly status: ImportOperationStatus
  readonly totalOperations: Scalars['SafeInt']['output']
}

/**
 * A single import operation for multiple vendor (AP) invoices.
 * Invoices can be imported from an ERP, or directly from Excel (see CreateVendorInvoiceImportOperationInput).
 * When importing from an ERP, the operation is processed by Cloud Tasks to account for long import times.
 * Imported invoices are available in `operation.invoices`.
 */
export type VendorInvoiceImportOperation = {
  readonly __typename: 'VendorInvoiceImportOperation'
  readonly company: Company
  /** Might not be provided if importing from Excel */
  readonly companyIntegration: Maybe<CompanyIntegration>
  /** Provide to narrow down by contract. Previously-cached contract invoices will be deleted */
  readonly contract: Maybe<Contract>
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  /** Format is YYYY-MM-DD */
  readonly endDate: Scalars['String']['output']
  readonly errors: ReadonlyArray<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly invoiceCount: Scalars['Int']['output']
  readonly invoices: ReadonlyArray<ImportedVendorInvoice>
  /** Format is YYYY-MM-DD */
  readonly startDate: Scalars['String']['output']
  readonly status: ImportOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
}

export type VendorInvoiceImportStatus = {
  readonly __typename: 'VendorInvoiceImportStatus'
  /** In case there's an operation in progress */
  readonly activeOperation: Maybe<VendorInvoiceImportOperation>
  /** If a previous operation has completed, it is available here */
  readonly lastOperation: Maybe<VendorInvoiceImportOperation>
}

export type VendorLegalDocument = {
  readonly __typename: 'VendorLegalDocument'
  readonly document: Maybe<LegalDocument>
  readonly isSkippedPeriod: Scalars['Boolean']['output']
  readonly vendorRequirement: VendorLegalRequirement
}

/** Metadata about a legal requirement that is for a vendor. */
export type VendorLegalRequirement = {
  readonly __typename: 'VendorLegalRequirement'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly legalRequirement: LegalRequirement
  readonly skippedPeriods: ReadonlyArray<Scalars['String']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContract: VendorContract
}

export type VendorLienWaiverDashboardSummary = {
  readonly __typename: 'VendorLienWaiverDashboardSummary'
  /** If empty, the company has never requested a lien waiver */
  readonly numOutstandingLienWaiversThisMonth: Maybe<Scalars['SafeInt']['output']>
  readonly outstandingLienWaiversByMonth: ReadonlyArray<OutstandingLienWaiversByMonth>
  readonly outstandingVendors: Scalars['SafeInt']['output']
}

export { VendorLienWaiverReminderFrequency }

/** DEPRECATED */
export type VendorLienWaiversByMonth = {
  readonly __typename: 'VendorLienWaiversByMonth'
  readonly lienWaiversByMonth: ReadonlyArray<LienWaiversByMonth>
  readonly vendor: Vendor
}

export { VendorListSortCriteria }

/** A preliminary notice for a vendor, filed on a certain project */
export type VendorPreliminaryNotice = {
  readonly __typename: 'VendorPreliminaryNotice'
  readonly createdAt: Scalars['DateTime']['output']
  /** The notice date or date filed for the preliminary notice */
  readonly date: Scalars['DateTime']['output']
  readonly file: StoredFile
  readonly id: Scalars['ID']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly vendorContract: VendorContract
}

export type VendorReportAmountByProject = {
  readonly __typename: 'VendorReportAmountByProject'
  readonly amount: Scalars['SafeInt']['output']
  readonly projectId: Scalars['ID']['output']
}

export type VendorReportAmountByVendor = {
  readonly __typename: 'VendorReportAmountByVendor'
  readonly amount: Scalars['SafeInt']['output']
  readonly vendorId: Scalars['ID']['output']
}

/** Open AR and open AP amounts for the vendor report, grouped by project and vendor */
export type VendorReportOpenAmounts = {
  readonly __typename: 'VendorReportOpenAmounts'
  /** Open AP (accounts payable) amounts per project, from all vendors including non-Siteline, in cents */
  readonly openApByProject: ReadonlyArray<VendorReportAmountByProject>
  /** Open AP amounts per Siteline vendor, in cents */
  readonly openApByVendor: ReadonlyArray<VendorReportAmountByVendor>
  /** Open AR (accounts receivable aging) amounts per project, in cents */
  readonly openArByProject: ReadonlyArray<VendorReportAmountByProject>
}

/** Response type for address verification */
export type VerifyMailAddressResponse = {
  readonly __typename: 'VerifyMailAddressResponse'
  readonly originalAddress: MailAddress
  readonly status: Maybe<Scalars['String']['output']>
  readonly suggestedAddress: Maybe<MailAddress>
  readonly verified: Scalars['Boolean']['output']
}

export type WorksheetLineItem = {
  readonly __typename: 'WorksheetLineItem'
  readonly billedToDate: Scalars['SafeInt']['output']
  readonly code: Scalars['String']['output']
  readonly costCode: Maybe<Scalars['String']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly name: Scalars['String']['output']
  readonly previousBilled: Scalars['SafeInt']['output']
  readonly progress: ReadonlyArray<WorksheetLineItemProgress>
  /**
   * This is the order of the worksheet line item relative to other worksheet items on the same SOV
   * line item. Within a single SOV, there may be multiple worksheet line items with the same sort
   * order (e.g. there will likely be many worksheet line items with sort order 1), but every worksheet
   * item corresponding to the same SOV line item should have a unique sort order.
   */
  readonly sortOrder: Scalars['SafeInt']['output']
  readonly sovLineItem: SovLineItem
  readonly totalValue: Scalars['SafeInt']['output']
  readonly unitName: Maybe<Scalars['String']['output']>
  /** Unit price and name are inferred from the SOV line item, and cannot diverge */
  readonly unitPrice: Maybe<Scalars['Decimal']['output']>
  readonly updatedAt: Scalars['DateTime']['output']
}

export type WorksheetLineItemProgress = {
  readonly __typename: 'WorksheetLineItemProgress'
  readonly createdAt: Scalars['DateTime']['output']
  readonly id: Scalars['ID']['output']
  readonly payApp: PayApp
  readonly previousBilled: Scalars['SafeInt']['output']
  readonly progressBilled: Scalars['SafeInt']['output']
  readonly totalValue: Scalars['SafeInt']['output']
  readonly updatedAt: Scalars['DateTime']['output']
  readonly updatedBy: Maybe<User>
  readonly worksheetLineItem: WorksheetLineItem
}

export type WriteSyncOperation = {
  readonly __typename: 'WriteSyncOperation'
  /**
   * Bulk payload is the minimal amount of information needed to generate a normal
   * write sync payload in the context of a bulk sync.
   * Bulk payload and normal payload are separate so that we don't need to overwrite bulkPayload
   * and can debug more easily if there are issues.
   */
  readonly bulkPayload: Maybe<Scalars['JSONObject']['output']>
  readonly createdAt: Scalars['DateTime']['output']
  readonly createdBy: User
  /**
   * Timestamp when the sync step succeeded or failed. Used to prevent multiple notifications in a bulk sync context.
   * NOTE that this does not guarantee that the export was successful, just that the sync step finished.
   * Use the result field to check if the export was successful.
   */
  readonly exportCompletedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * When the actual export step occurs (eg: creating the invoice).
   * We use this to prevent retries of the export step.
   */
  readonly exportStartedAt: Maybe<Scalars['DateTime']['output']>
  /**
   * Maps to a group, similar to the bulk import group.
   * Null if the operation is not part of a group.
   * Indexing on a nullable field *is* allowed in Postgres.
   */
  readonly groupId: Maybe<Scalars['ID']['output']>
  readonly id: Scalars['ID']['output']
  readonly integration: Integration
  readonly legalDocuments: ReadonlyArray<LegalDocument>
  readonly legalRequirement: Maybe<LegalRequirement>
  readonly lienWaivers: ReadonlyArray<LienWaiver>
  readonly payApp: Maybe<PayApp>
  /** Either payload or minimalPayload must be defined */
  readonly payload: Maybe<Scalars['JSONObject']['output']>
  readonly result: Maybe<Scalars['JSONObject']['output']>
  readonly status: WriteSyncOperationStatus
  readonly updatedAt: Scalars['DateTime']['output']
  readonly writeSyncOperationGroup: Maybe<WriteSyncOperationGroup>
}

/** Contains some stats about a particular import group. Computed for each WriteSyncOperation group */
export type WriteSyncOperationGroup = {
  readonly __typename: 'WriteSyncOperationGroup'
  readonly id: Scalars['ID']['output']
  /** The last operation that was completed. Used to prevent multiple notifications in a bulk sync context. */
  readonly lastOperationCompletedId: Maybe<Scalars['ID']['output']>
  readonly numFailed: Scalars['SafeInt']['output']
  readonly numSuccessful: Scalars['SafeInt']['output']
  readonly status: WriteSyncOperationGroupStatus
  readonly totalOperations: Scalars['SafeInt']['output']
}

export { WriteSyncOperationGroupStatus }

export { WriteSyncOperationStatus }

export type WriteSyncOperationsSort = {
  readonly criteria: WriteSyncOperationsSortCriteria
  readonly order: PaginatedListSortOrder
}

export { WriteSyncOperationsSortCriteria }

export type CompaniesForAutocompleteQueryVariables = Exact<{
  input: GetPaginatedCompaniesInput
}>

export type CompaniesForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly paginatedCompanies: {
    readonly __typename: 'PaginatedCompanyList'
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type CompanyForAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
  }
}

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput
}>

export type UpdateCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly updateCompany: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly deleteCompany: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type DeleteAllContractsForCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input']
  confirmation: Scalars['String']['input']
}>

export type DeleteAllContractsForCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly deleteAllContractsForCompany: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type MarkCompanyAsChurnedMutationVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type MarkCompanyAsChurnedMutation = {
  readonly __typename: 'Mutation'
  readonly markCompanyAsChurned: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type GetCompanyQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type PayAppForAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PayAppForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly payApp: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly billingEnd: DateTime['output']
    readonly timeZone: String['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
      }
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
    }
  }
}

export type TemplatesForAutocompleteQueryVariables = Exact<{
  input: GetPaginatedTemplatesInput
}>

export type TemplatesForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly paginatedTemplates: {
    readonly __typename: 'PaginatedTemplateList'
    readonly templates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly userVisibleName: String['output']
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
    }>
  }
}

export type TemplateForAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TemplateForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly formTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly userVisibleName: String['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
  }
}

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input']
  type?: InputMaybe<SearchResultType>
}>

export type SearchQuery = {
  readonly __typename: 'Query'
  readonly search: ReadonlyArray<{
    readonly __typename: 'SearchResult'
    readonly id: String['output']
    readonly type: SearchResultType
    readonly description: String['output']
    readonly score: Float['output']
  }>
}

export type CreateTestTemplateMutationVariables = Exact<{
  input: CreateTestTemplateInput
}>

export type CreateTestTemplateMutation = {
  readonly __typename: 'Mutation'
  readonly createTestTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
    }>
  }
}

export type TemplateVariantForAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TemplateVariantForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly formTemplateVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly userVisibleName: String['output'] | null
    readonly internalName: String['output']
    readonly isDefaultVariant: Boolean['output']
    readonly hidesZeroDollarAmounts: Boolean['output'] | null
    readonly roundPercentages: Boolean['output'] | null
    readonly useCompanyNotarySignatureIfAvailable: Boolean['output'] | null
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly userVisibleName: String['output']
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
      }>
    }
  }
}

export type LocationProperties = {
  readonly __typename: 'Location'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly nickname: String['output'] | null
  readonly street1: String['output'] | null
  readonly street2: String['output'] | null
  readonly city: String['output']
  readonly county: String['output'] | null
  readonly state: String['output']
  readonly country: String['output']
  readonly postalCode: String['output'] | null
  readonly timeZone: String['output']
  readonly coordinates: LatLng['output']
}

export type CompanyProperties = {
  readonly __typename: 'Company'
  readonly id: ID['output']
  readonly name: String['output']
  readonly nickname: String['output'] | null
  readonly type: CompanyType
  readonly phoneNumber: PhoneNumber['output'] | null
  readonly expectedNumberOfProjects: SafeInt['output'] | null
  readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
  readonly allowLumpSumOverbilling: Boolean['output']
  readonly notaryTags: ReadonlyArray<NotaryTag>
  readonly notaryExpiresAt: DateTime['output'] | null
  readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
  readonly isDemoCompany: Boolean['output']
  readonly hasChurned: Boolean['output']
  readonly mfaRequirement: CompanyMfaRequirement
  readonly allowsLienRightsTracking: Boolean['output']
  readonly defaultLienRightsTracking: Boolean['output']
  readonly userSessionTimeout: Int['output'] | null
  readonly enableDailyContractMismatchReport: Boolean['output']
  readonly picture: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly notaryStamp: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly notarySignature: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly secondarySignature: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly locations: ReadonlyArray<{
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }>
  readonly metadata: {
    readonly __typename: 'CompanyMetadata'
    readonly subtrade: String['output'] | null
    readonly domains: ReadonlyArray<String['output']>
    readonly domainSignup: Boolean['output']
    readonly monthlyCreatePayAppReminderDate: Int['output'] | null
  }
  readonly defaultQuickBillingTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  } | null
  readonly sitelinePointOfContact: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
  } | null
  readonly linkedCompanies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
  }>
}

export type CompanyIntegrationProperties = {
  readonly __typename: 'CompanyIntegration'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly type: IntegrationType
  readonly label: String['output'] | null
  readonly shortName: String['output']
  readonly longName: String['output']
  readonly credentialsUpdatedAt: DateTime['output'] | null
  readonly credentialsReadyForAutoRotation: Boolean['output']
  readonly archivedAt: DateTime['output'] | null
  readonly shouldImportNewProjectSov: Boolean['output']
  readonly metadata: JSONObject['output']
  readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
  readonly importComboJobMethod: ImportIntegrationComboJobMethod
  readonly importProjectNameSource: ImportIntegrationProjectNameSource
  readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
  readonly vendorCount: SafeInt['output']
  readonly location: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
}

export type MinimalUserProperties = {
  readonly __typename: 'User'
  readonly id: ID['output']
  readonly firstName: String['output']
  readonly lastName: String['output']
  readonly email: EmailAddress['output']
  readonly jobTitle: String['output'] | null
  readonly phoneNumber: PhoneNumber['output'] | null
  readonly companies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
  }>
}

export type UserProperties = {
  readonly __typename: 'User'
  readonly blockedEmails: ReadonlyArray<EmailType>
  readonly blockedNotifications: ReadonlyArray<NotificationType>
  readonly policiesAcceptedAt: DateTime['output'] | null
  readonly mfaEnrolled: Boolean['output']
  readonly id: ID['output']
  readonly firstName: String['output']
  readonly lastName: String['output']
  readonly email: EmailAddress['output']
  readonly jobTitle: String['output'] | null
  readonly phoneNumber: PhoneNumber['output'] | null
  readonly companies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }>
  readonly companyUsers: ReadonlyArray<{
    readonly __typename: 'CompanyUser'
    readonly id: ID['output']
    readonly status: UserStatus
    readonly role: CompanyUserRole
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
  }>
}

export type MinimalCompanyUserProperties = {
  readonly __typename: 'CompanyUser'
  readonly id: ID['output']
  readonly role: CompanyUserRole
  readonly user: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type CompanyUserProperties = {
  readonly __typename: 'CompanyUser'
  readonly id: ID['output']
  readonly role: CompanyUserRole
  readonly isSitelineAdmin: Boolean['output']
  readonly status: UserStatus
  readonly permissions: ReadonlyArray<Permission>
  readonly user: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
  }
}

export type StoredFileProperties = {
  readonly __typename: 'StoredFile'
  readonly id: ID['output']
  readonly type: StoredFileType
  readonly url: URL['output']
  readonly name: String['output']
}

export type SovProperties = {
  readonly __typename: 'Sov'
  readonly id: ID['output']
  readonly totalValue: SafeInt['output']
  readonly totalBilled: SafeInt['output']
  readonly totalRetention: SafeInt['output']
}

export type SovLineItemGroupProperties = {
  readonly __typename: 'SovLineItemGroup'
  readonly id: ID['output']
  readonly name: String['output']
  readonly code: String['output'] | null
}

export type SovLineItemProperties = {
  readonly __typename: 'SovLineItem'
  readonly id: ID['output']
  readonly code: String['output']
  readonly sortOrder: SafeInt['output']
  readonly name: String['output']
  readonly isChangeOrder: Boolean['output']
  readonly changeOrderApprovedDate: DateTime['output'] | null
  readonly latestTotalValue: SafeInt['output']
  readonly totalBilled: SafeInt['output']
  readonly previousBilled: SafeInt['output']
  readonly previousStoredMaterials: SafeInt['output']
  readonly retentionHeldTotal: SafeInt['output']
  readonly progressComplete: Float['output']
  readonly defaultRetentionPercent: Float['output'] | null
  readonly sovLineItemGroup: {
    readonly __typename: 'SovLineItemGroup'
    readonly id: ID['output']
    readonly name: String['output']
    readonly code: String['output'] | null
  } | null
}

export type CompanySovProperties = {
  readonly __typename: 'Sov'
  readonly id: ID['output']
  readonly totalValue: SafeInt['output']
  readonly totalBilled: SafeInt['output']
  readonly totalRetention: SafeInt['output']
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly timeZone: String['output']
  }
  readonly lineItems: ReadonlyArray<{
    readonly __typename: 'SovLineItem'
    readonly id: ID['output']
    readonly code: String['output']
    readonly sortOrder: SafeInt['output']
    readonly name: String['output']
    readonly isChangeOrder: Boolean['output']
    readonly changeOrderApprovedDate: DateTime['output'] | null
    readonly latestTotalValue: SafeInt['output']
    readonly totalBilled: SafeInt['output']
    readonly previousBilled: SafeInt['output']
    readonly previousStoredMaterials: SafeInt['output']
    readonly retentionHeldTotal: SafeInt['output']
    readonly progressComplete: Float['output']
    readonly defaultRetentionPercent: Float['output'] | null
    readonly sovLineItemGroup: {
      readonly __typename: 'SovLineItemGroup'
      readonly id: ID['output']
      readonly name: String['output']
      readonly code: String['output'] | null
    } | null
  }>
}

export type SovLineItemProgressProperties = {
  readonly __typename: 'SovLineItemProgress'
  readonly id: ID['output']
  readonly currentBilled: SafeInt['output']
  readonly progressBilled: SafeInt['output']
  readonly retentionHeldCurrent: SafeInt['output']
  readonly previousBilled: SafeInt['output']
  readonly storedMaterialBilled: SafeInt['output']
  readonly previousRetention: SafeInt['output']
  readonly retentionReleasedCurrent: SafeInt['output']
  readonly totalValue: SafeInt['output']
  readonly sovLineItem: {
    readonly __typename: 'SovLineItem'
    readonly id: ID['output']
    readonly code: String['output']
    readonly sortOrder: SafeInt['output']
    readonly name: String['output']
    readonly isChangeOrder: Boolean['output']
    readonly changeOrderApprovedDate: DateTime['output'] | null
    readonly latestTotalValue: SafeInt['output']
    readonly totalBilled: SafeInt['output']
    readonly previousBilled: SafeInt['output']
    readonly previousStoredMaterials: SafeInt['output']
    readonly retentionHeldTotal: SafeInt['output']
    readonly progressComplete: Float['output']
    readonly defaultRetentionPercent: Float['output'] | null
    readonly sovLineItemGroup: {
      readonly __typename: 'SovLineItemGroup'
      readonly id: ID['output']
      readonly name: String['output']
      readonly code: String['output'] | null
    } | null
  }
}

export type FormTemplateAnnotationProperties = {
  readonly __typename: 'FormTemplateAnnotation'
  readonly id: ID['output']
  readonly permanentId: ID['output']
  readonly syncTag: String['output'] | null
  readonly userVisibleName: String['output']
  readonly type: FormTemplateAnnotationType
  readonly xStart: Float['output']
  readonly yStart: Float['output']
  readonly width: Float['output']
  readonly height: Float['output']
  readonly pageNumber: Int['output']
  readonly fontFamily: FormTemplateFont
  readonly fontColor: String['output']
  readonly textAlignment: TextAlignment
  readonly wrapText: Boolean['output']
  readonly isOptional: Boolean['output']
  readonly selectedKey: String['output'] | null
  readonly defaultValueKey: String['output'] | null
  readonly prefix: String['output'] | null
  readonly suffix: String['output'] | null
  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
  readonly doNotRetainOnReset: Boolean['output']
  readonly dynamicFieldTag: String['output'] | null
  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
  readonly imageType: FormTemplateAnnotationImageType | null
  readonly signatureType: SignatureAnnotationType | null
  readonly isFromAiSuggestion: Boolean['output']
}

export type FormTemplateStatusLogProperties = {
  readonly __typename: 'FormTemplateStatusLog'
  readonly id: ID['output']
  readonly statusUpdatedAt: DateTime['output']
  readonly status: FormTemplateStatus
  readonly user: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
  }
}

export type FormTemplateVersionProperties = {
  readonly __typename: 'FormTemplateVersion'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly updatedAt: DateTime['output']
  readonly versionNumber: Int['output']
  readonly isReadyForManualStoredMaterials: Boolean['output']
  readonly file: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly type: StoredFileType
    readonly url: URL['output']
    readonly name: String['output']
  }
  readonly annotations: ReadonlyArray<{
    readonly __typename: 'FormTemplateAnnotation'
    readonly id: ID['output']
    readonly permanentId: ID['output']
    readonly syncTag: String['output'] | null
    readonly userVisibleName: String['output']
    readonly type: FormTemplateAnnotationType
    readonly xStart: Float['output']
    readonly yStart: Float['output']
    readonly width: Float['output']
    readonly height: Float['output']
    readonly pageNumber: Int['output']
    readonly fontFamily: FormTemplateFont
    readonly fontColor: String['output']
    readonly textAlignment: TextAlignment
    readonly wrapText: Boolean['output']
    readonly isOptional: Boolean['output']
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output']
    readonly dynamicFieldTag: String['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly isFromAiSuggestion: Boolean['output']
  }>
  readonly currentSuggestionsRun: {
    readonly __typename: 'FormTemplateSuggestionsRun'
    readonly id: ID['output']
    readonly phase: FormTemplateSuggestionsRunPhase
    readonly error: String['output'] | null
  } | null
}

export type FormTemplateSuggestionsRunProperties = {
  readonly __typename: 'FormTemplateSuggestionsRun'
  readonly id: ID['output']
  readonly phase: FormTemplateSuggestionsRunPhase
  readonly error: String['output'] | null
  readonly formTemplateVersion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type FormTemplateCommentProperties = {
  readonly __typename: 'FormTemplateComment'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly message: String['output']
  readonly isSystemGenerated: Boolean['output']
  readonly user: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
  }
}

export type FormTemplateProperties = {
  readonly __typename: 'FormTemplate'
  readonly id: String['output']
  readonly createdAt: DateTime['output']
  readonly type: FormTemplateType
  readonly status: FormTemplateStatus
  readonly skippedValidation: Boolean['output']
  readonly userVisibleName: String['output']
  readonly isCustomerReady: Boolean['output']
  readonly tags: ReadonlyArray<FormTemplateTag>
  readonly dueDate: DateTime['output'] | null
  readonly statusLogs: ReadonlyArray<{
    readonly __typename: 'FormTemplateStatusLog'
    readonly id: ID['output']
    readonly statusUpdatedAt: DateTime['output']
    readonly status: FormTemplateStatus
    readonly user: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    }
  }>
  readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
  readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
  readonly associatedContracts: ReadonlyArray<{
    readonly __typename: 'FormTemplateAssociatedContract'
    readonly id: String['output']
    readonly providedAsFormType: ProjectOnboardingFormType | null
    readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
  }>
  readonly owner: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
  }
  readonly builder: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
  }
  readonly validator: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
  } | null
  readonly versions: ReadonlyArray<{
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }>
  readonly variants: ReadonlyArray<{
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly isDefaultVariant: Boolean['output']
  }>
  readonly comments: ReadonlyArray<{
    readonly __typename: 'FormTemplateComment'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly message: String['output']
    readonly isSystemGenerated: Boolean['output']
    readonly user: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
      readonly email: EmailAddress['output']
    }
  }>
  readonly originalFile: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly type: StoredFileType
    readonly url: URL['output']
    readonly name: String['output']
  } | null
  readonly duplicateTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly userVisibleName: String['output']
  } | null
}

export type MinimalFormTemplateProperties = {
  readonly __typename: 'FormTemplate'
  readonly id: String['output']
  readonly createdAt: DateTime['output']
  readonly isCustomerReady: Boolean['output']
  readonly userVisibleName: String['output']
  readonly skippedValidation: Boolean['output']
  readonly type: FormTemplateType
  readonly status: FormTemplateStatus
  readonly versions: ReadonlyArray<{
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }>
  readonly variants: ReadonlyArray<{
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly isDefaultVariant: Boolean['output']
  }>
}

export type AnnotationOverrideProperties = {
  readonly __typename: 'AnnotationOverride'
  readonly id: ID['output']
  readonly annotationPermanentId: ID['output']
  readonly userVisibleName: String['output'] | null
  readonly fontFamily: FormTemplateFont | null
  readonly fontColor: String['output'] | null
  readonly textAlignment: TextAlignment | null
  readonly wrapText: Boolean['output'] | null
  readonly isOptional: Boolean['output'] | null
  readonly selectedKey: String['output'] | null
  readonly defaultValueKey: String['output'] | null
  readonly prefix: String['output'] | null
  readonly suffix: String['output'] | null
  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
  readonly doNotRetainOnReset: Boolean['output'] | null
  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
  readonly imageType: FormTemplateAnnotationImageType | null
  readonly signatureType: SignatureAnnotationType | null
  readonly syncTag: String['output'] | null
}

export type FormTemplateVariantProperties = {
  readonly __typename: 'FormTemplateVariant'
  readonly id: ID['output']
  readonly internalName: String['output']
  readonly userVisibleName: String['output'] | null
  readonly isDefaultVariant: Boolean['output']
  readonly hidesZeroDollarAmounts: Boolean['output'] | null
  readonly roundPercentages: Boolean['output'] | null
  readonly useCompanyNotarySignatureIfAvailable: Boolean['output'] | null
  readonly annotationOverrides: ReadonlyArray<{
    readonly __typename: 'AnnotationOverride'
    readonly id: ID['output']
    readonly annotationPermanentId: ID['output']
    readonly userVisibleName: String['output'] | null
    readonly fontFamily: FormTemplateFont | null
    readonly fontColor: String['output'] | null
    readonly textAlignment: TextAlignment | null
    readonly wrapText: Boolean['output'] | null
    readonly isOptional: Boolean['output'] | null
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly syncTag: String['output'] | null
  }>
}

export type SimilarTemplateProperties = {
  readonly __typename: 'SimilarTemplate'
  readonly score: Float['output']
  readonly template: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
  readonly version: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type AmountLineItemProperties = {
  readonly __typename: 'AmountLineItem'
  readonly id: ID['output']
  readonly description: String['output']
  readonly amount: SafeInt['output']
  readonly sortOrder: SafeInt['output']
}

export type PayAppProperties = {
  readonly __typename: 'PayApp'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly timeZone: String['output']
  readonly status: PayAppStatus
  readonly retentionOnly: Boolean['output']
  readonly billingStart: DateTime['output']
  readonly billingEnd: DateTime['output']
  readonly payAppDueDate: DateTime['output']
  readonly currentBilled: SafeInt['output']
  readonly retentionHeldCurrent: SafeInt['output']
  readonly retentionHeldToDate: SafeInt['output']
  readonly retentionReleasedCurrent: SafeInt['output']
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
  }
  readonly progress: ReadonlyArray<{
    readonly __typename: 'SovLineItemProgress'
    readonly id: ID['output']
    readonly currentBilled: SafeInt['output']
    readonly progressBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly previousBilled: SafeInt['output']
    readonly storedMaterialBilled: SafeInt['output']
    readonly previousRetention: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly totalValue: SafeInt['output']
    readonly sovLineItem: {
      readonly __typename: 'SovLineItem'
      readonly id: ID['output']
      readonly code: String['output']
      readonly sortOrder: SafeInt['output']
      readonly name: String['output']
      readonly isChangeOrder: Boolean['output']
      readonly changeOrderApprovedDate: DateTime['output'] | null
      readonly latestTotalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly previousStoredMaterials: SafeInt['output']
      readonly retentionHeldTotal: SafeInt['output']
      readonly progressComplete: Float['output']
      readonly defaultRetentionPercent: Float['output'] | null
      readonly sovLineItemGroup: {
        readonly __typename: 'SovLineItemGroup'
        readonly id: ID['output']
        readonly name: String['output']
        readonly code: String['output'] | null
      } | null
    }
  }>
  readonly amountLineItems: ReadonlyArray<{
    readonly __typename: 'AmountLineItem'
    readonly id: ID['output']
    readonly description: String['output']
    readonly amount: SafeInt['output']
    readonly sortOrder: SafeInt['output']
  }>
}

export type CompanyProjectMetadataProperties = {
  readonly __typename: 'CompanyProjectMetadata'
  readonly role: CompanyProjectRole
  readonly companyName: String['output'] | null
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
  readonly selectedAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
}

export type ProjectProperties = {
  readonly __typename: 'Project'
  readonly id: ID['output']
  readonly name: String['output']
  readonly projectNumber: String['output']
  readonly gcName: String['output'] | null
  readonly location: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }
  readonly gc: {
    readonly __typename: 'GeneralContractor'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly gcAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
  readonly ownerEntity: {
    readonly __typename: 'Owner'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly ownerAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
}

export type IntegrationProperties = {
  readonly __typename: 'Integration'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly type: IntegrationType
  readonly credentialsUpdatedAt: DateTime['output'] | null
  readonly mappings: JSONObject['output']
  readonly isActive: Boolean['output']
  readonly shortName: String['output']
  readonly longName: String['output']
  readonly companyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
  }
}

export type LegalDocumentProperties = {
  readonly __typename: 'LegalDocument'
  readonly id: ID['output']
  readonly name: String['output']
  readonly periodStart: DateTime['output'] | null
  readonly periodEnd: DateTime['output'] | null
  readonly lastSyncIfSuccessful: {
    readonly __typename: 'WriteSyncOperation'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
  } | null
}

export type LegalRequirementProperties = {
  readonly __typename: 'LegalRequirement'
  readonly id: ID['output']
  readonly createdAt: DateTime['output']
  readonly name: String['output']
  readonly timeZone: String['output']
  readonly expirationFrequency: DocumentExpirationFrequency
  readonly startDate: DateTime['output'] | null
  readonly endDate: DateTime['output'] | null
  readonly isVendorRequirement: Boolean['output']
  readonly documents: ReadonlyArray<{
    readonly __typename: 'LegalDocument'
    readonly id: ID['output']
  }>
  readonly formTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  } | null
}

export type PayAppRequirementProperties = {
  readonly __typename: 'PayAppRequirement'
  readonly id: ID['output']
  readonly groupOrder: Int['output']
  readonly conditions: ReadonlyArray<PayAppRequirementCondition>
  readonly templateVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly userVisibleName: String['output'] | null
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly isCustomerReady: Boolean['output']
    }
  } | null
}

export type PayAppRequirementGroupProperties = {
  readonly __typename: 'PayAppRequirementGroup'
  readonly id: ID['output']
  readonly order: Int['output']
  readonly payAppRequirements: ReadonlyArray<{
    readonly __typename: 'PayAppRequirement'
    readonly id: ID['output']
    readonly groupOrder: Int['output']
    readonly conditions: ReadonlyArray<PayAppRequirementCondition>
    readonly templateVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly userVisibleName: String['output'] | null
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly isCustomerReady: Boolean['output']
      }
    } | null
  }>
}

export type LienWaiverFormTemplateVariantProperties = {
  readonly __typename: 'FormTemplateVariant'
  readonly id: ID['output']
  readonly template: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type SubcontractorLienWaiverTemplateSetProperties = {
  readonly __typename: 'SubcontractorLienWaiverTemplateSet'
  readonly id: ID['output']
  readonly conditionalFinalVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly userVisibleName: String['output']
      readonly isCustomerReady: Boolean['output']
      readonly tags: ReadonlyArray<FormTemplateTag>
      readonly dueDate: DateTime['output'] | null
      readonly statusLogs: ReadonlyArray<{
        readonly __typename: 'FormTemplateStatusLog'
        readonly id: ID['output']
        readonly statusUpdatedAt: DateTime['output']
        readonly status: FormTemplateStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly associatedCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly associatedContracts: ReadonlyArray<{
        readonly __typename: 'FormTemplateAssociatedContract'
        readonly id: String['output']
        readonly providedAsFormType: ProjectOnboardingFormType | null
        readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
      }>
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
      readonly comments: ReadonlyArray<{
        readonly __typename: 'FormTemplateComment'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly message: String['output']
        readonly isSystemGenerated: Boolean['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly originalFile: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      } | null
      readonly duplicateTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly userVisibleName: String['output']
      } | null
    }
  } | null
  readonly conditionalProgressVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly userVisibleName: String['output']
      readonly isCustomerReady: Boolean['output']
      readonly tags: ReadonlyArray<FormTemplateTag>
      readonly dueDate: DateTime['output'] | null
      readonly statusLogs: ReadonlyArray<{
        readonly __typename: 'FormTemplateStatusLog'
        readonly id: ID['output']
        readonly statusUpdatedAt: DateTime['output']
        readonly status: FormTemplateStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly associatedCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly associatedContracts: ReadonlyArray<{
        readonly __typename: 'FormTemplateAssociatedContract'
        readonly id: String['output']
        readonly providedAsFormType: ProjectOnboardingFormType | null
        readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
      }>
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
      readonly comments: ReadonlyArray<{
        readonly __typename: 'FormTemplateComment'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly message: String['output']
        readonly isSystemGenerated: Boolean['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly originalFile: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      } | null
      readonly duplicateTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly userVisibleName: String['output']
      } | null
    }
  } | null
  readonly unconditionalFinalVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly userVisibleName: String['output']
      readonly isCustomerReady: Boolean['output']
      readonly tags: ReadonlyArray<FormTemplateTag>
      readonly dueDate: DateTime['output'] | null
      readonly statusLogs: ReadonlyArray<{
        readonly __typename: 'FormTemplateStatusLog'
        readonly id: ID['output']
        readonly statusUpdatedAt: DateTime['output']
        readonly status: FormTemplateStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly associatedCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly associatedContracts: ReadonlyArray<{
        readonly __typename: 'FormTemplateAssociatedContract'
        readonly id: String['output']
        readonly providedAsFormType: ProjectOnboardingFormType | null
        readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
      }>
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
      readonly comments: ReadonlyArray<{
        readonly __typename: 'FormTemplateComment'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly message: String['output']
        readonly isSystemGenerated: Boolean['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly originalFile: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      } | null
      readonly duplicateTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly userVisibleName: String['output']
      } | null
    }
  } | null
  readonly unconditionalProgressVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly userVisibleName: String['output']
      readonly isCustomerReady: Boolean['output']
      readonly tags: ReadonlyArray<FormTemplateTag>
      readonly dueDate: DateTime['output'] | null
      readonly statusLogs: ReadonlyArray<{
        readonly __typename: 'FormTemplateStatusLog'
        readonly id: ID['output']
        readonly statusUpdatedAt: DateTime['output']
        readonly status: FormTemplateStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly associatedCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly associatedContracts: ReadonlyArray<{
        readonly __typename: 'FormTemplateAssociatedContract'
        readonly id: String['output']
        readonly providedAsFormType: ProjectOnboardingFormType | null
        readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
      }>
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
      readonly comments: ReadonlyArray<{
        readonly __typename: 'FormTemplateComment'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly message: String['output']
        readonly isSystemGenerated: Boolean['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly originalFile: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      } | null
      readonly duplicateTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly userVisibleName: String['output']
      } | null
    }
  } | null
}

export type LeanLienWaiverFormTemplateVariantProperties = {
  readonly __typename: 'FormTemplateVariant'
  readonly id: ID['output']
  readonly template: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly createdAt: DateTime['output']
  }
}

export type LeanSubcontractorLienWaiverTemplateSetProperties = {
  readonly __typename: 'SubcontractorLienWaiverTemplateSet'
  readonly id: ID['output']
  readonly conditionalFinalVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly createdAt: DateTime['output']
    }
  } | null
  readonly conditionalProgressVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly createdAt: DateTime['output']
    }
  } | null
  readonly unconditionalFinalVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly createdAt: DateTime['output']
    }
  } | null
  readonly unconditionalProgressVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly createdAt: DateTime['output']
    }
  } | null
}

export type ContractProperties = {
  readonly __typename: 'Contract'
  readonly id: ID['output']
  readonly role: CompanyProjectRole
  readonly status: ContractStatus
  readonly timeZone: String['output']
  readonly contractDate: DateTime['output'] | null
  readonly contractNumber: String['output'] | null
  readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
  readonly defaultRetentionPercent: Float['output'] | null
  readonly retentionTrackingLevel: RetentionTrackingLevel
  readonly daysBeforePayAppDue: Int['output']
  readonly billingType: BillingType
  readonly contractTemplateVariables: JSONObject['output']
  readonly internalProjectNumber: String['output'] | null
  readonly vendorNumber: String['output'] | null
  readonly pastPayAppCount: Int['output']
  readonly roundRetention: Boolean['output']
  readonly project: {
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly projectNumber: String['output']
    readonly gcName: String['output'] | null
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly gcAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly ownerEntity: {
      readonly __typename: 'Owner'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly ownerAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
  readonly sov: {
    readonly __typename: 'Sov'
    readonly id: ID['output']
    readonly totalValue: SafeInt['output']
    readonly totalBilled: SafeInt['output']
    readonly totalRetention: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly timeZone: String['output']
    }
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'SovLineItem'
      readonly id: ID['output']
      readonly code: String['output']
      readonly sortOrder: SafeInt['output']
      readonly name: String['output']
      readonly isChangeOrder: Boolean['output']
      readonly changeOrderApprovedDate: DateTime['output'] | null
      readonly latestTotalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly previousStoredMaterials: SafeInt['output']
      readonly retentionHeldTotal: SafeInt['output']
      readonly progressComplete: Float['output']
      readonly defaultRetentionPercent: Float['output'] | null
      readonly sovLineItemGroup: {
        readonly __typename: 'SovLineItemGroup'
        readonly id: ID['output']
        readonly name: String['output']
        readonly code: String['output'] | null
      } | null
    }>
  } | null
  readonly lienWaiverTemplates: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
  readonly lowerTierLienWaiverTemplates: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
  readonly subTierLienWaiverTemplates: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
  readonly payAppRequirementGroups: ReadonlyArray<{
    readonly __typename: 'PayAppRequirementGroup'
    readonly id: ID['output']
    readonly order: Int['output']
    readonly payAppRequirements: ReadonlyArray<{
      readonly __typename: 'PayAppRequirement'
      readonly id: ID['output']
      readonly groupOrder: Int['output']
      readonly conditions: ReadonlyArray<PayAppRequirementCondition>
      readonly templateVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly userVisibleName: String['output'] | null
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly isCustomerReady: Boolean['output']
        }
      } | null
    }>
  }>
  readonly legalRequirements: ReadonlyArray<{
    readonly __typename: 'LegalRequirement'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly name: String['output']
    readonly timeZone: String['output']
    readonly expirationFrequency: DocumentExpirationFrequency
    readonly startDate: DateTime['output'] | null
    readonly endDate: DateTime['output'] | null
    readonly isVendorRequirement: Boolean['output']
    readonly documents: ReadonlyArray<{
      readonly __typename: 'LegalDocument'
      readonly id: ID['output']
    }>
    readonly formTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
  }>
  readonly selectedAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }
  readonly changeOrderRequestTemplates: ReadonlyArray<{
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  }>
  readonly changeOrderLogTemplates: ReadonlyArray<{
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  }>
  readonly integrations: ReadonlyArray<{
    readonly __typename: 'Integration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly mappings: JSONObject['output']
    readonly isActive: Boolean['output']
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly companyIntegration: {
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
    }
  }>
  readonly onboardedStatus: {
    readonly __typename: 'OnboardedProjectContractStatus'
    readonly selectedPayAppForms: Boolean['output']
    readonly onboardedPayAppForms: Boolean['output']
    readonly selectedPrimaryLienWaivers: Boolean['output']
    readonly onboardedPrimaryLienWaiverForms: Boolean['output']
    readonly selectedVendorLienWaivers: Boolean['output']
    readonly onboardedVendorLienWaiverForms: Boolean['output']
    readonly selectedChangeOrderRequestForms: Boolean['output']
    readonly onboardedChangeOrderRequestForms: Boolean['output']
    readonly selectedChangeOrderLogForms: Boolean['output']
    readonly onboardedChangeOrderLogForms: Boolean['output']
    readonly addedSov: Boolean['output']
    readonly selectedRateTable: Boolean['output']
    readonly addedTeammates: Boolean['output']
    readonly addedGcContacts: Boolean['output']
    readonly startedBilling: Boolean['output']
    readonly notifiedOnboardedForms: Boolean['output']
  }
}

export type ProjectForDetailsProperties = {
  readonly __typename: 'Project'
  readonly id: ID['output']
  readonly name: String['output']
  readonly projectNumber: String['output']
  readonly gcName: String['output'] | null
  readonly location: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }
  readonly ownerEntity: {
    readonly __typename: 'Owner'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly ownerAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
  readonly gc: {
    readonly __typename: 'GeneralContractor'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly gcAddress: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  } | null
  readonly architect: {
    readonly __typename: 'CompanyProjectMetadata'
    readonly role: CompanyProjectRole
    readonly companyName: String['output'] | null
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  } | null
  readonly contracts: ReadonlyArray<{
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly users: ReadonlyArray<{
        readonly __typename: 'CompanyUser'
        readonly id: ID['output']
        readonly role: CompanyUserRole
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
          readonly jobTitle: String['output'] | null
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly companies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }
      }>
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly users: ReadonlyArray<{
      readonly __typename: 'ContractUser'
      readonly id: ID['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
        readonly jobTitle: String['output'] | null
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly companies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }>
  readonly metadata: {
    readonly __typename: 'ProjectMetadata'
    readonly payAppDueOnDayOfMonth: Int['output']
  }
}

export type CompanyContactProperties = {
  readonly __typename: 'CompanyContact'
  readonly id: ID['output']
  readonly fullName: String['output']
  readonly email: EmailAddress['output']
  readonly companyName: String['output']
  readonly archivedAt: DateTime['output'] | null
}

export type VendorProperties = {
  readonly __typename: 'Vendor'
  readonly id: ID['output']
  readonly name: String['output']
}

export type CompanyPayAppFormTemplateSetProperties = {
  readonly __typename: 'CompanyPayAppFormTemplateSet'
  readonly id: ID['output']
  readonly name: String['output']
  readonly state: String['output'] | null
  readonly billingType: BillingType
  readonly gc: {
    readonly __typename: 'GeneralContractor'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly payAppRequirementGroups: ReadonlyArray<{
    readonly __typename: 'PayAppRequirementGroup'
    readonly id: ID['output']
    readonly order: Int['output']
    readonly payAppRequirements: ReadonlyArray<{
      readonly __typename: 'PayAppRequirement'
      readonly id: ID['output']
      readonly groupOrder: Int['output']
      readonly conditions: ReadonlyArray<PayAppRequirementCondition>
      readonly templateVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly userVisibleName: String['output'] | null
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly isCustomerReady: Boolean['output']
        }
      } | null
    }>
  }>
}

export type CompanyLienWaiverTemplateSetProperties = {
  readonly __typename: 'CompanyLienWaiverTemplateSet'
  readonly id: ID['output']
  readonly name: String['output']
  readonly state: String['output'] | null
  readonly gc: {
    readonly __typename: 'GeneralContractor'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly lienWaivers: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
}

export type CompanyFormTemplateCollectionProperties = {
  readonly __typename: 'CompanyFormTemplateCollection'
  readonly id: ID['output']
  readonly name: String['output']
  readonly state: String['output'] | null
  readonly billingType: BillingType
  readonly gc: {
    readonly __typename: 'GeneralContractor'
    readonly id: ID['output']
    readonly name: String['output']
  } | null
  readonly payAppForms: {
    readonly __typename: 'CompanyPayAppFormTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly billingType: BillingType
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
  } | null
  readonly primaryLienWaivers: {
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  } | null
  readonly vendorLienWaivers: {
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  } | null
  readonly subTierLienWaivers: {
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  } | null
  readonly changeOrderRequest: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly isDefaultVariant: Boolean['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly isCustomerReady: Boolean['output']
      readonly userVisibleName: String['output']
      readonly skippedValidation: Boolean['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
    }
  } | null
  readonly changeOrderLog: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly isDefaultVariant: Boolean['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly isCustomerReady: Boolean['output']
      readonly userVisibleName: String['output']
      readonly skippedValidation: Boolean['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
    }
  } | null
}

export type CompanyForDetailsProperties = {
  readonly __typename: 'Company'
  readonly id: ID['output']
  readonly name: String['output']
  readonly nickname: String['output'] | null
  readonly type: CompanyType
  readonly phoneNumber: PhoneNumber['output'] | null
  readonly expectedNumberOfProjects: SafeInt['output'] | null
  readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
  readonly allowLumpSumOverbilling: Boolean['output']
  readonly notaryTags: ReadonlyArray<NotaryTag>
  readonly notaryExpiresAt: DateTime['output'] | null
  readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
  readonly isDemoCompany: Boolean['output']
  readonly hasChurned: Boolean['output']
  readonly mfaRequirement: CompanyMfaRequirement
  readonly allowsLienRightsTracking: Boolean['output']
  readonly defaultLienRightsTracking: Boolean['output']
  readonly userSessionTimeout: Int['output'] | null
  readonly enableDailyContractMismatchReport: Boolean['output']
  readonly companyIntegrations: ReadonlyArray<{
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }>
  readonly formTemplateCollections: ReadonlyArray<{
    readonly __typename: 'CompanyFormTemplateCollection'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly billingType: BillingType
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly payAppForms: {
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    } | null
    readonly primaryLienWaivers: {
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    } | null
    readonly vendorLienWaivers: {
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    } | null
    readonly subTierLienWaivers: {
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    } | null
    readonly changeOrderRequest: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly isCustomerReady: Boolean['output']
        readonly userVisibleName: String['output']
        readonly skippedValidation: Boolean['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
      }
    } | null
    readonly changeOrderLog: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly isCustomerReady: Boolean['output']
        readonly userVisibleName: String['output']
        readonly skippedValidation: Boolean['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
      }
    } | null
  }>
  readonly payAppFormTemplateSets: ReadonlyArray<{
    readonly __typename: 'CompanyPayAppFormTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly billingType: BillingType
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
  }>
  readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }>
  readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }>
  readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
    readonly __typename: 'CompanyLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly name: String['output']
    readonly state: String['output'] | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly lienWaivers: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }>
  readonly defaultChangeOrderRequestTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  } | null
  readonly defaultChangeOrderLogTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  } | null
  readonly picture: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly notaryStamp: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly notarySignature: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly secondarySignature: {
    readonly __typename: 'StoredFile'
    readonly id: ID['output']
    readonly url: URL['output']
  } | null
  readonly locations: ReadonlyArray<{
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }>
  readonly metadata: {
    readonly __typename: 'CompanyMetadata'
    readonly subtrade: String['output'] | null
    readonly domains: ReadonlyArray<String['output']>
    readonly domainSignup: Boolean['output']
    readonly monthlyCreatePayAppReminderDate: Int['output'] | null
  }
  readonly defaultQuickBillingTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
  } | null
  readonly sitelinePointOfContact: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
  } | null
  readonly linkedCompanies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
  }>
}

export type UserEducationCampaignProperties = {
  readonly __typename: 'UserEducationCampaign'
  readonly id: ID['output']
  readonly name: String['output']
  readonly startDate: DateTime['output']
  readonly endDate: DateTime['output']
  readonly targetPermissions: ReadonlyArray<Permission>
  readonly showNewTag: Boolean['output']
  readonly title: String['output']
  readonly message: String['output']
  readonly anchorSelector: String['output'] | null
  readonly buttonLabel: String['output'] | null
  readonly buttonLink: String['output'] | null
}

export type LienDeadlineNoticeRequirementNewDeadlineProperties = {
  readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
  readonly type: LienDeadlineNoticeRequirementType
  readonly interval: SafeInt['output']
  readonly granularity: LienRightsDeadlineGranularity
  readonly modifier: LienRightsDeadlineModifier
  readonly anchor: LienRightsDeadlineAnchor
}

export type LienDeadlineNoticeRequirementProperties = {
  readonly __typename: 'LienDeadlineNoticeRequirement'
  readonly id: ID['output']
  readonly documentName: String['output']
  readonly newDeadlines: ReadonlyArray<{
    readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
    readonly type: LienDeadlineNoticeRequirementType
    readonly interval: SafeInt['output']
    readonly granularity: LienRightsDeadlineGranularity
    readonly modifier: LienRightsDeadlineModifier
    readonly anchor: LienRightsDeadlineAnchor
  }>
}

export type StateLienRequirementsSummaryProperties = {
  readonly __typename: 'StateLienRequirementsSummary'
  readonly id: ID['output']
  readonly state: String['output']
  readonly updatedAt: DateTime['output']
  readonly preliminaryNoticeName: String['output'] | null
  readonly preliminaryNoticeDeadlineInterval: SafeInt['output'] | null
  readonly preliminaryNoticeDeadlineGranularity: LienRightsDeadlineGranularity | null
  readonly preliminaryNoticeDeadlineModifier: LienRightsDeadlineModifier | null
  readonly preliminaryNoticeDeadlineAnchor: LienRightsDeadlineAnchor | null
  readonly preliminaryNoticeContingentOn: String['output'] | null
  readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
  readonly preliminaryNoticeAdditionalNotes: String['output'] | null
  readonly preliminaryNoticeLateFilingInterval: SafeInt['output'] | null
  readonly preliminaryNoticeLateFilingGranularity: LienRightsDeadlineGranularity | null
  readonly preliminaryNoticeLateFilingModifier: LienRightsDeadlineModifier | null
  readonly preLienName: String['output'] | null
  readonly preLienInterval: SafeInt['output'] | null
  readonly preLienIntervalGranularity: LienRightsDeadlineGranularity | null
  readonly preLienModifier: LienRightsDeadlineModifier | null
  readonly preLienAnchor: LienRightsDeadlineAnchor | null
  readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
  readonly lienDeadlineInterval: SafeInt['output']
  readonly lienDeadlineModifier: LienRightsDeadlineModifier
  readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
  readonly lienEnforcementInterval: SafeInt['output']
  readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
  readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
  readonly lienAdditionalNotes: String['output'] | null
  readonly citations: ReadonlyArray<String['output']>
  readonly lienDeadlineNoticeRequirements: ReadonlyArray<{
    readonly __typename: 'LienDeadlineNoticeRequirement'
    readonly id: ID['output']
    readonly documentName: String['output']
    readonly newDeadlines: ReadonlyArray<{
      readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
      readonly type: LienDeadlineNoticeRequirementType
      readonly interval: SafeInt['output']
      readonly granularity: LienRightsDeadlineGranularity
      readonly modifier: LienRightsDeadlineModifier
      readonly anchor: LienRightsDeadlineAnchor
    }>
  }>
}

export type CreateAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CreateAdminUserMutation = {
  readonly __typename: 'Mutation'
  readonly createAdminUser: { readonly __typename: 'User'; readonly id: ID['output'] }
}

export type AgaveConnectorCompanyIntegrationsStatusQueryVariables = Exact<{ [key: string]: never }>

export type AgaveConnectorCompanyIntegrationsStatusQuery = {
  readonly __typename: 'Query'
  readonly agaveConnectorCompanyIntegrationsStatus: ReadonlyArray<{
    readonly __typename: 'AgaveConnectorCompanyIntegrationStatus'
    readonly isConnectorOnline: Boolean['output']
    readonly lastPingedAt: DateTime['output'] | null
    readonly errorMessage: String['output'] | null
    readonly connectorVersion: String['output'] | null
    readonly companyIntegration: {
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
      readonly type: IntegrationType
      readonly longName: String['output']
      readonly label: String['output'] | null
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
    }
  }>
}

export type AgaveEndpointMatrixQueryVariables = Exact<{ [key: string]: never }>

export type AgaveEndpointMatrixQuery = {
  readonly __typename: 'Query'
  readonly agaveEndpointMatrix: {
    readonly __typename: 'AgaveEndpointMatrix'
    readonly endpoints: ReadonlyArray<String['output']>
    readonly integrationTypes: ReadonlyArray<IntegrationType>
    readonly cells: ReadonlyArray<{
      readonly __typename: 'AgaveEndpointMatrixCell'
      readonly endpoint: String['output']
      readonly integrationType: IntegrationType
      readonly lastRequestId: String['output']
    }>
  }
}

export type IntegrationRequestDetailQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type IntegrationRequestDetailQuery = {
  readonly __typename: 'Query'
  readonly integrationRequest: {
    readonly __typename: 'IntegrationRequest'
    readonly id: ID['output']
    readonly response: JSONObject['output'] | null
  }
}

export type FullyBilledContractsQueryVariables = Exact<{ [key: string]: never }>

export type FullyBilledContractsQuery = {
  readonly __typename: 'Query'
  readonly fullyBilledContracts: ReadonlyArray<{
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly timeZone: String['output']
    readonly pastPayAppCount: Int['output']
    readonly percentComplete: Float['output'] | null
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }
    readonly payApps: ReadonlyArray<{
      readonly __typename: 'PayApp'
      readonly id: ID['output']
      readonly billingEnd: DateTime['output']
      readonly balanceToFinish: SafeInt['output']
      readonly currentBilled: SafeInt['output']
      readonly payAppNumber: SafeInt['output']
      readonly retentionOnly: Boolean['output']
    }>
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalRetention: SafeInt['output']
    } | null
  }>
}

export type CacheKeysQueryVariables = Exact<{
  input: GetCacheKeysInput
}>

export type CacheKeysQuery = {
  readonly __typename: 'Query'
  readonly cacheKeys: ReadonlyArray<String['output']>
}

export type DeleteCacheKeysMutationVariables = Exact<{
  input: DeleteCacheKeysInput
}>

export type DeleteCacheKeysMutation = {
  readonly __typename: 'Mutation'
  readonly deleteCacheKeys: Boolean['output']
}

export type CreateCompanyMutationVariables = Exact<{
  input: CompanyInput
}>

export type CreateCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly createCompany: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type AddCompanyIntegrationMutationVariables = Exact<{
  input: AddCompanyIntegrationInput
}>

export type AddCompanyIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly addCompanyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type UpdateCompanyIntegrationMutationVariables = Exact<{
  input: UpdateCompanyIntegrationInput
}>

export type UpdateCompanyIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly updateCompanyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type GetIntegrationInvoiceTypesQueryVariables = Exact<{
  input: IntegrationInvoiceTypesInput
}>

export type GetIntegrationInvoiceTypesQuery = {
  readonly __typename: 'Query'
  readonly integrationInvoiceTypes: ReadonlyArray<{
    readonly __typename: 'IntegrationInvoiceType'
    readonly invoiceType: String['output']
    readonly hasAutoNumberingEnabled: Boolean['output']
  }>
}

export type InviteCompanyUserMutationVariables = Exact<{
  input: InviteCompanyUserInput
}>

export type InviteCompanyUserMutation = {
  readonly __typename: 'Mutation'
  readonly inviteCompanyUser: {
    readonly __typename: 'CompanyUser'
    readonly id: ID['output']
    readonly role: CompanyUserRole
    readonly isSitelineAdmin: Boolean['output']
    readonly status: UserStatus
    readonly permissions: ReadonlyArray<Permission>
    readonly user: {
      readonly __typename: 'User'
      readonly blockedEmails: ReadonlyArray<EmailType>
      readonly blockedNotifications: ReadonlyArray<NotificationType>
      readonly policiesAcceptedAt: DateTime['output'] | null
      readonly mfaEnrolled: Boolean['output']
      readonly id: ID['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
      readonly email: EmailAddress['output']
      readonly jobTitle: String['output'] | null
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly companies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }>
      readonly companyUsers: ReadonlyArray<{
        readonly __typename: 'CompanyUser'
        readonly id: ID['output']
        readonly status: UserStatus
        readonly role: CompanyUserRole
        readonly company: {
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
          readonly nickname: String['output'] | null
          readonly type: CompanyType
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly expectedNumberOfProjects: SafeInt['output'] | null
          readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
          readonly allowLumpSumOverbilling: Boolean['output']
          readonly notaryTags: ReadonlyArray<NotaryTag>
          readonly notaryExpiresAt: DateTime['output'] | null
          readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
          readonly isDemoCompany: Boolean['output']
          readonly hasChurned: Boolean['output']
          readonly mfaRequirement: CompanyMfaRequirement
          readonly allowsLienRightsTracking: Boolean['output']
          readonly defaultLienRightsTracking: Boolean['output']
          readonly userSessionTimeout: Int['output'] | null
          readonly enableDailyContractMismatchReport: Boolean['output']
          readonly picture: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notaryStamp: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly secondarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly locations: ReadonlyArray<{
            readonly __typename: 'Location'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly nickname: String['output'] | null
            readonly street1: String['output'] | null
            readonly street2: String['output'] | null
            readonly city: String['output']
            readonly county: String['output'] | null
            readonly state: String['output']
            readonly country: String['output']
            readonly postalCode: String['output'] | null
            readonly timeZone: String['output']
            readonly coordinates: LatLng['output']
          }>
          readonly metadata: {
            readonly __typename: 'CompanyMetadata'
            readonly subtrade: String['output'] | null
            readonly domains: ReadonlyArray<String['output']>
            readonly domainSignup: Boolean['output']
            readonly monthlyCreatePayAppReminderDate: Int['output'] | null
          }
          readonly defaultQuickBillingTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
          } | null
          readonly sitelinePointOfContact: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          } | null
          readonly linkedCompanies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }
      }>
    }
  }
}

export type GetCompanyContactsQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyContactsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly contacts: ReadonlyArray<{
      readonly __typename: 'CompanyContact'
      readonly id: ID['output']
      readonly fullName: String['output']
      readonly email: EmailAddress['output']
      readonly companyName: String['output']
      readonly archivedAt: DateTime['output'] | null
    }>
  }
}

export type CreateCompanyContactMutationVariables = Exact<{
  input: CreateCompanyContactInput
}>

export type CreateCompanyContactMutation = {
  readonly __typename: 'Mutation'
  readonly createCompanyContact: {
    readonly __typename: 'CompanyContact'
    readonly id: ID['output']
    readonly fullName: String['output']
    readonly email: EmailAddress['output']
    readonly companyName: String['output']
    readonly archivedAt: DateTime['output'] | null
  }
}

export type UpdateCompanyContactMutationVariables = Exact<{
  input: UpdateCompanyContactInput
}>

export type UpdateCompanyContactMutation = {
  readonly __typename: 'Mutation'
  readonly updateCompanyContact: {
    readonly __typename: 'CompanyContact'
    readonly id: ID['output']
    readonly fullName: String['output']
    readonly email: EmailAddress['output']
    readonly companyName: String['output']
    readonly archivedAt: DateTime['output'] | null
  }
}

export type ClearCompanyContactsMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ClearCompanyContactsMutation = {
  readonly __typename: 'Mutation'
  readonly clearCompanyContacts: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly contacts: ReadonlyArray<{
      readonly __typename: 'CompanyContact'
      readonly id: ID['output']
      readonly fullName: String['output']
      readonly email: EmailAddress['output']
      readonly companyName: String['output']
      readonly archivedAt: DateTime['output'] | null
    }>
  }
}

export type GetCompanyForDetailsQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyForDetailsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly companyIntegrations: ReadonlyArray<{
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly label: String['output'] | null
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly credentialsReadyForAutoRotation: Boolean['output']
      readonly archivedAt: DateTime['output'] | null
      readonly shouldImportNewProjectSov: Boolean['output']
      readonly metadata: JSONObject['output']
      readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
      readonly importComboJobMethod: ImportIntegrationComboJobMethod
      readonly importProjectNameSource: ImportIntegrationProjectNameSource
      readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
      readonly vendorCount: SafeInt['output']
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }>
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly defaultChangeOrderRequestTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly defaultChangeOrderLogTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type UpdateDefaultChangeOrderLogFormMutationVariables = Exact<{
  input: UpdateDefaultChangeOrderLogFormInput
}>

export type UpdateDefaultChangeOrderLogFormMutation = {
  readonly __typename: 'Mutation'
  readonly updateDefaultChangeOrderLogForm: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly companyIntegrations: ReadonlyArray<{
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly label: String['output'] | null
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly credentialsReadyForAutoRotation: Boolean['output']
      readonly archivedAt: DateTime['output'] | null
      readonly shouldImportNewProjectSov: Boolean['output']
      readonly metadata: JSONObject['output']
      readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
      readonly importComboJobMethod: ImportIntegrationComboJobMethod
      readonly importProjectNameSource: ImportIntegrationProjectNameSource
      readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
      readonly vendorCount: SafeInt['output']
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }>
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly defaultChangeOrderRequestTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly defaultChangeOrderLogTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type UpdateDefaultChangeOrderRequestFormMutationVariables = Exact<{
  input: UpdateDefaultChangeOrderRequestFormInput
}>

export type UpdateDefaultChangeOrderRequestFormMutation = {
  readonly __typename: 'Mutation'
  readonly updateDefaultChangeOrderRequestForm: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
    readonly type: CompanyType
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly expectedNumberOfProjects: SafeInt['output'] | null
    readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
    readonly allowLumpSumOverbilling: Boolean['output']
    readonly notaryTags: ReadonlyArray<NotaryTag>
    readonly notaryExpiresAt: DateTime['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly isDemoCompany: Boolean['output']
    readonly hasChurned: Boolean['output']
    readonly mfaRequirement: CompanyMfaRequirement
    readonly allowsLienRightsTracking: Boolean['output']
    readonly defaultLienRightsTracking: Boolean['output']
    readonly userSessionTimeout: Int['output'] | null
    readonly enableDailyContractMismatchReport: Boolean['output']
    readonly companyIntegrations: ReadonlyArray<{
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly label: String['output'] | null
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly credentialsReadyForAutoRotation: Boolean['output']
      readonly archivedAt: DateTime['output'] | null
      readonly shouldImportNewProjectSov: Boolean['output']
      readonly metadata: JSONObject['output']
      readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
      readonly importComboJobMethod: ImportIntegrationComboJobMethod
      readonly importProjectNameSource: ImportIntegrationProjectNameSource
      readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
      readonly vendorCount: SafeInt['output']
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }>
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly defaultChangeOrderRequestTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly defaultChangeOrderLogTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly picture: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notaryStamp: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly notarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly secondarySignature: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly url: URL['output']
    } | null
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
    readonly metadata: {
      readonly __typename: 'CompanyMetadata'
      readonly subtrade: String['output'] | null
      readonly domains: ReadonlyArray<String['output']>
      readonly domainSignup: Boolean['output']
      readonly monthlyCreatePayAppReminderDate: Int['output'] | null
    }
    readonly defaultQuickBillingTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
    readonly sitelinePointOfContact: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
    } | null
    readonly linkedCompanies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type CreateCompanyFormTemplateCollectionMutationVariables = Exact<{
  input: CreateCompanyFormTemplateCollectionInput
}>

export type CreateCompanyFormTemplateCollectionMutation = {
  readonly __typename: 'Mutation'
  readonly createCompanyFormTemplateCollection: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
  }
}

export type UpdateCompanyFormTemplateCollectionMutationVariables = Exact<{
  input: UpdateCompanyFormTemplateCollectionInput
}>

export type UpdateCompanyFormTemplateCollectionMutation = {
  readonly __typename: 'Mutation'
  readonly updateCompanyFormTemplateCollection: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
  }
}

export type DeleteCompanyFormTemplateCollectionMutationVariables = Exact<{
  input: DeleteCompanyFormTemplateCollectionInput
}>

export type DeleteCompanyFormTemplateCollectionMutation = {
  readonly __typename: 'Mutation'
  readonly deleteCompanyFormTemplateCollection: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly formTemplateCollections: ReadonlyArray<{
      readonly __typename: 'CompanyFormTemplateCollection'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppForms: {
        readonly __typename: 'CompanyPayAppFormTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly billingType: BillingType
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly order: Int['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly groupOrder: Int['output']
            readonly conditions: ReadonlyArray<PayAppRequirementCondition>
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly userVisibleName: String['output'] | null
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly isCustomerReady: Boolean['output']
              }
            } | null
          }>
        }>
      } | null
      readonly primaryLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly vendorLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly subTierLienWaivers: {
        readonly __typename: 'CompanyLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly name: String['output']
        readonly state: String['output'] | null
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly lienWaivers: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly createdAt: DateTime['output']
              readonly type: FormTemplateType
              readonly status: FormTemplateStatus
              readonly skippedValidation: Boolean['output']
              readonly userVisibleName: String['output']
              readonly isCustomerReady: Boolean['output']
              readonly tags: ReadonlyArray<FormTemplateTag>
              readonly dueDate: DateTime['output'] | null
              readonly statusLogs: ReadonlyArray<{
                readonly __typename: 'FormTemplateStatusLog'
                readonly id: ID['output']
                readonly statusUpdatedAt: DateTime['output']
                readonly status: FormTemplateStatus
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly associatedCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly requestingCompany: {
                readonly __typename: 'Company'
                readonly id: ID['output']
              } | null
              readonly associatedContracts: ReadonlyArray<{
                readonly __typename: 'FormTemplateAssociatedContract'
                readonly id: String['output']
                readonly providedAsFormType: ProjectOnboardingFormType | null
                readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
              }>
              readonly owner: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly builder: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              }
              readonly validator: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
              } | null
              readonly versions: ReadonlyArray<{
                readonly __typename: 'FormTemplateVersion'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly updatedAt: DateTime['output']
                readonly versionNumber: Int['output']
                readonly isReadyForManualStoredMaterials: Boolean['output']
                readonly file: {
                  readonly __typename: 'StoredFile'
                  readonly id: ID['output']
                  readonly type: StoredFileType
                  readonly url: URL['output']
                  readonly name: String['output']
                }
                readonly annotations: ReadonlyArray<{
                  readonly __typename: 'FormTemplateAnnotation'
                  readonly id: ID['output']
                  readonly permanentId: ID['output']
                  readonly syncTag: String['output'] | null
                  readonly userVisibleName: String['output']
                  readonly type: FormTemplateAnnotationType
                  readonly xStart: Float['output']
                  readonly yStart: Float['output']
                  readonly width: Float['output']
                  readonly height: Float['output']
                  readonly pageNumber: Int['output']
                  readonly fontFamily: FormTemplateFont
                  readonly fontColor: String['output']
                  readonly textAlignment: TextAlignment
                  readonly wrapText: Boolean['output']
                  readonly isOptional: Boolean['output']
                  readonly selectedKey: String['output'] | null
                  readonly defaultValueKey: String['output'] | null
                  readonly prefix: String['output'] | null
                  readonly suffix: String['output'] | null
                  readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                  readonly doNotRetainOnReset: Boolean['output']
                  readonly dynamicFieldTag: String['output'] | null
                  readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                  readonly imageType: FormTemplateAnnotationImageType | null
                  readonly signatureType: SignatureAnnotationType | null
                  readonly isFromAiSuggestion: Boolean['output']
                }>
                readonly currentSuggestionsRun: {
                  readonly __typename: 'FormTemplateSuggestionsRun'
                  readonly id: ID['output']
                  readonly phase: FormTemplateSuggestionsRunPhase
                  readonly error: String['output'] | null
                } | null
              }>
              readonly variants: ReadonlyArray<{
                readonly __typename: 'FormTemplateVariant'
                readonly id: ID['output']
                readonly internalName: String['output']
                readonly isDefaultVariant: Boolean['output']
              }>
              readonly comments: ReadonlyArray<{
                readonly __typename: 'FormTemplateComment'
                readonly id: ID['output']
                readonly createdAt: DateTime['output']
                readonly message: String['output']
                readonly isSystemGenerated: Boolean['output']
                readonly user: {
                  readonly __typename: 'User'
                  readonly id: ID['output']
                  readonly firstName: String['output']
                  readonly lastName: String['output']
                  readonly email: EmailAddress['output']
                }
              }>
              readonly originalFile: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              } | null
              readonly duplicateTemplate: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
                readonly userVisibleName: String['output']
              } | null
            }
          } | null
        } | null
      } | null
      readonly changeOrderRequest: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
      readonly changeOrderLog: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly isCustomerReady: Boolean['output']
          readonly userVisibleName: String['output']
          readonly skippedValidation: Boolean['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
        }
      } | null
    }>
  }
}

export type RotateExternalApiTokenMutationVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type RotateExternalApiTokenMutation = {
  readonly __typename: 'Mutation'
  readonly rotateExternalApiToken: String['output']
}

export type ArchiveCompanyIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ArchiveCompanyIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly archiveCompanyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type UnarchiveCompanyIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UnarchiveCompanyIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly unarchiveCompanyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type UserForCompanyIntegrationRowQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UserForCompanyIntegrationRowQuery = {
  readonly __typename: 'Query'
  readonly user: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly sitelineTeamMemberRole: SitelineTeamMemberRole | null
    readonly email: EmailAddress['output']
  }
}

export type UpdateIntegrationCredentialMutationVariables = Exact<{
  input: UpdateIntegrationCredentialInput
}>

export type UpdateIntegrationCredentialMutation = {
  readonly __typename: 'Mutation'
  readonly updateIntegrationCredential: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type ExportIntegrationCredentialsToPostmanMutationVariables = Exact<{
  input: ExportIntegrationCredentialsToPostmanInput
}>

export type ExportIntegrationCredentialsToPostmanMutation = {
  readonly __typename: 'Mutation'
  readonly exportIntegrationCredentialsToPostman: Boolean['output']
}

export type AgaveCredentialsForDevEnvQueryVariables = Exact<{
  input: AgaveCredentialsForDevEnvInput
}>

export type AgaveCredentialsForDevEnvQuery = {
  readonly __typename: 'Query'
  readonly agaveCredentialsForDevEnv: String['output']
}

export type RotateIntegrationCredentialMutationVariables = Exact<{
  input: RotateIntegrationCredentialInput
}>

export type RotateIntegrationCredentialMutation = {
  readonly __typename: 'Mutation'
  readonly rotateIntegrationCredential: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly label: String['output'] | null
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
    readonly archivedAt: DateTime['output'] | null
    readonly shouldImportNewProjectSov: Boolean['output']
    readonly metadata: JSONObject['output']
    readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
    readonly importComboJobMethod: ImportIntegrationComboJobMethod
    readonly importProjectNameSource: ImportIntegrationProjectNameSource
    readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
    readonly vendorCount: SafeInt['output']
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }
}

export type CompanyForCredentialsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyForCredentialsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly companyIntegrations: ReadonlyArray<{
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly label: String['output'] | null
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly credentialsReadyForAutoRotation: Boolean['output']
      readonly archivedAt: DateTime['output'] | null
      readonly shouldImportNewProjectSov: Boolean['output']
      readonly metadata: JSONObject['output']
      readonly importChangeOrdersMethod: ImportIntegrationChangeOrdersMethod
      readonly importComboJobMethod: ImportIntegrationComboJobMethod
      readonly importProjectNameSource: ImportIntegrationProjectNameSource
      readonly revertPayAppsToDraftWhenTexturaInvoiceRejected: Boolean['output']
      readonly vendorCount: SafeInt['output']
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }>
  }
}

export type AgaveDebuggerSessionUrlQueryVariables = Exact<{
  input: AgaveDebuggerSessionUrlInput
}>

export type AgaveDebuggerSessionUrlQuery = {
  readonly __typename: 'Query'
  readonly agaveDebuggerSessionUrl: String['output'] | null
}

export type UpdateLocationRequestMutationVariables = Exact<{
  input: UpdateLocationInput
}>

export type UpdateLocationRequestMutation = {
  readonly __typename: 'Mutation'
  readonly updateLocation: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }
}

export type CreateLocationRequestMutationVariables = Exact<{
  input: CreateLocationInput
}>

export type CreateLocationRequestMutation = {
  readonly __typename: 'Mutation'
  readonly createLocation: {
    readonly __typename: 'Location'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly nickname: String['output'] | null
    readonly street1: String['output'] | null
    readonly street2: String['output'] | null
    readonly city: String['output']
    readonly county: String['output'] | null
    readonly state: String['output']
    readonly country: String['output']
    readonly postalCode: String['output'] | null
    readonly timeZone: String['output']
    readonly coordinates: LatLng['output']
  }
}

export type SetCompanyInternalSitelineNotesMutationVariables = Exact<{
  input: SetCompanyInternalSitelineNotesInput
}>

export type SetCompanyInternalSitelineNotesMutation = {
  readonly __typename: 'Mutation'
  readonly setCompanyInternalSitelineNotes: Boolean['output']
}

export type CompanyInternalSitelineNotesQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type CompanyInternalSitelineNotesQuery = {
  readonly __typename: 'Query'
  readonly companyInternalSitelineNotes: String['output'] | null
}

export type ProjectsByCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ProjectsByCompanyQuery = {
  readonly __typename: 'Query'
  readonly projectsByCompany: ReadonlyArray<{
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly projectNumber: String['output']
    readonly gcName: String['output'] | null
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly contractNumber: String['output'] | null
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
    }>
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly gcAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly ownerEntity: {
      readonly __typename: 'Owner'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly ownerAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }>
}

export type DisableUserMutationVariables = Exact<{
  input: DisableUserInput
}>

export type DisableUserMutation = {
  readonly __typename: 'Mutation'
  readonly disableUser: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
  }
}

export type EnableUserMutationVariables = Exact<{
  input: EnableUserInput
}>

export type EnableUserMutation = {
  readonly __typename: 'Mutation'
  readonly enableUser: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
  }
}

export type GetCompanyUsersQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyUsersQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly users: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly role: CompanyUserRole
      readonly isSitelineAdmin: Boolean['output']
      readonly status: UserStatus
      readonly permissions: ReadonlyArray<Permission>
      readonly user: {
        readonly __typename: 'User'
        readonly blockedEmails: ReadonlyArray<EmailType>
        readonly blockedNotifications: ReadonlyArray<NotificationType>
        readonly policiesAcceptedAt: DateTime['output'] | null
        readonly mfaEnrolled: Boolean['output']
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
        readonly jobTitle: String['output'] | null
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly companies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
          readonly nickname: String['output'] | null
          readonly type: CompanyType
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly expectedNumberOfProjects: SafeInt['output'] | null
          readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
          readonly allowLumpSumOverbilling: Boolean['output']
          readonly notaryTags: ReadonlyArray<NotaryTag>
          readonly notaryExpiresAt: DateTime['output'] | null
          readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
          readonly isDemoCompany: Boolean['output']
          readonly hasChurned: Boolean['output']
          readonly mfaRequirement: CompanyMfaRequirement
          readonly allowsLienRightsTracking: Boolean['output']
          readonly defaultLienRightsTracking: Boolean['output']
          readonly userSessionTimeout: Int['output'] | null
          readonly enableDailyContractMismatchReport: Boolean['output']
          readonly picture: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notaryStamp: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly secondarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly locations: ReadonlyArray<{
            readonly __typename: 'Location'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly nickname: String['output'] | null
            readonly street1: String['output'] | null
            readonly street2: String['output'] | null
            readonly city: String['output']
            readonly county: String['output'] | null
            readonly state: String['output']
            readonly country: String['output']
            readonly postalCode: String['output'] | null
            readonly timeZone: String['output']
            readonly coordinates: LatLng['output']
          }>
          readonly metadata: {
            readonly __typename: 'CompanyMetadata'
            readonly subtrade: String['output'] | null
            readonly domains: ReadonlyArray<String['output']>
            readonly domainSignup: Boolean['output']
            readonly monthlyCreatePayAppReminderDate: Int['output'] | null
          }
          readonly defaultQuickBillingTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
          } | null
          readonly sitelinePointOfContact: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          } | null
          readonly linkedCompanies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }>
        readonly companyUsers: ReadonlyArray<{
          readonly __typename: 'CompanyUser'
          readonly id: ID['output']
          readonly status: UserStatus
          readonly role: CompanyUserRole
          readonly company: {
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
            readonly nickname: String['output'] | null
            readonly type: CompanyType
            readonly phoneNumber: PhoneNumber['output'] | null
            readonly expectedNumberOfProjects: SafeInt['output'] | null
            readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
            readonly allowLumpSumOverbilling: Boolean['output']
            readonly notaryTags: ReadonlyArray<NotaryTag>
            readonly notaryExpiresAt: DateTime['output'] | null
            readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
            readonly isDemoCompany: Boolean['output']
            readonly hasChurned: Boolean['output']
            readonly mfaRequirement: CompanyMfaRequirement
            readonly allowsLienRightsTracking: Boolean['output']
            readonly defaultLienRightsTracking: Boolean['output']
            readonly userSessionTimeout: Int['output'] | null
            readonly enableDailyContractMismatchReport: Boolean['output']
            readonly picture: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly url: URL['output']
            } | null
            readonly notaryStamp: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly url: URL['output']
            } | null
            readonly notarySignature: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly url: URL['output']
            } | null
            readonly secondarySignature: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly url: URL['output']
            } | null
            readonly locations: ReadonlyArray<{
              readonly __typename: 'Location'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly nickname: String['output'] | null
              readonly street1: String['output'] | null
              readonly street2: String['output'] | null
              readonly city: String['output']
              readonly county: String['output'] | null
              readonly state: String['output']
              readonly country: String['output']
              readonly postalCode: String['output'] | null
              readonly timeZone: String['output']
              readonly coordinates: LatLng['output']
            }>
            readonly metadata: {
              readonly __typename: 'CompanyMetadata'
              readonly subtrade: String['output'] | null
              readonly domains: ReadonlyArray<String['output']>
              readonly domainSignup: Boolean['output']
              readonly monthlyCreatePayAppReminderDate: Int['output'] | null
            }
            readonly defaultQuickBillingTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            } | null
            readonly sitelinePointOfContact: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            } | null
            readonly linkedCompanies: ReadonlyArray<{
              readonly __typename: 'Company'
              readonly id: ID['output']
              readonly name: String['output']
            }>
          }
        }>
      }
    }>
  }
}

export type GetCompanyVendorContactsQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyVendorContactsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly vendors: ReadonlyArray<{
      readonly __typename: 'Vendor'
      readonly id: ID['output']
      readonly name: String['output']
      readonly contacts: ReadonlyArray<{
        readonly __typename: 'VendorContact'
        readonly id: ID['output']
        readonly fullName: String['output']
        readonly email: EmailAddress['output']
        readonly archivedAt: DateTime['output'] | null
      }>
    }>
  }
}

export type GetCompanyVendorsQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GetCompanyVendorsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly vendors: ReadonlyArray<{
      readonly __typename: 'Vendor'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type DeleteVendorMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteVendorMutation = {
  readonly __typename: 'Mutation'
  readonly deleteVendor: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type MigrateIntegrationContractsMutationVariables = Exact<{
  input: MigrateIntegrationContractsInput
}>

export type MigrateIntegrationContractsMutation = {
  readonly __typename: 'Mutation'
  readonly migrateIntegrationContracts: String['output']
}

export type MigrateIntegrationVendorsMutationVariables = Exact<{
  input: MigrateIntegrationVendorsInput
}>

export type MigrateIntegrationVendorsMutation = {
  readonly __typename: 'Mutation'
  readonly migrateIntegrationVendors: String['output']
}

export type UpdateFoundationPeyoteCredentialsMutationVariables = Exact<{
  input: UpdateFoundationPeyoteCredentialsInput
}>

export type UpdateFoundationPeyoteCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateFoundationPeyoteCredentials: Boolean['output']
}

export type GenerateSage100PeyotePairingCodeMutationVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
}>

export type GenerateSage100PeyotePairingCodeMutation = {
  readonly __typename: 'Mutation'
  readonly generateSage100PeyotePairingCode: String['output']
}

export type TestSage100PeyoteConnectorConnectionMutationVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
}>

export type TestSage100PeyoteConnectorConnectionMutation = {
  readonly __typename: 'Mutation'
  readonly testSage100PeyoteConnectorConnection: {
    readonly __typename: 'PeyoteConnectorStatus'
    readonly isConnectorOnline: Boolean['output']
    readonly connectorVersion: String['output'] | null
    readonly errorMessage: String['output'] | null
  }
}

export type UpdateSageIntacctPeyoteCredentialsMutationVariables = Exact<{
  input: UpdateSageIntacctPeyoteCredentialsInput
}>

export type UpdateSageIntacctPeyoteCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateSageIntacctPeyoteCredentials: Boolean['output']
}

export type SageIntacctPeyoteHasSenderCredentialsQueryVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
}>

export type SageIntacctPeyoteHasSenderCredentialsQuery = {
  readonly __typename: 'Query'
  readonly sageIntacctPeyoteHasSenderCredentials: Boolean['output']
}

export type UpdateSpectrumPeyoteCredentialsMutationVariables = Exact<{
  input: UpdateSpectrumPeyoteCredentialsInput
}>

export type UpdateSpectrumPeyoteCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateSpectrumPeyoteCredentials: Boolean['output']
}

export type UpdateSpectrumPeyoteCompanyMutationVariables = Exact<{
  input: UpdateSpectrumPeyoteCompanyInput
}>

export type UpdateSpectrumPeyoteCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly updateSpectrumPeyoteCompany: Boolean['output']
}

export type UpdateVistaPeyoteCredentialsMutationVariables = Exact<{
  input: UpdateVistaPeyoteCredentialsInput
}>

export type UpdateVistaPeyoteCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateVistaPeyoteCredentials: Boolean['output']
}

export type LinkCompaniesQueryVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
}>

export type LinkCompaniesQuery = {
  readonly __typename: 'Query'
  readonly linkCompanies: ReadonlyArray<{
    readonly __typename: 'LinkCompany'
    readonly integrationId: String['output']
    readonly sourceCompanyId: String['output']
    readonly name: String['output']
  }>
}

export type UpdateLinkCompanyMutationVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
  sourceCompanyId: Scalars['String']['input']
}>

export type UpdateLinkCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly updateLinkCompany: Boolean['output']
}

export type UpdateAcumaticaPeyoteCredentialsMutationVariables = Exact<{
  input: UpdateAcumaticaPeyoteCredentialsInput
}>

export type UpdateAcumaticaPeyoteCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateAcumaticaPeyoteCredentials: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
  }
}

export type AgaveLinkTokenQueryVariables = Exact<{
  companyIntegrationId: Scalars['ID']['input']
}>

export type AgaveLinkTokenQuery = {
  readonly __typename: 'Query'
  readonly agaveLinkToken: String['output']
}

export type UpdateAgaveIntegrationCredentialMutationVariables = Exact<{
  input: UpdateAgaveIntegrationCredentialInput
}>

export type UpdateAgaveIntegrationCredentialMutation = {
  readonly __typename: 'Mutation'
  readonly updateAgaveIntegrationCredential: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
  }
}

export type IntegrationOauthAuthorizeUrlQueryVariables = Exact<{
  input: IntegrationOauthAuthorizeUrlInput
}>

export type IntegrationOauthAuthorizeUrlQuery = {
  readonly __typename: 'Query'
  readonly integrationOauthAuthorizeUrl: String['output']
}

export type IntegrationOnePasswordItemsQueryVariables = Exact<{ [key: string]: never }>

export type IntegrationOnePasswordItemsQuery = {
  readonly __typename: 'Query'
  readonly integrationOnePasswordItems: ReadonlyArray<{
    readonly __typename: 'IntegrationOnePasswordItem'
    readonly vaultId: ID['output']
    readonly itemId: ID['output']
    readonly title: String['output']
  }>
}

export type EnableIntegrationCredentialAutoRotationMutationVariables = Exact<{
  input: EnableIntegrationCredentialAutoRotationInput
}>

export type EnableIntegrationCredentialAutoRotationMutation = {
  readonly __typename: 'Mutation'
  readonly enableIntegrationCredentialAutoRotation: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly credentialsReadyForAutoRotation: Boolean['output']
  }
}

export type UpdateCmicPeyoteBasicCredentialsMutationVariables = Exact<{
  input: UpdateCmicPeyoteBasicCredentialsInput
}>

export type UpdateCmicPeyoteBasicCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateCmicPeyoteBasicCredentials: Boolean['output']
}

export type UpdateCmicPeyoteOauthCredentialsMutationVariables = Exact<{
  input: UpdateCmicPeyoteOauthCredentialsInput
}>

export type UpdateCmicPeyoteOauthCredentialsMutation = {
  readonly __typename: 'Mutation'
  readonly updateCmicPeyoteOauthCredentials: Boolean['output']
}

export type CompanyForGeneralContractorsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyForGeneralContractorsQuery = {
  readonly __typename: 'Query'
  readonly company: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly generalContractors: ReadonlyArray<{
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    }>
  }
}

export type CreateLienWaiverFormTemplateSetMutationVariables = Exact<{
  input: CreateLienWaiverFormTemplateSetInput
}>

export type CreateLienWaiverFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly createLienWaiverFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
  }
}

export type UpdateLienWaiverFormTemplateSetMutationVariables = Exact<{
  input: UpdateLienWaiverFormTemplateSetInput
}>

export type UpdateLienWaiverFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly updateLienWaiverFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
  }
}

export type DeleteLienWaiverFormTemplateSetMutationVariables = Exact<{
  input: DeleteLienWaiverFormTemplateSetInput
}>

export type DeleteLienWaiverFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly deleteLienWaiverFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly primaryLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly vendorLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
    readonly subTierLienWaiverTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly lienWaivers: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
    }>
  }
}

export type CreatePayAppFormTemplateSetMutationVariables = Exact<{
  input: CreatePayAppFormTemplateSetInput
}>

export type CreatePayAppFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly createPayAppFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
  }
}

export type UpdatePayAppFormTemplateSetMutationVariables = Exact<{
  input: UpdatePayAppFormTemplateSetInput
}>

export type UpdatePayAppFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly updatePayAppFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
  }
}

export type DeletePayAppFormTemplateSetMutationVariables = Exact<{
  input: DeletePayAppFormTemplateSetInput
}>

export type DeletePayAppFormTemplateSetMutation = {
  readonly __typename: 'Mutation'
  readonly deletePayAppFormTemplateSet: {
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly payAppFormTemplateSets: ReadonlyArray<{
      readonly __typename: 'CompanyPayAppFormTemplateSet'
      readonly id: ID['output']
      readonly name: String['output']
      readonly state: String['output'] | null
      readonly billingType: BillingType
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
    }>
  }
}

export type GetContractQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetContractQuery = {
  readonly __typename: 'Query'
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly billingType: BillingType
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly daysBeforePayAppDue: Int['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly contractTemplateVariables: JSONObject['output']
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
    readonly sov: { readonly __typename: 'Sov'; readonly id: ID['output'] } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly createdAt: DateTime['output']
        }
      } | null
    } | null
  }
}

export type UpdateOnboardedProjectContractStatusMutationVariables = Exact<{
  input: UpdateOnboardedProjectContractStatusInput
}>

export type UpdateOnboardedProjectContractStatusMutation = {
  readonly __typename: 'Mutation'
  readonly updateOnboardedProjectContractStatus: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type UpdatePayAppRequirementGroupsMutationVariables = Exact<{
  input: UpdatePayAppRequirementGroupsInput
}>

export type UpdatePayAppRequirementGroupsMutation = {
  readonly __typename: 'Mutation'
  readonly updatePayAppRequirementGroups: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type ContractFormTemplatesQueryVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type ContractFormTemplatesQuery = {
  readonly __typename: 'Query'
  readonly contractFormTemplates: ReadonlyArray<{
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly userVisibleName: String['output']
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly ignoreProvidedAsFormType: Boolean['output']
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
  }>
}

export type IgnoreFormTemplateProvidedTypeMutationVariables = Exact<{
  input: IgnoreFormTemplateProvidedTypeInput
}>

export type IgnoreFormTemplateProvidedTypeMutation = {
  readonly __typename: 'Mutation'
  readonly ignoreFormTemplateProvidedType: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly associatedFormTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly ignoreProvidedAsFormType: Boolean['output']
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type ContractForUsersQueryVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type ContractForUsersQuery = {
  readonly __typename: 'Query'
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly users: ReadonlyArray<{
      readonly __typename: 'ContractUser'
      readonly id: ID['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
        readonly jobTitle: String['output'] | null
        readonly phoneNumber: PhoneNumber['output'] | null
      }
    }>
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly users: ReadonlyArray<{
        readonly __typename: 'CompanyUser'
        readonly id: ID['output']
        readonly role: CompanyUserRole
        readonly status: UserStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
          readonly jobTitle: String['output'] | null
          readonly phoneNumber: PhoneNumber['output'] | null
        }
      }>
    }
  }
}

export type UpdateContractUsersMutationVariables = Exact<{
  input: UpdateContractUsersInput
}>

export type UpdateContractUsersMutation = {
  readonly __typename: 'Mutation'
  readonly updateContractUsers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly users: ReadonlyArray<{
      readonly __typename: 'ContractUser'
      readonly id: ID['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
        readonly jobTitle: String['output'] | null
        readonly phoneNumber: PhoneNumber['output'] | null
      }
    }>
  }
}

export type FinishedOnboardingFormsMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FinishedOnboardingFormsMutation = {
  readonly __typename: 'Mutation'
  readonly finishedOnboardingForms: { readonly __typename: 'Contract'; readonly id: ID['output'] }
}

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly deleteIntegration: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type UpdateLegalRequirementsMutationVariables = Exact<{
  input: UpdateLegalRequirementsInput
}>

export type UpdateLegalRequirementsMutation = {
  readonly __typename: 'Mutation'
  readonly updateLegalRequirements: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type CreateSovLineItemGroupMutationVariables = Exact<{
  input: CreateSovLineItemGroupInput
}>

export type CreateSovLineItemGroupMutation = {
  readonly __typename: 'Mutation'
  readonly createSovLineItemGroup: {
    readonly __typename: 'SovLineItemGroup'
    readonly id: ID['output']
    readonly name: String['output']
    readonly code: String['output'] | null
  }
}

export type UpdateSovLineItemGroupMutationVariables = Exact<{
  input: UpdateSovLineItemGroupInput
}>

export type UpdateSovLineItemGroupMutation = {
  readonly __typename: 'Mutation'
  readonly updateSovLineItemGroup: {
    readonly __typename: 'SovLineItemGroup'
    readonly id: ID['output']
    readonly name: String['output']
    readonly code: String['output'] | null
  }
}

export type DeleteSovLineItemGroupMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteSovLineItemGroupMutation = {
  readonly __typename: 'Mutation'
  readonly deleteSovLineItemGroup: {
    readonly __typename: 'DeletionResult'
    readonly id: ID['output']
  }
}

export type SetLineItemsInGroupMutationVariables = Exact<{
  input: SetLineItemsInGroupInput
}>

export type SetLineItemsInGroupMutation = {
  readonly __typename: 'Mutation'
  readonly setLineItemsInGroup: {
    readonly __typename: 'SovLineItemGroup'
    readonly id: ID['output']
    readonly name: String['output']
    readonly code: String['output'] | null
  }
}

export type ContractForLienWaiverSettings = {
  readonly __typename: 'Contract'
  readonly id: ID['output']
  readonly lienWaiverTemplates: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
  readonly lowerTierLienWaiverTemplates: {
    readonly __typename: 'SubcontractorLienWaiverTemplateSet'
    readonly id: ID['output']
    readonly conditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly conditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalFinalVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
    readonly unconditionalProgressVariant: {
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly template: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly createdAt: DateTime['output']
        readonly type: FormTemplateType
        readonly status: FormTemplateStatus
        readonly skippedValidation: Boolean['output']
        readonly userVisibleName: String['output']
        readonly isCustomerReady: Boolean['output']
        readonly tags: ReadonlyArray<FormTemplateTag>
        readonly dueDate: DateTime['output'] | null
        readonly statusLogs: ReadonlyArray<{
          readonly __typename: 'FormTemplateStatusLog'
          readonly id: ID['output']
          readonly statusUpdatedAt: DateTime['output']
          readonly status: FormTemplateStatus
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly associatedCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly requestingCompany: {
          readonly __typename: 'Company'
          readonly id: ID['output']
        } | null
        readonly associatedContracts: ReadonlyArray<{
          readonly __typename: 'FormTemplateAssociatedContract'
          readonly id: String['output']
          readonly providedAsFormType: ProjectOnboardingFormType | null
          readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
        }>
        readonly owner: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly builder: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        }
        readonly validator: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
        } | null
        readonly versions: ReadonlyArray<{
          readonly __typename: 'FormTemplateVersion'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly updatedAt: DateTime['output']
          readonly versionNumber: Int['output']
          readonly isReadyForManualStoredMaterials: Boolean['output']
          readonly file: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          }
          readonly annotations: ReadonlyArray<{
            readonly __typename: 'FormTemplateAnnotation'
            readonly id: ID['output']
            readonly permanentId: ID['output']
            readonly syncTag: String['output'] | null
            readonly userVisibleName: String['output']
            readonly type: FormTemplateAnnotationType
            readonly xStart: Float['output']
            readonly yStart: Float['output']
            readonly width: Float['output']
            readonly height: Float['output']
            readonly pageNumber: Int['output']
            readonly fontFamily: FormTemplateFont
            readonly fontColor: String['output']
            readonly textAlignment: TextAlignment
            readonly wrapText: Boolean['output']
            readonly isOptional: Boolean['output']
            readonly selectedKey: String['output'] | null
            readonly defaultValueKey: String['output'] | null
            readonly prefix: String['output'] | null
            readonly suffix: String['output'] | null
            readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
            readonly doNotRetainOnReset: Boolean['output']
            readonly dynamicFieldTag: String['output'] | null
            readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
            readonly imageType: FormTemplateAnnotationImageType | null
            readonly signatureType: SignatureAnnotationType | null
            readonly isFromAiSuggestion: Boolean['output']
          }>
          readonly currentSuggestionsRun: {
            readonly __typename: 'FormTemplateSuggestionsRun'
            readonly id: ID['output']
            readonly phase: FormTemplateSuggestionsRunPhase
            readonly error: String['output'] | null
          } | null
        }>
        readonly variants: ReadonlyArray<{
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly isDefaultVariant: Boolean['output']
        }>
        readonly comments: ReadonlyArray<{
          readonly __typename: 'FormTemplateComment'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly message: String['output']
          readonly isSystemGenerated: Boolean['output']
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
          }
        }>
        readonly originalFile: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        } | null
        readonly duplicateTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        } | null
      }
    } | null
  } | null
}

export type EnablePrimaryLienWaiversMutationVariables = Exact<{
  input: EnableLienWaiverInput
}>

export type EnablePrimaryLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly enablePrimaryLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type DisablePrimaryLienWaiversMutationVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type DisablePrimaryLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly disablePrimaryLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type EnableLowerTierLienWaiversMutationVariables = Exact<{
  input: EnableLienWaiverInput
}>

export type EnableLowerTierLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly enableLowerTierLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type DisableLowerTierLienWaiversMutationVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type DisableLowerTierLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly disableLowerTierLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type EnableSubTierLienWaiversMutationVariables = Exact<{
  input: EnableLienWaiverInput
}>

export type EnableSubTierLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly enableSubTierLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type DisableSubTierLienWaiversMutationVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type DisableSubTierLienWaiversMutation = {
  readonly __typename: 'Mutation'
  readonly disableSubTierLienWaivers: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
  }
}

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput
}>

export type UpdateContractMutation = {
  readonly __typename: 'Mutation'
  readonly updateContract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type SovLineItemGroupsQueryVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type SovLineItemGroupsQuery = {
  readonly __typename: 'Query'
  readonly sovLineItemGroups: ReadonlyArray<{
    readonly __typename: 'SovLineItemGroup'
    readonly id: ID['output']
    readonly name: String['output']
    readonly code: String['output'] | null
  }>
}

export type ContractForSovQueryVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type ContractForSovQuery = {
  readonly __typename: 'Query'
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
  }
}

export type ContractForPayAppsQueryVariables = Exact<{
  contractId: Scalars['ID']['input']
}>

export type ContractForPayAppsQuery = {
  readonly __typename: 'Query'
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly payApps: ReadonlyArray<{
      readonly __typename: 'PayApp'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly timeZone: String['output']
      readonly status: PayAppStatus
      readonly retentionOnly: Boolean['output']
      readonly billingStart: DateTime['output']
      readonly billingEnd: DateTime['output']
      readonly payAppDueDate: DateTime['output']
      readonly currentBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly retentionHeldToDate: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly payAppNumber: SafeInt['output']
    }>
  }
}

export type UpdateChangeOrderRequestFormMutationVariables = Exact<{
  input: UpdateChangeOrderRequestFormInput
}>

export type UpdateChangeOrderRequestFormMutation = {
  readonly __typename: 'Mutation'
  readonly updateChangeOrderRequestForm: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
  }
}

export type UpdateChangeOrderLogFormMutationVariables = Exact<{
  input: UpdateChangeOrderLogFormInput
}>

export type UpdateChangeOrderLogFormMutation = {
  readonly __typename: 'Mutation'
  readonly updateChangeOrderLogForm: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
  }
}

export type ConvertRetentionTrackingLevelMutationVariables = Exact<{
  input: ConvertRetentionTrackingLevelInput
}>

export type ConvertRetentionTrackingLevelMutation = {
  readonly __typename: 'Mutation'
  readonly convertRetentionTrackingLevel: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type UpdateRoundRetentionMutationVariables = Exact<{
  input: UpdateRoundRetentionInput
}>

export type UpdateRoundRetentionMutation = {
  readonly __typename: 'Mutation'
  readonly updateRoundRetention: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly role: CompanyProjectRole
    readonly status: ContractStatus
    readonly timeZone: String['output']
    readonly contractDate: DateTime['output'] | null
    readonly contractNumber: String['output'] | null
    readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
    readonly defaultRetentionPercent: Float['output'] | null
    readonly retentionTrackingLevel: RetentionTrackingLevel
    readonly daysBeforePayAppDue: Int['output']
    readonly billingType: BillingType
    readonly contractTemplateVariables: JSONObject['output']
    readonly internalProjectNumber: String['output'] | null
    readonly vendorNumber: String['output'] | null
    readonly pastPayAppCount: Int['output']
    readonly roundRetention: Boolean['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly projectNumber: String['output']
      readonly gcName: String['output'] | null
      readonly location: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly gc: {
        readonly __typename: 'GeneralContractor'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly gcAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
      readonly ownerEntity: {
        readonly __typename: 'Owner'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly ownerAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    }
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }
    readonly sov: {
      readonly __typename: 'Sov'
      readonly id: ID['output']
      readonly totalValue: SafeInt['output']
      readonly totalBilled: SafeInt['output']
      readonly totalRetention: SafeInt['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly timeZone: String['output']
      }
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }>
    } | null
    readonly lienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly lowerTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly subTierLienWaiverTemplates: {
      readonly __typename: 'SubcontractorLienWaiverTemplateSet'
      readonly id: ID['output']
      readonly conditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly conditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalFinalVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
      readonly unconditionalProgressVariant: {
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly template: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly createdAt: DateTime['output']
          readonly type: FormTemplateType
          readonly status: FormTemplateStatus
          readonly skippedValidation: Boolean['output']
          readonly userVisibleName: String['output']
          readonly isCustomerReady: Boolean['output']
          readonly tags: ReadonlyArray<FormTemplateTag>
          readonly dueDate: DateTime['output'] | null
          readonly statusLogs: ReadonlyArray<{
            readonly __typename: 'FormTemplateStatusLog'
            readonly id: ID['output']
            readonly statusUpdatedAt: DateTime['output']
            readonly status: FormTemplateStatus
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly associatedCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly requestingCompany: {
            readonly __typename: 'Company'
            readonly id: ID['output']
          } | null
          readonly associatedContracts: ReadonlyArray<{
            readonly __typename: 'FormTemplateAssociatedContract'
            readonly id: String['output']
            readonly providedAsFormType: ProjectOnboardingFormType | null
            readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
          }>
          readonly owner: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly builder: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          }
          readonly validator: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
          } | null
          readonly versions: ReadonlyArray<{
            readonly __typename: 'FormTemplateVersion'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly updatedAt: DateTime['output']
            readonly versionNumber: Int['output']
            readonly isReadyForManualStoredMaterials: Boolean['output']
            readonly file: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            }
            readonly annotations: ReadonlyArray<{
              readonly __typename: 'FormTemplateAnnotation'
              readonly id: ID['output']
              readonly permanentId: ID['output']
              readonly syncTag: String['output'] | null
              readonly userVisibleName: String['output']
              readonly type: FormTemplateAnnotationType
              readonly xStart: Float['output']
              readonly yStart: Float['output']
              readonly width: Float['output']
              readonly height: Float['output']
              readonly pageNumber: Int['output']
              readonly fontFamily: FormTemplateFont
              readonly fontColor: String['output']
              readonly textAlignment: TextAlignment
              readonly wrapText: Boolean['output']
              readonly isOptional: Boolean['output']
              readonly selectedKey: String['output'] | null
              readonly defaultValueKey: String['output'] | null
              readonly prefix: String['output'] | null
              readonly suffix: String['output'] | null
              readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
              readonly doNotRetainOnReset: Boolean['output']
              readonly dynamicFieldTag: String['output'] | null
              readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
              readonly imageType: FormTemplateAnnotationImageType | null
              readonly signatureType: SignatureAnnotationType | null
              readonly isFromAiSuggestion: Boolean['output']
            }>
            readonly currentSuggestionsRun: {
              readonly __typename: 'FormTemplateSuggestionsRun'
              readonly id: ID['output']
              readonly phase: FormTemplateSuggestionsRunPhase
              readonly error: String['output'] | null
            } | null
          }>
          readonly variants: ReadonlyArray<{
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly isDefaultVariant: Boolean['output']
          }>
          readonly comments: ReadonlyArray<{
            readonly __typename: 'FormTemplateComment'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly message: String['output']
            readonly isSystemGenerated: Boolean['output']
            readonly user: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
              readonly email: EmailAddress['output']
            }
          }>
          readonly originalFile: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly type: StoredFileType
            readonly url: URL['output']
            readonly name: String['output']
          } | null
          readonly duplicateTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly userVisibleName: String['output']
          } | null
        }
      } | null
    } | null
    readonly payAppRequirementGroups: ReadonlyArray<{
      readonly __typename: 'PayAppRequirementGroup'
      readonly id: ID['output']
      readonly order: Int['output']
      readonly payAppRequirements: ReadonlyArray<{
        readonly __typename: 'PayAppRequirement'
        readonly id: ID['output']
        readonly groupOrder: Int['output']
        readonly conditions: ReadonlyArray<PayAppRequirementCondition>
        readonly templateVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly internalName: String['output']
          readonly userVisibleName: String['output'] | null
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly isCustomerReady: Boolean['output']
          }
        } | null
      }>
    }>
    readonly legalRequirements: ReadonlyArray<{
      readonly __typename: 'LegalRequirement'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly expirationFrequency: DocumentExpirationFrequency
      readonly startDate: DateTime['output'] | null
      readonly endDate: DateTime['output'] | null
      readonly isVendorRequirement: Boolean['output']
      readonly documents: ReadonlyArray<{
        readonly __typename: 'LegalDocument'
        readonly id: ID['output']
      }>
      readonly formTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
    }>
    readonly selectedAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly changeOrderRequestTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly changeOrderLogTemplates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    }>
    readonly integrations: ReadonlyArray<{
      readonly __typename: 'Integration'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly type: IntegrationType
      readonly credentialsUpdatedAt: DateTime['output'] | null
      readonly mappings: JSONObject['output']
      readonly isActive: Boolean['output']
      readonly shortName: String['output']
      readonly longName: String['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      }
    }>
    readonly onboardedStatus: {
      readonly __typename: 'OnboardedProjectContractStatus'
      readonly selectedPayAppForms: Boolean['output']
      readonly onboardedPayAppForms: Boolean['output']
      readonly selectedPrimaryLienWaivers: Boolean['output']
      readonly onboardedPrimaryLienWaiverForms: Boolean['output']
      readonly selectedVendorLienWaivers: Boolean['output']
      readonly onboardedVendorLienWaiverForms: Boolean['output']
      readonly selectedChangeOrderRequestForms: Boolean['output']
      readonly onboardedChangeOrderRequestForms: Boolean['output']
      readonly selectedChangeOrderLogForms: Boolean['output']
      readonly onboardedChangeOrderLogForms: Boolean['output']
      readonly addedSov: Boolean['output']
      readonly selectedRateTable: Boolean['output']
      readonly addedTeammates: Boolean['output']
      readonly addedGcContacts: Boolean['output']
      readonly startedBilling: Boolean['output']
      readonly notifiedOnboardedForms: Boolean['output']
    }
  }
}

export type DeleteSovLineItemMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteSovLineItemMutation = {
  readonly __typename: 'Mutation'
  readonly deleteSovLineItem: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type UpdateIntegrationMappingsMutationVariables = Exact<{
  input: UpdateIntegrationMappingsInput
}>

export type UpdateIntegrationMappingsMutation = {
  readonly __typename: 'Mutation'
  readonly updateIntegrationMappings: {
    readonly __typename: 'Integration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly mappings: JSONObject['output']
    readonly isActive: Boolean['output']
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly companyIntegration: {
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
    }
  }
}

export type RefreshIntegrationMappingsMutationVariables = Exact<{
  input: RefreshIntegrationMappingsInput
}>

export type RefreshIntegrationMappingsMutation = {
  readonly __typename: 'Mutation'
  readonly refreshIntegrationMappings: {
    readonly __typename: 'Integration'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly type: IntegrationType
    readonly credentialsUpdatedAt: DateTime['output'] | null
    readonly mappings: JSONObject['output']
    readonly isActive: Boolean['output']
    readonly shortName: String['output']
    readonly longName: String['output']
    readonly companyIntegration: {
      readonly __typename: 'CompanyIntegration'
      readonly id: ID['output']
    }
  }
}

export type ImportSovFromIntegrationMutationVariables = Exact<{
  input: ImportSovFromIntegrationInput
}>

export type ImportSovFromIntegrationMutation = {
  readonly __typename: 'Mutation'
  readonly importSovFromIntegration: {
    readonly __typename: 'Sov'
    readonly id: ID['output']
    readonly totalValue: SafeInt['output']
    readonly totalBilled: SafeInt['output']
    readonly totalRetention: SafeInt['output']
  }
}

export type PaginatedContractMismatchReportOperationGroupsQueryVariables = Exact<{
  input: GetPaginatedContractMismatchReportOperationGroupsInput
}>

export type PaginatedContractMismatchReportOperationGroupsQuery = {
  readonly __typename: 'Query'
  readonly paginatedContractMismatchReportOperationGroups: {
    readonly __typename: 'PaginatedContractMismatchReportOperationGroups'
    readonly hasNext: Boolean['output']
    readonly cursor: ID['output'] | null
    readonly totalCount: Int['output']
    readonly groups: ReadonlyArray<{
      readonly __typename: 'ContractMismatchReportOperationGroup'
      readonly id: ID['output']
      readonly firstOperationCreatedAt: DateTime['output']
      readonly mostRecentOperationUpdatedAt: DateTime['output']
      readonly status: ContractMismatchReportOperationGroupStatus
      readonly numSuccessful: SafeInt['output']
      readonly numFailed: SafeInt['output']
      readonly totalOperations: SafeInt['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
      readonly requestedBy: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
      } | null
    }>
  }
}

export type AbandonedPayAppsQueryVariables = Exact<{ [key: string]: never }>

export type AbandonedPayAppsQuery = {
  readonly __typename: 'Query'
  readonly abandonedPayApps: ReadonlyArray<{
    readonly __typename: 'AbandonedPayAppsData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly abandonedPayAppsCount: SafeInt['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type BillingTotalsQueryVariables = Exact<{
  input: BillingTotalsInput
}>

export type BillingTotalsQuery = {
  readonly __typename: 'Query'
  readonly billingTotals: ReadonlyArray<{
    readonly __typename: 'BillingTotalsData'
    readonly month: DateTime['output']
    readonly companyId: ID['output']
    readonly companyCreatedAt: DateTime['output']
    readonly companyName: String['output']
    readonly submittedPayAppCount: SafeInt['output']
    readonly totalBilledThisMonth: Float['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type ChangeOrderLogUseQueryVariables = Exact<{ [key: string]: never }>

export type ChangeOrderLogUseQuery = {
  readonly __typename: 'Query'
  readonly changeOrderLogUse: ReadonlyArray<{
    readonly __typename: 'ChangeOrderLogUseData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly percentProjectsWithChangeOrder: Float['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type ComplianceUseQueryVariables = Exact<{ [key: string]: never }>

export type ComplianceUseQuery = {
  readonly __typename: 'Query'
  readonly complianceUse: ReadonlyArray<{
    readonly __typename: 'ComplianceUseData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly percentProjectsWithComplianceRequirements: Float['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type FormTrackerQueryVariables = Exact<{
  input: FormTrackerInput
}>

export type FormTrackerQuery = {
  readonly __typename: 'Query'
  readonly formTracker: ReadonlyArray<{
    readonly __typename: 'FormTrackerData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly requestedFormsCount: SafeInt['output']
    readonly completedFormsCount: SafeInt['output']
    readonly formsCompletedRatio: Float['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type PayAppsSubmittedMonthQueryVariables = Exact<{
  input: PayAppsSubmittedMonthInput
}>

export type PayAppsSubmittedMonthQuery = {
  readonly __typename: 'Query'
  readonly payAppsSubmittedMonth: ReadonlyArray<{
    readonly __typename: 'PayAppsSubmittedData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly payAppsSubmittedThisMonth: SafeInt['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type TimeToValueQueryVariables = Exact<{ [key: string]: never }>

export type TimeToValueQuery = {
  readonly __typename: 'Query'
  readonly timeToValue: ReadonlyArray<{
    readonly __typename: 'TimeToValueData'
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly nickname: String['output'] | null
      readonly name: String['output']
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
    }
    readonly billingByMonth: ReadonlyArray<{
      readonly __typename: 'TimeToValueMonth'
      readonly month: String['output']
      readonly cumulativeContractsBilled: SafeInt['output']
    }>
  }>
}

export type LienWaiversRequestedQueryVariables = Exact<{ [key: string]: never }>

export type LienWaiversRequestedQuery = {
  readonly __typename: 'Query'
  readonly lienWaiversRequested: ReadonlyArray<{
    readonly __typename: 'LienWaiverRequestData'
    readonly companyId: ID['output']
    readonly companyName: String['output']
    readonly companyCreatedAt: DateTime['output']
    readonly lienWaiversRequested: SafeInt['output']
    readonly sitelinePointOfContactId: ID['output'] | null
    readonly sitelinePointOfContactName: String['output'] | null
  }>
}

export type ProjectLocationsQueryVariables = Exact<{ [key: string]: never }>

export type ProjectLocationsQuery = {
  readonly __typename: 'Query'
  readonly projects: ReadonlyArray<{
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly users: ReadonlyArray<{
        readonly __typename: 'ContractUser'
        readonly id: ID['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
    }>
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
  }>
}

export type CompanyLocationsQueryVariables = Exact<{ [key: string]: never }>

export type CompanyLocationsQuery = {
  readonly __typename: 'Query'
  readonly companies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly type: CompanyType
    readonly users: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly locations: ReadonlyArray<{
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }>
  }>
}

export type DemoCompaniesQueryVariables = Exact<{ [key: string]: never }>

export type DemoCompaniesQuery = {
  readonly __typename: 'Query'
  readonly demoCompanies: ReadonlyArray<{
    readonly __typename: 'Company'
    readonly id: ID['output']
    readonly name: String['output']
    readonly nickname: String['output'] | null
  }>
}

export type MarkOldSubmittedPayAppsAsPaidMutationVariables = Exact<{
  input: MarkOldSubmittedPayAppsAsPaidInput
}>

export type MarkOldSubmittedPayAppsAsPaidMutation = {
  readonly __typename: 'Mutation'
  readonly markOldSubmittedPayAppsAsPaid: Boolean['output']
}

export type DeleteLienWaiverRequestsForMonthMutationVariables = Exact<{
  input: DeleteLienWaiverRequestsForMonthInput
}>

export type DeleteLienWaiverRequestsForMonthMutation = {
  readonly __typename: 'Mutation'
  readonly deleteLienWaiverRequestsForMonth: Boolean['output']
}

export type MarkLienWaiverRequestsAsSubmittedForMonthMutationVariables = Exact<{
  input: MarkLienWaiverRequestsAsSubmittedForMonthInput
}>

export type MarkLienWaiverRequestsAsSubmittedForMonthMutation = {
  readonly __typename: 'Mutation'
  readonly markLienWaiverRequestsAsSubmittedForMonth: Boolean['output']
}

export type CompaniesByRolloutPercentageQueryVariables = Exact<{
  input: CompaniesByRolloutPercentageInput
}>

export type CompaniesByRolloutPercentageQuery = {
  readonly __typename: 'Query'
  readonly companiesByRolloutPercentage: ReadonlyArray<ID['output']>
}

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never }>

export type FeatureFlagsQuery = {
  readonly __typename: 'Query'
  readonly featureFlags: ReadonlyArray<{
    readonly __typename: 'FeatureFlag'
    readonly id: ID['output']
    readonly name: FeatureFlagName
    readonly enabled: Boolean['output']
    readonly sitelineTeamMembersOnly: Boolean['output']
    readonly companyIds: ReadonlyArray<ID['output']>
    readonly description: String['output']
    readonly rolloutPercentage: Int['output'] | null
  }>
}

export type CreateFeatureFlagMutationVariables = Exact<{
  input: CreateFeatureFlagInput
}>

export type CreateFeatureFlagMutation = {
  readonly __typename: 'Mutation'
  readonly createFeatureFlag: {
    readonly __typename: 'FeatureFlag'
    readonly id: ID['output']
    readonly name: FeatureFlagName
    readonly enabled: Boolean['output']
    readonly sitelineTeamMembersOnly: Boolean['output']
    readonly companyIds: ReadonlyArray<ID['output']>
    readonly description: String['output']
    readonly rolloutPercentage: Int['output'] | null
  }
}

export type UpdateFeatureFlagMutationVariables = Exact<{
  input: UpdateFeatureFlagInput
}>

export type UpdateFeatureFlagMutation = {
  readonly __typename: 'Mutation'
  readonly updateFeatureFlag: {
    readonly __typename: 'FeatureFlag'
    readonly id: ID['output']
    readonly name: FeatureFlagName
    readonly enabled: Boolean['output']
    readonly sitelineTeamMembersOnly: Boolean['output']
    readonly companyIds: ReadonlyArray<ID['output']>
    readonly description: String['output']
    readonly rolloutPercentage: Int['output'] | null
  }
}

export type CreateFormTemplateMutationVariables = Exact<{
  input: CreateFormTemplateInput
}>

export type CreateFormTemplateMutation = {
  readonly __typename: 'Mutation'
  readonly createFormTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type SitelineTeamMembersQueryVariables = Exact<{ [key: string]: never }>

export type SitelineTeamMembersQuery = {
  readonly __typename: 'Query'
  readonly sitelineTeamMembers: ReadonlyArray<{
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
  }>
}

export type UpdateFormTemplateStatusMutationVariables = Exact<{
  input: UpdateFormTemplateStatusInput
}>

export type UpdateFormTemplateStatusMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateStatus: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateOwnerMutationVariables = Exact<{
  input: UpdateFormTemplateUserInput
}>

export type UpdateFormTemplateOwnerMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateOwner: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateBuilderMutationVariables = Exact<{
  input: UpdateFormTemplateUserInput
}>

export type UpdateFormTemplateBuilderMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateBuilder: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateValidatorMutationVariables = Exact<{
  input: UpdateFormTemplateUserInput
}>

export type UpdateFormTemplateValidatorMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateValidator: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateOriginalFileMutationVariables = Exact<{
  input: UpdateFormTemplateOriginalFileInput
}>

export type UpdateFormTemplateOriginalFileMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateOriginalFile: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateDueDateMutationVariables = Exact<{
  input: UpdateFormTemplateDueDateInput
}>

export type UpdateFormTemplateDueDateMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateDueDate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type MarkFormTemplateAsDuplicateMutationVariables = Exact<{
  input: MarkFormTemplateAsDuplicateInput
}>

export type MarkFormTemplateAsDuplicateMutation = {
  readonly __typename: 'Mutation'
  readonly markFormTemplateAsDuplicate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type AddFormTemplateCommentMutationVariables = Exact<{
  input: AddFormTemplateCommentInput
}>

export type AddFormTemplateCommentMutation = {
  readonly __typename: 'Mutation'
  readonly addFormTemplateComment: {
    readonly __typename: 'FormTemplateComment'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly message: String['output']
    readonly isSystemGenerated: Boolean['output']
    readonly user: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
      readonly email: EmailAddress['output']
    }
  }
}

export type DeleteFormTemplateCommentMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteFormTemplateCommentMutation = {
  readonly __typename: 'Mutation'
  readonly deleteFormTemplateComment: {
    readonly __typename: 'DeletionResult'
    readonly id: ID['output']
  }
}

export type GetFormTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetFormTemplateQuery = {
  readonly __typename: 'Query'
  readonly formTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly requestingCompany: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
    } | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type FormTemplateForDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FormTemplateForDetailsQuery = {
  readonly __typename: 'Query'
  readonly formTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly ignoreProvidedAsFormType: Boolean['output']
      readonly contract: {
        readonly __typename: 'Contract'
        readonly id: ID['output']
        readonly billingType: BillingType
        readonly daysBeforePayAppDue: Int['output']
        readonly payAppRequirementGroups: ReadonlyArray<{
          readonly __typename: 'PayAppRequirementGroup'
          readonly id: ID['output']
          readonly payAppRequirements: ReadonlyArray<{
            readonly __typename: 'PayAppRequirement'
            readonly id: ID['output']
            readonly templateVariant: {
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly template: {
                readonly __typename: 'FormTemplate'
                readonly id: String['output']
              }
            } | null
          }>
        }>
        readonly lienWaiverTemplates: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
        } | null
        readonly lowerTierLienWaiverTemplates: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
        } | null
        readonly subTierLienWaiverTemplates: {
          readonly __typename: 'SubcontractorLienWaiverTemplateSet'
          readonly id: ID['output']
          readonly conditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalProgressVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly conditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
          readonly unconditionalFinalVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
            }
          } | null
        } | null
        readonly changeOrderRequestTemplates: ReadonlyArray<{
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        }>
        readonly changeOrderLogTemplates: ReadonlyArray<{
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        }>
        readonly legalRequirements: ReadonlyArray<{
          readonly __typename: 'LegalRequirement'
          readonly id: ID['output']
          readonly formTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
          } | null
        }>
        readonly project: {
          readonly __typename: 'Project'
          readonly id: ID['output']
          readonly name: String['output']
          readonly timeZone: String['output']
          readonly metadata: {
            readonly __typename: 'ProjectMetadata'
            readonly payAppDueOnDayOfMonth: Int['output']
          }
        }
        readonly company: {
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }
      }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdatedFormTemplateSubscriptionVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UpdatedFormTemplateSubscription = {
  readonly __typename: 'Subscription'
  readonly updatedFormTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type ContractsWithTemplateQueryVariables = Exact<{
  input: GetPaginatedContractsInput
}>

export type ContractsWithTemplateQuery = {
  readonly __typename: 'Query'
  readonly paginatedContracts: {
    readonly __typename: 'PaginatedContractList'
    readonly hasNext: Boolean['output']
    readonly totalCount: Int['output']
    readonly cursor: ID['output'] | null
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
      }
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
    }>
  }
}

export type ContractsForAutocompleteQueryVariables = Exact<{
  input: GetPaginatedContractsInput
}>

export type ContractsForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly paginatedContracts: {
    readonly __typename: 'PaginatedContractList'
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly daysBeforePayAppDue: Int['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
        readonly timeZone: String['output']
        readonly metadata: {
          readonly __typename: 'ProjectMetadata'
          readonly payAppDueOnDayOfMonth: Int['output']
        }
      }
    }>
  }
}

export type UpdateFormTemplateMutationVariables = Exact<{
  input: UpdateFormTemplateInput
}>

export type UpdateFormTemplateMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateAssociatedCompanyMutationVariables = Exact<{
  input: UpdateFormTemplateAssociatedCompanyInput
}>

export type UpdateFormTemplateAssociatedCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateAssociatedCompany: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateRequestingCompanyMutationVariables = Exact<{
  input: UpdateFormTemplateRequestingCompanyInput
}>

export type UpdateFormTemplateRequestingCompanyMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateRequestingCompany: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type UpdateFormTemplateAssociatedContractsMutationVariables = Exact<{
  input: UpdateFormTemplateAssociatedContractsInput
}>

export type UpdateFormTemplateAssociatedContractsMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateAssociatedContracts: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type DeleteFormTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteFormTemplateMutation = {
  readonly __typename: 'Mutation'
  readonly deleteFormTemplate: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type CloneFormTemplateMutationVariables = Exact<{
  input: CloneFormTemplateInput
}>

export type CloneFormTemplateMutation = {
  readonly __typename: 'Mutation'
  readonly cloneFormTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type SetFormTemplateTagsMutationVariables = Exact<{
  input: SetFormTemplateTagsInput
}>

export type SetFormTemplateTagsMutation = {
  readonly __typename: 'Mutation'
  readonly setFormTemplateTags: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type FormTemplateContractsForDueDateQueryVariables = Exact<{
  input: ContractsByIdInput
}>

export type FormTemplateContractsForDueDateQuery = {
  readonly __typename: 'Query'
  readonly contractsById: ReadonlyArray<{
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly skippedPayAppMonths: ReadonlyArray<String['output']>
    readonly daysBeforePayAppDue: Int['output']
    readonly timeZone: String['output']
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly metadata: {
        readonly __typename: 'ProjectMetadata'
        readonly payAppDueOnDayOfMonth: Int['output']
      }
    }
    readonly payApps: ReadonlyArray<{
      readonly __typename: 'PayApp'
      readonly id: ID['output']
      readonly payAppNumber: SafeInt['output']
      readonly billingEnd: DateTime['output']
      readonly internalDueDate: DateTime['output']
      readonly status: PayAppStatus
    }>
  }>
}

export type CloneFormTemplateVersionMutationVariables = Exact<{
  formTemplateVersionId: Scalars['ID']['input']
}>

export type CloneFormTemplateVersionMutation = {
  readonly __typename: 'Mutation'
  readonly cloneFormTemplateVersion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type SkipFormTemplateValidationMutationVariables = Exact<{
  input: SkipFormTemplateValidationInput
}>

export type SkipFormTemplateValidationMutation = {
  readonly __typename: 'Mutation'
  readonly skipFormTemplateValidation: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly createdAt: DateTime['output']
    readonly type: FormTemplateType
    readonly status: FormTemplateStatus
    readonly skippedValidation: Boolean['output']
    readonly userVisibleName: String['output']
    readonly isCustomerReady: Boolean['output']
    readonly tags: ReadonlyArray<FormTemplateTag>
    readonly dueDate: DateTime['output'] | null
    readonly statusLogs: ReadonlyArray<{
      readonly __typename: 'FormTemplateStatusLog'
      readonly id: ID['output']
      readonly statusUpdatedAt: DateTime['output']
      readonly status: FormTemplateStatus
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly associatedCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly requestingCompany: { readonly __typename: 'Company'; readonly id: ID['output'] } | null
    readonly associatedContracts: ReadonlyArray<{
      readonly __typename: 'FormTemplateAssociatedContract'
      readonly id: String['output']
      readonly providedAsFormType: ProjectOnboardingFormType | null
      readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
    }>
    readonly owner: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly builder: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }
    readonly validator: {
      readonly __typename: 'User'
      readonly id: ID['output']
      readonly email: EmailAddress['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    } | null
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
    }>
    readonly comments: ReadonlyArray<{
      readonly __typename: 'FormTemplateComment'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly message: String['output']
      readonly isSystemGenerated: Boolean['output']
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
        readonly email: EmailAddress['output']
      }
    }>
    readonly originalFile: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    } | null
    readonly duplicateTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly userVisibleName: String['output']
    } | null
  }
}

export type ContractForAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ContractForAutocompleteQuery = {
  readonly __typename: 'Query'
  readonly contract: {
    readonly __typename: 'Contract'
    readonly id: ID['output']
    readonly daysBeforePayAppDue: Int['output']
    readonly company: {
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
    }
    readonly project: {
      readonly __typename: 'Project'
      readonly id: ID['output']
      readonly name: String['output']
      readonly timeZone: String['output']
      readonly metadata: {
        readonly __typename: 'ProjectMetadata'
        readonly payAppDueOnDayOfMonth: Int['output']
      }
    }
  }
}

export type PaginatedTemplatesQueryVariables = Exact<{
  input: GetPaginatedTemplatesInput
}>

export type PaginatedTemplatesQuery = {
  readonly __typename: 'Query'
  readonly paginatedTemplates: {
    readonly __typename: 'PaginatedTemplateList'
    readonly hasNext: Boolean['output']
    readonly cursor: ID['output'] | null
    readonly totalCount: Int['output']
    readonly templates: ReadonlyArray<{
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly type: FormTemplateType
      readonly createdAt: DateTime['output']
      readonly userVisibleName: String['output']
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly dueDate: DateTime['output'] | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      } | null
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
      } | null
    }>
  }
}

export type TemplateBuildStatsQueryVariables = Exact<{ [key: string]: never }>

export type TemplateBuildStatsQuery = {
  readonly __typename: 'Query'
  readonly templateBuildStats: {
    readonly __typename: 'TemplateBuildStats'
    readonly builders: ReadonlyArray<{
      readonly __typename: 'TemplateBuildStatsBuilder'
      readonly user: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly firstName: String['output']
      }
    }>
  }
}

export type SimilarTemplatesQueryVariables = Exact<{
  upload: Scalars['Upload']['input']
}>

export type SimilarTemplatesQuery = {
  readonly __typename: 'Query'
  readonly similarTemplates: ReadonlyArray<{
    readonly __typename: 'SimilarTemplate'
    readonly score: Float['output']
    readonly template: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
      readonly createdAt: DateTime['output']
      readonly type: FormTemplateType
      readonly status: FormTemplateStatus
      readonly skippedValidation: Boolean['output']
      readonly userVisibleName: String['output']
      readonly isCustomerReady: Boolean['output']
      readonly tags: ReadonlyArray<FormTemplateTag>
      readonly dueDate: DateTime['output'] | null
      readonly statusLogs: ReadonlyArray<{
        readonly __typename: 'FormTemplateStatusLog'
        readonly id: ID['output']
        readonly statusUpdatedAt: DateTime['output']
        readonly status: FormTemplateStatus
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly associatedCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly requestingCompany: {
        readonly __typename: 'Company'
        readonly id: ID['output']
      } | null
      readonly associatedContracts: ReadonlyArray<{
        readonly __typename: 'FormTemplateAssociatedContract'
        readonly id: String['output']
        readonly providedAsFormType: ProjectOnboardingFormType | null
        readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
      }>
      readonly owner: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly builder: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      }
      readonly validator: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
        readonly lastName: String['output']
      } | null
      readonly versions: ReadonlyArray<{
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }>
      readonly variants: ReadonlyArray<{
        readonly __typename: 'FormTemplateVariant'
        readonly id: ID['output']
        readonly internalName: String['output']
        readonly isDefaultVariant: Boolean['output']
      }>
      readonly comments: ReadonlyArray<{
        readonly __typename: 'FormTemplateComment'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly message: String['output']
        readonly isSystemGenerated: Boolean['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
        }
      }>
      readonly originalFile: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      } | null
      readonly duplicateTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
        readonly userVisibleName: String['output']
      } | null
    }
    readonly version: {
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }
  }>
}

export type FormTurnaroundDataQueryVariables = Exact<{
  input: FormTurnaroundDataInput
}>

export type FormTurnaroundDataQuery = {
  readonly __typename: 'Query'
  readonly formTurnaroundData: {
    readonly __typename: 'FormTurnaroundData'
    readonly forms: ReadonlyArray<{
      readonly __typename: 'FormTurnaroundFormData'
      readonly startDate: DateTime['output']
      readonly endDate: DateTime['output']
      readonly formTemplate: {
        readonly __typename: 'MinimalFormTurnaroundFormTemplate'
        readonly id: ID['output']
        readonly userVisibleName: String['output']
        readonly builderId: ID['output'] | null
        readonly requestingCompanyId: ID['output'] | null
        readonly validatorId: ID['output'] | null
        readonly ownerId: ID['output'] | null
      }
    }>
    readonly companies: ReadonlyArray<{
      readonly __typename: 'MinimalFormTurnaroundCompany'
      readonly id: ID['output']
      readonly name: String['output']
    }>
    readonly users: ReadonlyArray<{
      readonly __typename: 'MinimalFormTurnaroundUser'
      readonly id: ID['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
    }>
  }
}

export type CreateFormTemplateVersionMutationVariables = Exact<{
  input: CreateFormTemplateVersionInput
}>

export type CreateFormTemplateVersionMutation = {
  readonly __typename: 'Mutation'
  readonly createFormTemplateVersion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type ReplaceFormTemplateAnnotationsMutationVariables = Exact<{
  input: ReplaceFormTemplateAnnotationsInput
}>

export type ReplaceFormTemplateAnnotationsMutation = {
  readonly __typename: 'Mutation'
  readonly replaceFormTemplateAnnotations: ReadonlyArray<{
    readonly __typename: 'FormTemplateAnnotation'
    readonly id: ID['output']
    readonly permanentId: ID['output']
    readonly syncTag: String['output'] | null
    readonly userVisibleName: String['output']
    readonly type: FormTemplateAnnotationType
    readonly xStart: Float['output']
    readonly yStart: Float['output']
    readonly width: Float['output']
    readonly height: Float['output']
    readonly pageNumber: Int['output']
    readonly fontFamily: FormTemplateFont
    readonly fontColor: String['output']
    readonly textAlignment: TextAlignment
    readonly wrapText: Boolean['output']
    readonly isOptional: Boolean['output']
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output']
    readonly dynamicFieldTag: String['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly isFromAiSuggestion: Boolean['output']
  }>
}

export type TemplateForPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TemplateForPreviewQuery = {
  readonly __typename: 'Query'
  readonly formTemplate: {
    readonly __typename: 'FormTemplate'
    readonly id: String['output']
    readonly updatedAt: DateTime['output']
    readonly status: FormTemplateStatus
    readonly versions: ReadonlyArray<{
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly versionNumber: Int['output']
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
        readonly name: String['output']
      }
    }>
    readonly variants: ReadonlyArray<{
      readonly __typename: 'FormTemplateVariant'
      readonly id: ID['output']
      readonly internalName: String['output']
      readonly isDefaultVariant: Boolean['output']
      readonly hidesZeroDollarAmounts: Boolean['output'] | null
      readonly roundPercentages: Boolean['output'] | null
      readonly annotationOverrides: ReadonlyArray<{
        readonly __typename: 'AnnotationOverride'
        readonly id: ID['output']
        readonly annotationPermanentId: ID['output']
        readonly userVisibleName: String['output'] | null
        readonly fontFamily: FormTemplateFont | null
        readonly fontColor: String['output'] | null
        readonly textAlignment: TextAlignment | null
        readonly wrapText: Boolean['output'] | null
        readonly isOptional: Boolean['output'] | null
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly syncTag: String['output'] | null
      }>
    }>
  }
}

export type CreateTemplateVariantMutationVariables = Exact<{
  input: CreateTemplateVariantInput
}>

export type CreateTemplateVariantMutation = {
  readonly __typename: 'Mutation'
  readonly createTemplateVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly userVisibleName: String['output'] | null
    readonly isDefaultVariant: Boolean['output']
    readonly hidesZeroDollarAmounts: Boolean['output'] | null
    readonly roundPercentages: Boolean['output'] | null
    readonly useCompanyNotarySignatureIfAvailable: Boolean['output'] | null
    readonly annotationOverrides: ReadonlyArray<{
      readonly __typename: 'AnnotationOverride'
      readonly id: ID['output']
      readonly annotationPermanentId: ID['output']
      readonly userVisibleName: String['output'] | null
      readonly fontFamily: FormTemplateFont | null
      readonly fontColor: String['output'] | null
      readonly textAlignment: TextAlignment | null
      readonly wrapText: Boolean['output'] | null
      readonly isOptional: Boolean['output'] | null
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly syncTag: String['output'] | null
    }>
  }
}

export type DeleteAnnotationsMutationVariables = Exact<{
  input: DeleteAnnotationsFromAiSuggestionInput
}>

export type DeleteAnnotationsMutation = {
  readonly __typename: 'Mutation'
  readonly deleteAnnotationsFromAiSuggestion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
  }
}

export type UpdateTemplateVariantMutationVariables = Exact<{
  input: UpdateTemplateVariantInput
}>

export type UpdateTemplateVariantMutation = {
  readonly __typename: 'Mutation'
  readonly updateTemplateVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly userVisibleName: String['output'] | null
    readonly isDefaultVariant: Boolean['output']
    readonly hidesZeroDollarAmounts: Boolean['output'] | null
    readonly roundPercentages: Boolean['output'] | null
    readonly useCompanyNotarySignatureIfAvailable: Boolean['output'] | null
    readonly annotationOverrides: ReadonlyArray<{
      readonly __typename: 'AnnotationOverride'
      readonly id: ID['output']
      readonly annotationPermanentId: ID['output']
      readonly userVisibleName: String['output'] | null
      readonly fontFamily: FormTemplateFont | null
      readonly fontColor: String['output'] | null
      readonly textAlignment: TextAlignment | null
      readonly wrapText: Boolean['output'] | null
      readonly isOptional: Boolean['output'] | null
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly syncTag: String['output'] | null
    }>
  }
}

export type DeleteTemplateVariantMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteTemplateVariantMutation = {
  readonly __typename: 'Mutation'
  readonly deleteTemplateVariant: {
    readonly __typename: 'DeletionResult'
    readonly id: ID['output']
  }
}

export type CreateFormTemplateAnnotationMutationVariables = Exact<{
  input: CreateFormAnnotationInput
}>

export type CreateFormTemplateAnnotationMutation = {
  readonly __typename: 'Mutation'
  readonly createFormTemplateAnnotation: {
    readonly __typename: 'FormTemplateAnnotation'
    readonly id: ID['output']
    readonly permanentId: ID['output']
    readonly syncTag: String['output'] | null
    readonly userVisibleName: String['output']
    readonly type: FormTemplateAnnotationType
    readonly xStart: Float['output']
    readonly yStart: Float['output']
    readonly width: Float['output']
    readonly height: Float['output']
    readonly pageNumber: Int['output']
    readonly fontFamily: FormTemplateFont
    readonly fontColor: String['output']
    readonly textAlignment: TextAlignment
    readonly wrapText: Boolean['output']
    readonly isOptional: Boolean['output']
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output']
    readonly dynamicFieldTag: String['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly isFromAiSuggestion: Boolean['output']
  }
}

export type CreateFormTemplateAnnotationsMutationVariables = Exact<{
  input: CreateFormAnnotationsInput
}>

export type CreateFormTemplateAnnotationsMutation = {
  readonly __typename: 'Mutation'
  readonly createFormTemplateAnnotations: ReadonlyArray<{
    readonly __typename: 'FormTemplateAnnotation'
    readonly id: ID['output']
    readonly permanentId: ID['output']
    readonly syncTag: String['output'] | null
    readonly userVisibleName: String['output']
    readonly type: FormTemplateAnnotationType
    readonly xStart: Float['output']
    readonly yStart: Float['output']
    readonly width: Float['output']
    readonly height: Float['output']
    readonly pageNumber: Int['output']
    readonly fontFamily: FormTemplateFont
    readonly fontColor: String['output']
    readonly textAlignment: TextAlignment
    readonly wrapText: Boolean['output']
    readonly isOptional: Boolean['output']
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output']
    readonly dynamicFieldTag: String['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly isFromAiSuggestion: Boolean['output']
  }>
}

export type DeleteFormTemplateAnnotationsMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type DeleteFormTemplateAnnotationsMutation = {
  readonly __typename: 'Mutation'
  readonly deleteFormTemplateAnnotations: ReadonlyArray<{
    readonly __typename: 'DeletionResult'
    readonly id: ID['output']
  }>
}

export type UpdateFormTemplateAnnotationsMutationVariables = Exact<{
  input: UpdateFormAnnotationsInput
}>

export type UpdateFormTemplateAnnotationsMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateAnnotations: ReadonlyArray<{
    readonly __typename: 'FormTemplateAnnotation'
    readonly id: ID['output']
    readonly permanentId: ID['output']
    readonly syncTag: String['output'] | null
    readonly userVisibleName: String['output']
    readonly type: FormTemplateAnnotationType
    readonly xStart: Float['output']
    readonly yStart: Float['output']
    readonly width: Float['output']
    readonly height: Float['output']
    readonly pageNumber: Int['output']
    readonly fontFamily: FormTemplateFont
    readonly fontColor: String['output']
    readonly textAlignment: TextAlignment
    readonly wrapText: Boolean['output']
    readonly isOptional: Boolean['output']
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output']
    readonly dynamicFieldTag: String['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly isFromAiSuggestion: Boolean['output']
  }>
}

export type ApplyAnnotationOverrideMutationVariables = Exact<{
  input: ApplyAnnotationOverrideInput
}>

export type ApplyAnnotationOverrideMutation = {
  readonly __typename: 'Mutation'
  readonly applyAnnotationOverride: {
    readonly __typename: 'AnnotationOverride'
    readonly id: ID['output']
    readonly annotationPermanentId: ID['output']
    readonly userVisibleName: String['output'] | null
    readonly fontFamily: FormTemplateFont | null
    readonly fontColor: String['output'] | null
    readonly textAlignment: TextAlignment | null
    readonly wrapText: Boolean['output'] | null
    readonly isOptional: Boolean['output'] | null
    readonly selectedKey: String['output'] | null
    readonly defaultValueKey: String['output'] | null
    readonly prefix: String['output'] | null
    readonly suffix: String['output'] | null
    readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
    readonly doNotRetainOnReset: Boolean['output'] | null
    readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
    readonly imageType: FormTemplateAnnotationImageType | null
    readonly signatureType: SignatureAnnotationType | null
    readonly syncTag: String['output'] | null
  }
}

export type RunFormTemplateSuggestionsMutationVariables = Exact<{
  input: RunFormTemplateSuggestionsInput
}>

export type RunFormTemplateSuggestionsMutation = {
  readonly __typename: 'Mutation'
  readonly runFormTemplateSuggestions: {
    readonly __typename: 'FormTemplateSuggestionsRun'
    readonly id: ID['output']
    readonly phase: FormTemplateSuggestionsRunPhase
    readonly error: String['output'] | null
    readonly formTemplateVersion: {
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }
  }
}

export type FormTemplateSuggestionsRunUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FormTemplateSuggestionsRunUpdatedSubscription = {
  readonly __typename: 'Subscription'
  readonly formTemplateSuggestionsRunUpdated: {
    readonly __typename: 'FormTemplateSuggestionsRun'
    readonly id: ID['output']
    readonly phase: FormTemplateSuggestionsRunPhase
    readonly error: String['output'] | null
    readonly formTemplateVersion: {
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }
  }
}

export type DeleteAnnotationsFromAiSuggestionMutationVariables = Exact<{
  input: DeleteAnnotationsFromAiSuggestionInput
}>

export type DeleteAnnotationsFromAiSuggestionMutation = {
  readonly __typename: 'Mutation'
  readonly deleteAnnotationsFromAiSuggestion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
  }
}

export type TemplateVersionForEditorQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TemplateVersionForEditorQuery = {
  readonly __typename: 'Query'
  readonly formTemplateVersion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type TemplateVariantForEditorQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TemplateVariantForEditorQuery = {
  readonly __typename: 'Query'
  readonly formTemplateVariant: {
    readonly __typename: 'FormTemplateVariant'
    readonly id: ID['output']
    readonly internalName: String['output']
    readonly userVisibleName: String['output'] | null
    readonly isDefaultVariant: Boolean['output']
    readonly hidesZeroDollarAmounts: Boolean['output'] | null
    readonly roundPercentages: Boolean['output'] | null
    readonly useCompanyNotarySignatureIfAvailable: Boolean['output'] | null
    readonly annotationOverrides: ReadonlyArray<{
      readonly __typename: 'AnnotationOverride'
      readonly id: ID['output']
      readonly annotationPermanentId: ID['output']
      readonly userVisibleName: String['output'] | null
      readonly fontFamily: FormTemplateFont | null
      readonly fontColor: String['output'] | null
      readonly textAlignment: TextAlignment | null
      readonly wrapText: Boolean['output'] | null
      readonly isOptional: Boolean['output'] | null
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output'] | null
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly syncTag: String['output'] | null
    }>
  }
}

export type RunFormTemplateSuggestionsForSuggestAnnotationsButtonMutationVariables = Exact<{
  input: RunFormTemplateSuggestionsInput
}>

export type RunFormTemplateSuggestionsForSuggestAnnotationsButtonMutation = {
  readonly __typename: 'Mutation'
  readonly runFormTemplateSuggestions: {
    readonly __typename: 'FormTemplateSuggestionsRun'
    readonly id: ID['output']
    readonly phase: FormTemplateSuggestionsRunPhase
    readonly error: String['output'] | null
    readonly formTemplateVersion: {
      readonly __typename: 'FormTemplateVersion'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly versionNumber: Int['output']
      readonly isReadyForManualStoredMaterials: Boolean['output']
      readonly file: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly type: StoredFileType
        readonly url: URL['output']
        readonly name: String['output']
      }
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'FormTemplateAnnotation'
        readonly id: ID['output']
        readonly permanentId: ID['output']
        readonly syncTag: String['output'] | null
        readonly userVisibleName: String['output']
        readonly type: FormTemplateAnnotationType
        readonly xStart: Float['output']
        readonly yStart: Float['output']
        readonly width: Float['output']
        readonly height: Float['output']
        readonly pageNumber: Int['output']
        readonly fontFamily: FormTemplateFont
        readonly fontColor: String['output']
        readonly textAlignment: TextAlignment
        readonly wrapText: Boolean['output']
        readonly isOptional: Boolean['output']
        readonly selectedKey: String['output'] | null
        readonly defaultValueKey: String['output'] | null
        readonly prefix: String['output'] | null
        readonly suffix: String['output'] | null
        readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
        readonly doNotRetainOnReset: Boolean['output']
        readonly dynamicFieldTag: String['output'] | null
        readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
        readonly imageType: FormTemplateAnnotationImageType | null
        readonly signatureType: SignatureAnnotationType | null
        readonly isFromAiSuggestion: Boolean['output']
      }>
      readonly currentSuggestionsRun: {
        readonly __typename: 'FormTemplateSuggestionsRun'
        readonly id: ID['output']
        readonly phase: FormTemplateSuggestionsRunPhase
        readonly error: String['output'] | null
      } | null
    }
  }
}

export type UpdateFormTemplateVersionMutationVariables = Exact<{
  input: UpdateFormTemplateVersionInput
}>

export type UpdateFormTemplateVersionMutation = {
  readonly __typename: 'Mutation'
  readonly updateFormTemplateVersion: {
    readonly __typename: 'FormTemplateVersion'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly updatedAt: DateTime['output']
    readonly versionNumber: Int['output']
    readonly isReadyForManualStoredMaterials: Boolean['output']
    readonly file: {
      readonly __typename: 'StoredFile'
      readonly id: ID['output']
      readonly type: StoredFileType
      readonly url: URL['output']
      readonly name: String['output']
    }
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'FormTemplateAnnotation'
      readonly id: ID['output']
      readonly permanentId: ID['output']
      readonly syncTag: String['output'] | null
      readonly userVisibleName: String['output']
      readonly type: FormTemplateAnnotationType
      readonly xStart: Float['output']
      readonly yStart: Float['output']
      readonly width: Float['output']
      readonly height: Float['output']
      readonly pageNumber: Int['output']
      readonly fontFamily: FormTemplateFont
      readonly fontColor: String['output']
      readonly textAlignment: TextAlignment
      readonly wrapText: Boolean['output']
      readonly isOptional: Boolean['output']
      readonly selectedKey: String['output'] | null
      readonly defaultValueKey: String['output'] | null
      readonly prefix: String['output'] | null
      readonly suffix: String['output'] | null
      readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
      readonly doNotRetainOnReset: Boolean['output']
      readonly dynamicFieldTag: String['output'] | null
      readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
      readonly imageType: FormTemplateAnnotationImageType | null
      readonly signatureType: SignatureAnnotationType | null
      readonly isFromAiSuggestion: Boolean['output']
    }>
    readonly currentSuggestionsRun: {
      readonly __typename: 'FormTemplateSuggestionsRun'
      readonly id: ID['output']
      readonly phase: FormTemplateSuggestionsRunPhase
      readonly error: String['output'] | null
    } | null
  }
}

export type DeleteFormTemplateVersionMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteFormTemplateVersionMutation = {
  readonly __typename: 'Mutation'
  readonly deleteFormTemplateVersion: {
    readonly __typename: 'DeletionResult'
    readonly id: ID['output']
  }
}

export type GeneralContractorsForDedupeQueryVariables = Exact<{
  companyId: Scalars['ID']['input']
}>

export type GeneralContractorsForDedupeQuery = {
  readonly __typename: 'Query'
  readonly generalContractorsForDedupe: ReadonlyArray<{
    readonly __typename: 'GeneralContractorForDedupe'
    readonly contractCount: SafeInt['output']
    readonly generalContractor: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
    }
  }>
}

export type MergeGeneralContractorsMutationVariables = Exact<{
  input: MergeGeneralContractorsInput
}>

export type MergeGeneralContractorsMutation = {
  readonly __typename: 'Mutation'
  readonly mergeGeneralContractors: Boolean['output']
}

export type PaginatedIntegrationRequestsQueryVariables = Exact<{
  input: GetPaginatedIntegrationRequestsInput
}>

export type PaginatedIntegrationRequestsQuery = {
  readonly __typename: 'Query'
  readonly paginatedIntegrationRequests: {
    readonly __typename: 'PaginatedIntegrationRequestList'
    readonly hasNext: Boolean['output']
    readonly cursor: ID['output'] | null
    readonly totalCount: Int['output']
    readonly integrationRequests: ReadonlyArray<{
      readonly __typename: 'IntegrationRequest'
      readonly id: ID['output']
      readonly integrationType: IntegrationType | null
      readonly request: JSONObject['output']
      readonly response: JSONObject['output'] | null
      readonly startedAt: DateTime['output']
      readonly endedAt: DateTime['output']
      readonly companyIntegration: {
        readonly __typename: 'CompanyIntegration'
        readonly id: ID['output']
      } | null
    }>
  }
}

export type CloudLoggingLogsQueryVariables = Exact<{
  input: CloudLoggingLogsInput
}>

export type CloudLoggingLogsQuery = {
  readonly __typename: 'Query'
  readonly cloudLoggingLogs: {
    readonly __typename: 'CloudLoggingLogsResponse'
    readonly entries: ReadonlyArray<JSONObject['output']>
    readonly nextPageToken: String['output'] | null
  }
}

export type SetLegalDocumentSyncedMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type SetLegalDocumentSyncedMutation = {
  readonly __typename: 'Mutation'
  readonly setLegalDocumentSynced: {
    readonly __typename: 'LegalRequirement'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly name: String['output']
    readonly timeZone: String['output']
    readonly expirationFrequency: DocumentExpirationFrequency
    readonly startDate: DateTime['output'] | null
    readonly endDate: DateTime['output'] | null
    readonly isVendorRequirement: Boolean['output']
    readonly documents: ReadonlyArray<{
      readonly __typename: 'LegalDocument'
      readonly id: ID['output']
      readonly name: String['output']
      readonly periodStart: DateTime['output'] | null
      readonly periodEnd: DateTime['output'] | null
      readonly lastSyncIfSuccessful: {
        readonly __typename: 'WriteSyncOperation'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
      } | null
    }>
    readonly formTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
  }
}

export type GetLegalRequirementQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetLegalRequirementQuery = {
  readonly __typename: 'Query'
  readonly legalRequirement: {
    readonly __typename: 'LegalRequirement'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly name: String['output']
    readonly timeZone: String['output']
    readonly expirationFrequency: DocumentExpirationFrequency
    readonly startDate: DateTime['output'] | null
    readonly endDate: DateTime['output'] | null
    readonly isVendorRequirement: Boolean['output']
    readonly documents: ReadonlyArray<{
      readonly __typename: 'LegalDocument'
      readonly id: ID['output']
      readonly name: String['output']
      readonly periodStart: DateTime['output'] | null
      readonly periodEnd: DateTime['output'] | null
      readonly lastSyncIfSuccessful: {
        readonly __typename: 'WriteSyncOperation'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
      } | null
    }>
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly integrations: ReadonlyArray<{
        readonly __typename: 'Integration'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly type: IntegrationType
        readonly credentialsUpdatedAt: DateTime['output'] | null
        readonly mappings: JSONObject['output']
        readonly isActive: Boolean['output']
        readonly shortName: String['output']
        readonly longName: String['output']
        readonly companyIntegration: {
          readonly __typename: 'CompanyIntegration'
          readonly id: ID['output']
        }
      }>
    }
    readonly formTemplate: {
      readonly __typename: 'FormTemplate'
      readonly id: String['output']
    } | null
  }
}

export type StateLienRequirementsSummaryQueryVariables = Exact<{
  input: StateLienRequirementsSummaryInput
}>

export type StateLienRequirementsSummaryQuery = {
  readonly __typename: 'Query'
  readonly stateLienRequirementsSummary: {
    readonly __typename: 'StateLienRequirementsSummary'
    readonly id: ID['output']
    readonly state: String['output']
    readonly updatedAt: DateTime['output']
    readonly preliminaryNoticeName: String['output'] | null
    readonly preliminaryNoticeDeadlineInterval: SafeInt['output'] | null
    readonly preliminaryNoticeDeadlineGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeDeadlineModifier: LienRightsDeadlineModifier | null
    readonly preliminaryNoticeDeadlineAnchor: LienRightsDeadlineAnchor | null
    readonly preliminaryNoticeContingentOn: String['output'] | null
    readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
    readonly preliminaryNoticeAdditionalNotes: String['output'] | null
    readonly preliminaryNoticeLateFilingInterval: SafeInt['output'] | null
    readonly preliminaryNoticeLateFilingGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeLateFilingModifier: LienRightsDeadlineModifier | null
    readonly preLienName: String['output'] | null
    readonly preLienInterval: SafeInt['output'] | null
    readonly preLienIntervalGranularity: LienRightsDeadlineGranularity | null
    readonly preLienModifier: LienRightsDeadlineModifier | null
    readonly preLienAnchor: LienRightsDeadlineAnchor | null
    readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
    readonly lienDeadlineInterval: SafeInt['output']
    readonly lienDeadlineModifier: LienRightsDeadlineModifier
    readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
    readonly lienEnforcementInterval: SafeInt['output']
    readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
    readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
    readonly lienAdditionalNotes: String['output'] | null
    readonly citations: ReadonlyArray<String['output']>
    readonly lienDeadlineNoticeRequirements: ReadonlyArray<{
      readonly __typename: 'LienDeadlineNoticeRequirement'
      readonly id: ID['output']
      readonly documentName: String['output']
      readonly newDeadlines: ReadonlyArray<{
        readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
        readonly type: LienDeadlineNoticeRequirementType
        readonly interval: SafeInt['output']
        readonly granularity: LienRightsDeadlineGranularity
        readonly modifier: LienRightsDeadlineModifier
        readonly anchor: LienRightsDeadlineAnchor
      }>
    }>
  } | null
}

export type UpdateStateLienRequirementsSummaryMutationVariables = Exact<{
  input: UpdateStateLienRequirementsSummaryInput
}>

export type UpdateStateLienRequirementsSummaryMutation = {
  readonly __typename: 'Mutation'
  readonly updateStateLienRequirementsSummary: {
    readonly __typename: 'StateLienRequirementsSummary'
    readonly id: ID['output']
    readonly state: String['output']
    readonly updatedAt: DateTime['output']
    readonly preliminaryNoticeName: String['output'] | null
    readonly preliminaryNoticeDeadlineInterval: SafeInt['output'] | null
    readonly preliminaryNoticeDeadlineGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeDeadlineModifier: LienRightsDeadlineModifier | null
    readonly preliminaryNoticeDeadlineAnchor: LienRightsDeadlineAnchor | null
    readonly preliminaryNoticeContingentOn: String['output'] | null
    readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
    readonly preliminaryNoticeAdditionalNotes: String['output'] | null
    readonly preliminaryNoticeLateFilingInterval: SafeInt['output'] | null
    readonly preliminaryNoticeLateFilingGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeLateFilingModifier: LienRightsDeadlineModifier | null
    readonly preLienName: String['output'] | null
    readonly preLienInterval: SafeInt['output'] | null
    readonly preLienIntervalGranularity: LienRightsDeadlineGranularity | null
    readonly preLienModifier: LienRightsDeadlineModifier | null
    readonly preLienAnchor: LienRightsDeadlineAnchor | null
    readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
    readonly lienDeadlineInterval: SafeInt['output']
    readonly lienDeadlineModifier: LienRightsDeadlineModifier
    readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
    readonly lienEnforcementInterval: SafeInt['output']
    readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
    readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
    readonly lienAdditionalNotes: String['output'] | null
    readonly citations: ReadonlyArray<String['output']>
    readonly lienDeadlineNoticeRequirements: ReadonlyArray<{
      readonly __typename: 'LienDeadlineNoticeRequirement'
      readonly id: ID['output']
      readonly documentName: String['output']
      readonly newDeadlines: ReadonlyArray<{
        readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
        readonly type: LienDeadlineNoticeRequirementType
        readonly interval: SafeInt['output']
        readonly granularity: LienRightsDeadlineGranularity
        readonly modifier: LienRightsDeadlineModifier
        readonly anchor: LienRightsDeadlineAnchor
      }>
    }>
  }
}

export type StateLienRequirementsSummariesQueryVariables = Exact<{ [key: string]: never }>

export type StateLienRequirementsSummariesQuery = {
  readonly __typename: 'Query'
  readonly stateLienRequirementsSummaries: ReadonlyArray<{
    readonly __typename: 'StateLienRequirementsSummary'
    readonly id: ID['output']
    readonly state: String['output']
    readonly updatedAt: DateTime['output']
    readonly preliminaryNoticeName: String['output'] | null
    readonly preliminaryNoticeDeadlineInterval: SafeInt['output'] | null
    readonly preliminaryNoticeDeadlineGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeDeadlineModifier: LienRightsDeadlineModifier | null
    readonly preliminaryNoticeDeadlineAnchor: LienRightsDeadlineAnchor | null
    readonly preliminaryNoticeContingentOn: String['output'] | null
    readonly preliminaryNoticeRequirementType: LienMilestoneRequirementType
    readonly preliminaryNoticeAdditionalNotes: String['output'] | null
    readonly preliminaryNoticeLateFilingInterval: SafeInt['output'] | null
    readonly preliminaryNoticeLateFilingGranularity: LienRightsDeadlineGranularity | null
    readonly preliminaryNoticeLateFilingModifier: LienRightsDeadlineModifier | null
    readonly preLienName: String['output'] | null
    readonly preLienInterval: SafeInt['output'] | null
    readonly preLienIntervalGranularity: LienRightsDeadlineGranularity | null
    readonly preLienModifier: LienRightsDeadlineModifier | null
    readonly preLienAnchor: LienRightsDeadlineAnchor | null
    readonly lienDeadlineGranularity: LienRightsDeadlineGranularity
    readonly lienDeadlineInterval: SafeInt['output']
    readonly lienDeadlineModifier: LienRightsDeadlineModifier
    readonly lienDeadlineAnchor: LienRightsDeadlineAnchor
    readonly lienEnforcementInterval: SafeInt['output']
    readonly lienEnforcementGranularity: LienRightsDeadlineGranularity
    readonly lienEnforcementAnchor: LienRightsDeadlineAnchor
    readonly lienAdditionalNotes: String['output'] | null
    readonly citations: ReadonlyArray<String['output']>
    readonly lienDeadlineNoticeRequirements: ReadonlyArray<{
      readonly __typename: 'LienDeadlineNoticeRequirement'
      readonly id: ID['output']
      readonly documentName: String['output']
      readonly newDeadlines: ReadonlyArray<{
        readonly __typename: 'LienDeadlineNoticeRequirementNewDeadline'
        readonly type: LienDeadlineNoticeRequirementType
        readonly interval: SafeInt['output']
        readonly granularity: LienRightsDeadlineGranularity
        readonly modifier: LienRightsDeadlineModifier
        readonly anchor: LienRightsDeadlineAnchor
      }>
    }>
  }>
}

export type GetPayAppForDetailsQueryVariables = Exact<{
  payAppId: Scalars['ID']['input']
}>

export type GetPayAppForDetailsQuery = {
  readonly __typename: 'Query'
  readonly payApp: {
    readonly __typename: 'PayApp'
    readonly hasPinnedTemplates: Boolean['output']
    readonly billingType: BillingType
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly formTemplates: ReadonlyArray<{
      readonly __typename: 'PinnedPayAppTemplate'
      readonly order: Int['output']
      readonly formTemplateVersion: {
        readonly __typename: 'FormTemplateVersion'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly updatedAt: DateTime['output']
        readonly versionNumber: Int['output']
        readonly isReadyForManualStoredMaterials: Boolean['output']
        readonly formTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
          readonly userVisibleName: String['output']
        }
        readonly file: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly type: StoredFileType
          readonly url: URL['output']
          readonly name: String['output']
        }
        readonly annotations: ReadonlyArray<{
          readonly __typename: 'FormTemplateAnnotation'
          readonly id: ID['output']
          readonly permanentId: ID['output']
          readonly syncTag: String['output'] | null
          readonly userVisibleName: String['output']
          readonly type: FormTemplateAnnotationType
          readonly xStart: Float['output']
          readonly yStart: Float['output']
          readonly width: Float['output']
          readonly height: Float['output']
          readonly pageNumber: Int['output']
          readonly fontFamily: FormTemplateFont
          readonly fontColor: String['output']
          readonly textAlignment: TextAlignment
          readonly wrapText: Boolean['output']
          readonly isOptional: Boolean['output']
          readonly selectedKey: String['output'] | null
          readonly defaultValueKey: String['output'] | null
          readonly prefix: String['output'] | null
          readonly suffix: String['output'] | null
          readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
          readonly doNotRetainOnReset: Boolean['output']
          readonly dynamicFieldTag: String['output'] | null
          readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
          readonly imageType: FormTemplateAnnotationImageType | null
          readonly signatureType: SignatureAnnotationType | null
          readonly isFromAiSuggestion: Boolean['output']
        }>
        readonly currentSuggestionsRun: {
          readonly __typename: 'FormTemplateSuggestionsRun'
          readonly id: ID['output']
          readonly phase: FormTemplateSuggestionsRunPhase
          readonly error: String['output'] | null
        } | null
      }
    }>
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly role: CompanyProjectRole
      readonly status: ContractStatus
      readonly timeZone: String['output']
      readonly contractDate: DateTime['output'] | null
      readonly contractNumber: String['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly defaultRetentionPercent: Float['output'] | null
      readonly retentionTrackingLevel: RetentionTrackingLevel
      readonly daysBeforePayAppDue: Int['output']
      readonly billingType: BillingType
      readonly contractTemplateVariables: JSONObject['output']
      readonly internalProjectNumber: String['output'] | null
      readonly vendorNumber: String['output'] | null
      readonly pastPayAppCount: Int['output']
      readonly roundRetention: Boolean['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
        readonly projectNumber: String['output']
        readonly gcName: String['output'] | null
        readonly location: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly gcAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
        readonly ownerEntity: {
          readonly __typename: 'Owner'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly ownerAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
      }
      readonly sov: {
        readonly __typename: 'Sov'
        readonly id: ID['output']
        readonly totalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly totalRetention: SafeInt['output']
        readonly contract: {
          readonly __typename: 'Contract'
          readonly id: ID['output']
          readonly timeZone: String['output']
        }
        readonly lineItems: ReadonlyArray<{
          readonly __typename: 'SovLineItem'
          readonly id: ID['output']
          readonly code: String['output']
          readonly sortOrder: SafeInt['output']
          readonly name: String['output']
          readonly isChangeOrder: Boolean['output']
          readonly changeOrderApprovedDate: DateTime['output'] | null
          readonly latestTotalValue: SafeInt['output']
          readonly totalBilled: SafeInt['output']
          readonly previousBilled: SafeInt['output']
          readonly previousStoredMaterials: SafeInt['output']
          readonly retentionHeldTotal: SafeInt['output']
          readonly progressComplete: Float['output']
          readonly defaultRetentionPercent: Float['output'] | null
          readonly sovLineItemGroup: {
            readonly __typename: 'SovLineItemGroup'
            readonly id: ID['output']
            readonly name: String['output']
            readonly code: String['output'] | null
          } | null
        }>
      } | null
      readonly lienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly lowerTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly subTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
      readonly legalRequirements: ReadonlyArray<{
        readonly __typename: 'LegalRequirement'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly name: String['output']
        readonly timeZone: String['output']
        readonly expirationFrequency: DocumentExpirationFrequency
        readonly startDate: DateTime['output'] | null
        readonly endDate: DateTime['output'] | null
        readonly isVendorRequirement: Boolean['output']
        readonly documents: ReadonlyArray<{
          readonly __typename: 'LegalDocument'
          readonly id: ID['output']
        }>
        readonly formTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
      }>
      readonly selectedAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly changeOrderRequestTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly changeOrderLogTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly integrations: ReadonlyArray<{
        readonly __typename: 'Integration'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly type: IntegrationType
        readonly credentialsUpdatedAt: DateTime['output'] | null
        readonly mappings: JSONObject['output']
        readonly isActive: Boolean['output']
        readonly shortName: String['output']
        readonly longName: String['output']
        readonly companyIntegration: {
          readonly __typename: 'CompanyIntegration'
          readonly id: ID['output']
        }
      }>
      readonly onboardedStatus: {
        readonly __typename: 'OnboardedProjectContractStatus'
        readonly selectedPayAppForms: Boolean['output']
        readonly onboardedPayAppForms: Boolean['output']
        readonly selectedPrimaryLienWaivers: Boolean['output']
        readonly onboardedPrimaryLienWaiverForms: Boolean['output']
        readonly selectedVendorLienWaivers: Boolean['output']
        readonly onboardedVendorLienWaiverForms: Boolean['output']
        readonly selectedChangeOrderRequestForms: Boolean['output']
        readonly onboardedChangeOrderRequestForms: Boolean['output']
        readonly selectedChangeOrderLogForms: Boolean['output']
        readonly onboardedChangeOrderLogForms: Boolean['output']
        readonly addedSov: Boolean['output']
        readonly selectedRateTable: Boolean['output']
        readonly addedTeammates: Boolean['output']
        readonly addedGcContacts: Boolean['output']
        readonly startedBilling: Boolean['output']
        readonly notifiedOnboardedForms: Boolean['output']
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type ResetPayAppMutationVariables = Exact<{
  payAppId: Scalars['ID']['input']
}>

export type ResetPayAppMutation = {
  readonly __typename: 'Mutation'
  readonly resetPayApp: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type ClearPayAppEventsMutationVariables = Exact<{
  payAppId: Scalars['ID']['input']
}>

export type ClearPayAppEventsMutation = {
  readonly __typename: 'Mutation'
  readonly clearPayAppEvents: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type RetractPayAppMutationVariables = Exact<{
  payAppId: Scalars['ID']['input']
}>

export type RetractPayAppMutation = {
  readonly __typename: 'Mutation'
  readonly retractPayApp: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type SetPayAppSyncedMutationVariables = Exact<{
  input: SetPayAppSyncedInput
}>

export type SetPayAppSyncedMutation = {
  readonly __typename: 'Mutation'
  readonly setPayAppSynced: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type DeletePayAppMutationVariables = Exact<{
  payAppId: Scalars['ID']['input']
}>

export type DeletePayAppMutation = {
  readonly __typename: 'Mutation'
  readonly deletePayApp: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type SetPayAppProposedMutationVariables = Exact<{
  input: SetPayAppProposedInput
}>

export type SetPayAppProposedMutation = {
  readonly __typename: 'Mutation'
  readonly setPayAppProposed: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type UpdatePayAppMutationVariables = Exact<{
  input: UpdatePayAppInput
}>

export type UpdatePayAppMutation = {
  readonly __typename: 'Mutation'
  readonly updatePayApp: {
    readonly __typename: 'PayApp'
    readonly id: ID['output']
    readonly createdAt: DateTime['output']
    readonly timeZone: String['output']
    readonly status: PayAppStatus
    readonly retentionOnly: Boolean['output']
    readonly billingStart: DateTime['output']
    readonly billingEnd: DateTime['output']
    readonly payAppDueDate: DateTime['output']
    readonly currentBilled: SafeInt['output']
    readonly retentionHeldCurrent: SafeInt['output']
    readonly retentionHeldToDate: SafeInt['output']
    readonly retentionReleasedCurrent: SafeInt['output']
    readonly contract: {
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
        readonly projectNumber: String['output']
        readonly gcName: String['output'] | null
        readonly location: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly gcAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
        readonly ownerEntity: {
          readonly __typename: 'Owner'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly ownerAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
      }
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }
    readonly progress: ReadonlyArray<{
      readonly __typename: 'SovLineItemProgress'
      readonly id: ID['output']
      readonly currentBilled: SafeInt['output']
      readonly progressBilled: SafeInt['output']
      readonly retentionHeldCurrent: SafeInt['output']
      readonly previousBilled: SafeInt['output']
      readonly storedMaterialBilled: SafeInt['output']
      readonly previousRetention: SafeInt['output']
      readonly retentionReleasedCurrent: SafeInt['output']
      readonly totalValue: SafeInt['output']
      readonly sovLineItem: {
        readonly __typename: 'SovLineItem'
        readonly id: ID['output']
        readonly code: String['output']
        readonly sortOrder: SafeInt['output']
        readonly name: String['output']
        readonly isChangeOrder: Boolean['output']
        readonly changeOrderApprovedDate: DateTime['output'] | null
        readonly latestTotalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly previousBilled: SafeInt['output']
        readonly previousStoredMaterials: SafeInt['output']
        readonly retentionHeldTotal: SafeInt['output']
        readonly progressComplete: Float['output']
        readonly defaultRetentionPercent: Float['output'] | null
        readonly sovLineItemGroup: {
          readonly __typename: 'SovLineItemGroup'
          readonly id: ID['output']
          readonly name: String['output']
          readonly code: String['output'] | null
        } | null
      }
    }>
    readonly amountLineItems: ReadonlyArray<{
      readonly __typename: 'AmountLineItem'
      readonly id: ID['output']
      readonly description: String['output']
      readonly amount: SafeInt['output']
      readonly sortOrder: SafeInt['output']
    }>
  }
}

export type CompanyIntegrationForPeyoteDebuggerQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyIntegrationForPeyoteDebuggerQuery = {
  readonly __typename: 'Query'
  readonly companyIntegration: {
    readonly __typename: 'CompanyIntegration'
    readonly id: ID['output']
    readonly type: IntegrationType
  }
}

export type IntegrationCredentialQueryVariables = Exact<{
  input: IntegrationCredentialInput
}>

export type IntegrationCredentialQuery = {
  readonly __typename: 'Query'
  readonly integrationCredential: JSONObject['output']
}

export type PeyoteCheckNetworkConnectionMutationVariables = Exact<{
  input: PeyoteCheckNetworkConnectionInput
}>

export type PeyoteCheckNetworkConnectionMutation = {
  readonly __typename: 'Mutation'
  readonly peyoteCheckNetworkConnection: {
    readonly __typename: 'PeyoteSqlDebuggerResult'
    readonly status: PeyoteSqlDebuggerStatus
    readonly message: String['output']
    readonly context: JSONObject['output']
  }
}

export type PeyoteCheckUsernamePasswordMutationVariables = Exact<{
  input: PeyoteCheckUsernamePasswordInput
}>

export type PeyoteCheckUsernamePasswordMutation = {
  readonly __typename: 'Mutation'
  readonly peyoteCheckUsernamePassword: {
    readonly __typename: 'PeyoteSqlDebuggerResult'
    readonly status: PeyoteSqlDebuggerStatus
    readonly message: String['output']
    readonly context: JSONObject['output']
  }
}

export type PeyoteCheckDatabasePermissionsMutationVariables = Exact<{
  input: PeyoteCheckDatabasePermissionsInput
}>

export type PeyoteCheckDatabasePermissionsMutation = {
  readonly __typename: 'Mutation'
  readonly peyoteCheckDatabasePermissions: {
    readonly __typename: 'PeyoteSqlDebuggerResult'
    readonly status: PeyoteSqlDebuggerStatus
    readonly message: String['output']
    readonly context: JSONObject['output']
  }
}

export type ContractsForProcessingQueryVariables = Exact<{
  input: GetPaginatedContractsInput
}>

export type ContractsForProcessingQuery = {
  readonly __typename: 'Query'
  readonly paginatedContracts: {
    readonly __typename: 'PaginatedContractList'
    readonly hasNext: Boolean['output']
    readonly cursor: ID['output'] | null
    readonly totalCount: Int['output']
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly internalProjectNumber: String['output'] | null
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly projectNumber: String['output']
        readonly name: String['output']
      }
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }
      readonly onboardedStatus: {
        readonly __typename: 'OnboardedProjectContractStatus'
        readonly selectedPayAppForms: Boolean['output']
        readonly onboardedPayAppForms: Boolean['output']
        readonly selectedPrimaryLienWaivers: Boolean['output']
        readonly onboardedPrimaryLienWaiverForms: Boolean['output']
        readonly selectedVendorLienWaivers: Boolean['output']
        readonly onboardedVendorLienWaiverForms: Boolean['output']
        readonly selectedChangeOrderRequestForms: Boolean['output']
        readonly onboardedChangeOrderRequestForms: Boolean['output']
        readonly selectedChangeOrderLogForms: Boolean['output']
        readonly onboardedChangeOrderLogForms: Boolean['output']
      }
    }>
  }
}

export type GetProjectForDetailsQueryVariables = Exact<{
  projectId: Scalars['ID']['input']
}>

export type GetProjectForDetailsQuery = {
  readonly __typename: 'Query'
  readonly project: {
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly projectNumber: String['output']
    readonly gcName: String['output'] | null
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly ownerEntity: {
      readonly __typename: 'Owner'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly ownerAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly gcAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly architect: {
      readonly __typename: 'CompanyProjectMetadata'
      readonly role: CompanyProjectRole
      readonly companyName: String['output'] | null
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
      readonly selectedAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    } | null
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly role: CompanyProjectRole
      readonly status: ContractStatus
      readonly timeZone: String['output']
      readonly contractDate: DateTime['output'] | null
      readonly contractNumber: String['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly defaultRetentionPercent: Float['output'] | null
      readonly retentionTrackingLevel: RetentionTrackingLevel
      readonly daysBeforePayAppDue: Int['output']
      readonly billingType: BillingType
      readonly contractTemplateVariables: JSONObject['output']
      readonly internalProjectNumber: String['output'] | null
      readonly vendorNumber: String['output'] | null
      readonly pastPayAppCount: Int['output']
      readonly roundRetention: Boolean['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly users: ReadonlyArray<{
          readonly __typename: 'CompanyUser'
          readonly id: ID['output']
          readonly role: CompanyUserRole
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
            readonly jobTitle: String['output'] | null
            readonly phoneNumber: PhoneNumber['output'] | null
            readonly companies: ReadonlyArray<{
              readonly __typename: 'Company'
              readonly id: ID['output']
              readonly name: String['output']
            }>
          }
        }>
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
      readonly users: ReadonlyArray<{
        readonly __typename: 'ContractUser'
        readonly id: ID['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
          readonly jobTitle: String['output'] | null
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly companies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }
      }>
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
        readonly projectNumber: String['output']
        readonly gcName: String['output'] | null
        readonly location: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly gcAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
        readonly ownerEntity: {
          readonly __typename: 'Owner'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly ownerAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
      }
      readonly sov: {
        readonly __typename: 'Sov'
        readonly id: ID['output']
        readonly totalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly totalRetention: SafeInt['output']
        readonly contract: {
          readonly __typename: 'Contract'
          readonly id: ID['output']
          readonly timeZone: String['output']
        }
        readonly lineItems: ReadonlyArray<{
          readonly __typename: 'SovLineItem'
          readonly id: ID['output']
          readonly code: String['output']
          readonly sortOrder: SafeInt['output']
          readonly name: String['output']
          readonly isChangeOrder: Boolean['output']
          readonly changeOrderApprovedDate: DateTime['output'] | null
          readonly latestTotalValue: SafeInt['output']
          readonly totalBilled: SafeInt['output']
          readonly previousBilled: SafeInt['output']
          readonly previousStoredMaterials: SafeInt['output']
          readonly retentionHeldTotal: SafeInt['output']
          readonly progressComplete: Float['output']
          readonly defaultRetentionPercent: Float['output'] | null
          readonly sovLineItemGroup: {
            readonly __typename: 'SovLineItemGroup'
            readonly id: ID['output']
            readonly name: String['output']
            readonly code: String['output'] | null
          } | null
        }>
      } | null
      readonly lienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly lowerTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly subTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
      readonly legalRequirements: ReadonlyArray<{
        readonly __typename: 'LegalRequirement'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly name: String['output']
        readonly timeZone: String['output']
        readonly expirationFrequency: DocumentExpirationFrequency
        readonly startDate: DateTime['output'] | null
        readonly endDate: DateTime['output'] | null
        readonly isVendorRequirement: Boolean['output']
        readonly documents: ReadonlyArray<{
          readonly __typename: 'LegalDocument'
          readonly id: ID['output']
        }>
        readonly formTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
      }>
      readonly selectedAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly changeOrderRequestTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly changeOrderLogTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly integrations: ReadonlyArray<{
        readonly __typename: 'Integration'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly type: IntegrationType
        readonly credentialsUpdatedAt: DateTime['output'] | null
        readonly mappings: JSONObject['output']
        readonly isActive: Boolean['output']
        readonly shortName: String['output']
        readonly longName: String['output']
        readonly companyIntegration: {
          readonly __typename: 'CompanyIntegration'
          readonly id: ID['output']
        }
      }>
      readonly onboardedStatus: {
        readonly __typename: 'OnboardedProjectContractStatus'
        readonly selectedPayAppForms: Boolean['output']
        readonly onboardedPayAppForms: Boolean['output']
        readonly selectedPrimaryLienWaivers: Boolean['output']
        readonly onboardedPrimaryLienWaiverForms: Boolean['output']
        readonly selectedVendorLienWaivers: Boolean['output']
        readonly onboardedVendorLienWaiverForms: Boolean['output']
        readonly selectedChangeOrderRequestForms: Boolean['output']
        readonly onboardedChangeOrderRequestForms: Boolean['output']
        readonly selectedChangeOrderLogForms: Boolean['output']
        readonly onboardedChangeOrderLogForms: Boolean['output']
        readonly addedSov: Boolean['output']
        readonly selectedRateTable: Boolean['output']
        readonly addedTeammates: Boolean['output']
        readonly addedGcContacts: Boolean['output']
        readonly startedBilling: Boolean['output']
        readonly notifiedOnboardedForms: Boolean['output']
      }
    }>
    readonly metadata: {
      readonly __typename: 'ProjectMetadata'
      readonly payAppDueOnDayOfMonth: Int['output']
    }
  }
}

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput
}>

export type UpdateProjectMutation = {
  readonly __typename: 'Mutation'
  readonly updateProject: {
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly projectNumber: String['output']
    readonly gcName: String['output'] | null
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly ownerEntity: {
      readonly __typename: 'Owner'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly ownerAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly gcAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly architect: {
      readonly __typename: 'CompanyProjectMetadata'
      readonly role: CompanyProjectRole
      readonly companyName: String['output'] | null
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
      readonly selectedAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      } | null
    } | null
    readonly contracts: ReadonlyArray<{
      readonly __typename: 'Contract'
      readonly id: ID['output']
      readonly role: CompanyProjectRole
      readonly status: ContractStatus
      readonly timeZone: String['output']
      readonly contractDate: DateTime['output'] | null
      readonly contractNumber: String['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly defaultRetentionPercent: Float['output'] | null
      readonly retentionTrackingLevel: RetentionTrackingLevel
      readonly daysBeforePayAppDue: Int['output']
      readonly billingType: BillingType
      readonly contractTemplateVariables: JSONObject['output']
      readonly internalProjectNumber: String['output'] | null
      readonly vendorNumber: String['output'] | null
      readonly pastPayAppCount: Int['output']
      readonly roundRetention: Boolean['output']
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly users: ReadonlyArray<{
          readonly __typename: 'CompanyUser'
          readonly id: ID['output']
          readonly role: CompanyUserRole
          readonly user: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly firstName: String['output']
            readonly lastName: String['output']
            readonly email: EmailAddress['output']
            readonly jobTitle: String['output'] | null
            readonly phoneNumber: PhoneNumber['output'] | null
            readonly companies: ReadonlyArray<{
              readonly __typename: 'Company'
              readonly id: ID['output']
              readonly name: String['output']
            }>
          }
        }>
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
      readonly users: ReadonlyArray<{
        readonly __typename: 'ContractUser'
        readonly id: ID['output']
        readonly user: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly firstName: String['output']
          readonly lastName: String['output']
          readonly email: EmailAddress['output']
          readonly jobTitle: String['output'] | null
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly companies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }
      }>
      readonly project: {
        readonly __typename: 'Project'
        readonly id: ID['output']
        readonly name: String['output']
        readonly projectNumber: String['output']
        readonly gcName: String['output'] | null
        readonly location: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }
        readonly gc: {
          readonly __typename: 'GeneralContractor'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly gcAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
        readonly ownerEntity: {
          readonly __typename: 'Owner'
          readonly id: ID['output']
          readonly name: String['output']
        } | null
        readonly ownerAddress: {
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        } | null
      }
      readonly sov: {
        readonly __typename: 'Sov'
        readonly id: ID['output']
        readonly totalValue: SafeInt['output']
        readonly totalBilled: SafeInt['output']
        readonly totalRetention: SafeInt['output']
        readonly contract: {
          readonly __typename: 'Contract'
          readonly id: ID['output']
          readonly timeZone: String['output']
        }
        readonly lineItems: ReadonlyArray<{
          readonly __typename: 'SovLineItem'
          readonly id: ID['output']
          readonly code: String['output']
          readonly sortOrder: SafeInt['output']
          readonly name: String['output']
          readonly isChangeOrder: Boolean['output']
          readonly changeOrderApprovedDate: DateTime['output'] | null
          readonly latestTotalValue: SafeInt['output']
          readonly totalBilled: SafeInt['output']
          readonly previousBilled: SafeInt['output']
          readonly previousStoredMaterials: SafeInt['output']
          readonly retentionHeldTotal: SafeInt['output']
          readonly progressComplete: Float['output']
          readonly defaultRetentionPercent: Float['output'] | null
          readonly sovLineItemGroup: {
            readonly __typename: 'SovLineItemGroup'
            readonly id: ID['output']
            readonly name: String['output']
            readonly code: String['output'] | null
          } | null
        }>
      } | null
      readonly lienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly lowerTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly subTierLienWaiverTemplates: {
        readonly __typename: 'SubcontractorLienWaiverTemplateSet'
        readonly id: ID['output']
        readonly conditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly conditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalFinalVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
        readonly unconditionalProgressVariant: {
          readonly __typename: 'FormTemplateVariant'
          readonly id: ID['output']
          readonly template: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
            readonly createdAt: DateTime['output']
            readonly type: FormTemplateType
            readonly status: FormTemplateStatus
            readonly skippedValidation: Boolean['output']
            readonly userVisibleName: String['output']
            readonly isCustomerReady: Boolean['output']
            readonly tags: ReadonlyArray<FormTemplateTag>
            readonly dueDate: DateTime['output'] | null
            readonly statusLogs: ReadonlyArray<{
              readonly __typename: 'FormTemplateStatusLog'
              readonly id: ID['output']
              readonly statusUpdatedAt: DateTime['output']
              readonly status: FormTemplateStatus
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly associatedCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly requestingCompany: {
              readonly __typename: 'Company'
              readonly id: ID['output']
            } | null
            readonly associatedContracts: ReadonlyArray<{
              readonly __typename: 'FormTemplateAssociatedContract'
              readonly id: String['output']
              readonly providedAsFormType: ProjectOnboardingFormType | null
              readonly contract: { readonly __typename: 'Contract'; readonly id: ID['output'] }
            }>
            readonly owner: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly builder: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            }
            readonly validator: {
              readonly __typename: 'User'
              readonly id: ID['output']
              readonly email: EmailAddress['output']
              readonly firstName: String['output']
              readonly lastName: String['output']
            } | null
            readonly versions: ReadonlyArray<{
              readonly __typename: 'FormTemplateVersion'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly updatedAt: DateTime['output']
              readonly versionNumber: Int['output']
              readonly isReadyForManualStoredMaterials: Boolean['output']
              readonly file: {
                readonly __typename: 'StoredFile'
                readonly id: ID['output']
                readonly type: StoredFileType
                readonly url: URL['output']
                readonly name: String['output']
              }
              readonly annotations: ReadonlyArray<{
                readonly __typename: 'FormTemplateAnnotation'
                readonly id: ID['output']
                readonly permanentId: ID['output']
                readonly syncTag: String['output'] | null
                readonly userVisibleName: String['output']
                readonly type: FormTemplateAnnotationType
                readonly xStart: Float['output']
                readonly yStart: Float['output']
                readonly width: Float['output']
                readonly height: Float['output']
                readonly pageNumber: Int['output']
                readonly fontFamily: FormTemplateFont
                readonly fontColor: String['output']
                readonly textAlignment: TextAlignment
                readonly wrapText: Boolean['output']
                readonly isOptional: Boolean['output']
                readonly selectedKey: String['output'] | null
                readonly defaultValueKey: String['output'] | null
                readonly prefix: String['output'] | null
                readonly suffix: String['output'] | null
                readonly fieldType: FormTemplateAnnotationMetadataFieldType | null
                readonly doNotRetainOnReset: Boolean['output']
                readonly dynamicFieldTag: String['output'] | null
                readonly copyDefaultValueFromPreviousAnnotationValue: Boolean['output']
                readonly imageType: FormTemplateAnnotationImageType | null
                readonly signatureType: SignatureAnnotationType | null
                readonly isFromAiSuggestion: Boolean['output']
              }>
              readonly currentSuggestionsRun: {
                readonly __typename: 'FormTemplateSuggestionsRun'
                readonly id: ID['output']
                readonly phase: FormTemplateSuggestionsRunPhase
                readonly error: String['output'] | null
              } | null
            }>
            readonly variants: ReadonlyArray<{
              readonly __typename: 'FormTemplateVariant'
              readonly id: ID['output']
              readonly internalName: String['output']
              readonly isDefaultVariant: Boolean['output']
            }>
            readonly comments: ReadonlyArray<{
              readonly __typename: 'FormTemplateComment'
              readonly id: ID['output']
              readonly createdAt: DateTime['output']
              readonly message: String['output']
              readonly isSystemGenerated: Boolean['output']
              readonly user: {
                readonly __typename: 'User'
                readonly id: ID['output']
                readonly firstName: String['output']
                readonly lastName: String['output']
                readonly email: EmailAddress['output']
              }
            }>
            readonly originalFile: {
              readonly __typename: 'StoredFile'
              readonly id: ID['output']
              readonly type: StoredFileType
              readonly url: URL['output']
              readonly name: String['output']
            } | null
            readonly duplicateTemplate: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly userVisibleName: String['output']
            } | null
          }
        } | null
      } | null
      readonly payAppRequirementGroups: ReadonlyArray<{
        readonly __typename: 'PayAppRequirementGroup'
        readonly id: ID['output']
        readonly order: Int['output']
        readonly payAppRequirements: ReadonlyArray<{
          readonly __typename: 'PayAppRequirement'
          readonly id: ID['output']
          readonly groupOrder: Int['output']
          readonly conditions: ReadonlyArray<PayAppRequirementCondition>
          readonly templateVariant: {
            readonly __typename: 'FormTemplateVariant'
            readonly id: ID['output']
            readonly internalName: String['output']
            readonly userVisibleName: String['output'] | null
            readonly template: {
              readonly __typename: 'FormTemplate'
              readonly id: String['output']
              readonly isCustomerReady: Boolean['output']
            }
          } | null
        }>
      }>
      readonly legalRequirements: ReadonlyArray<{
        readonly __typename: 'LegalRequirement'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly name: String['output']
        readonly timeZone: String['output']
        readonly expirationFrequency: DocumentExpirationFrequency
        readonly startDate: DateTime['output'] | null
        readonly endDate: DateTime['output'] | null
        readonly isVendorRequirement: Boolean['output']
        readonly documents: ReadonlyArray<{
          readonly __typename: 'LegalDocument'
          readonly id: ID['output']
        }>
        readonly formTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
      }>
      readonly selectedAddress: {
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }
      readonly changeOrderRequestTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly changeOrderLogTemplates: ReadonlyArray<{
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      }>
      readonly integrations: ReadonlyArray<{
        readonly __typename: 'Integration'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly type: IntegrationType
        readonly credentialsUpdatedAt: DateTime['output'] | null
        readonly mappings: JSONObject['output']
        readonly isActive: Boolean['output']
        readonly shortName: String['output']
        readonly longName: String['output']
        readonly companyIntegration: {
          readonly __typename: 'CompanyIntegration'
          readonly id: ID['output']
        }
      }>
      readonly onboardedStatus: {
        readonly __typename: 'OnboardedProjectContractStatus'
        readonly selectedPayAppForms: Boolean['output']
        readonly onboardedPayAppForms: Boolean['output']
        readonly selectedPrimaryLienWaivers: Boolean['output']
        readonly onboardedPrimaryLienWaiverForms: Boolean['output']
        readonly selectedVendorLienWaivers: Boolean['output']
        readonly onboardedVendorLienWaiverForms: Boolean['output']
        readonly selectedChangeOrderRequestForms: Boolean['output']
        readonly onboardedChangeOrderRequestForms: Boolean['output']
        readonly selectedChangeOrderLogForms: Boolean['output']
        readonly onboardedChangeOrderLogForms: Boolean['output']
        readonly addedSov: Boolean['output']
        readonly selectedRateTable: Boolean['output']
        readonly addedTeammates: Boolean['output']
        readonly addedGcContacts: Boolean['output']
        readonly startedBilling: Boolean['output']
        readonly notifiedOnboardedForms: Boolean['output']
      }
    }>
    readonly metadata: {
      readonly __typename: 'ProjectMetadata'
      readonly payAppDueOnDayOfMonth: Int['output']
    }
  }
}

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteProjectMutation = {
  readonly __typename: 'Mutation'
  readonly deleteProject: { readonly __typename: 'DeletionResult'; readonly id: ID['output'] }
}

export type AllProjectUsersByCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AllProjectUsersByCompanyQuery = {
  readonly __typename: 'Query'
  readonly allProjectUsersByCompany: ReadonlyArray<{
    readonly __typename: 'CompanyUser'
    readonly id: ID['output']
    readonly role: CompanyUserRole
    readonly isSitelineAdmin: Boolean['output']
    readonly status: UserStatus
    readonly permissions: ReadonlyArray<Permission>
    readonly user: {
      readonly __typename: 'User'
      readonly blockedEmails: ReadonlyArray<EmailType>
      readonly blockedNotifications: ReadonlyArray<NotificationType>
      readonly policiesAcceptedAt: DateTime['output'] | null
      readonly mfaEnrolled: Boolean['output']
      readonly id: ID['output']
      readonly firstName: String['output']
      readonly lastName: String['output']
      readonly email: EmailAddress['output']
      readonly jobTitle: String['output'] | null
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly companies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }>
      readonly companyUsers: ReadonlyArray<{
        readonly __typename: 'CompanyUser'
        readonly id: ID['output']
        readonly status: UserStatus
        readonly role: CompanyUserRole
        readonly company: {
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
          readonly nickname: String['output'] | null
          readonly type: CompanyType
          readonly phoneNumber: PhoneNumber['output'] | null
          readonly expectedNumberOfProjects: SafeInt['output'] | null
          readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
          readonly allowLumpSumOverbilling: Boolean['output']
          readonly notaryTags: ReadonlyArray<NotaryTag>
          readonly notaryExpiresAt: DateTime['output'] | null
          readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
          readonly isDemoCompany: Boolean['output']
          readonly hasChurned: Boolean['output']
          readonly mfaRequirement: CompanyMfaRequirement
          readonly allowsLienRightsTracking: Boolean['output']
          readonly defaultLienRightsTracking: Boolean['output']
          readonly userSessionTimeout: Int['output'] | null
          readonly enableDailyContractMismatchReport: Boolean['output']
          readonly picture: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notaryStamp: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly notarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly secondarySignature: {
            readonly __typename: 'StoredFile'
            readonly id: ID['output']
            readonly url: URL['output']
          } | null
          readonly locations: ReadonlyArray<{
            readonly __typename: 'Location'
            readonly id: ID['output']
            readonly createdAt: DateTime['output']
            readonly nickname: String['output'] | null
            readonly street1: String['output'] | null
            readonly street2: String['output'] | null
            readonly city: String['output']
            readonly county: String['output'] | null
            readonly state: String['output']
            readonly country: String['output']
            readonly postalCode: String['output'] | null
            readonly timeZone: String['output']
            readonly coordinates: LatLng['output']
          }>
          readonly metadata: {
            readonly __typename: 'CompanyMetadata'
            readonly subtrade: String['output'] | null
            readonly domains: ReadonlyArray<String['output']>
            readonly domainSignup: Boolean['output']
            readonly monthlyCreatePayAppReminderDate: Int['output'] | null
          }
          readonly defaultQuickBillingTemplate: {
            readonly __typename: 'FormTemplate'
            readonly id: String['output']
          } | null
          readonly sitelinePointOfContact: {
            readonly __typename: 'User'
            readonly id: ID['output']
            readonly email: EmailAddress['output']
          } | null
          readonly linkedCompanies: ReadonlyArray<{
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }>
        }
      }>
    }
  }>
}

export type SendCompanyMonthlyReportTestEmailMutationVariables = Exact<{
  input: SendCompanyMonthlyReportTestEmailInput
}>

export type SendCompanyMonthlyReportTestEmailMutation = {
  readonly __typename: 'Mutation'
  readonly sendCompanyMonthlyReportTestEmail: ReadonlyArray<{
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly email: EmailAddress['output']
  }>
}

export type UserEducationCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UserEducationCampaignQuery = {
  readonly __typename: 'Query'
  readonly userEducationCampaign: {
    readonly __typename: 'UserEducationCampaign'
    readonly id: ID['output']
    readonly name: String['output']
    readonly startDate: DateTime['output']
    readonly endDate: DateTime['output']
    readonly targetPermissions: ReadonlyArray<Permission>
    readonly showNewTag: Boolean['output']
    readonly title: String['output']
    readonly message: String['output']
    readonly anchorSelector: String['output'] | null
    readonly buttonLabel: String['output'] | null
    readonly buttonLink: String['output'] | null
  }
}

export type CreateUserEducationCampaignMutationVariables = Exact<{
  input: CreateUserEducationCampaignInput
}>

export type CreateUserEducationCampaignMutation = {
  readonly __typename: 'Mutation'
  readonly createUserEducationCampaign: {
    readonly __typename: 'UserEducationCampaign'
    readonly id: ID['output']
    readonly name: String['output']
    readonly startDate: DateTime['output']
    readonly endDate: DateTime['output']
    readonly targetPermissions: ReadonlyArray<Permission>
    readonly showNewTag: Boolean['output']
    readonly title: String['output']
    readonly message: String['output']
    readonly anchorSelector: String['output'] | null
    readonly buttonLabel: String['output'] | null
    readonly buttonLink: String['output'] | null
  }
}

export type UpdateUserEducationCampaignMutationVariables = Exact<{
  input: UpdateUserEducationCampaignInput
}>

export type UpdateUserEducationCampaignMutation = {
  readonly __typename: 'Mutation'
  readonly updateUserEducationCampaign: {
    readonly __typename: 'UserEducationCampaign'
    readonly id: ID['output']
    readonly name: String['output']
    readonly startDate: DateTime['output']
    readonly endDate: DateTime['output']
    readonly targetPermissions: ReadonlyArray<Permission>
    readonly showNewTag: Boolean['output']
    readonly title: String['output']
    readonly message: String['output']
    readonly anchorSelector: String['output'] | null
    readonly buttonLabel: String['output'] | null
    readonly buttonLink: String['output'] | null
  }
}

export type UserEducationCampaignsQueryVariables = Exact<{ [key: string]: never }>

export type UserEducationCampaignsQuery = {
  readonly __typename: 'Query'
  readonly userEducationCampaigns: ReadonlyArray<{
    readonly __typename: 'UserEducationCampaign'
    readonly id: ID['output']
    readonly name: String['output']
    readonly startDate: DateTime['output']
    readonly endDate: DateTime['output']
    readonly targetPermissions: ReadonlyArray<Permission>
    readonly showNewTag: Boolean['output']
    readonly title: String['output']
    readonly message: String['output']
    readonly anchorSelector: String['output'] | null
    readonly buttonLabel: String['output'] | null
    readonly buttonLink: String['output'] | null
  }>
}

export type GetUserForDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type GetUserForDetailsQuery = {
  readonly __typename: 'Query'
  readonly user: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly billingDeadline: DueToType
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
  }
}

export type ModifyNotificationPreferencesMutationVariables = Exact<{
  input: ModifyNotificationPreferencesInput
}>

export type ModifyNotificationPreferencesMutation = {
  readonly __typename: 'Mutation'
  readonly modifyNotificationPreferences: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
  }
}

export type ModifyEmailPreferencesMutationVariables = Exact<{
  input: ModifyEmailPreferencesInput
}>

export type ModifyEmailPreferencesMutation = {
  readonly __typename: 'Mutation'
  readonly modifyEmailPreferences: {
    readonly __typename: 'User'
    readonly blockedEmails: ReadonlyArray<EmailType>
    readonly blockedNotifications: ReadonlyArray<NotificationType>
    readonly policiesAcceptedAt: DateTime['output'] | null
    readonly mfaEnrolled: Boolean['output']
    readonly id: ID['output']
    readonly firstName: String['output']
    readonly lastName: String['output']
    readonly email: EmailAddress['output']
    readonly jobTitle: String['output'] | null
    readonly phoneNumber: PhoneNumber['output'] | null
    readonly companies: ReadonlyArray<{
      readonly __typename: 'Company'
      readonly id: ID['output']
      readonly name: String['output']
      readonly nickname: String['output'] | null
      readonly type: CompanyType
      readonly phoneNumber: PhoneNumber['output'] | null
      readonly expectedNumberOfProjects: SafeInt['output'] | null
      readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
      readonly allowLumpSumOverbilling: Boolean['output']
      readonly notaryTags: ReadonlyArray<NotaryTag>
      readonly notaryExpiresAt: DateTime['output'] | null
      readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
      readonly isDemoCompany: Boolean['output']
      readonly hasChurned: Boolean['output']
      readonly mfaRequirement: CompanyMfaRequirement
      readonly allowsLienRightsTracking: Boolean['output']
      readonly defaultLienRightsTracking: Boolean['output']
      readonly userSessionTimeout: Int['output'] | null
      readonly enableDailyContractMismatchReport: Boolean['output']
      readonly picture: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notaryStamp: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly notarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly secondarySignature: {
        readonly __typename: 'StoredFile'
        readonly id: ID['output']
        readonly url: URL['output']
      } | null
      readonly locations: ReadonlyArray<{
        readonly __typename: 'Location'
        readonly id: ID['output']
        readonly createdAt: DateTime['output']
        readonly nickname: String['output'] | null
        readonly street1: String['output'] | null
        readonly street2: String['output'] | null
        readonly city: String['output']
        readonly county: String['output'] | null
        readonly state: String['output']
        readonly country: String['output']
        readonly postalCode: String['output'] | null
        readonly timeZone: String['output']
        readonly coordinates: LatLng['output']
      }>
      readonly metadata: {
        readonly __typename: 'CompanyMetadata'
        readonly subtrade: String['output'] | null
        readonly domains: ReadonlyArray<String['output']>
        readonly domainSignup: Boolean['output']
        readonly monthlyCreatePayAppReminderDate: Int['output'] | null
      }
      readonly defaultQuickBillingTemplate: {
        readonly __typename: 'FormTemplate'
        readonly id: String['output']
      } | null
      readonly sitelinePointOfContact: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
      } | null
      readonly linkedCompanies: ReadonlyArray<{
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
      }>
    }>
    readonly companyUsers: ReadonlyArray<{
      readonly __typename: 'CompanyUser'
      readonly id: ID['output']
      readonly status: UserStatus
      readonly role: CompanyUserRole
      readonly company: {
        readonly __typename: 'Company'
        readonly id: ID['output']
        readonly name: String['output']
        readonly nickname: String['output'] | null
        readonly type: CompanyType
        readonly phoneNumber: PhoneNumber['output'] | null
        readonly expectedNumberOfProjects: SafeInt['output'] | null
        readonly defaultShowAuditItemOnSignedPackages: Boolean['output']
        readonly allowLumpSumOverbilling: Boolean['output']
        readonly notaryTags: ReadonlyArray<NotaryTag>
        readonly notaryExpiresAt: DateTime['output'] | null
        readonly storedMaterialsCarryoverType: StoredMaterialsCarryoverType
        readonly isDemoCompany: Boolean['output']
        readonly hasChurned: Boolean['output']
        readonly mfaRequirement: CompanyMfaRequirement
        readonly allowsLienRightsTracking: Boolean['output']
        readonly defaultLienRightsTracking: Boolean['output']
        readonly userSessionTimeout: Int['output'] | null
        readonly enableDailyContractMismatchReport: Boolean['output']
        readonly picture: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notaryStamp: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly notarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly secondarySignature: {
          readonly __typename: 'StoredFile'
          readonly id: ID['output']
          readonly url: URL['output']
        } | null
        readonly locations: ReadonlyArray<{
          readonly __typename: 'Location'
          readonly id: ID['output']
          readonly createdAt: DateTime['output']
          readonly nickname: String['output'] | null
          readonly street1: String['output'] | null
          readonly street2: String['output'] | null
          readonly city: String['output']
          readonly county: String['output'] | null
          readonly state: String['output']
          readonly country: String['output']
          readonly postalCode: String['output'] | null
          readonly timeZone: String['output']
          readonly coordinates: LatLng['output']
        }>
        readonly metadata: {
          readonly __typename: 'CompanyMetadata'
          readonly subtrade: String['output'] | null
          readonly domains: ReadonlyArray<String['output']>
          readonly domainSignup: Boolean['output']
          readonly monthlyCreatePayAppReminderDate: Int['output'] | null
        }
        readonly defaultQuickBillingTemplate: {
          readonly __typename: 'FormTemplate'
          readonly id: String['output']
        } | null
        readonly sitelinePointOfContact: {
          readonly __typename: 'User'
          readonly id: ID['output']
          readonly email: EmailAddress['output']
        } | null
        readonly linkedCompanies: ReadonlyArray<{
          readonly __typename: 'Company'
          readonly id: ID['output']
          readonly name: String['output']
        }>
      }
    }>
  }
}

export type ResendUserInviteMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResendUserInviteMutation = {
  readonly __typename: 'Mutation'
  readonly resendUserInvite: { readonly __typename: 'User'; readonly id: ID['output'] }
}

export type ResetUserMfaMutationVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type ResetUserMfaMutation = {
  readonly __typename: 'Mutation'
  readonly resetUserMfa: {
    readonly __typename: 'User'
    readonly id: ID['output']
    readonly mfaEnrolled: Boolean['output']
  }
}

export type ProjectsByUserQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ProjectsByUserQuery = {
  readonly __typename: 'Query'
  readonly projectsByUser: ReadonlyArray<{
    readonly __typename: 'Project'
    readonly id: ID['output']
    readonly name: String['output']
    readonly projectNumber: String['output']
    readonly gcName: String['output'] | null
    readonly location: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    }
    readonly gc: {
      readonly __typename: 'GeneralContractor'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly gcAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
    readonly ownerEntity: {
      readonly __typename: 'Owner'
      readonly id: ID['output']
      readonly name: String['output']
    } | null
    readonly ownerAddress: {
      readonly __typename: 'Location'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly nickname: String['output'] | null
      readonly street1: String['output'] | null
      readonly street2: String['output'] | null
      readonly city: String['output']
      readonly county: String['output'] | null
      readonly state: String['output']
      readonly country: String['output']
      readonly postalCode: String['output'] | null
      readonly timeZone: String['output']
      readonly coordinates: LatLng['output']
    } | null
  }>
}

export type MarkWriteSyncAsFailedMutationVariables = Exact<{
  input: MarkWriteSyncAsFailedInput
}>

export type MarkWriteSyncAsFailedMutation = {
  readonly __typename: 'Mutation'
  readonly markWriteSyncAsFailed: {
    readonly __typename: 'WriteSyncOperation'
    readonly id: ID['output']
    readonly updatedAt: DateTime['output']
    readonly status: WriteSyncOperationStatus
    readonly result: JSONObject['output'] | null
  }
}

export type PaginatedWriteSyncOperationsQueryVariables = Exact<{
  input: GetPaginatedWriteSyncOperationsInput
}>

export type PaginatedWriteSyncOperationsQuery = {
  readonly __typename: 'Query'
  readonly paginatedWriteSyncOperations: {
    readonly __typename: 'PaginatedWriteSyncOperations'
    readonly hasNext: Boolean['output']
    readonly cursor: ID['output'] | null
    readonly totalCount: Int['output']
    readonly operations: ReadonlyArray<{
      readonly __typename: 'WriteSyncOperation'
      readonly id: ID['output']
      readonly createdAt: DateTime['output']
      readonly updatedAt: DateTime['output']
      readonly status: WriteSyncOperationStatus
      readonly payload: JSONObject['output'] | null
      readonly result: JSONObject['output'] | null
      readonly createdBy: {
        readonly __typename: 'User'
        readonly id: ID['output']
        readonly email: EmailAddress['output']
        readonly firstName: String['output']
      }
      readonly integration: {
        readonly __typename: 'Integration'
        readonly id: ID['output']
        readonly type: IntegrationType
        readonly contract: {
          readonly __typename: 'Contract'
          readonly id: ID['output']
          readonly internalProjectNumber: String['output'] | null
          readonly project: {
            readonly __typename: 'Project'
            readonly id: ID['output']
            readonly name: String['output']
            readonly projectNumber: String['output']
          }
          readonly company: {
            readonly __typename: 'Company'
            readonly id: ID['output']
            readonly name: String['output']
          }
        }
      }
    }>
  }
}

export type RequeueWriteSyncMutationVariables = Exact<{
  input: RequeueWriteSyncInput
}>

export type RequeueWriteSyncMutation = {
  readonly __typename: 'Mutation'
  readonly requeueWriteSync: {
    readonly __typename: 'WriteSyncOperation'
    readonly id: ID['output']
    readonly updatedAt: DateTime['output']
    readonly status: WriteSyncOperationStatus
    readonly result: JSONObject['output'] | null
  }
}

export type ChatToolsQueryVariables = Exact<{ [key: string]: never }>

export type ChatToolsQuery = {
  readonly __typename: 'Query'
  readonly chatTools: {
    readonly __typename: 'ChatToolsResponse'
    readonly errors: ReadonlyArray<{
      readonly __typename: 'ChatToolsLoadError'
      readonly source: String['output']
      readonly message: String['output']
      readonly repairCommand: String['output'] | null
    }>
  }
}

export const MinimalUserPropertiesDoc = gql`
  fragment MinimalUserProperties on User {
    id
    firstName
    lastName
    email
    jobTitle
    phoneNumber
    companies {
      id
      name
    }
  }
` as unknown as DocumentNode<MinimalUserProperties, unknown>
export const LocationPropertiesDoc = gql`
  fragment LocationProperties on Location {
    id
    createdAt
    nickname
    street1
    street2
    city
    county
    state
    country
    postalCode
    timeZone
    coordinates
  }
` as unknown as DocumentNode<LocationProperties, unknown>
export const CompanyPropertiesDoc = gql`
  fragment CompanyProperties on Company {
    id
    name
    nickname
    type
    phoneNumber
    expectedNumberOfProjects
    defaultShowAuditItemOnSignedPackages
    allowLumpSumOverbilling
    notaryTags
    notaryExpiresAt
    storedMaterialsCarryoverType
    isDemoCompany
    hasChurned
    mfaRequirement
    allowsLienRightsTracking
    defaultLienRightsTracking
    userSessionTimeout
    enableDailyContractMismatchReport
    picture {
      id
      url
    }
    notaryStamp {
      id
      url
    }
    notarySignature {
      id
      url
    }
    secondarySignature {
      id
      url
    }
    locations {
      ...LocationProperties
    }
    metadata {
      subtrade
      domains
      domainSignup
      monthlyCreatePayAppReminderDate
    }
    defaultQuickBillingTemplate {
      id
    }
    sitelinePointOfContact {
      id
      email
    }
    linkedCompanies {
      id
      name
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<CompanyProperties, unknown>
export const UserPropertiesDoc = gql`
  fragment UserProperties on User {
    ...MinimalUserProperties
    blockedEmails
    blockedNotifications
    policiesAcceptedAt
    mfaEnrolled
    companies {
      ...CompanyProperties
    }
    companyUsers {
      id
      status
      role
      company {
        ...CompanyProperties
      }
    }
  }
  ${MinimalUserPropertiesDoc}
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<UserProperties, unknown>
export const CompanyUserPropertiesDoc = gql`
  fragment CompanyUserProperties on CompanyUser {
    id
    role
    isSitelineAdmin
    status
    permissions
    user {
      ...UserProperties
    }
  }
  ${UserPropertiesDoc}
` as unknown as DocumentNode<CompanyUserProperties, unknown>
export const StoredFilePropertiesDoc = gql`
  fragment StoredFileProperties on StoredFile {
    id
    type
    url
    name
  }
` as unknown as DocumentNode<StoredFileProperties, unknown>
export const FormTemplateAnnotationPropertiesDoc = gql`
  fragment FormTemplateAnnotationProperties on FormTemplateAnnotation {
    id
    permanentId
    syncTag
    userVisibleName
    type
    xStart
    yStart
    width
    height
    pageNumber
    fontFamily
    fontColor
    textAlignment
    wrapText
    isOptional
    selectedKey
    defaultValueKey
    prefix
    suffix
    fieldType
    doNotRetainOnReset
    dynamicFieldTag
    copyDefaultValueFromPreviousAnnotationValue
    imageType
    signatureType
    isFromAiSuggestion
  }
` as unknown as DocumentNode<FormTemplateAnnotationProperties, unknown>
export const FormTemplateVersionPropertiesDoc = gql`
  fragment FormTemplateVersionProperties on FormTemplateVersion {
    id
    createdAt
    updatedAt
    file {
      ...StoredFileProperties
    }
    annotations {
      ...FormTemplateAnnotationProperties
    }
    versionNumber
    isReadyForManualStoredMaterials
    currentSuggestionsRun {
      id
      phase
      error
    }
  }
  ${StoredFilePropertiesDoc}
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<FormTemplateVersionProperties, unknown>
export const FormTemplateSuggestionsRunPropertiesDoc = gql`
  fragment FormTemplateSuggestionsRunProperties on FormTemplateSuggestionsRun {
    id
    phase
    error
    formTemplateVersion {
      id
      ...FormTemplateVersionProperties
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<FormTemplateSuggestionsRunProperties, unknown>
export const AnnotationOverridePropertiesDoc = gql`
  fragment AnnotationOverrideProperties on AnnotationOverride {
    id
    annotationPermanentId
    userVisibleName
    fontFamily
    fontColor
    textAlignment
    wrapText
    isOptional
    selectedKey
    defaultValueKey
    prefix
    suffix
    fieldType
    doNotRetainOnReset
    copyDefaultValueFromPreviousAnnotationValue
    imageType
    signatureType
    syncTag
  }
` as unknown as DocumentNode<AnnotationOverrideProperties, unknown>
export const FormTemplateVariantPropertiesDoc = gql`
  fragment FormTemplateVariantProperties on FormTemplateVariant {
    id
    internalName
    userVisibleName
    isDefaultVariant
    hidesZeroDollarAmounts
    roundPercentages
    useCompanyNotarySignatureIfAvailable
    annotationOverrides {
      ...AnnotationOverrideProperties
    }
  }
  ${AnnotationOverridePropertiesDoc}
` as unknown as DocumentNode<FormTemplateVariantProperties, unknown>
export const FormTemplateStatusLogPropertiesDoc = gql`
  fragment FormTemplateStatusLogProperties on FormTemplateStatusLog {
    id
    statusUpdatedAt
    status
    user {
      id
      email
    }
  }
` as unknown as DocumentNode<FormTemplateStatusLogProperties, unknown>
export const FormTemplateCommentPropertiesDoc = gql`
  fragment FormTemplateCommentProperties on FormTemplateComment {
    id
    createdAt
    message
    isSystemGenerated
    user {
      id
      firstName
      lastName
      email
    }
  }
` as unknown as DocumentNode<FormTemplateCommentProperties, unknown>
export const FormTemplatePropertiesDoc = gql`
  fragment FormTemplateProperties on FormTemplate {
    id
    createdAt
    type
    status
    statusLogs {
      ...FormTemplateStatusLogProperties
    }
    skippedValidation
    userVisibleName
    isCustomerReady
    tags
    dueDate
    associatedCompany {
      id
    }
    requestingCompany {
      id
    }
    associatedContracts {
      id
      providedAsFormType
      contract {
        id
      }
    }
    owner {
      id
      email
      firstName
      lastName
    }
    builder {
      id
      email
      firstName
      lastName
    }
    validator {
      id
      email
      firstName
      lastName
    }
    versions {
      ...FormTemplateVersionProperties
    }
    variants {
      id
      internalName
      isDefaultVariant
    }
    comments {
      ...FormTemplateCommentProperties
    }
    originalFile {
      ...StoredFileProperties
    }
    duplicateTemplate {
      id
      userVisibleName
    }
  }
  ${FormTemplateStatusLogPropertiesDoc}
  ${FormTemplateVersionPropertiesDoc}
  ${FormTemplateCommentPropertiesDoc}
  ${StoredFilePropertiesDoc}
` as unknown as DocumentNode<FormTemplateProperties, unknown>
export const SimilarTemplatePropertiesDoc = gql`
  fragment SimilarTemplateProperties on SimilarTemplate {
    template {
      ...FormTemplateProperties
    }
    version {
      ...FormTemplateVersionProperties
    }
    score
  }
  ${FormTemplatePropertiesDoc}
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<SimilarTemplateProperties, unknown>
export const SovLineItemGroupPropertiesDoc = gql`
  fragment SovLineItemGroupProperties on SovLineItemGroup {
    id
    name
    code
  }
` as unknown as DocumentNode<SovLineItemGroupProperties, unknown>
export const SovLineItemPropertiesDoc = gql`
  fragment SovLineItemProperties on SovLineItem {
    id
    code
    sortOrder
    name
    isChangeOrder
    changeOrderApprovedDate
    latestTotalValue
    totalBilled
    previousBilled
    previousStoredMaterials
    retentionHeldTotal
    progressComplete
    defaultRetentionPercent
    sovLineItemGroup {
      ...SovLineItemGroupProperties
    }
  }
  ${SovLineItemGroupPropertiesDoc}
` as unknown as DocumentNode<SovLineItemProperties, unknown>
export const SovLineItemProgressPropertiesDoc = gql`
  fragment SovLineItemProgressProperties on SovLineItemProgress {
    id
    currentBilled
    progressBilled
    retentionHeldCurrent
    previousBilled
    storedMaterialBilled
    previousRetention
    retentionReleasedCurrent
    totalValue
    sovLineItem {
      ...SovLineItemProperties
    }
  }
  ${SovLineItemPropertiesDoc}
` as unknown as DocumentNode<SovLineItemProgressProperties, unknown>
export const AmountLineItemPropertiesDoc = gql`
  fragment AmountLineItemProperties on AmountLineItem {
    id
    description
    amount
    sortOrder
  }
` as unknown as DocumentNode<AmountLineItemProperties, unknown>
export const PayAppPropertiesDoc = gql`
  fragment PayAppProperties on PayApp {
    id
    createdAt
    timeZone
    status
    retentionOnly
    billingStart
    billingEnd
    payAppDueDate
    currentBilled
    retentionHeldCurrent
    retentionHeldToDate
    retentionReleasedCurrent
    contract {
      id
      company {
        ...CompanyProperties
      }
    }
    progress {
      ...SovLineItemProgressProperties
    }
    amountLineItems {
      ...AmountLineItemProperties
    }
  }
  ${CompanyPropertiesDoc}
  ${SovLineItemProgressPropertiesDoc}
  ${AmountLineItemPropertiesDoc}
` as unknown as DocumentNode<PayAppProperties, unknown>
export const LegalDocumentPropertiesDoc = gql`
  fragment LegalDocumentProperties on LegalDocument {
    id
    name
    periodStart
    periodEnd
    lastSyncIfSuccessful {
      id
      createdAt
    }
  }
` as unknown as DocumentNode<LegalDocumentProperties, unknown>
export const LeanLienWaiverFormTemplateVariantPropertiesDoc = gql`
  fragment LeanLienWaiverFormTemplateVariantProperties on FormTemplateVariant {
    id
    template {
      id
      type
      status
      skippedValidation
      createdAt
    }
  }
` as unknown as DocumentNode<LeanLienWaiverFormTemplateVariantProperties, unknown>
export const LeanSubcontractorLienWaiverTemplateSetPropertiesDoc = gql`
  fragment LeanSubcontractorLienWaiverTemplateSetProperties on SubcontractorLienWaiverTemplateSet {
    id
    conditionalFinalVariant {
      ...LeanLienWaiverFormTemplateVariantProperties
    }
    conditionalProgressVariant {
      ...LeanLienWaiverFormTemplateVariantProperties
    }
    unconditionalFinalVariant {
      ...LeanLienWaiverFormTemplateVariantProperties
    }
    unconditionalProgressVariant {
      ...LeanLienWaiverFormTemplateVariantProperties
    }
  }
  ${LeanLienWaiverFormTemplateVariantPropertiesDoc}
` as unknown as DocumentNode<LeanSubcontractorLienWaiverTemplateSetProperties, unknown>
export const CompanyProjectMetadataPropertiesDoc = gql`
  fragment CompanyProjectMetadataProperties on CompanyProjectMetadata {
    role
    companyName
    company {
      ...CompanyProperties
    }
    selectedAddress {
      ...LocationProperties
    }
  }
  ${CompanyPropertiesDoc}
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<CompanyProjectMetadataProperties, unknown>
export const ProjectPropertiesDoc = gql`
  fragment ProjectProperties on Project {
    id
    name
    projectNumber
    location {
      ...LocationProperties
    }
    gcName
    gc {
      id
      name
    }
    gcAddress {
      ...LocationProperties
    }
    ownerEntity {
      id
      name
    }
    ownerAddress {
      ...LocationProperties
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<ProjectProperties, unknown>
export const SovPropertiesDoc = gql`
  fragment SovProperties on Sov {
    id
    totalValue
    totalBilled
    totalRetention
  }
` as unknown as DocumentNode<SovProperties, unknown>
export const CompanySovPropertiesDoc = gql`
  fragment CompanySovProperties on Sov {
    ...SovProperties
    contract {
      id
      timeZone
    }
    lineItems {
      ...SovLineItemProperties
    }
  }
  ${SovPropertiesDoc}
  ${SovLineItemPropertiesDoc}
` as unknown as DocumentNode<CompanySovProperties, unknown>
export const LienWaiverFormTemplateVariantPropertiesDoc = gql`
  fragment LienWaiverFormTemplateVariantProperties on FormTemplateVariant {
    id
    template {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<LienWaiverFormTemplateVariantProperties, unknown>
export const SubcontractorLienWaiverTemplateSetPropertiesDoc = gql`
  fragment SubcontractorLienWaiverTemplateSetProperties on SubcontractorLienWaiverTemplateSet {
    id
    conditionalFinalVariant {
      ...LienWaiverFormTemplateVariantProperties
    }
    conditionalProgressVariant {
      ...LienWaiverFormTemplateVariantProperties
    }
    unconditionalFinalVariant {
      ...LienWaiverFormTemplateVariantProperties
    }
    unconditionalProgressVariant {
      ...LienWaiverFormTemplateVariantProperties
    }
  }
  ${LienWaiverFormTemplateVariantPropertiesDoc}
` as unknown as DocumentNode<SubcontractorLienWaiverTemplateSetProperties, unknown>
export const PayAppRequirementPropertiesDoc = gql`
  fragment PayAppRequirementProperties on PayAppRequirement {
    id
    templateVariant {
      id
      internalName
      userVisibleName
      template {
        id
        isCustomerReady
      }
    }
    groupOrder
    conditions
  }
` as unknown as DocumentNode<PayAppRequirementProperties, unknown>
export const PayAppRequirementGroupPropertiesDoc = gql`
  fragment PayAppRequirementGroupProperties on PayAppRequirementGroup {
    id
    order
    payAppRequirements {
      ...PayAppRequirementProperties
    }
  }
  ${PayAppRequirementPropertiesDoc}
` as unknown as DocumentNode<PayAppRequirementGroupProperties, unknown>
export const LegalRequirementPropertiesDoc = gql`
  fragment LegalRequirementProperties on LegalRequirement {
    id
    createdAt
    name
    timeZone
    expirationFrequency
    startDate
    endDate
    isVendorRequirement
    documents {
      id
    }
    formTemplate {
      id
    }
  }
` as unknown as DocumentNode<LegalRequirementProperties, unknown>
export const IntegrationPropertiesDoc = gql`
  fragment IntegrationProperties on Integration {
    id
    createdAt
    type
    credentialsUpdatedAt
    mappings
    isActive
    shortName
    longName
    companyIntegration {
      id
    }
  }
` as unknown as DocumentNode<IntegrationProperties, unknown>
export const ContractPropertiesDoc = gql`
  fragment ContractProperties on Contract {
    id
    role
    status
    timeZone
    contractDate
    contractNumber
    storedMaterialsCarryoverType
    project {
      ...ProjectProperties
    }
    company {
      ...CompanyProperties
    }
    sov {
      ...CompanySovProperties
    }
    defaultRetentionPercent
    retentionTrackingLevel
    daysBeforePayAppDue
    billingType
    contractTemplateVariables
    lienWaiverTemplates {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
    lowerTierLienWaiverTemplates {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
    subTierLienWaiverTemplates {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
    internalProjectNumber
    vendorNumber
    pastPayAppCount
    payAppRequirementGroups {
      ...PayAppRequirementGroupProperties
    }
    legalRequirements {
      ...LegalRequirementProperties
    }
    selectedAddress {
      ...LocationProperties
    }
    changeOrderRequestTemplates {
      id
    }
    changeOrderLogTemplates {
      id
    }
    roundRetention
    integrations {
      ...IntegrationProperties
    }
    onboardedStatus {
      selectedPayAppForms
      onboardedPayAppForms
      selectedPrimaryLienWaivers
      onboardedPrimaryLienWaiverForms
      selectedVendorLienWaivers
      onboardedVendorLienWaiverForms
      selectedChangeOrderRequestForms
      onboardedChangeOrderRequestForms
      selectedChangeOrderLogForms
      onboardedChangeOrderLogForms
      addedSov
      selectedRateTable
      addedTeammates
      addedGcContacts
      startedBilling
      notifiedOnboardedForms
    }
  }
  ${ProjectPropertiesDoc}
  ${CompanyPropertiesDoc}
  ${CompanySovPropertiesDoc}
  ${SubcontractorLienWaiverTemplateSetPropertiesDoc}
  ${PayAppRequirementGroupPropertiesDoc}
  ${LegalRequirementPropertiesDoc}
  ${LocationPropertiesDoc}
  ${IntegrationPropertiesDoc}
` as unknown as DocumentNode<ContractProperties, unknown>
export const MinimalCompanyUserPropertiesDoc = gql`
  fragment MinimalCompanyUserProperties on CompanyUser {
    id
    role
    user {
      ...MinimalUserProperties
    }
  }
  ${MinimalUserPropertiesDoc}
` as unknown as DocumentNode<MinimalCompanyUserProperties, unknown>
export const ProjectForDetailsPropertiesDoc = gql`
  fragment ProjectForDetailsProperties on Project {
    id
    name
    projectNumber
    location {
      ...LocationProperties
    }
    ownerEntity {
      id
      name
    }
    ownerAddress {
      ...LocationProperties
    }
    gcName
    gc {
      id
      name
    }
    gcAddress {
      ...LocationProperties
    }
    architect {
      ...CompanyProjectMetadataProperties
    }
    contracts {
      ...ContractProperties
      company {
        id
        users {
          ...MinimalCompanyUserProperties
        }
      }
      users {
        id
        user {
          ...MinimalUserProperties
        }
      }
    }
    metadata {
      payAppDueOnDayOfMonth
    }
  }
  ${LocationPropertiesDoc}
  ${CompanyProjectMetadataPropertiesDoc}
  ${ContractPropertiesDoc}
  ${MinimalCompanyUserPropertiesDoc}
  ${MinimalUserPropertiesDoc}
` as unknown as DocumentNode<ProjectForDetailsProperties, unknown>
export const CompanyContactPropertiesDoc = gql`
  fragment CompanyContactProperties on CompanyContact {
    id
    fullName
    email
    companyName
    archivedAt
  }
` as unknown as DocumentNode<CompanyContactProperties, unknown>
export const VendorPropertiesDoc = gql`
  fragment VendorProperties on Vendor {
    id
    name
  }
` as unknown as DocumentNode<VendorProperties, unknown>
export const CompanyIntegrationPropertiesDoc = gql`
  fragment CompanyIntegrationProperties on CompanyIntegration {
    id
    createdAt
    type
    label
    shortName
    longName
    credentialsUpdatedAt
    credentialsReadyForAutoRotation
    archivedAt
    shouldImportNewProjectSov
    metadata
    importChangeOrdersMethod
    importComboJobMethod
    importProjectNameSource
    revertPayAppsToDraftWhenTexturaInvoiceRejected
    vendorCount
    location {
      ...LocationProperties
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<CompanyIntegrationProperties, unknown>
export const CompanyPayAppFormTemplateSetPropertiesDoc = gql`
  fragment CompanyPayAppFormTemplateSetProperties on CompanyPayAppFormTemplateSet {
    id
    name
    state
    billingType
    gc {
      id
      name
    }
    payAppRequirementGroups {
      ...PayAppRequirementGroupProperties
    }
  }
  ${PayAppRequirementGroupPropertiesDoc}
` as unknown as DocumentNode<CompanyPayAppFormTemplateSetProperties, unknown>
export const CompanyLienWaiverTemplateSetPropertiesDoc = gql`
  fragment CompanyLienWaiverTemplateSetProperties on CompanyLienWaiverTemplateSet {
    id
    name
    state
    gc {
      id
      name
    }
    lienWaivers {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
  }
  ${SubcontractorLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<CompanyLienWaiverTemplateSetProperties, unknown>
export const MinimalFormTemplatePropertiesDoc = gql`
  fragment MinimalFormTemplateProperties on FormTemplate {
    id
    createdAt
    isCustomerReady
    userVisibleName
    skippedValidation
    type
    status
    versions {
      ...FormTemplateVersionProperties
    }
    variants {
      id
      internalName
      isDefaultVariant
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<MinimalFormTemplateProperties, unknown>
export const CompanyFormTemplateCollectionPropertiesDoc = gql`
  fragment CompanyFormTemplateCollectionProperties on CompanyFormTemplateCollection {
    id
    name
    state
    billingType
    gc {
      id
      name
    }
    payAppForms {
      ...CompanyPayAppFormTemplateSetProperties
    }
    primaryLienWaivers {
      ...CompanyLienWaiverTemplateSetProperties
    }
    vendorLienWaivers {
      ...CompanyLienWaiverTemplateSetProperties
    }
    subTierLienWaivers {
      ...CompanyLienWaiverTemplateSetProperties
    }
    changeOrderRequest {
      id
      internalName
      isDefaultVariant
      template {
        ...MinimalFormTemplateProperties
      }
    }
    changeOrderLog {
      id
      internalName
      isDefaultVariant
      template {
        ...MinimalFormTemplateProperties
      }
    }
  }
  ${CompanyPayAppFormTemplateSetPropertiesDoc}
  ${CompanyLienWaiverTemplateSetPropertiesDoc}
  ${MinimalFormTemplatePropertiesDoc}
` as unknown as DocumentNode<CompanyFormTemplateCollectionProperties, unknown>
export const CompanyForDetailsPropertiesDoc = gql`
  fragment CompanyForDetailsProperties on Company {
    ...CompanyProperties
    companyIntegrations {
      ...CompanyIntegrationProperties
    }
    formTemplateCollections {
      ...CompanyFormTemplateCollectionProperties
    }
    payAppFormTemplateSets {
      ...CompanyPayAppFormTemplateSetProperties
    }
    primaryLienWaiverTemplateSets {
      ...CompanyLienWaiverTemplateSetProperties
    }
    vendorLienWaiverTemplateSets {
      ...CompanyLienWaiverTemplateSetProperties
    }
    subTierLienWaiverTemplateSets {
      ...CompanyLienWaiverTemplateSetProperties
    }
    defaultChangeOrderRequestTemplate {
      id
    }
    defaultChangeOrderLogTemplate {
      id
    }
  }
  ${CompanyPropertiesDoc}
  ${CompanyIntegrationPropertiesDoc}
  ${CompanyFormTemplateCollectionPropertiesDoc}
  ${CompanyPayAppFormTemplateSetPropertiesDoc}
  ${CompanyLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<CompanyForDetailsProperties, unknown>
export const UserEducationCampaignPropertiesDoc = gql`
  fragment UserEducationCampaignProperties on UserEducationCampaign {
    id
    name
    startDate
    endDate
    targetPermissions
    showNewTag
    title
    message
    anchorSelector
    buttonLabel
    buttonLink
  }
` as unknown as DocumentNode<UserEducationCampaignProperties, unknown>
export const LienDeadlineNoticeRequirementNewDeadlinePropertiesDoc = gql`
  fragment LienDeadlineNoticeRequirementNewDeadlineProperties on LienDeadlineNoticeRequirementNewDeadline {
    type
    interval
    granularity
    modifier
    anchor
  }
` as unknown as DocumentNode<LienDeadlineNoticeRequirementNewDeadlineProperties, unknown>
export const LienDeadlineNoticeRequirementPropertiesDoc = gql`
  fragment LienDeadlineNoticeRequirementProperties on LienDeadlineNoticeRequirement {
    id
    documentName
    newDeadlines {
      ...LienDeadlineNoticeRequirementNewDeadlineProperties
    }
  }
  ${LienDeadlineNoticeRequirementNewDeadlinePropertiesDoc}
` as unknown as DocumentNode<LienDeadlineNoticeRequirementProperties, unknown>
export const StateLienRequirementsSummaryPropertiesDoc = gql`
  fragment StateLienRequirementsSummaryProperties on StateLienRequirementsSummary {
    id
    state
    updatedAt
    preliminaryNoticeName
    preliminaryNoticeDeadlineInterval
    preliminaryNoticeDeadlineGranularity
    preliminaryNoticeDeadlineModifier
    preliminaryNoticeDeadlineAnchor
    preliminaryNoticeContingentOn
    preliminaryNoticeRequirementType
    preliminaryNoticeAdditionalNotes
    preliminaryNoticeLateFilingInterval
    preliminaryNoticeLateFilingGranularity
    preliminaryNoticeLateFilingModifier
    preLienName
    preLienInterval
    preLienIntervalGranularity
    preLienModifier
    preLienAnchor
    lienDeadlineGranularity
    lienDeadlineInterval
    lienDeadlineModifier
    lienDeadlineAnchor
    lienDeadlineNoticeRequirements {
      ...LienDeadlineNoticeRequirementProperties
    }
    lienEnforcementInterval
    lienEnforcementGranularity
    lienEnforcementAnchor
    lienAdditionalNotes
    citations
  }
  ${LienDeadlineNoticeRequirementPropertiesDoc}
` as unknown as DocumentNode<StateLienRequirementsSummaryProperties, unknown>
export const ContractForLienWaiverSettingsDoc = gql`
  fragment ContractForLienWaiverSettings on Contract {
    id
    lienWaiverTemplates {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
    lowerTierLienWaiverTemplates {
      ...SubcontractorLienWaiverTemplateSetProperties
    }
  }
  ${SubcontractorLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<ContractForLienWaiverSettings, unknown>
export const CompaniesForAutocompleteDocument = gql`
  query companiesForAutocomplete($input: GetPaginatedCompaniesInput!) {
    paginatedCompanies(input: $input) {
      companies {
        id
        name
      }
    }
  }
` as unknown as DocumentNode<CompaniesForAutocompleteQuery, CompaniesForAutocompleteQueryVariables>
export const CompanyForAutocompleteDocument = gql`
  query companyForAutocomplete($id: ID!) {
    company(id: $id) {
      id
      name
    }
  }
` as unknown as DocumentNode<CompanyForAutocompleteQuery, CompanyForAutocompleteQueryVariables>
export const UpdateCompanyDocument = gql`
  mutation updateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      ...CompanyProperties
    }
  }
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<UpdateCompanyMutation, UpdateCompanyMutationVariables>
export const DeleteCompanyDocument = gql`
  mutation deleteCompany($id: ID!) {
    deleteCompany(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteCompanyMutation, DeleteCompanyMutationVariables>
export const DeleteAllContractsForCompanyDocument = gql`
  mutation deleteAllContractsForCompany($companyId: ID!, $confirmation: String!) {
    deleteAllContractsForCompany(companyId: $companyId, confirmation: $confirmation) {
      ...CompanyProperties
    }
  }
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<
  DeleteAllContractsForCompanyMutation,
  DeleteAllContractsForCompanyMutationVariables
>
export const MarkCompanyAsChurnedDocument = gql`
  mutation markCompanyAsChurned($companyId: ID!) {
    markCompanyAsChurned(companyId: $companyId) {
      ...CompanyProperties
    }
  }
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<MarkCompanyAsChurnedMutation, MarkCompanyAsChurnedMutationVariables>
export const GetCompanyDocument = gql`
  query getCompany($companyId: ID!) {
    company(id: $companyId) {
      ...CompanyProperties
    }
  }
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>
export const PayAppForAutocompleteDocument = gql`
  query payAppForAutocomplete($id: ID!) {
    payApp(id: $id) {
      id
      billingEnd
      timeZone
      contract {
        id
        project {
          id
          name
        }
        company {
          id
          name
        }
      }
    }
  }
` as unknown as DocumentNode<PayAppForAutocompleteQuery, PayAppForAutocompleteQueryVariables>
export const TemplatesForAutocompleteDocument = gql`
  query templatesForAutocomplete($input: GetPaginatedTemplatesInput!) {
    paginatedTemplates(input: $input) {
      templates {
        id
        createdAt
        type
        userVisibleName
        status
        skippedValidation
        variants {
          id
          internalName
          isDefaultVariant
        }
      }
    }
  }
` as unknown as DocumentNode<TemplatesForAutocompleteQuery, TemplatesForAutocompleteQueryVariables>
export const TemplateForAutocompleteDocument = gql`
  query templateForAutocomplete($id: ID!) {
    formTemplate(id: $id) {
      id
      createdAt
      userVisibleName
      type
      status
      skippedValidation
      variants {
        id
        internalName
        isDefaultVariant
      }
    }
  }
` as unknown as DocumentNode<TemplateForAutocompleteQuery, TemplateForAutocompleteQueryVariables>
export const SearchDocument = gql`
  query search($query: String!, $type: SearchResultType) {
    search(query: $query, type: $type) {
      id
      type
      description
      score
    }
  }
` as unknown as DocumentNode<SearchQuery, SearchQueryVariables>
export const CreateTestTemplateDocument = gql`
  mutation createTestTemplate($input: CreateTestTemplateInput!) {
    createTestTemplate(input: $input) {
      id
      versions {
        id
      }
    }
  }
` as unknown as DocumentNode<CreateTestTemplateMutation, CreateTestTemplateMutationVariables>
export const TemplateVariantForAutocompleteDocument = gql`
  query templateVariantForAutocomplete($id: ID!) {
    formTemplateVariant(id: $id) {
      id
      userVisibleName
      internalName
      isDefaultVariant
      hidesZeroDollarAmounts
      roundPercentages
      useCompanyNotarySignatureIfAvailable
      template {
        id
        createdAt
        type
        userVisibleName
        status
        skippedValidation
        versions {
          id
          versionNumber
          isReadyForManualStoredMaterials
        }
      }
    }
  }
` as unknown as DocumentNode<
  TemplateVariantForAutocompleteQuery,
  TemplateVariantForAutocompleteQueryVariables
>
export const CreateAdminUserDocument = gql`
  mutation createAdminUser($id: ID!) {
    createAdminUser(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<CreateAdminUserMutation, CreateAdminUserMutationVariables>
export const AgaveConnectorCompanyIntegrationsStatusDocument = gql`
  query agaveConnectorCompanyIntegrationsStatus {
    agaveConnectorCompanyIntegrationsStatus {
      companyIntegration {
        id
        type
        longName
        label
        company {
          id
          name
        }
      }
      isConnectorOnline
      lastPingedAt
      errorMessage
      connectorVersion
    }
  }
` as unknown as DocumentNode<
  AgaveConnectorCompanyIntegrationsStatusQuery,
  AgaveConnectorCompanyIntegrationsStatusQueryVariables
>
export const AgaveEndpointMatrixDocument = gql`
  query agaveEndpointMatrix {
    agaveEndpointMatrix {
      endpoints
      integrationTypes
      cells {
        endpoint
        integrationType
        lastRequestId
      }
    }
  }
` as unknown as DocumentNode<AgaveEndpointMatrixQuery, AgaveEndpointMatrixQueryVariables>
export const IntegrationRequestDetailDocument = gql`
  query integrationRequestDetail($id: String!) {
    integrationRequest(id: $id) {
      id
      response
    }
  }
` as unknown as DocumentNode<IntegrationRequestDetailQuery, IntegrationRequestDetailQueryVariables>
export const FullyBilledContractsDocument = gql`
  query fullyBilledContracts {
    fullyBilledContracts {
      id
      timeZone
      pastPayAppCount
      percentComplete
      project {
        id
        name
      }
      company {
        id
        name
      }
      payApps {
        id
        billingEnd
        balanceToFinish
        currentBilled
        payAppNumber
        retentionOnly
      }
      sov {
        id
        totalValue
        totalRetention
      }
    }
  }
` as unknown as DocumentNode<FullyBilledContractsQuery, FullyBilledContractsQueryVariables>
export const CacheKeysDocument = gql`
  query cacheKeys($input: GetCacheKeysInput!) {
    cacheKeys(input: $input)
  }
` as unknown as DocumentNode<CacheKeysQuery, CacheKeysQueryVariables>
export const DeleteCacheKeysDocument = gql`
  mutation deleteCacheKeys($input: DeleteCacheKeysInput!) {
    deleteCacheKeys(input: $input)
  }
` as unknown as DocumentNode<DeleteCacheKeysMutation, DeleteCacheKeysMutationVariables>
export const CreateCompanyDocument = gql`
  mutation createCompany($input: CompanyInput!) {
    createCompany(company: $input) {
      ...CompanyProperties
    }
  }
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<CreateCompanyMutation, CreateCompanyMutationVariables>
export const AddCompanyIntegrationDocument = gql`
  mutation addCompanyIntegration($input: AddCompanyIntegrationInput!) {
    addCompanyIntegration(input: $input) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<AddCompanyIntegrationMutation, AddCompanyIntegrationMutationVariables>
export const UpdateCompanyIntegrationDocument = gql`
  mutation updateCompanyIntegration($input: UpdateCompanyIntegrationInput!) {
    updateCompanyIntegration(input: $input) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<
  UpdateCompanyIntegrationMutation,
  UpdateCompanyIntegrationMutationVariables
>
export const GetIntegrationInvoiceTypesDocument = gql`
  query getIntegrationInvoiceTypes($input: IntegrationInvoiceTypesInput!) {
    integrationInvoiceTypes(input: $input) {
      invoiceType
      hasAutoNumberingEnabled
    }
  }
` as unknown as DocumentNode<
  GetIntegrationInvoiceTypesQuery,
  GetIntegrationInvoiceTypesQueryVariables
>
export const InviteCompanyUserDocument = gql`
  mutation inviteCompanyUser($input: InviteCompanyUserInput!) {
    inviteCompanyUser(input: $input) {
      ...CompanyUserProperties
    }
  }
  ${CompanyUserPropertiesDoc}
` as unknown as DocumentNode<InviteCompanyUserMutation, InviteCompanyUserMutationVariables>
export const GetCompanyContactsDocument = gql`
  query getCompanyContacts($companyId: ID!) {
    company(id: $companyId) {
      id
      contacts {
        ...CompanyContactProperties
      }
    }
  }
  ${CompanyContactPropertiesDoc}
` as unknown as DocumentNode<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>
export const CreateCompanyContactDocument = gql`
  mutation createCompanyContact($input: CreateCompanyContactInput!) {
    createCompanyContact(input: $input) {
      ...CompanyContactProperties
    }
  }
  ${CompanyContactPropertiesDoc}
` as unknown as DocumentNode<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>
export const UpdateCompanyContactDocument = gql`
  mutation updateCompanyContact($input: UpdateCompanyContactInput!) {
    updateCompanyContact(input: $input) {
      ...CompanyContactProperties
    }
  }
  ${CompanyContactPropertiesDoc}
` as unknown as DocumentNode<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>
export const ClearCompanyContactsDocument = gql`
  mutation clearCompanyContacts($id: ID!) {
    clearCompanyContacts(id: $id) {
      id
      contacts {
        ...CompanyContactProperties
      }
    }
  }
  ${CompanyContactPropertiesDoc}
` as unknown as DocumentNode<ClearCompanyContactsMutation, ClearCompanyContactsMutationVariables>
export const GetCompanyForDetailsDocument = gql`
  query getCompanyForDetails($companyId: ID!) {
    company(id: $companyId) {
      ...CompanyForDetailsProperties
    }
  }
  ${CompanyForDetailsPropertiesDoc}
` as unknown as DocumentNode<GetCompanyForDetailsQuery, GetCompanyForDetailsQueryVariables>
export const UpdateDefaultChangeOrderLogFormDocument = gql`
  mutation updateDefaultChangeOrderLogForm($input: UpdateDefaultChangeOrderLogFormInput!) {
    updateDefaultChangeOrderLogForm(input: $input) {
      ...CompanyForDetailsProperties
    }
  }
  ${CompanyForDetailsPropertiesDoc}
` as unknown as DocumentNode<
  UpdateDefaultChangeOrderLogFormMutation,
  UpdateDefaultChangeOrderLogFormMutationVariables
>
export const UpdateDefaultChangeOrderRequestFormDocument = gql`
  mutation updateDefaultChangeOrderRequestForm($input: UpdateDefaultChangeOrderRequestFormInput!) {
    updateDefaultChangeOrderRequestForm(input: $input) {
      ...CompanyForDetailsProperties
    }
  }
  ${CompanyForDetailsPropertiesDoc}
` as unknown as DocumentNode<
  UpdateDefaultChangeOrderRequestFormMutation,
  UpdateDefaultChangeOrderRequestFormMutationVariables
>
export const CreateCompanyFormTemplateCollectionDocument = gql`
  mutation createCompanyFormTemplateCollection($input: CreateCompanyFormTemplateCollectionInput!) {
    createCompanyFormTemplateCollection(input: $input) {
      id
      formTemplateCollections {
        ...CompanyFormTemplateCollectionProperties
      }
    }
  }
  ${CompanyFormTemplateCollectionPropertiesDoc}
` as unknown as DocumentNode<
  CreateCompanyFormTemplateCollectionMutation,
  CreateCompanyFormTemplateCollectionMutationVariables
>
export const UpdateCompanyFormTemplateCollectionDocument = gql`
  mutation updateCompanyFormTemplateCollection($input: UpdateCompanyFormTemplateCollectionInput!) {
    updateCompanyFormTemplateCollection(input: $input) {
      id
      formTemplateCollections {
        ...CompanyFormTemplateCollectionProperties
      }
    }
  }
  ${CompanyFormTemplateCollectionPropertiesDoc}
` as unknown as DocumentNode<
  UpdateCompanyFormTemplateCollectionMutation,
  UpdateCompanyFormTemplateCollectionMutationVariables
>
export const DeleteCompanyFormTemplateCollectionDocument = gql`
  mutation deleteCompanyFormTemplateCollection($input: DeleteCompanyFormTemplateCollectionInput!) {
    deleteCompanyFormTemplateCollection(input: $input) {
      id
      formTemplateCollections {
        ...CompanyFormTemplateCollectionProperties
      }
    }
  }
  ${CompanyFormTemplateCollectionPropertiesDoc}
` as unknown as DocumentNode<
  DeleteCompanyFormTemplateCollectionMutation,
  DeleteCompanyFormTemplateCollectionMutationVariables
>
export const RotateExternalApiTokenDocument = gql`
  mutation rotateExternalApiToken($companyId: ID!) {
    rotateExternalApiToken(companyId: $companyId)
  }
` as unknown as DocumentNode<
  RotateExternalApiTokenMutation,
  RotateExternalApiTokenMutationVariables
>
export const ArchiveCompanyIntegrationDocument = gql`
  mutation archiveCompanyIntegration($id: ID!) {
    archiveCompanyIntegration(id: $id) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<
  ArchiveCompanyIntegrationMutation,
  ArchiveCompanyIntegrationMutationVariables
>
export const UnarchiveCompanyIntegrationDocument = gql`
  mutation unarchiveCompanyIntegration($id: ID!) {
    unarchiveCompanyIntegration(id: $id) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<
  UnarchiveCompanyIntegrationMutation,
  UnarchiveCompanyIntegrationMutationVariables
>
export const UserForCompanyIntegrationRowDocument = gql`
  query userForCompanyIntegrationRow($id: ID!) {
    user(id: $id) {
      id
      sitelineTeamMemberRole
      email
    }
  }
` as unknown as DocumentNode<
  UserForCompanyIntegrationRowQuery,
  UserForCompanyIntegrationRowQueryVariables
>
export const UpdateIntegrationCredentialDocument = gql`
  mutation updateIntegrationCredential($input: UpdateIntegrationCredentialInput!) {
    updateIntegrationCredential(input: $input) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<
  UpdateIntegrationCredentialMutation,
  UpdateIntegrationCredentialMutationVariables
>
export const ExportIntegrationCredentialsToPostmanDocument = gql`
  mutation exportIntegrationCredentialsToPostman(
    $input: ExportIntegrationCredentialsToPostmanInput!
  ) {
    exportIntegrationCredentialsToPostman(input: $input)
  }
` as unknown as DocumentNode<
  ExportIntegrationCredentialsToPostmanMutation,
  ExportIntegrationCredentialsToPostmanMutationVariables
>
export const AgaveCredentialsForDevEnvDocument = gql`
  query agaveCredentialsForDevEnv($input: AgaveCredentialsForDevEnvInput!) {
    agaveCredentialsForDevEnv(input: $input)
  }
` as unknown as DocumentNode<
  AgaveCredentialsForDevEnvQuery,
  AgaveCredentialsForDevEnvQueryVariables
>
export const RotateIntegrationCredentialDocument = gql`
  mutation rotateIntegrationCredential($input: RotateIntegrationCredentialInput!) {
    rotateIntegrationCredential(input: $input) {
      ...CompanyIntegrationProperties
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<
  RotateIntegrationCredentialMutation,
  RotateIntegrationCredentialMutationVariables
>
export const CompanyForCredentialsDocument = gql`
  query companyForCredentials($id: ID!) {
    company(id: $id) {
      id
      companyIntegrations {
        ...CompanyIntegrationProperties
      }
    }
  }
  ${CompanyIntegrationPropertiesDoc}
` as unknown as DocumentNode<CompanyForCredentialsQuery, CompanyForCredentialsQueryVariables>
export const AgaveDebuggerSessionUrlDocument = gql`
  query agaveDebuggerSessionUrl($input: AgaveDebuggerSessionUrlInput!) {
    agaveDebuggerSessionUrl(input: $input)
  }
` as unknown as DocumentNode<AgaveDebuggerSessionUrlQuery, AgaveDebuggerSessionUrlQueryVariables>
export const UpdateLocationRequestDocument = gql`
  mutation updateLocationRequest($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      ...LocationProperties
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<UpdateLocationRequestMutation, UpdateLocationRequestMutationVariables>
export const CreateLocationRequestDocument = gql`
  mutation createLocationRequest($input: CreateLocationInput!) {
    createLocation(input: $input) {
      ...LocationProperties
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<CreateLocationRequestMutation, CreateLocationRequestMutationVariables>
export const SetCompanyInternalSitelineNotesDocument = gql`
  mutation setCompanyInternalSitelineNotes($input: SetCompanyInternalSitelineNotesInput!) {
    setCompanyInternalSitelineNotes(input: $input)
  }
` as unknown as DocumentNode<
  SetCompanyInternalSitelineNotesMutation,
  SetCompanyInternalSitelineNotesMutationVariables
>
export const CompanyInternalSitelineNotesDocument = gql`
  query companyInternalSitelineNotes($companyId: ID!) {
    companyInternalSitelineNotes(companyId: $companyId)
  }
` as unknown as DocumentNode<
  CompanyInternalSitelineNotesQuery,
  CompanyInternalSitelineNotesQueryVariables
>
export const ProjectsByCompanyDocument = gql`
  query projectsByCompany($id: ID!) {
    projectsByCompany(id: $id) {
      ...ProjectProperties
      contracts {
        id
        contractNumber
        company {
          id
          name
        }
      }
    }
  }
  ${ProjectPropertiesDoc}
` as unknown as DocumentNode<ProjectsByCompanyQuery, ProjectsByCompanyQueryVariables>
export const DisableUserDocument = gql`
  mutation disableUser($input: DisableUserInput!) {
    disableUser(input: $input) {
      ...UserProperties
    }
  }
  ${UserPropertiesDoc}
` as unknown as DocumentNode<DisableUserMutation, DisableUserMutationVariables>
export const EnableUserDocument = gql`
  mutation enableUser($input: EnableUserInput!) {
    enableUser(input: $input) {
      ...UserProperties
    }
  }
  ${UserPropertiesDoc}
` as unknown as DocumentNode<EnableUserMutation, EnableUserMutationVariables>
export const GetCompanyUsersDocument = gql`
  query getCompanyUsers($companyId: ID!) {
    company(id: $companyId) {
      id
      users {
        ...CompanyUserProperties
      }
    }
  }
  ${CompanyUserPropertiesDoc}
` as unknown as DocumentNode<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>
export const GetCompanyVendorContactsDocument = gql`
  query getCompanyVendorContacts($companyId: ID!) {
    company(id: $companyId) {
      id
      vendors {
        id
        name
        contacts {
          id
          fullName
          email
          archivedAt
        }
      }
    }
  }
` as unknown as DocumentNode<GetCompanyVendorContactsQuery, GetCompanyVendorContactsQueryVariables>
export const GetCompanyVendorsDocument = gql`
  query getCompanyVendors($companyId: ID!) {
    company(id: $companyId) {
      id
      vendors {
        ...VendorProperties
      }
    }
  }
  ${VendorPropertiesDoc}
` as unknown as DocumentNode<GetCompanyVendorsQuery, GetCompanyVendorsQueryVariables>
export const DeleteVendorDocument = gql`
  mutation deleteVendor($id: ID!) {
    deleteVendor(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteVendorMutation, DeleteVendorMutationVariables>
export const MigrateIntegrationContractsDocument = gql`
  mutation migrateIntegrationContracts($input: MigrateIntegrationContractsInput!) {
    migrateIntegrationContracts(input: $input)
  }
` as unknown as DocumentNode<
  MigrateIntegrationContractsMutation,
  MigrateIntegrationContractsMutationVariables
>
export const MigrateIntegrationVendorsDocument = gql`
  mutation migrateIntegrationVendors($input: MigrateIntegrationVendorsInput!) {
    migrateIntegrationVendors(input: $input)
  }
` as unknown as DocumentNode<
  MigrateIntegrationVendorsMutation,
  MigrateIntegrationVendorsMutationVariables
>
export const UpdateFoundationPeyoteCredentialsDocument = gql`
  mutation updateFoundationPeyoteCredentials($input: UpdateFoundationPeyoteCredentialsInput!) {
    updateFoundationPeyoteCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateFoundationPeyoteCredentialsMutation,
  UpdateFoundationPeyoteCredentialsMutationVariables
>
export const GenerateSage100PeyotePairingCodeDocument = gql`
  mutation generateSage100PeyotePairingCode($companyIntegrationId: ID!) {
    generateSage100PeyotePairingCode(companyIntegrationId: $companyIntegrationId)
  }
` as unknown as DocumentNode<
  GenerateSage100PeyotePairingCodeMutation,
  GenerateSage100PeyotePairingCodeMutationVariables
>
export const TestSage100PeyoteConnectorConnectionDocument = gql`
  mutation testSage100PeyoteConnectorConnection($companyIntegrationId: ID!) {
    testSage100PeyoteConnectorConnection(companyIntegrationId: $companyIntegrationId) {
      isConnectorOnline
      connectorVersion
      errorMessage
    }
  }
` as unknown as DocumentNode<
  TestSage100PeyoteConnectorConnectionMutation,
  TestSage100PeyoteConnectorConnectionMutationVariables
>
export const UpdateSageIntacctPeyoteCredentialsDocument = gql`
  mutation updateSageIntacctPeyoteCredentials($input: UpdateSageIntacctPeyoteCredentialsInput!) {
    updateSageIntacctPeyoteCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateSageIntacctPeyoteCredentialsMutation,
  UpdateSageIntacctPeyoteCredentialsMutationVariables
>
export const SageIntacctPeyoteHasSenderCredentialsDocument = gql`
  query sageIntacctPeyoteHasSenderCredentials($companyIntegrationId: ID!) {
    sageIntacctPeyoteHasSenderCredentials(companyIntegrationId: $companyIntegrationId)
  }
` as unknown as DocumentNode<
  SageIntacctPeyoteHasSenderCredentialsQuery,
  SageIntacctPeyoteHasSenderCredentialsQueryVariables
>
export const UpdateSpectrumPeyoteCredentialsDocument = gql`
  mutation updateSpectrumPeyoteCredentials($input: UpdateSpectrumPeyoteCredentialsInput!) {
    updateSpectrumPeyoteCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateSpectrumPeyoteCredentialsMutation,
  UpdateSpectrumPeyoteCredentialsMutationVariables
>
export const UpdateSpectrumPeyoteCompanyDocument = gql`
  mutation updateSpectrumPeyoteCompany($input: UpdateSpectrumPeyoteCompanyInput!) {
    updateSpectrumPeyoteCompany(input: $input)
  }
` as unknown as DocumentNode<
  UpdateSpectrumPeyoteCompanyMutation,
  UpdateSpectrumPeyoteCompanyMutationVariables
>
export const UpdateVistaPeyoteCredentialsDocument = gql`
  mutation updateVistaPeyoteCredentials($input: UpdateVistaPeyoteCredentialsInput!) {
    updateVistaPeyoteCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateVistaPeyoteCredentialsMutation,
  UpdateVistaPeyoteCredentialsMutationVariables
>
export const LinkCompaniesDocument = gql`
  query linkCompanies($companyIntegrationId: ID!) {
    linkCompanies(companyIntegrationId: $companyIntegrationId) {
      integrationId
      sourceCompanyId
      name
    }
  }
` as unknown as DocumentNode<LinkCompaniesQuery, LinkCompaniesQueryVariables>
export const UpdateLinkCompanyDocument = gql`
  mutation updateLinkCompany($companyIntegrationId: ID!, $sourceCompanyId: String!) {
    updateLinkCompany(
      companyIntegrationId: $companyIntegrationId
      sourceCompanyId: $sourceCompanyId
    )
  }
` as unknown as DocumentNode<UpdateLinkCompanyMutation, UpdateLinkCompanyMutationVariables>
export const UpdateAcumaticaPeyoteCredentialsDocument = gql`
  mutation updateAcumaticaPeyoteCredentials($input: UpdateAcumaticaPeyoteCredentialsInput!) {
    updateAcumaticaPeyoteCredentials(input: $input) {
      id
    }
  }
` as unknown as DocumentNode<
  UpdateAcumaticaPeyoteCredentialsMutation,
  UpdateAcumaticaPeyoteCredentialsMutationVariables
>
export const AgaveLinkTokenDocument = gql`
  query agaveLinkToken($companyIntegrationId: ID!) {
    agaveLinkToken(companyIntegrationId: $companyIntegrationId)
  }
` as unknown as DocumentNode<AgaveLinkTokenQuery, AgaveLinkTokenQueryVariables>
export const UpdateAgaveIntegrationCredentialDocument = gql`
  mutation updateAgaveIntegrationCredential($input: UpdateAgaveIntegrationCredentialInput!) {
    updateAgaveIntegrationCredential(input: $input) {
      id
      credentialsUpdatedAt
    }
  }
` as unknown as DocumentNode<
  UpdateAgaveIntegrationCredentialMutation,
  UpdateAgaveIntegrationCredentialMutationVariables
>
export const IntegrationOauthAuthorizeUrlDocument = gql`
  query integrationOauthAuthorizeUrl($input: IntegrationOauthAuthorizeUrlInput!) {
    integrationOauthAuthorizeUrl(input: $input)
  }
` as unknown as DocumentNode<
  IntegrationOauthAuthorizeUrlQuery,
  IntegrationOauthAuthorizeUrlQueryVariables
>
export const IntegrationOnePasswordItemsDocument = gql`
  query integrationOnePasswordItems {
    integrationOnePasswordItems {
      vaultId
      itemId
      title
    }
  }
` as unknown as DocumentNode<
  IntegrationOnePasswordItemsQuery,
  IntegrationOnePasswordItemsQueryVariables
>
export const EnableIntegrationCredentialAutoRotationDocument = gql`
  mutation enableIntegrationCredentialAutoRotation(
    $input: EnableIntegrationCredentialAutoRotationInput!
  ) {
    enableIntegrationCredentialAutoRotation(input: $input) {
      id
      credentialsUpdatedAt
      credentialsReadyForAutoRotation
    }
  }
` as unknown as DocumentNode<
  EnableIntegrationCredentialAutoRotationMutation,
  EnableIntegrationCredentialAutoRotationMutationVariables
>
export const UpdateCmicPeyoteBasicCredentialsDocument = gql`
  mutation updateCmicPeyoteBasicCredentials($input: UpdateCmicPeyoteBasicCredentialsInput!) {
    updateCmicPeyoteBasicCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateCmicPeyoteBasicCredentialsMutation,
  UpdateCmicPeyoteBasicCredentialsMutationVariables
>
export const UpdateCmicPeyoteOauthCredentialsDocument = gql`
  mutation updateCmicPeyoteOauthCredentials($input: UpdateCmicPeyoteOauthCredentialsInput!) {
    updateCmicPeyoteOauthCredentials(input: $input)
  }
` as unknown as DocumentNode<
  UpdateCmicPeyoteOauthCredentialsMutation,
  UpdateCmicPeyoteOauthCredentialsMutationVariables
>
export const CompanyForGeneralContractorsDocument = gql`
  query companyForGeneralContractors($id: ID!) {
    company(id: $id) {
      id
      generalContractors {
        id
        name
      }
    }
  }
` as unknown as DocumentNode<
  CompanyForGeneralContractorsQuery,
  CompanyForGeneralContractorsQueryVariables
>
export const CreateLienWaiverFormTemplateSetDocument = gql`
  mutation createLienWaiverFormTemplateSet($input: CreateLienWaiverFormTemplateSetInput!) {
    createLienWaiverFormTemplateSet(input: $input) {
      id
      primaryLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      vendorLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      subTierLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
    }
  }
  ${CompanyLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  CreateLienWaiverFormTemplateSetMutation,
  CreateLienWaiverFormTemplateSetMutationVariables
>
export const UpdateLienWaiverFormTemplateSetDocument = gql`
  mutation updateLienWaiverFormTemplateSet($input: UpdateLienWaiverFormTemplateSetInput!) {
    updateLienWaiverFormTemplateSet(input: $input) {
      id
      primaryLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      vendorLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      subTierLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
    }
  }
  ${CompanyLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  UpdateLienWaiverFormTemplateSetMutation,
  UpdateLienWaiverFormTemplateSetMutationVariables
>
export const DeleteLienWaiverFormTemplateSetDocument = gql`
  mutation deleteLienWaiverFormTemplateSet($input: DeleteLienWaiverFormTemplateSetInput!) {
    deleteLienWaiverFormTemplateSet(input: $input) {
      id
      primaryLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      vendorLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
      subTierLienWaiverTemplateSets {
        ...CompanyLienWaiverTemplateSetProperties
      }
    }
  }
  ${CompanyLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  DeleteLienWaiverFormTemplateSetMutation,
  DeleteLienWaiverFormTemplateSetMutationVariables
>
export const CreatePayAppFormTemplateSetDocument = gql`
  mutation createPayAppFormTemplateSet($input: CreatePayAppFormTemplateSetInput!) {
    createPayAppFormTemplateSet(input: $input) {
      id
      payAppFormTemplateSets {
        ...CompanyPayAppFormTemplateSetProperties
      }
    }
  }
  ${CompanyPayAppFormTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  CreatePayAppFormTemplateSetMutation,
  CreatePayAppFormTemplateSetMutationVariables
>
export const UpdatePayAppFormTemplateSetDocument = gql`
  mutation updatePayAppFormTemplateSet($input: UpdatePayAppFormTemplateSetInput!) {
    updatePayAppFormTemplateSet(input: $input) {
      id
      payAppFormTemplateSets {
        ...CompanyPayAppFormTemplateSetProperties
      }
    }
  }
  ${CompanyPayAppFormTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  UpdatePayAppFormTemplateSetMutation,
  UpdatePayAppFormTemplateSetMutationVariables
>
export const DeletePayAppFormTemplateSetDocument = gql`
  mutation deletePayAppFormTemplateSet($input: DeletePayAppFormTemplateSetInput!) {
    deletePayAppFormTemplateSet(input: $input) {
      id
      payAppFormTemplateSets {
        ...CompanyPayAppFormTemplateSetProperties
      }
    }
  }
  ${CompanyPayAppFormTemplateSetPropertiesDoc}
` as unknown as DocumentNode<
  DeletePayAppFormTemplateSetMutation,
  DeletePayAppFormTemplateSetMutationVariables
>
export const GetContractDocument = gql`
  query getContract($id: ID!) {
    contract(id: $id) {
      id
      role
      status
      timeZone
      billingType
      contractDate
      contractNumber
      storedMaterialsCarryoverType
      daysBeforePayAppDue
      internalProjectNumber
      vendorNumber
      pastPayAppCount
      roundRetention
      defaultRetentionPercent
      retentionTrackingLevel
      contractTemplateVariables
      selectedAddress {
        ...LocationProperties
      }
      changeOrderRequestTemplates {
        id
      }
      changeOrderLogTemplates {
        id
      }
      project {
        ...ProjectProperties
      }
      company {
        ...CompanyProperties
      }
      integrations {
        ...IntegrationProperties
      }
      payAppRequirementGroups {
        ...PayAppRequirementGroupProperties
      }
      legalRequirements {
        ...LegalRequirementProperties
      }
      onboardedStatus {
        selectedPayAppForms
        onboardedPayAppForms
        selectedPrimaryLienWaivers
        onboardedPrimaryLienWaiverForms
        selectedVendorLienWaivers
        onboardedVendorLienWaiverForms
        selectedChangeOrderRequestForms
        onboardedChangeOrderRequestForms
        selectedChangeOrderLogForms
        onboardedChangeOrderLogForms
        addedSov
        selectedRateTable
        addedTeammates
        addedGcContacts
        startedBilling
        notifiedOnboardedForms
      }
      sov {
        id
      }
      lienWaiverTemplates {
        ...LeanSubcontractorLienWaiverTemplateSetProperties
      }
      lowerTierLienWaiverTemplates {
        ...LeanSubcontractorLienWaiverTemplateSetProperties
      }
      subTierLienWaiverTemplates {
        ...LeanSubcontractorLienWaiverTemplateSetProperties
      }
    }
  }
  ${LocationPropertiesDoc}
  ${ProjectPropertiesDoc}
  ${CompanyPropertiesDoc}
  ${IntegrationPropertiesDoc}
  ${PayAppRequirementGroupPropertiesDoc}
  ${LegalRequirementPropertiesDoc}
  ${LeanSubcontractorLienWaiverTemplateSetPropertiesDoc}
` as unknown as DocumentNode<GetContractQuery, GetContractQueryVariables>
export const UpdateOnboardedProjectContractStatusDocument = gql`
  mutation updateOnboardedProjectContractStatus(
    $input: UpdateOnboardedProjectContractStatusInput!
  ) {
    updateOnboardedProjectContractStatus(input: $input) {
      id
      onboardedStatus {
        selectedPayAppForms
        onboardedPayAppForms
        selectedPrimaryLienWaivers
        onboardedPrimaryLienWaiverForms
        selectedVendorLienWaivers
        onboardedVendorLienWaiverForms
        selectedChangeOrderRequestForms
        onboardedChangeOrderRequestForms
        selectedChangeOrderLogForms
        onboardedChangeOrderLogForms
        addedSov
        selectedRateTable
        addedTeammates
        addedGcContacts
        startedBilling
        notifiedOnboardedForms
      }
    }
  }
` as unknown as DocumentNode<
  UpdateOnboardedProjectContractStatusMutation,
  UpdateOnboardedProjectContractStatusMutationVariables
>
export const UpdatePayAppRequirementGroupsDocument = gql`
  mutation updatePayAppRequirementGroups($input: UpdatePayAppRequirementGroupsInput!) {
    updatePayAppRequirementGroups(input: $input) {
      ...ContractProperties
    }
  }
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<
  UpdatePayAppRequirementGroupsMutation,
  UpdatePayAppRequirementGroupsMutationVariables
>
export const ContractFormTemplatesDocument = gql`
  query contractFormTemplates($contractId: ID!) {
    contractFormTemplates(contractId: $contractId) {
      id
      createdAt
      type
      userVisibleName
      status
      skippedValidation
      variants {
        id
        isDefaultVariant
      }
      associatedContracts {
        id
        providedAsFormType
        ignoreProvidedAsFormType
        contract {
          id
        }
      }
    }
  }
` as unknown as DocumentNode<ContractFormTemplatesQuery, ContractFormTemplatesQueryVariables>
export const IgnoreFormTemplateProvidedTypeDocument = gql`
  mutation ignoreFormTemplateProvidedType($input: IgnoreFormTemplateProvidedTypeInput!) {
    ignoreFormTemplateProvidedType(input: $input) {
      id
      associatedFormTemplates {
        id
        ignoreProvidedAsFormType
      }
      onboardedStatus {
        selectedPayAppForms
        onboardedPayAppForms
        selectedPrimaryLienWaivers
        onboardedPrimaryLienWaiverForms
        selectedVendorLienWaivers
        onboardedVendorLienWaiverForms
        selectedChangeOrderRequestForms
        onboardedChangeOrderRequestForms
        notifiedOnboardedForms
      }
    }
  }
` as unknown as DocumentNode<
  IgnoreFormTemplateProvidedTypeMutation,
  IgnoreFormTemplateProvidedTypeMutationVariables
>
export const ContractForUsersDocument = gql`
  query contractForUsers($contractId: ID!) {
    contract(id: $contractId) {
      id
      users {
        id
        user {
          id
          firstName
          lastName
          email
          jobTitle
          phoneNumber
        }
      }
      company {
        id
        users {
          id
          role
          status
          user {
            id
            firstName
            lastName
            email
            jobTitle
            phoneNumber
          }
        }
      }
    }
  }
` as unknown as DocumentNode<ContractForUsersQuery, ContractForUsersQueryVariables>
export const UpdateContractUsersDocument = gql`
  mutation updateContractUsers($input: UpdateContractUsersInput!) {
    updateContractUsers(input: $input) {
      id
      users {
        id
        user {
          id
          firstName
          lastName
          email
          jobTitle
          phoneNumber
        }
      }
    }
  }
` as unknown as DocumentNode<UpdateContractUsersMutation, UpdateContractUsersMutationVariables>
export const FinishedOnboardingFormsDocument = gql`
  mutation finishedOnboardingForms($id: ID!) {
    finishedOnboardingForms(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<
  FinishedOnboardingFormsMutation,
  FinishedOnboardingFormsMutationVariables
>
export const DeleteIntegrationDocument = gql`
  mutation deleteIntegration($id: ID!) {
    deleteIntegration(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>
export const UpdateLegalRequirementsDocument = gql`
  mutation updateLegalRequirements($input: UpdateLegalRequirementsInput!) {
    updateLegalRequirements(input: $input) {
      ...ContractProperties
    }
  }
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<
  UpdateLegalRequirementsMutation,
  UpdateLegalRequirementsMutationVariables
>
export const CreateSovLineItemGroupDocument = gql`
  mutation createSovLineItemGroup($input: CreateSovLineItemGroupInput!) {
    createSovLineItemGroup(input: $input) {
      ...SovLineItemGroupProperties
    }
  }
  ${SovLineItemGroupPropertiesDoc}
` as unknown as DocumentNode<
  CreateSovLineItemGroupMutation,
  CreateSovLineItemGroupMutationVariables
>
export const UpdateSovLineItemGroupDocument = gql`
  mutation updateSovLineItemGroup($input: UpdateSovLineItemGroupInput!) {
    updateSovLineItemGroup(input: $input) {
      ...SovLineItemGroupProperties
    }
  }
  ${SovLineItemGroupPropertiesDoc}
` as unknown as DocumentNode<
  UpdateSovLineItemGroupMutation,
  UpdateSovLineItemGroupMutationVariables
>
export const DeleteSovLineItemGroupDocument = gql`
  mutation deleteSovLineItemGroup($id: ID!) {
    deleteSovLineItemGroup(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<
  DeleteSovLineItemGroupMutation,
  DeleteSovLineItemGroupMutationVariables
>
export const SetLineItemsInGroupDocument = gql`
  mutation setLineItemsInGroup($input: SetLineItemsInGroupInput!) {
    setLineItemsInGroup(input: $input) {
      ...SovLineItemGroupProperties
    }
  }
  ${SovLineItemGroupPropertiesDoc}
` as unknown as DocumentNode<SetLineItemsInGroupMutation, SetLineItemsInGroupMutationVariables>
export const EnablePrimaryLienWaiversDocument = gql`
  mutation enablePrimaryLienWaivers($input: EnableLienWaiverInput!) {
    enablePrimaryLienWaivers(input: $input) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  EnablePrimaryLienWaiversMutation,
  EnablePrimaryLienWaiversMutationVariables
>
export const DisablePrimaryLienWaiversDocument = gql`
  mutation disablePrimaryLienWaivers($contractId: ID!) {
    disablePrimaryLienWaivers(contractId: $contractId) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  DisablePrimaryLienWaiversMutation,
  DisablePrimaryLienWaiversMutationVariables
>
export const EnableLowerTierLienWaiversDocument = gql`
  mutation enableLowerTierLienWaivers($input: EnableLienWaiverInput!) {
    enableLowerTierLienWaivers(input: $input) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  EnableLowerTierLienWaiversMutation,
  EnableLowerTierLienWaiversMutationVariables
>
export const DisableLowerTierLienWaiversDocument = gql`
  mutation disableLowerTierLienWaivers($contractId: ID!) {
    disableLowerTierLienWaivers(contractId: $contractId) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  DisableLowerTierLienWaiversMutation,
  DisableLowerTierLienWaiversMutationVariables
>
export const EnableSubTierLienWaiversDocument = gql`
  mutation enableSubTierLienWaivers($input: EnableLienWaiverInput!) {
    enableSubTierLienWaivers(input: $input) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  EnableSubTierLienWaiversMutation,
  EnableSubTierLienWaiversMutationVariables
>
export const DisableSubTierLienWaiversDocument = gql`
  mutation disableSubTierLienWaivers($contractId: ID!) {
    disableSubTierLienWaivers(contractId: $contractId) {
      ...ContractForLienWaiverSettings
    }
  }
  ${ContractForLienWaiverSettingsDoc}
` as unknown as DocumentNode<
  DisableSubTierLienWaiversMutation,
  DisableSubTierLienWaiversMutationVariables
>
export const UpdateContractDocument = gql`
  mutation updateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      ...ContractProperties
    }
  }
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<UpdateContractMutation, UpdateContractMutationVariables>
export const SovLineItemGroupsDocument = gql`
  query sovLineItemGroups($contractId: ID!) {
    sovLineItemGroups(contractId: $contractId) {
      ...SovLineItemGroupProperties
    }
  }
  ${SovLineItemGroupPropertiesDoc}
` as unknown as DocumentNode<SovLineItemGroupsQuery, SovLineItemGroupsQueryVariables>
export const ContractForSovDocument = gql`
  query contractForSov($contractId: ID!) {
    contract(id: $contractId) {
      id
      sov {
        ...CompanySovProperties
      }
    }
  }
  ${CompanySovPropertiesDoc}
` as unknown as DocumentNode<ContractForSovQuery, ContractForSovQueryVariables>
export const ContractForPayAppsDocument = gql`
  query contractForPayApps($contractId: ID!) {
    contract(id: $contractId) {
      id
      payApps {
        id
        createdAt
        timeZone
        status
        retentionOnly
        billingStart
        billingEnd
        payAppDueDate
        currentBilled
        retentionHeldCurrent
        retentionHeldToDate
        retentionReleasedCurrent
        payAppNumber
      }
    }
  }
` as unknown as DocumentNode<ContractForPayAppsQuery, ContractForPayAppsQueryVariables>
export const UpdateChangeOrderRequestFormDocument = gql`
  mutation updateChangeOrderRequestForm($input: UpdateChangeOrderRequestFormInput!) {
    updateChangeOrderRequestForm(input: $input) {
      id
      changeOrderRequestTemplates {
        id
      }
    }
  }
` as unknown as DocumentNode<
  UpdateChangeOrderRequestFormMutation,
  UpdateChangeOrderRequestFormMutationVariables
>
export const UpdateChangeOrderLogFormDocument = gql`
  mutation updateChangeOrderLogForm($input: UpdateChangeOrderLogFormInput!) {
    updateChangeOrderLogForm(input: $input) {
      id
      changeOrderLogTemplates {
        id
      }
    }
  }
` as unknown as DocumentNode<
  UpdateChangeOrderLogFormMutation,
  UpdateChangeOrderLogFormMutationVariables
>
export const ConvertRetentionTrackingLevelDocument = gql`
  mutation convertRetentionTrackingLevel($input: ConvertRetentionTrackingLevelInput!) {
    convertRetentionTrackingLevel(input: $input) {
      ...ContractProperties
    }
  }
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<
  ConvertRetentionTrackingLevelMutation,
  ConvertRetentionTrackingLevelMutationVariables
>
export const UpdateRoundRetentionDocument = gql`
  mutation updateRoundRetention($input: UpdateRoundRetentionInput!) {
    updateRoundRetention(input: $input) {
      ...ContractProperties
    }
  }
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<UpdateRoundRetentionMutation, UpdateRoundRetentionMutationVariables>
export const DeleteSovLineItemDocument = gql`
  mutation deleteSovLineItem($id: ID!) {
    deleteSovLineItem(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteSovLineItemMutation, DeleteSovLineItemMutationVariables>
export const UpdateIntegrationMappingsDocument = gql`
  mutation updateIntegrationMappings($input: UpdateIntegrationMappingsInput!) {
    updateIntegrationMappings(input: $input) {
      ...IntegrationProperties
    }
  }
  ${IntegrationPropertiesDoc}
` as unknown as DocumentNode<
  UpdateIntegrationMappingsMutation,
  UpdateIntegrationMappingsMutationVariables
>
export const RefreshIntegrationMappingsDocument = gql`
  mutation refreshIntegrationMappings($input: RefreshIntegrationMappingsInput!) {
    refreshIntegrationMappings(input: $input) {
      ...IntegrationProperties
    }
  }
  ${IntegrationPropertiesDoc}
` as unknown as DocumentNode<
  RefreshIntegrationMappingsMutation,
  RefreshIntegrationMappingsMutationVariables
>
export const ImportSovFromIntegrationDocument = gql`
  mutation importSovFromIntegration($input: ImportSovFromIntegrationInput!) {
    importSovFromIntegration(input: $input) {
      ...SovProperties
    }
  }
  ${SovPropertiesDoc}
` as unknown as DocumentNode<
  ImportSovFromIntegrationMutation,
  ImportSovFromIntegrationMutationVariables
>
export const PaginatedContractMismatchReportOperationGroupsDocument = gql`
  query paginatedContractMismatchReportOperationGroups(
    $input: GetPaginatedContractMismatchReportOperationGroupsInput!
  ) {
    paginatedContractMismatchReportOperationGroups(input: $input) {
      hasNext
      cursor
      totalCount
      groups {
        id
        firstOperationCreatedAt
        mostRecentOperationUpdatedAt
        status
        numSuccessful
        numFailed
        totalOperations
        company {
          id
          name
        }
        requestedBy {
          id
          email
          firstName
        }
      }
    }
  }
` as unknown as DocumentNode<
  PaginatedContractMismatchReportOperationGroupsQuery,
  PaginatedContractMismatchReportOperationGroupsQueryVariables
>
export const AbandonedPayAppsDocument = gql`
  query abandonedPayApps {
    abandonedPayApps {
      companyId
      companyName
      companyCreatedAt
      abandonedPayAppsCount
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<AbandonedPayAppsQuery, AbandonedPayAppsQueryVariables>
export const BillingTotalsDocument = gql`
  query billingTotals($input: BillingTotalsInput!) {
    billingTotals(input: $input) {
      month
      companyId
      companyCreatedAt
      companyName
      submittedPayAppCount
      totalBilledThisMonth
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<BillingTotalsQuery, BillingTotalsQueryVariables>
export const ChangeOrderLogUseDocument = gql`
  query changeOrderLogUse {
    changeOrderLogUse {
      companyId
      companyName
      companyCreatedAt
      percentProjectsWithChangeOrder
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<ChangeOrderLogUseQuery, ChangeOrderLogUseQueryVariables>
export const ComplianceUseDocument = gql`
  query complianceUse {
    complianceUse {
      companyId
      companyName
      companyCreatedAt
      percentProjectsWithComplianceRequirements
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<ComplianceUseQuery, ComplianceUseQueryVariables>
export const FormTrackerDocument = gql`
  query formTracker($input: FormTrackerInput!) {
    formTracker(input: $input) {
      companyId
      companyName
      companyCreatedAt
      requestedFormsCount
      completedFormsCount
      formsCompletedRatio
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<FormTrackerQuery, FormTrackerQueryVariables>
export const PayAppsSubmittedMonthDocument = gql`
  query payAppsSubmittedMonth($input: PayAppsSubmittedMonthInput!) {
    payAppsSubmittedMonth(input: $input) {
      companyId
      companyName
      companyCreatedAt
      payAppsSubmittedThisMonth
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<PayAppsSubmittedMonthQuery, PayAppsSubmittedMonthQueryVariables>
export const TimeToValueDocument = gql`
  query timeToValue {
    timeToValue {
      company {
        id
        nickname
        name
        expectedNumberOfProjects
        sitelinePointOfContact {
          id
          firstName
          lastName
        }
      }
      billingByMonth {
        month
        cumulativeContractsBilled
      }
    }
  }
` as unknown as DocumentNode<TimeToValueQuery, TimeToValueQueryVariables>
export const LienWaiversRequestedDocument = gql`
  query lienWaiversRequested {
    lienWaiversRequested {
      companyId
      companyName
      companyCreatedAt
      lienWaiversRequested
      sitelinePointOfContactId
      sitelinePointOfContactName
    }
  }
` as unknown as DocumentNode<LienWaiversRequestedQuery, LienWaiversRequestedQueryVariables>
export const ProjectLocationsDocument = gql`
  query projectLocations {
    projects {
      id
      name
      contracts {
        id
        users {
          id
          user {
            id
            email
          }
        }
      }
      location {
        ...LocationProperties
      }
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<ProjectLocationsQuery, ProjectLocationsQueryVariables>
export const CompanyLocationsDocument = gql`
  query companyLocations {
    companies {
      id
      name
      type
      users {
        id
        status
        user {
          id
          email
        }
      }
      locations {
        ...LocationProperties
      }
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<CompanyLocationsQuery, CompanyLocationsQueryVariables>
export const DemoCompaniesDocument = gql`
  query demoCompanies {
    demoCompanies {
      id
      name
      nickname
    }
  }
` as unknown as DocumentNode<DemoCompaniesQuery, DemoCompaniesQueryVariables>
export const MarkOldSubmittedPayAppsAsPaidDocument = gql`
  mutation markOldSubmittedPayAppsAsPaid($input: MarkOldSubmittedPayAppsAsPaidInput!) {
    markOldSubmittedPayAppsAsPaid(input: $input)
  }
` as unknown as DocumentNode<
  MarkOldSubmittedPayAppsAsPaidMutation,
  MarkOldSubmittedPayAppsAsPaidMutationVariables
>
export const DeleteLienWaiverRequestsForMonthDocument = gql`
  mutation deleteLienWaiverRequestsForMonth($input: DeleteLienWaiverRequestsForMonthInput!) {
    deleteLienWaiverRequestsForMonth(input: $input)
  }
` as unknown as DocumentNode<
  DeleteLienWaiverRequestsForMonthMutation,
  DeleteLienWaiverRequestsForMonthMutationVariables
>
export const MarkLienWaiverRequestsAsSubmittedForMonthDocument = gql`
  mutation markLienWaiverRequestsAsSubmittedForMonth(
    $input: MarkLienWaiverRequestsAsSubmittedForMonthInput!
  ) {
    markLienWaiverRequestsAsSubmittedForMonth(input: $input)
  }
` as unknown as DocumentNode<
  MarkLienWaiverRequestsAsSubmittedForMonthMutation,
  MarkLienWaiverRequestsAsSubmittedForMonthMutationVariables
>
export const CompaniesByRolloutPercentageDocument = gql`
  query companiesByRolloutPercentage($input: CompaniesByRolloutPercentageInput!) {
    companiesByRolloutPercentage(input: $input)
  }
` as unknown as DocumentNode<
  CompaniesByRolloutPercentageQuery,
  CompaniesByRolloutPercentageQueryVariables
>
export const FeatureFlagsDocument = gql`
  query featureFlags {
    featureFlags {
      id
      name
      enabled
      sitelineTeamMembersOnly
      companyIds
      description
      rolloutPercentage
    }
  }
` as unknown as DocumentNode<FeatureFlagsQuery, FeatureFlagsQueryVariables>
export const CreateFeatureFlagDocument = gql`
  mutation createFeatureFlag($input: CreateFeatureFlagInput!) {
    createFeatureFlag(input: $input) {
      id
      name
      enabled
      sitelineTeamMembersOnly
      companyIds
      description
      rolloutPercentage
    }
  }
` as unknown as DocumentNode<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>
export const UpdateFeatureFlagDocument = gql`
  mutation updateFeatureFlag($input: UpdateFeatureFlagInput!) {
    updateFeatureFlag(input: $input) {
      id
      name
      enabled
      sitelineTeamMembersOnly
      companyIds
      description
      rolloutPercentage
    }
  }
` as unknown as DocumentNode<UpdateFeatureFlagMutation, UpdateFeatureFlagMutationVariables>
export const CreateFormTemplateDocument = gql`
  mutation createFormTemplate($input: CreateFormTemplateInput!) {
    createFormTemplate(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>
export const SitelineTeamMembersDocument = gql`
  query sitelineTeamMembers {
    sitelineTeamMembers {
      id
      firstName
      lastName
      email
    }
  }
` as unknown as DocumentNode<SitelineTeamMembersQuery, SitelineTeamMembersQueryVariables>
export const UpdateFormTemplateStatusDocument = gql`
  mutation updateFormTemplateStatus($input: UpdateFormTemplateStatusInput!) {
    updateFormTemplateStatus(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateStatusMutation,
  UpdateFormTemplateStatusMutationVariables
>
export const UpdateFormTemplateOwnerDocument = gql`
  mutation updateFormTemplateOwner($input: UpdateFormTemplateUserInput!) {
    updateFormTemplateOwner(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateOwnerMutation,
  UpdateFormTemplateOwnerMutationVariables
>
export const UpdateFormTemplateBuilderDocument = gql`
  mutation updateFormTemplateBuilder($input: UpdateFormTemplateUserInput!) {
    updateFormTemplateBuilder(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateBuilderMutation,
  UpdateFormTemplateBuilderMutationVariables
>
export const UpdateFormTemplateValidatorDocument = gql`
  mutation updateFormTemplateValidator($input: UpdateFormTemplateUserInput!) {
    updateFormTemplateValidator(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateValidatorMutation,
  UpdateFormTemplateValidatorMutationVariables
>
export const UpdateFormTemplateOriginalFileDocument = gql`
  mutation updateFormTemplateOriginalFile($input: UpdateFormTemplateOriginalFileInput!) {
    updateFormTemplateOriginalFile(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateOriginalFileMutation,
  UpdateFormTemplateOriginalFileMutationVariables
>
export const UpdateFormTemplateDueDateDocument = gql`
  mutation updateFormTemplateDueDate($input: UpdateFormTemplateDueDateInput!) {
    updateFormTemplateDueDate(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateDueDateMutation,
  UpdateFormTemplateDueDateMutationVariables
>
export const MarkFormTemplateAsDuplicateDocument = gql`
  mutation markFormTemplateAsDuplicate($input: MarkFormTemplateAsDuplicateInput!) {
    markFormTemplateAsDuplicate(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  MarkFormTemplateAsDuplicateMutation,
  MarkFormTemplateAsDuplicateMutationVariables
>
export const AddFormTemplateCommentDocument = gql`
  mutation addFormTemplateComment($input: AddFormTemplateCommentInput!) {
    addFormTemplateComment(input: $input) {
      ...FormTemplateCommentProperties
    }
  }
  ${FormTemplateCommentPropertiesDoc}
` as unknown as DocumentNode<
  AddFormTemplateCommentMutation,
  AddFormTemplateCommentMutationVariables
>
export const DeleteFormTemplateCommentDocument = gql`
  mutation deleteFormTemplateComment($id: ID!) {
    deleteFormTemplateComment(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<
  DeleteFormTemplateCommentMutation,
  DeleteFormTemplateCommentMutationVariables
>
export const GetFormTemplateDocument = gql`
  query getFormTemplate($id: ID!) {
    formTemplate(id: $id) {
      ...FormTemplateProperties
      requestingCompany {
        id
        name
        picture {
          id
          url
        }
        notaryStamp {
          id
          url
        }
        notarySignature {
          id
          url
        }
        secondarySignature {
          id
          url
        }
      }
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<GetFormTemplateQuery, GetFormTemplateQueryVariables>
export const FormTemplateForDetailsDocument = gql`
  query formTemplateForDetails($id: ID!) {
    formTemplate(id: $id) {
      id
      createdAt
      type
      status
      statusLogs {
        ...FormTemplateStatusLogProperties
      }
      skippedValidation
      userVisibleName
      isCustomerReady
      tags
      dueDate
      associatedCompany {
        id
      }
      requestingCompany {
        id
      }
      associatedContracts {
        id
        providedAsFormType
        ignoreProvidedAsFormType
        contract {
          id
          billingType
          payAppRequirementGroups {
            id
            payAppRequirements {
              id
              templateVariant {
                id
                template {
                  id
                }
              }
            }
          }
          lienWaiverTemplates {
            id
            conditionalProgressVariant {
              id
              template {
                id
              }
            }
            unconditionalProgressVariant {
              id
              template {
                id
              }
            }
            conditionalFinalVariant {
              id
              template {
                id
              }
            }
            unconditionalFinalVariant {
              id
              template {
                id
              }
            }
          }
          lowerTierLienWaiverTemplates {
            id
            conditionalProgressVariant {
              id
              template {
                id
              }
            }
            unconditionalProgressVariant {
              id
              template {
                id
              }
            }
            conditionalFinalVariant {
              id
              template {
                id
              }
            }
            unconditionalFinalVariant {
              id
              template {
                id
              }
            }
          }
          subTierLienWaiverTemplates {
            id
            conditionalProgressVariant {
              id
              template {
                id
              }
            }
            unconditionalProgressVariant {
              id
              template {
                id
              }
            }
            conditionalFinalVariant {
              id
              template {
                id
              }
            }
            unconditionalFinalVariant {
              id
              template {
                id
              }
            }
          }
          changeOrderRequestTemplates {
            id
          }
          changeOrderLogTemplates {
            id
          }
          legalRequirements {
            id
            formTemplate {
              id
            }
          }
          daysBeforePayAppDue
          project {
            id
            name
            timeZone
            metadata {
              payAppDueOnDayOfMonth
            }
          }
          company {
            id
            name
          }
        }
      }
      owner {
        id
        email
        firstName
        lastName
      }
      builder {
        id
        email
        firstName
        lastName
      }
      validator {
        id
        email
        firstName
        lastName
      }
      versions {
        ...FormTemplateVersionProperties
      }
      variants {
        id
        internalName
        isDefaultVariant
      }
      comments {
        ...FormTemplateCommentProperties
      }
      originalFile {
        ...StoredFileProperties
      }
      duplicateTemplate {
        id
        userVisibleName
      }
    }
  }
  ${FormTemplateStatusLogPropertiesDoc}
  ${FormTemplateVersionPropertiesDoc}
  ${FormTemplateCommentPropertiesDoc}
  ${StoredFilePropertiesDoc}
` as unknown as DocumentNode<FormTemplateForDetailsQuery, FormTemplateForDetailsQueryVariables>
export const UpdatedFormTemplateDocument = gql`
  subscription updatedFormTemplate($id: ID!) {
    updatedFormTemplate(id: $id) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdatedFormTemplateSubscription,
  UpdatedFormTemplateSubscriptionVariables
>
export const ContractsWithTemplateDocument = gql`
  query contractsWithTemplate($input: GetPaginatedContractsInput!) {
    paginatedContracts(input: $input) {
      hasNext
      totalCount
      cursor
      contracts {
        id
        project {
          id
          name
        }
        company {
          id
          name
        }
      }
    }
  }
` as unknown as DocumentNode<ContractsWithTemplateQuery, ContractsWithTemplateQueryVariables>
export const ContractsForAutocompleteDocument = gql`
  query contractsForAutocomplete($input: GetPaginatedContractsInput!) {
    paginatedContracts(input: $input) {
      contracts {
        id
        daysBeforePayAppDue
        company {
          id
          name
        }
        project {
          id
          name
          timeZone
          metadata {
            payAppDueOnDayOfMonth
          }
        }
      }
    }
  }
` as unknown as DocumentNode<ContractsForAutocompleteQuery, ContractsForAutocompleteQueryVariables>
export const UpdateFormTemplateDocument = gql`
  mutation updateFormTemplate($input: UpdateFormTemplateInput!) {
    updateFormTemplate(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>
export const UpdateFormTemplateAssociatedCompanyDocument = gql`
  mutation updateFormTemplateAssociatedCompany($input: UpdateFormTemplateAssociatedCompanyInput!) {
    updateFormTemplateAssociatedCompany(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateAssociatedCompanyMutation,
  UpdateFormTemplateAssociatedCompanyMutationVariables
>
export const UpdateFormTemplateRequestingCompanyDocument = gql`
  mutation updateFormTemplateRequestingCompany($input: UpdateFormTemplateRequestingCompanyInput!) {
    updateFormTemplateRequestingCompany(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateRequestingCompanyMutation,
  UpdateFormTemplateRequestingCompanyMutationVariables
>
export const UpdateFormTemplateAssociatedContractsDocument = gql`
  mutation updateFormTemplateAssociatedContracts(
    $input: UpdateFormTemplateAssociatedContractsInput!
  ) {
    updateFormTemplateAssociatedContracts(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateAssociatedContractsMutation,
  UpdateFormTemplateAssociatedContractsMutationVariables
>
export const DeleteFormTemplateDocument = gql`
  mutation deleteFormTemplate($id: ID!) {
    deleteFormTemplate(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>
export const CloneFormTemplateDocument = gql`
  mutation cloneFormTemplate($input: CloneFormTemplateInput!) {
    cloneFormTemplate(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<CloneFormTemplateMutation, CloneFormTemplateMutationVariables>
export const SetFormTemplateTagsDocument = gql`
  mutation setFormTemplateTags($input: SetFormTemplateTagsInput!) {
    setFormTemplateTags(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<SetFormTemplateTagsMutation, SetFormTemplateTagsMutationVariables>
export const FormTemplateContractsForDueDateDocument = gql`
  query formTemplateContractsForDueDate($input: ContractsByIdInput!) {
    contractsById(input: $input) {
      id
      skippedPayAppMonths
      daysBeforePayAppDue
      timeZone
      project {
        id
        name
        metadata {
          payAppDueOnDayOfMonth
        }
      }
      payApps {
        id
        payAppNumber
        billingEnd
        internalDueDate
        status
      }
    }
  }
` as unknown as DocumentNode<
  FormTemplateContractsForDueDateQuery,
  FormTemplateContractsForDueDateQueryVariables
>
export const CloneFormTemplateVersionDocument = gql`
  mutation cloneFormTemplateVersion($formTemplateVersionId: ID!) {
    cloneFormTemplateVersion(formTemplateVersionId: $formTemplateVersionId) {
      ...FormTemplateVersionProperties
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<
  CloneFormTemplateVersionMutation,
  CloneFormTemplateVersionMutationVariables
>
export const SkipFormTemplateValidationDocument = gql`
  mutation skipFormTemplateValidation($input: SkipFormTemplateValidationInput!) {
    skipFormTemplateValidation(input: $input) {
      ...FormTemplateProperties
    }
  }
  ${FormTemplatePropertiesDoc}
` as unknown as DocumentNode<
  SkipFormTemplateValidationMutation,
  SkipFormTemplateValidationMutationVariables
>
export const ContractForAutocompleteDocument = gql`
  query contractForAutocomplete($id: ID!) {
    contract(id: $id) {
      id
      daysBeforePayAppDue
      company {
        id
        name
      }
      project {
        id
        name
        timeZone
        metadata {
          payAppDueOnDayOfMonth
        }
      }
    }
  }
` as unknown as DocumentNode<ContractForAutocompleteQuery, ContractForAutocompleteQueryVariables>
export const PaginatedTemplatesDocument = gql`
  query paginatedTemplates($input: GetPaginatedTemplatesInput!) {
    paginatedTemplates(input: $input) {
      hasNext
      cursor
      totalCount
      templates {
        id
        type
        createdAt
        userVisibleName
        status
        skippedValidation
        dueDate
        requestingCompany {
          id
          name
        }
        owner {
          id
          firstName
        }
        builder {
          id
          firstName
        }
        validator {
          id
          firstName
        }
      }
    }
  }
` as unknown as DocumentNode<PaginatedTemplatesQuery, PaginatedTemplatesQueryVariables>
export const TemplateBuildStatsDocument = gql`
  query templateBuildStats {
    templateBuildStats {
      builders {
        user {
          id
          firstName
        }
      }
    }
  }
` as unknown as DocumentNode<TemplateBuildStatsQuery, TemplateBuildStatsQueryVariables>
export const SimilarTemplatesDocument = gql`
  query similarTemplates($upload: Upload!) {
    similarTemplates(upload: $upload) {
      ...SimilarTemplateProperties
    }
  }
  ${SimilarTemplatePropertiesDoc}
` as unknown as DocumentNode<SimilarTemplatesQuery, SimilarTemplatesQueryVariables>
export const FormTurnaroundDataDocument = gql`
  query formTurnaroundData($input: FormTurnaroundDataInput!) {
    formTurnaroundData(input: $input) {
      forms {
        startDate
        endDate
        formTemplate {
          id
          userVisibleName
          builderId
          requestingCompanyId
          validatorId
          ownerId
        }
      }
      companies {
        id
        name
      }
      users {
        id
        firstName
        lastName
      }
    }
  }
` as unknown as DocumentNode<FormTurnaroundDataQuery, FormTurnaroundDataQueryVariables>
export const CreateFormTemplateVersionDocument = gql`
  mutation createFormTemplateVersion($input: CreateFormTemplateVersionInput!) {
    createFormTemplateVersion(input: $input) {
      ...FormTemplateVersionProperties
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<
  CreateFormTemplateVersionMutation,
  CreateFormTemplateVersionMutationVariables
>
export const ReplaceFormTemplateAnnotationsDocument = gql`
  mutation replaceFormTemplateAnnotations($input: ReplaceFormTemplateAnnotationsInput!) {
    replaceFormTemplateAnnotations(input: $input) {
      ...FormTemplateAnnotationProperties
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<
  ReplaceFormTemplateAnnotationsMutation,
  ReplaceFormTemplateAnnotationsMutationVariables
>
export const TemplateForPreviewDocument = gql`
  query templateForPreview($id: ID!) {
    formTemplate(id: $id) {
      id
      updatedAt
      status
      versions {
        id
        versionNumber
        annotations {
          ...FormTemplateAnnotationProperties
        }
        file {
          id
          url
          name
        }
      }
      variants {
        id
        internalName
        isDefaultVariant
        hidesZeroDollarAmounts
        roundPercentages
        annotationOverrides {
          ...AnnotationOverrideProperties
        }
      }
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
  ${AnnotationOverridePropertiesDoc}
` as unknown as DocumentNode<TemplateForPreviewQuery, TemplateForPreviewQueryVariables>
export const CreateTemplateVariantDocument = gql`
  mutation createTemplateVariant($input: CreateTemplateVariantInput!) {
    createTemplateVariant(input: $input) {
      ...FormTemplateVariantProperties
    }
  }
  ${FormTemplateVariantPropertiesDoc}
` as unknown as DocumentNode<CreateTemplateVariantMutation, CreateTemplateVariantMutationVariables>
export const DeleteAnnotationsDocument = gql`
  mutation DeleteAnnotations($input: DeleteAnnotationsFromAiSuggestionInput!) {
    deleteAnnotationsFromAiSuggestion(input: $input) {
      id
      annotations {
        ...FormTemplateAnnotationProperties
      }
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<DeleteAnnotationsMutation, DeleteAnnotationsMutationVariables>
export const UpdateTemplateVariantDocument = gql`
  mutation updateTemplateVariant($input: UpdateTemplateVariantInput!) {
    updateTemplateVariant(input: $input) {
      ...FormTemplateVariantProperties
    }
  }
  ${FormTemplateVariantPropertiesDoc}
` as unknown as DocumentNode<UpdateTemplateVariantMutation, UpdateTemplateVariantMutationVariables>
export const DeleteTemplateVariantDocument = gql`
  mutation deleteTemplateVariant($id: ID!) {
    deleteTemplateVariant(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteTemplateVariantMutation, DeleteTemplateVariantMutationVariables>
export const CreateFormTemplateAnnotationDocument = gql`
  mutation createFormTemplateAnnotation($input: CreateFormAnnotationInput!) {
    createFormTemplateAnnotation(input: $input) {
      ...FormTemplateAnnotationProperties
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<
  CreateFormTemplateAnnotationMutation,
  CreateFormTemplateAnnotationMutationVariables
>
export const CreateFormTemplateAnnotationsDocument = gql`
  mutation createFormTemplateAnnotations($input: CreateFormAnnotationsInput!) {
    createFormTemplateAnnotations(input: $input) {
      ...FormTemplateAnnotationProperties
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<
  CreateFormTemplateAnnotationsMutation,
  CreateFormTemplateAnnotationsMutationVariables
>
export const DeleteFormTemplateAnnotationsDocument = gql`
  mutation deleteFormTemplateAnnotations($ids: [ID!]!) {
    deleteFormTemplateAnnotations(ids: $ids) {
      id
    }
  }
` as unknown as DocumentNode<
  DeleteFormTemplateAnnotationsMutation,
  DeleteFormTemplateAnnotationsMutationVariables
>
export const UpdateFormTemplateAnnotationsDocument = gql`
  mutation updateFormTemplateAnnotations($input: UpdateFormAnnotationsInput!) {
    updateFormTemplateAnnotations(input: $input) {
      ...FormTemplateAnnotationProperties
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateAnnotationsMutation,
  UpdateFormTemplateAnnotationsMutationVariables
>
export const ApplyAnnotationOverrideDocument = gql`
  mutation applyAnnotationOverride($input: ApplyAnnotationOverrideInput!) {
    applyAnnotationOverride(input: $input) {
      ...AnnotationOverrideProperties
    }
  }
  ${AnnotationOverridePropertiesDoc}
` as unknown as DocumentNode<
  ApplyAnnotationOverrideMutation,
  ApplyAnnotationOverrideMutationVariables
>
export const RunFormTemplateSuggestionsDocument = gql`
  mutation runFormTemplateSuggestions($input: RunFormTemplateSuggestionsInput!) {
    runFormTemplateSuggestions(input: $input) {
      ...FormTemplateSuggestionsRunProperties
    }
  }
  ${FormTemplateSuggestionsRunPropertiesDoc}
` as unknown as DocumentNode<
  RunFormTemplateSuggestionsMutation,
  RunFormTemplateSuggestionsMutationVariables
>
export const FormTemplateSuggestionsRunUpdatedDocument = gql`
  subscription formTemplateSuggestionsRunUpdated($id: ID!) {
    formTemplateSuggestionsRunUpdated(id: $id) {
      ...FormTemplateSuggestionsRunProperties
    }
  }
  ${FormTemplateSuggestionsRunPropertiesDoc}
` as unknown as DocumentNode<
  FormTemplateSuggestionsRunUpdatedSubscription,
  FormTemplateSuggestionsRunUpdatedSubscriptionVariables
>
export const DeleteAnnotationsFromAiSuggestionDocument = gql`
  mutation deleteAnnotationsFromAiSuggestion($input: DeleteAnnotationsFromAiSuggestionInput!) {
    deleteAnnotationsFromAiSuggestion(input: $input) {
      id
      annotations {
        ...FormTemplateAnnotationProperties
      }
    }
  }
  ${FormTemplateAnnotationPropertiesDoc}
` as unknown as DocumentNode<
  DeleteAnnotationsFromAiSuggestionMutation,
  DeleteAnnotationsFromAiSuggestionMutationVariables
>
export const TemplateVersionForEditorDocument = gql`
  query templateVersionForEditor($id: ID!) {
    formTemplateVersion(id: $id) {
      ...FormTemplateVersionProperties
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<TemplateVersionForEditorQuery, TemplateVersionForEditorQueryVariables>
export const TemplateVariantForEditorDocument = gql`
  query templateVariantForEditor($id: ID!) {
    formTemplateVariant(id: $id) {
      ...FormTemplateVariantProperties
    }
  }
  ${FormTemplateVariantPropertiesDoc}
` as unknown as DocumentNode<TemplateVariantForEditorQuery, TemplateVariantForEditorQueryVariables>
export const RunFormTemplateSuggestionsForSuggestAnnotationsButtonDocument = gql`
  mutation runFormTemplateSuggestionsForSuggestAnnotationsButton(
    $input: RunFormTemplateSuggestionsInput!
  ) {
    runFormTemplateSuggestions(input: $input) {
      ...FormTemplateSuggestionsRunProperties
    }
  }
  ${FormTemplateSuggestionsRunPropertiesDoc}
` as unknown as DocumentNode<
  RunFormTemplateSuggestionsForSuggestAnnotationsButtonMutation,
  RunFormTemplateSuggestionsForSuggestAnnotationsButtonMutationVariables
>
export const UpdateFormTemplateVersionDocument = gql`
  mutation updateFormTemplateVersion($input: UpdateFormTemplateVersionInput!) {
    updateFormTemplateVersion(input: $input) {
      ...FormTemplateVersionProperties
    }
  }
  ${FormTemplateVersionPropertiesDoc}
` as unknown as DocumentNode<
  UpdateFormTemplateVersionMutation,
  UpdateFormTemplateVersionMutationVariables
>
export const DeleteFormTemplateVersionDocument = gql`
  mutation deleteFormTemplateVersion($id: ID!) {
    deleteFormTemplateVersion(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<
  DeleteFormTemplateVersionMutation,
  DeleteFormTemplateVersionMutationVariables
>
export const GeneralContractorsForDedupeDocument = gql`
  query generalContractorsForDedupe($companyId: ID!) {
    generalContractorsForDedupe(companyId: $companyId) {
      generalContractor {
        id
        name
        locations {
          ...LocationProperties
        }
      }
      contractCount
    }
  }
  ${LocationPropertiesDoc}
` as unknown as DocumentNode<
  GeneralContractorsForDedupeQuery,
  GeneralContractorsForDedupeQueryVariables
>
export const MergeGeneralContractorsDocument = gql`
  mutation mergeGeneralContractors($input: MergeGeneralContractorsInput!) {
    mergeGeneralContractors(input: $input)
  }
` as unknown as DocumentNode<
  MergeGeneralContractorsMutation,
  MergeGeneralContractorsMutationVariables
>
export const PaginatedIntegrationRequestsDocument = gql`
  query paginatedIntegrationRequests($input: GetPaginatedIntegrationRequestsInput!) {
    paginatedIntegrationRequests(input: $input) {
      hasNext
      cursor
      totalCount
      integrationRequests {
        id
        companyIntegration {
          id
        }
        integrationType
        request
        response
        startedAt
        endedAt
      }
    }
  }
` as unknown as DocumentNode<
  PaginatedIntegrationRequestsQuery,
  PaginatedIntegrationRequestsQueryVariables
>
export const CloudLoggingLogsDocument = gql`
  query cloudLoggingLogs($input: CloudLoggingLogsInput!) {
    cloudLoggingLogs(input: $input) {
      entries
      nextPageToken
    }
  }
` as unknown as DocumentNode<CloudLoggingLogsQuery, CloudLoggingLogsQueryVariables>
export const SetLegalDocumentSyncedDocument = gql`
  mutation setLegalDocumentSynced($id: ID!) {
    setLegalDocumentSynced(id: $id) {
      ...LegalRequirementProperties
      documents {
        ...LegalDocumentProperties
      }
    }
  }
  ${LegalRequirementPropertiesDoc}
  ${LegalDocumentPropertiesDoc}
` as unknown as DocumentNode<
  SetLegalDocumentSyncedMutation,
  SetLegalDocumentSyncedMutationVariables
>
export const GetLegalRequirementDocument = gql`
  query getLegalRequirement($id: ID!) {
    legalRequirement(id: $id) {
      ...LegalRequirementProperties
      documents {
        ...LegalDocumentProperties
      }
      contract {
        id
        integrations {
          ...IntegrationProperties
        }
      }
    }
  }
  ${LegalRequirementPropertiesDoc}
  ${LegalDocumentPropertiesDoc}
  ${IntegrationPropertiesDoc}
` as unknown as DocumentNode<GetLegalRequirementQuery, GetLegalRequirementQueryVariables>
export const StateLienRequirementsSummaryDocument = gql`
  query stateLienRequirementsSummary($input: StateLienRequirementsSummaryInput!) {
    stateLienRequirementsSummary(input: $input) {
      ...StateLienRequirementsSummaryProperties
    }
  }
  ${StateLienRequirementsSummaryPropertiesDoc}
` as unknown as DocumentNode<
  StateLienRequirementsSummaryQuery,
  StateLienRequirementsSummaryQueryVariables
>
export const UpdateStateLienRequirementsSummaryDocument = gql`
  mutation updateStateLienRequirementsSummary($input: UpdateStateLienRequirementsSummaryInput!) {
    updateStateLienRequirementsSummary(input: $input) {
      ...StateLienRequirementsSummaryProperties
    }
  }
  ${StateLienRequirementsSummaryPropertiesDoc}
` as unknown as DocumentNode<
  UpdateStateLienRequirementsSummaryMutation,
  UpdateStateLienRequirementsSummaryMutationVariables
>
export const StateLienRequirementsSummariesDocument = gql`
  query stateLienRequirementsSummaries {
    stateLienRequirementsSummaries {
      ...StateLienRequirementsSummaryProperties
    }
  }
  ${StateLienRequirementsSummaryPropertiesDoc}
` as unknown as DocumentNode<
  StateLienRequirementsSummariesQuery,
  StateLienRequirementsSummariesQueryVariables
>
export const GetPayAppForDetailsDocument = gql`
  query getPayAppForDetails($payAppId: ID!) {
    payApp(id: $payAppId) {
      ...PayAppProperties
      hasPinnedTemplates
      billingType
      formTemplates {
        order
        formTemplateVersion {
          ...FormTemplateVersionProperties
          formTemplate {
            id
            userVisibleName
          }
        }
      }
      contract {
        ...ContractProperties
      }
    }
  }
  ${PayAppPropertiesDoc}
  ${FormTemplateVersionPropertiesDoc}
  ${ContractPropertiesDoc}
` as unknown as DocumentNode<GetPayAppForDetailsQuery, GetPayAppForDetailsQueryVariables>
export const ResetPayAppDocument = gql`
  mutation resetPayApp($payAppId: ID!) {
    resetPayApp(payAppId: $payAppId) {
      ...PayAppProperties
    }
  }
  ${PayAppPropertiesDoc}
` as unknown as DocumentNode<ResetPayAppMutation, ResetPayAppMutationVariables>
export const ClearPayAppEventsDocument = gql`
  mutation clearPayAppEvents($payAppId: ID!) {
    clearPayAppEvents(payAppId: $payAppId) {
      ...PayAppProperties
    }
  }
  ${PayAppPropertiesDoc}
` as unknown as DocumentNode<ClearPayAppEventsMutation, ClearPayAppEventsMutationVariables>
export const RetractPayAppDocument = gql`
  mutation retractPayApp($payAppId: ID!) {
    retractPayApp(payAppId: $payAppId) {
      ...PayAppProperties
    }
  }
  ${PayAppPropertiesDoc}
` as unknown as DocumentNode<RetractPayAppMutation, RetractPayAppMutationVariables>
export const SetPayAppSyncedDocument = gql`
  mutation setPayAppSynced($input: SetPayAppSyncedInput!) {
    setPayAppSynced(input: $input) {
      ...PayAppProperties
    }
  }
  ${PayAppPropertiesDoc}
` as unknown as DocumentNode<SetPayAppSyncedMutation, SetPayAppSyncedMutationVariables>
export const DeletePayAppDocument = gql`
  mutation deletePayApp($payAppId: ID!) {
    deletePayApp(payAppId: $payAppId) {
      id
    }
  }
` as unknown as DocumentNode<DeletePayAppMutation, DeletePayAppMutationVariables>
export const SetPayAppProposedDocument = gql`
  mutation setPayAppProposed($input: SetPayAppProposedInput!) {
    setPayAppProposed(input: $input) {
      ...PayAppProperties
    }
  }
  ${PayAppPropertiesDoc}
` as unknown as DocumentNode<SetPayAppProposedMutation, SetPayAppProposedMutationVariables>
export const UpdatePayAppDocument = gql`
  mutation updatePayApp($input: UpdatePayAppInput!) {
    updatePayApp(input: $input) {
      ...PayAppProperties
      contract {
        id
        project {
          ...ProjectProperties
        }
      }
    }
  }
  ${PayAppPropertiesDoc}
  ${ProjectPropertiesDoc}
` as unknown as DocumentNode<UpdatePayAppMutation, UpdatePayAppMutationVariables>
export const CompanyIntegrationForPeyoteDebuggerDocument = gql`
  query companyIntegrationForPeyoteDebugger($id: ID!) {
    companyIntegration(id: $id) {
      id
      type
    }
  }
` as unknown as DocumentNode<
  CompanyIntegrationForPeyoteDebuggerQuery,
  CompanyIntegrationForPeyoteDebuggerQueryVariables
>
export const IntegrationCredentialDocument = gql`
  query integrationCredential($input: IntegrationCredentialInput!) {
    integrationCredential(input: $input)
  }
` as unknown as DocumentNode<IntegrationCredentialQuery, IntegrationCredentialQueryVariables>
export const PeyoteCheckNetworkConnectionDocument = gql`
  mutation peyoteCheckNetworkConnection($input: PeyoteCheckNetworkConnectionInput!) {
    peyoteCheckNetworkConnection(input: $input) {
      status
      message
      context
    }
  }
` as unknown as DocumentNode<
  PeyoteCheckNetworkConnectionMutation,
  PeyoteCheckNetworkConnectionMutationVariables
>
export const PeyoteCheckUsernamePasswordDocument = gql`
  mutation peyoteCheckUsernamePassword($input: PeyoteCheckUsernamePasswordInput!) {
    peyoteCheckUsernamePassword(input: $input) {
      status
      message
      context
    }
  }
` as unknown as DocumentNode<
  PeyoteCheckUsernamePasswordMutation,
  PeyoteCheckUsernamePasswordMutationVariables
>
export const PeyoteCheckDatabasePermissionsDocument = gql`
  mutation peyoteCheckDatabasePermissions($input: PeyoteCheckDatabasePermissionsInput!) {
    peyoteCheckDatabasePermissions(input: $input) {
      status
      message
      context
    }
  }
` as unknown as DocumentNode<
  PeyoteCheckDatabasePermissionsMutation,
  PeyoteCheckDatabasePermissionsMutationVariables
>
export const ContractsForProcessingDocument = gql`
  query contractsForProcessing($input: GetPaginatedContractsInput!) {
    paginatedContracts(input: $input) {
      hasNext
      cursor
      totalCount
      contracts {
        id
        internalProjectNumber
        project {
          id
          projectNumber
          name
        }
        company {
          id
          name
        }
        onboardedStatus {
          selectedPayAppForms
          onboardedPayAppForms
          selectedPrimaryLienWaivers
          onboardedPrimaryLienWaiverForms
          selectedVendorLienWaivers
          onboardedVendorLienWaiverForms
          selectedChangeOrderRequestForms
          onboardedChangeOrderRequestForms
          selectedChangeOrderLogForms
          onboardedChangeOrderLogForms
        }
      }
    }
  }
` as unknown as DocumentNode<ContractsForProcessingQuery, ContractsForProcessingQueryVariables>
export const GetProjectForDetailsDocument = gql`
  query getProjectForDetails($projectId: ID!) {
    project(id: $projectId) {
      ...ProjectForDetailsProperties
    }
  }
  ${ProjectForDetailsPropertiesDoc}
` as unknown as DocumentNode<GetProjectForDetailsQuery, GetProjectForDetailsQueryVariables>
export const UpdateProjectDocument = gql`
  mutation updateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      ...ProjectForDetailsProperties
    }
  }
  ${ProjectForDetailsPropertiesDoc}
` as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>
export const DeleteProjectDocument = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>
export const AllProjectUsersByCompanyDocument = gql`
  query allProjectUsersByCompany($id: ID!) {
    allProjectUsersByCompany(id: $id) {
      ...CompanyUserProperties
      user {
        ...UserProperties
        blockedEmails
      }
    }
  }
  ${CompanyUserPropertiesDoc}
  ${UserPropertiesDoc}
` as unknown as DocumentNode<AllProjectUsersByCompanyQuery, AllProjectUsersByCompanyQueryVariables>
export const SendCompanyMonthlyReportTestEmailDocument = gql`
  mutation sendCompanyMonthlyReportTestEmail($input: SendCompanyMonthlyReportTestEmailInput!) {
    sendCompanyMonthlyReportTestEmail(input: $input) {
      id
      email
    }
  }
` as unknown as DocumentNode<
  SendCompanyMonthlyReportTestEmailMutation,
  SendCompanyMonthlyReportTestEmailMutationVariables
>
export const UserEducationCampaignDocument = gql`
  query userEducationCampaign($id: ID!) {
    userEducationCampaign(id: $id) {
      ...UserEducationCampaignProperties
    }
  }
  ${UserEducationCampaignPropertiesDoc}
` as unknown as DocumentNode<UserEducationCampaignQuery, UserEducationCampaignQueryVariables>
export const CreateUserEducationCampaignDocument = gql`
  mutation createUserEducationCampaign($input: CreateUserEducationCampaignInput!) {
    createUserEducationCampaign(input: $input) {
      ...UserEducationCampaignProperties
    }
  }
  ${UserEducationCampaignPropertiesDoc}
` as unknown as DocumentNode<
  CreateUserEducationCampaignMutation,
  CreateUserEducationCampaignMutationVariables
>
export const UpdateUserEducationCampaignDocument = gql`
  mutation updateUserEducationCampaign($input: UpdateUserEducationCampaignInput!) {
    updateUserEducationCampaign(input: $input) {
      ...UserEducationCampaignProperties
    }
  }
  ${UserEducationCampaignPropertiesDoc}
` as unknown as DocumentNode<
  UpdateUserEducationCampaignMutation,
  UpdateUserEducationCampaignMutationVariables
>
export const UserEducationCampaignsDocument = gql`
  query userEducationCampaigns {
    userEducationCampaigns {
      ...UserEducationCampaignProperties
    }
  }
  ${UserEducationCampaignPropertiesDoc}
` as unknown as DocumentNode<UserEducationCampaignsQuery, UserEducationCampaignsQueryVariables>
export const GetUserForDetailsDocument = gql`
  query getUserForDetails($userId: ID!) {
    user(id: $userId) {
      ...UserProperties
      companyUsers {
        id
        status
        role
        billingDeadline
        company {
          ...CompanyProperties
        }
      }
    }
  }
  ${UserPropertiesDoc}
  ${CompanyPropertiesDoc}
` as unknown as DocumentNode<GetUserForDetailsQuery, GetUserForDetailsQueryVariables>
export const ModifyNotificationPreferencesDocument = gql`
  mutation modifyNotificationPreferences($input: ModifyNotificationPreferencesInput!) {
    modifyNotificationPreferences(input: $input) {
      ...UserProperties
    }
  }
  ${UserPropertiesDoc}
` as unknown as DocumentNode<
  ModifyNotificationPreferencesMutation,
  ModifyNotificationPreferencesMutationVariables
>
export const ModifyEmailPreferencesDocument = gql`
  mutation modifyEmailPreferences($input: ModifyEmailPreferencesInput!) {
    modifyEmailPreferences(input: $input) {
      ...UserProperties
    }
  }
  ${UserPropertiesDoc}
` as unknown as DocumentNode<
  ModifyEmailPreferencesMutation,
  ModifyEmailPreferencesMutationVariables
>
export const ResendUserInviteDocument = gql`
  mutation resendUserInvite($id: ID!) {
    resendUserInvite(id: $id) {
      id
    }
  }
` as unknown as DocumentNode<ResendUserInviteMutation, ResendUserInviteMutationVariables>
export const ResetUserMfaDocument = gql`
  mutation resetUserMfa($userId: ID!) {
    resetUserMfa(userId: $userId) {
      id
      mfaEnrolled
    }
  }
` as unknown as DocumentNode<ResetUserMfaMutation, ResetUserMfaMutationVariables>
export const ProjectsByUserDocument = gql`
  query projectsByUser($id: ID!) {
    projectsByUser(id: $id) {
      ...ProjectProperties
    }
  }
  ${ProjectPropertiesDoc}
` as unknown as DocumentNode<ProjectsByUserQuery, ProjectsByUserQueryVariables>
export const MarkWriteSyncAsFailedDocument = gql`
  mutation markWriteSyncAsFailed($input: MarkWriteSyncAsFailedInput!) {
    markWriteSyncAsFailed(input: $input) {
      id
      updatedAt
      status
      result
    }
  }
` as unknown as DocumentNode<MarkWriteSyncAsFailedMutation, MarkWriteSyncAsFailedMutationVariables>
export const PaginatedWriteSyncOperationsDocument = gql`
  query paginatedWriteSyncOperations($input: GetPaginatedWriteSyncOperationsInput!) {
    paginatedWriteSyncOperations(input: $input) {
      hasNext
      cursor
      totalCount
      operations {
        id
        createdAt
        updatedAt
        status
        payload
        result
        createdBy {
          id
          email
          firstName
        }
        integration {
          id
          type
          contract {
            id
            internalProjectNumber
            project {
              id
              name
              projectNumber
            }
            company {
              id
              name
            }
          }
        }
      }
    }
  }
` as unknown as DocumentNode<
  PaginatedWriteSyncOperationsQuery,
  PaginatedWriteSyncOperationsQueryVariables
>
export const RequeueWriteSyncDocument = gql`
  mutation requeueWriteSync($input: RequeueWriteSyncInput!) {
    requeueWriteSync(input: $input) {
      id
      updatedAt
      status
      result
    }
  }
` as unknown as DocumentNode<RequeueWriteSyncMutation, RequeueWriteSyncMutationVariables>
export const ChatToolsDocument = gql`
  query chatTools {
    chatTools {
      errors {
        source
        message
        repairCommand
      }
    }
  }
` as unknown as DocumentNode<ChatToolsQuery, ChatToolsQueryVariables>
